/*
 * @license
 * Pipeline Theme (c) Groupthought Themes
 *
 * This file is included for advanced development by
 * Shopify Agencies.  Modified versions of the theme
 * code are not supported by Shopify or Groupthought.
 *
 */ !(function (e, t, i, s, r, n, a, o, l, d, c) {
    "use strict";
    var h,
        u,
        p,
        m,
        f,
        g,
        y,
        v,
        b,
        $,
        w,
        S,
        E,
        x,
        k,
        T,
        L,
        _,
        A,
        C,
        q,
        I,
        P,
        M =
            ((k = c),
            (T = Object.create(null)),
            k &&
                Object.keys(k).forEach(function (e) {
                    if ("default" !== e) {
                        var t = Object.getOwnPropertyDescriptor(k, e);
                        Object.defineProperty(
                            T,
                            e,
                            t.get
                                ? t
                                : {
                                      enumerable: !0,
                                      get: function () {
                                          return k[e];
                                      },
                                  }
                        );
                    }
                }),
            (T.default = k),
            Object.freeze(T));
    function D(e) {
        let t = e.querySelectorAll("[data-modal]"),
            i = document.querySelector("[data-modal-container]");
        t.forEach((e) => {
            let t = i.querySelector(`[id="${e.id}"]`);
            t || i.appendChild(e);
        });
    }
    function O(e) {
        let t = e.querySelectorAll(".float__wrapper");
        t.forEach((e) => {
            let t = e.querySelector("label"),
                i = e.querySelector("input, textarea");
            t &&
                i.addEventListener("keyup", (e) => {
                    "" !== e.target.value ? t.classList.add("label--float") : t.classList.remove("label--float");
                }),
                i && i.value && i.value.length && t.classList.add("label--float");
        });
    }
    function F(e) {
        let t = e.querySelectorAll(".errors");
        t.forEach((e) => {
            e.setAttribute("tabindex", "0"), e.setAttribute("aria-live", "assertive"), e.setAttribute("role", "alert");
        });
    }
    function B(e) {
        e.querySelectorAll("img").forEach((e) => {
            e.complete && e.parentNode.classList.remove("loading-shimmer");
        });
    }
    function V() {
        let e = {};
        return (
            (e.windowHeight = window.innerHeight),
            (e.announcementHeight = W("[data-announcement-bar]")),
            (e.toolbarHeight = W("[data-toolbar-height]")),
            (e.footerHeight = W('[data-section-type*="footer"]')),
            (e.menuHeight = W("[data-header-height]")),
            (e.headerHeight = e.menuHeight + e.announcementHeight),
            (e.logoHeight = (function e() {
                let t = W("[data-footer-logo]");
                return t > 0 ? t + 20 : 0;
            })()),
            (e.stickyHeader = document.querySelector('[data-header-sticky="sticky"]') ? e.menuHeight : 0),
            (e.backfillHeight = W("[data-header-backfill]")),
            e
        );
    }
    function H() {
        let {
            windowHeight: e,
            announcementHeight: t,
            toolbarHeight: i,
            headerHeight: s,
            logoHeight: r,
            menuHeight: n,
            footerHeight: a,
            stickyHeader: o,
            backfillHeight: l,
        } = V();
        document.documentElement.style.setProperty("--scrollbar-width", `${R()}px`),
            document.documentElement.style.setProperty("--full-screen", `${e}px`),
            document.documentElement.style.setProperty("--menu-height", `${n}px`),
            document.documentElement.style.setProperty("--announcement-height", `${t}px`),
            document.documentElement.style.setProperty("--toolbar-height", `${i}px`),
            document.documentElement.style.setProperty("--header-height", `${s}px`),
            document.documentElement.style.setProperty("--footer-height", `${a}px`),
            document.documentElement.style.setProperty("--content-full", `${e - s - r / 2}px`),
            document.documentElement.style.setProperty("--menu-height-sticky", `${o}px`);
        let d = Math.abs(l - n) > 1 ? `${n}px` : "auto";
        document.documentElement.style.setProperty("--menu-backfill-height", d);
    }
    function W(e) {
        let t = document.querySelector(e);
        return t ? t.clientHeight : 0;
    }
    function R() {
        let e = document.createElement("div");
        (e.style.visibility = "hidden"),
            (e.style.overflow = "scroll"),
            (e.style.msOverflowStyle = "scrollbar"),
            document.body.appendChild(e);
        let t = document.createElement("div");
        e.appendChild(t);
        let i = e.offsetWidth - t.offsetWidth;
        return e.parentNode.removeChild(e), i;
    }
    function N(e, t) {
        let i = 64,
            s = 0;
        t.forEach((e) => {
            if (e.offsetHeight > s) {
                let t = parseInt(window.getComputedStyle(e).marginTop),
                    r = parseInt(window.getComputedStyle(e).marginBottom),
                    n = t + r;
                n > i && (i = n), (s = e.offsetHeight);
            }
        });
        let r = e.querySelectorAll("[data-overflow-background]");
        [e, ...r].forEach((e) => {
            e.style.setProperty("min-height", `calc(${s + i}px + var(--menu-height))`);
        });
    }
    function z(e) {
        let t = document.querySelector("[data-footer-logo]")
                ? document.querySelector("[data-footer-logo]").clientHeight + 20
                : 0,
            i = document.querySelector("#MainContent .shopify-section:last-child [data-section-id]"),
            s = i ? i.getAttribute("data-section-id") : null;
        if (
            (((null === s || e.getAttribute("data-section-id") === s) && i) || (t = 0),
            window.innerWidth < window.theme.sizes.medium)
        ) {
            e.querySelectorAll("[data-overflow-frame]").forEach((e) => {
                let t = e.querySelectorAll("[data-overflow-content]");
                N(e, t);
            });
            return;
        }
        let r = document.createElement("div");
        e.prepend(r), (r.style.display = "none"), (r.style.width = getComputedStyle(e).getPropertyValue("--outer"));
        let n = 2 * parseInt(getComputedStyle(r).getPropertyValue("width"));
        e.firstChild.remove();
        let a = 0,
            o = e.querySelectorAll("[data-overflow-frame]"),
            l = e.querySelectorAll("[data-overflow-content]");
        l.forEach((e) => {
            e.offsetHeight > a && (a = e.offsetHeight);
        });
        let d = e.querySelectorAll("[data-overflow-background]");
        [...o, ...d].forEach((e) => {
            e.style.setProperty("min-height", `${a + n}px`);
        }),
            e.style.setProperty("min-height", `${a + n + 2 + t}px`);
    }
    function j(e) {
        let i = e.querySelectorAll(".js-overflow-container");
        if (i) {
            i.forEach((e) => {
                let t = e.querySelectorAll(".js-overflow-content");
                N(e, t),
                    document.addEventListener("theme:resize", () => {
                        N(e, t);
                    });
            });
            let s = e.querySelectorAll("[data-slideshow-wrapper]");
            s.length &&
                s.forEach((e) => {
                    let i = t.data(e);
                    void 0 !== i && i.reloadCells();
                });
        }
        let r = e.querySelectorAll("[data-overflow-wrapper]");
        r &&
            r.forEach((e) => {
                z(e),
                    document.addEventListener("theme:resize", () => {
                        z(e);
                    });
            });
    }
    function U(e, t = 500, i = !1) {
        function s() {
            var d = Date.now() - o;
            d < t && d >= 0 ? (r = setTimeout(s, t - d)) : ((r = null), i || ((l = e.apply(a, n)), (a = n = null)));
        }
        null == t && (t = 100);
        var r,
            n,
            a,
            o,
            l,
            d = function () {
                (a = this), (n = arguments), (o = Date.now());
                var d = i && !r;
                return r || (r = setTimeout(s, t)), d && ((l = e.apply(a, n)), (a = n = null)), l;
            };
        return (
            (d.clear = function () {
                r && (clearTimeout(r), (r = null));
            }),
            (d.flush = function () {
                r && ((l = e.apply(a, n)), (a = n = null), clearTimeout(r), (r = null));
            }),
            d
        );
    }
    !(function () {
        let e = { NODE_ENV: "production" };
        try {
            if (process) {
                (process.env = Object.assign({}, process.env)), Object.assign(process.env, e);
                return;
            }
        } catch (t) {}
        globalThis.process = { env: e };
    })(),
        (window.requestIdleCallback =
            window.requestIdleCallback ||
            function (e) {
                var t = Date.now();
                return setTimeout(function () {
                    e({
                        didTimeout: !1,
                        timeRemaining: function () {
                            return Math.max(0, 50 - (Date.now() - t));
                        },
                    });
                }, 1);
            }),
        (window.cancelIdleCallback =
            window.cancelIdleCallback ||
            function (e) {
                clearTimeout(e);
            });
    let G = window.innerWidth,
        K = window.innerHeight;
    function X() {
        document.dispatchEvent(new CustomEvent("theme:resize", { bubbles: !0 })),
            G !== window.innerWidth &&
                (document.dispatchEvent(new CustomEvent("theme:resize:width", { bubbles: !0 })),
                (G = window.innerWidth)),
            K !== window.innerHeight &&
                (document.dispatchEvent(new CustomEvent("theme:resize:height", { bubbles: !0 })),
                (K = window.innerHeight));
    }
    let Y,
        J = window.pageYOffset,
        Q = null,
        Z = null,
        ee = null,
        et = null,
        ei = 0;
    function es() {
        let e = window.pageYOffset;
        e > J ? ((Z = !0), (Q = !1)) : e < J ? ((Z = !1), (Q = !0)) : ((Q = null), (Z = null)),
            (J = e),
            document.dispatchEvent(
                new CustomEvent("theme:scroll", { detail: { up: Q, down: Z, position: e }, bubbles: !1 })
            ),
            Q &&
                !ee &&
                document.dispatchEvent(new CustomEvent("theme:scroll:up", { detail: { position: e }, bubbles: !1 })),
            Z &&
                !et &&
                document.dispatchEvent(new CustomEvent("theme:scroll:down", { detail: { position: e }, bubbles: !1 })),
            (et = Z),
            (ee = Q);
    }
    function er() {
        i.clearQueueScrollLocks(), i.enablePageScroll(), document.documentElement.removeAttribute("data-scroll-locked");
    }
    let en = {
            time: "time",
            days: "[data-days]",
            hours: "[data-hours]",
            minutes: "[data-minutes]",
            seconds: "[data-seconds]",
            shopifySection: ".shopify-section",
        },
        ea = { showMessage: "show-message", hideCountdown: "hidden" },
        eo = { hideSection: "hide-section", showMessage: "show-message" },
        el = class e extends HTMLElement {
            connectedCallback() {
                if (isNaN(this.endDate) || this.endDate <= Date.now()) {
                    this.onComplete();
                    return;
                }
                this.interval = setInterval(this.update, 1e3);
            }
            disconnectedCallback() {
                this.stopTimer();
            }
            convertTime(e) {
                let t = this.formatDigits(parseInt(e / this.daysInMs, 10));
                e -= t * this.daysInMs;
                let i = this.formatDigits(parseInt(e / this.hoursInMs, 10));
                e -= i * this.hoursInMs;
                let s = this.formatDigits(parseInt(e / this.minutesInMs, 10));
                e -= s * this.minutesInMs;
                let r = this.formatDigits(parseInt(e / this.secondsInMs, 10));
                return { days: t, hours: i, minutes: s, seconds: r };
            }
            formatDigits(e) {
                return e < 10 && (e = "0" + e), e;
            }
            render(e) {
                (this.days.textContent = e.days),
                    (this.hours.textContent = e.hours),
                    (this.minutes.textContent = e.minutes),
                    (this.seconds.textContent = e.seconds);
            }
            stopTimer() {
                clearInterval(this.interval);
            }
            onComplete() {
                this.render({ days: 0, hours: 0, minutes: 0, seconds: 0 }),
                    this.shouldHideOnComplete && this.shopifySection.classList.add(ea.hideCountdown),
                    this.shouldShowMessage && this.classList.add(ea.showMessage);
            }
            update() {
                let e = new Date().getTime(),
                    t = this.endDate - e;
                t <= 0 && (this.stopTimer(), this.onComplete());
                let i = this.convertTime(t);
                this.render(i);
            }
            constructor() {
                super(),
                    (this.shopifySection = this.closest(en.shopifySection)),
                    (this.expirationBehavior = this.getAttribute("data-expiration-behavior")),
                    (this.time = this.querySelector(en.time)),
                    (this.days = this.querySelector(en.days)),
                    (this.hours = this.querySelector(en.hours)),
                    (this.minutes = this.querySelector(en.minutes)),
                    (this.seconds = this.querySelector(en.seconds)),
                    (this.endDate = Date.parse(this.time.dateTime)),
                    (this.daysInMs = 864e5),
                    (this.hoursInMs = this.daysInMs / 24),
                    (this.minutesInMs = this.hoursInMs / 60),
                    (this.secondsInMs = this.minutesInMs / 60),
                    (this.shouldHideOnComplete = this.expirationBehavior === eo.hideSection),
                    (this.shouldShowMessage = this.expirationBehavior === eo.showMessage),
                    (this.update = this.update.bind(this));
            }
        };
    window.addEventListener("resize", () => {
        Y && window.cancelAnimationFrame(Y), (Y = window.requestAnimationFrame(U(X, 50)));
    });
    let ed;
    window.addEventListener(
        "scroll",
        function () {
            ed && window.cancelAnimationFrame(ed), (ed = window.requestAnimationFrame(es));
        },
        { passive: !0 }
    ),
        window.addEventListener("theme:scroll:lock", function e(t) {
            setTimeout(() => {
                ei && clearTimeout(ei),
                    i.disablePageScroll(t.detail, { allowTouchMove: (e) => "TEXTAREA" === e.tagName }),
                    document.documentElement.setAttribute("data-scroll-locked", "");
            });
        }),
        window.addEventListener("theme:scroll:unlock", function e(t) {
            let i = t.detail;
            i ? (ei = setTimeout(er, i)) : er();
        }),
        B(document),
        document.addEventListener(
            "load",
            (e) => {
                var t;
                let i = e.target;
                "IMG" == (t = i).tagName &&
                    t.parentNode.classList.contains("loading-shimmer") &&
                    t.parentNode.classList.remove("loading-shimmer");
            },
            !0
        ),
        window.addEventListener("DOMContentLoaded", () => {
            document.addEventListener("theme:resize", H),
                (function e() {
                    let {
                        windowHeight: t,
                        announcementHeight: i,
                        toolbarHeight: s,
                        headerHeight: r,
                        logoHeight: n,
                        menuHeight: a,
                        footerHeight: o,
                        stickyHeader: l,
                        backfillHeight: d,
                    } = V();
                    document.documentElement.style.setProperty("--scrollbar-width", `${R()}px`),
                        document.documentElement.style.setProperty("--footer-logo", `${n}px`),
                        document.documentElement.style.setProperty("--full-screen", `${t}px`),
                        document.documentElement.style.setProperty("--three-quarters", `${0.75 * t}px`),
                        document.documentElement.style.setProperty("--two-thirds", `${0.66 * t}px`),
                        document.documentElement.style.setProperty("--one-half", `${0.5 * t}px`),
                        document.documentElement.style.setProperty("--one-third", `${0.33 * t}px`),
                        document.documentElement.style.setProperty("--one-fifth", `${0.2 * t}px`),
                        document.documentElement.style.setProperty("--menu-height", `${a}px`),
                        document.documentElement.style.setProperty("--announcement-height", `${i}px`),
                        document.documentElement.style.setProperty("--toolbar-height", `${s}px`),
                        document.documentElement.style.setProperty("--header-height", `${r}px`),
                        document.documentElement.style.setProperty("--footer-height", `${o}px`),
                        document.documentElement.style.setProperty("--content-full", `${t - r - n / 2}px`),
                        document.documentElement.style.setProperty("--menu-height-sticky", `${l}px`);
                    let c = Math.abs(d - a) > 1 ? `${a}px` : "auto";
                    document.documentElement.style.setProperty("--menu-backfill-height", c);
                })(),
                O(document),
                F(document),
                D(document),
                window.theme.settings.animate_scroll && e.refresh();
        }),
        window.addEventListener("load", () => {
            j(document), B(document);
        }),
        document.addEventListener("shopify:section:load", (t) => {
            let i = t.target;
            O(i), F(i), D(i), j(i), window.theme.settings.animate_scroll && e.refresh();
        }),
        document.addEventListener("shopify:section:reorder", () => {
            document.dispatchEvent(new CustomEvent("theme:header:check", { bubbles: !1 }));
        }),
        customElements.get("countdown-timer") || customElements.define("countdown-timer", el);
    let ec = (e, t = !1, i = "block") => {
        e && (t ? e.style.removeProperty("display") : (e.style.display = i));
    };
    function eh(e) {
        (this.status = e.status || null),
            (this.headers = e.headers || null),
            (this.json = e.json || null),
            (this.body = e.body || null);
    }
    eh.prototype = Error.prototype;
    let eu = {
            scrollbar: "data-scrollbar-slider",
            scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
            scrollbarArrowNext: "[data-scrollbar-arrow-next]",
        },
        ep = { hidden: "is-hidden" },
        em = { delay: 200 },
        ef = class e {
            init() {
                this.arrowNext &&
                    this.arrowPrev &&
                    (window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow(), this.events());
            }
            resize() {
                document.addEventListener("theme:resize", () => {
                    window.isRTL ? this.togglePrevArrow() : this.toggleNextArrow();
                });
            }
            events() {
                this.arrowNext.addEventListener("click", (e) => {
                    e.preventDefault(), this.goToNext();
                }),
                    this.arrowPrev.addEventListener("click", (e) => {
                        e.preventDefault(), this.goToPrev();
                    }),
                    this.scrollbar.addEventListener("scroll", () => {
                        this.togglePrevArrow(), this.toggleNextArrow();
                    });
            }
            goToNext() {
                let e = this.scrollbar.getBoundingClientRect().width / 2 + this.scrollbar.scrollLeft;
                this.move(e), this.arrowPrev.classList.remove(ep.hidden), this.toggleNextArrow();
            }
            goToPrev() {
                let e = this.scrollbar.scrollLeft - this.scrollbar.getBoundingClientRect().width / 2;
                this.move(e), this.arrowNext.classList.remove(ep.hidden), this.togglePrevArrow();
            }
            toggleNextArrow() {
                setTimeout(() => {
                    window.isRTL
                        ? this.arrowNext.classList.toggle(ep.hidden, 0 === this.scrollbar.scrollLeft)
                        : this.arrowNext.classList.toggle(
                              ep.hidden,
                              Math.round(
                                  this.scrollbar.scrollLeft + this.scrollbar.getBoundingClientRect().width + 1
                              ) >= this.scrollbar.scrollWidth
                          );
                }, em.delay);
            }
            togglePrevArrow() {
                setTimeout(() => {
                    window.isRTL
                        ? this.arrowPrev.classList.toggle(
                              ep.hidden,
                              Math.abs(this.scrollbar.scrollLeft) + this.scrollbar.getBoundingClientRect().width + 1 >=
                                  this.scrollbar.scrollWidth
                          )
                        : this.arrowPrev.classList.toggle(ep.hidden, this.scrollbar.scrollLeft <= 0);
                }, em.delay);
            }
            scrollToVisibleElement() {
                [].forEach.call(this.scrollbar.children, (e) => {
                    e.addEventListener("click", (t) => {
                        ("a" === t.target.tagName.toLowerCase() ||
                            (t.currentTarget && "a" === t.currentTarget.tagName.toLowerCase()) ||
                            (t.currentTarget && t.currentTarget.querySelector("a"))) &&
                            t.preventDefault(),
                            this.move(e.offsetLeft - e.clientWidth);
                    });
                });
            }
            move(e) {
                this.scrollbar.scrollTo({ top: 0, left: e, behavior: "smooth" });
            }
            constructor(e) {
                (this.scrollbar = e),
                    (this.arrowNext = this.scrollbar.parentNode.querySelector(eu.scrollbarArrowNext)),
                    (this.arrowPrev = this.scrollbar.parentNode.querySelector(eu.scrollbarArrowPrev)),
                    this.init(),
                    this.resize(),
                    this.scrollbar.hasAttribute(eu.scrollbar) && this.scrollToVisibleElement();
            }
        },
        eg = class e {
            init() {
                this.siblings.forEach((e) => {
                    new ef(e);
                });
            }
            constructor(e) {
                (this.siblings = e.querySelectorAll("[data-sibling-inner]")), this.init();
            }
        },
        ey = {
            onLoad() {
                new eg(this.container);
            },
        },
        ev = { expires: 7, path: "/", domain: window.location.hostname },
        eb = class e {
            write(e) {
                document.cookie = `${this.options.name}=${e}; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
            }
            read() {
                let e = [],
                    t = document.cookie.split("; ").find((e) => e.startsWith(this.options.name));
                if (-1 !== document.cookie.indexOf("; ") && t) {
                    let i = document.cookie
                        .split("; ")
                        .find((e) => e.startsWith(this.options.name))
                        .split("=")[1];
                    null !== i && (e = i.split(","));
                }
                return e;
            }
            destroy() {
                document.cookie = `${this.options.name}=null; expires=${this.options.expires}; path=${this.options.path}; domain=${this.options.domain}`;
            }
            remove(e) {
                let t = this.read(),
                    i = t.indexOf(e);
                -1 !== i && (t.splice(i, 1), this.write(t));
            }
            constructor(e = {}) {
                this.options = { ...ev, ...e };
            }
        },
        e$ = {
            howManyToShow: 4,
            howManyToStoreInMemory: 10,
            wrapper: "[data-recently-viewed-products]",
            limit: "data-limit",
            recentTabLink: "[data-recent-link-tab]",
            recentWrapper: "[data-recent-wrapper]",
            recentViewedTab: "[data-recently-viewed-tab]",
            tabsHolderScroll: "[data-tabs-holder-scroll]",
            apiContent: "[data-api-content]",
            dataMinimum: "data-minimum",
            dataItemId: "data-item-id",
        },
        ew = { hide: "hide", containerWithoutTabsNav: "section-without-title--skip" },
        e8 = { expires: 90, name: "shopify_recently_viewed" },
        eS = [],
        eE = [],
        ex = class e {
            renderProducts() {
                let e = this.cookie.read(),
                    t = [],
                    i = 0;
                if (e.length > 0) {
                    for (let s = 0; s < e.length; s++) {
                        let r = e[s];
                        if (eE.includes(r)) continue;
                        let n = `${window.theme.routes.root_url}products/${r}?section_id=api-product-grid-item`;
                        if ((t.push(n), ++i === this.howManyToShow || i === e.length - 1)) break;
                    }
                    if (t.length > 0 && t.length >= this.minimum) {
                        this.container.classList.remove(ew.hide),
                            this.recentViewedLink &&
                                this.recentViewedLink.previousElementSibling &&
                                (this.tabsHolderScroll.classList.remove(ew.hide),
                                this.container.classList.add(ew.containerWithoutTabsNav));
                        let a = t.map((e) => fetch(e, { mode: "no-cors" }).then(this.handleErrors)),
                            o = [];
                        Promise.allSettled(a)
                            .then((e) =>
                                Promise.all(
                                    e.map(async (e) => {
                                        "fulfilled" === e.status && o.push(await e.value.text());
                                    })
                                )
                            )
                            .then(() => {
                                o.forEach((e) => {
                                    let t = document.createElement("div"),
                                        i = document.createElement("div");
                                    t.innerHTML = e;
                                    let s = t.querySelector(`[${e$.dataItemId}]`),
                                        r = "" === s.getAttribute(e$.dataItemId);
                                    !r &&
                                        (i.classList.add("product-grid-slide"),
                                        i.setAttribute("data-carousel-slide", null),
                                        i.setAttribute("data-item", null),
                                        (i.innerHTML = t.querySelector(e$.apiContent).innerHTML),
                                        this.wrapper.appendChild(i));
                                }),
                                    new eg(this.container);
                            })
                            .then(() => {
                                ec(this.wrapper, !0),
                                    this.container.dispatchEvent(
                                        new CustomEvent("theme:recent-products:added", { bubbles: !0 })
                                    );
                            });
                    } else if (this.recentViewedTab) {
                        let l =
                            Array.prototype.filter.call(
                                this.recentViewedTab.parentNode.children,
                                (e) => e !== this.recentViewedTab
                            ).length > 1;
                        this.recentViewedLink &&
                            this.recentViewedLink.previousElementSibling &&
                            (this.tabsHolderScroll.classList.add(ew.hide),
                            this.container.classList.remove(ew.containerWithoutTabsNav)),
                            l || this.container.classList.add(ew.hide);
                    } else this.container.classList.add(ew.hide);
                }
            }
            handleErrors(e) {
                return e.ok
                    ? e
                    : e.text().then(function (t) {
                          let i = new eh({ status: e.statusText, headers: e.headers, text: t });
                          throw i;
                      });
            }
            constructor(e) {
                if (
                    ((this.container = e.container),
                    (this.cookie = new eb(e8)),
                    (this.wrapper = this.container.querySelector(e$.wrapper)),
                    null === this.wrapper)
                )
                    return;
                (this.howManyToShow =
                    parseInt(this.container.querySelector(e$.recentWrapper).getAttribute(e$.limit)) ||
                    e$.howManyToShow),
                    (this.minimum = parseInt(
                        this.container.querySelector(e$.recentWrapper).getAttribute(e$.dataMinimum)
                    )),
                    (this.recentViewedTab = this.container.querySelector(e$.recentViewedTab)),
                    (this.recentViewedLink = this.container.querySelector(e$.recentTabLink)),
                    (this.tabsHolderScroll = this.container.querySelector(e$.tabsHolderScroll)),
                    this.renderProducts();
            }
        },
        ek = class e {
            updateCookie() {
                let e = this.cookie.read(),
                    t = e.indexOf(this.handle);
                -1 === t
                    ? (e.unshift(this.handle), (e = e.splice(0, e$.howManyToStoreInMemory)))
                    : (e.splice(t, 1), e.unshift(this.handle));
                let i = e.join(",");
                this.cookie.write(i);
            }
            constructor(e) {
                if (((this.handle = encodeURIComponent(e)), (this.cookie = new eb(e8)), void 0 === this.handle)) return;
                eE.push(this.handle), this.updateCookie();
            }
        };
    function eT() {
        let e = "(any-pointer: coarse)",
            t = `(max-width: ${window.theme.sizes.medium}px)`,
            i = `(min-width: ${window.theme.sizes.medium + 1}px) and (max-width: ${window.theme.sizes.large}px)`,
            s = `(min-width: ${window.theme.sizes.large + 1}px)`;
        (eT.isTouch = () => {
            let t = window.matchMedia(e).matches;
            return document.documentElement.classList.toggle("supports-touch", t), t;
        }),
            (eT.isMobile = () => window.matchMedia(t).matches),
            (eT.isTablet = () => window.matchMedia(i).matches),
            (eT.isDesktop = () => window.matchMedia(s).matches);
        let r = [
            [e, eT.isTouch],
            [t, eT.isMobile],
            [i, eT.isTablet],
            [s, eT.isDesktop],
        ];
        eT.onChange = (e) => {
            r.forEach((t) => {
                window.matchMedia(t[0]).addEventListener("change", () => {
                    t[1]() && e && e();
                });
            });
        };
    }
    eT();
    let eL = {
            holderItems: "[data-custom-scrollbar-items]",
            scrollbar: "[data-custom-scrollbar]",
            scrollbarTrack: "[data-custom-scrollbar-track]",
        },
        e_ = { hide: "hide" },
        eA = {},
        eC = class e {
            events() {
                this.holderItems.addEventListener("scroll", this.calculatePosition.bind(this)),
                    this.holderItems.addEventListener("theme:carousel:scroll", this.calculatePosition.bind(this)),
                    document.addEventListener("theme:resize:width", this.calculateTrackWidth.bind(this)),
                    document.addEventListener("theme:resize:width", this.calculatePosition.bind(this));
            }
            calculateTrackWidth() {
                let e = document.createElement("div");
                this.holderItems.prepend(e),
                    (e.style.display = "none"),
                    (e.style.width = getComputedStyle(this.holderItems).getPropertyValue("--outer"));
                let t = parseInt(getComputedStyle(e).getPropertyValue("width"));
                this.holderItems.firstChild.remove(),
                    (this.scrollbarWidth =
                        0 === this.scrollbar.clientWidth
                            ? this.scrollbar.parentNode.getBoundingClientRect().width
                            : this.scrollbar.clientWidth),
                    setTimeout(() => {
                        let e = this.children[0].clientWidth,
                            i = Number(getComputedStyle(this.children[0]).marginRight.replace("px", "")),
                            s = Number(getComputedStyle(this.children[0]).marginLeft.replace("px", ""));
                        (this.scrollWidth = this.children.length * (e + i + s) + t - i),
                            (this.trackWidth = ((this.scrollbarWidth + t) / this.scrollWidth) * 100),
                            (this.trackWidth = this.trackWidth < 5 ? 5 : this.trackWidth),
                            this.scrollbar.style.setProperty("--track-width", `${this.trackWidth}%`);
                        let r = Math.ceil(this.trackWidth) >= 100;
                        this.scrollbar.classList.toggle(e_.hide, r);
                    }, 100);
            }
            calculatePosition() {
                let e =
                    Math.abs(this.holderItems.scrollLeft) /
                    (this.holderItems.scrollWidth - this.holderItems.clientWidth);
                (e *= this.scrollbar.clientWidth - this.scrollbarTrack.clientWidth),
                    (e = isNaN((e = e < 0 ? 0 : e)) ? 0 : e),
                    this.scrollbar.style.setProperty("--position", `${Math.round(e)}px`),
                    document.dispatchEvent(
                        new CustomEvent("theme:scrollbar:scroll", { bubbles: !0, detail: { holder: this.holderItems } })
                    );
            }
            constructor(e, t = null) {
                (this.holderItems = e.querySelector(eL.holderItems)),
                    (this.scrollbar = e.querySelector(eL.scrollbar)),
                    (this.scrollbarTrack = e.querySelector(eL.scrollbarTrack)),
                    (this.trackWidth = 0),
                    (this.scrollWidth = 0),
                    this.scrollbar &&
                        this.holderItems &&
                        ((this.children = t || this.holderItems.children), this.events(), this.calculateTrackWidth());
            }
        },
        eq = {
            onLoad() {
                eA[this.id] = new eC(this.container);
            },
        },
        eI = {
            carousel: "[data-carousel]",
            carouselWithProgress: "data-carousel-progress",
            carouselSlide: "[data-carousel-slide]",
            carouselFirstSlidePhoto: "[data-grid-slide]",
            pgiFirstSlidePhoto: "product-grid-item-variant:not([hidden]) [data-grid-slide]",
            wrapper: "[data-wrapper]",
            carouselTrack: "[data-carousel-track]",
            slider: ".flickity-slider",
            carouselOptions: "data-options",
            carouselCustomScrollbar: "data-custom-scrollbar-items",
            carouselPrev: ".flickity-button.previous",
            carouselNext: ".flickity-button.next",
            recentlyViewHolder: "data-recently-viewed-products",
            relatedHolder: "data-related-products",
            sectionHolder: "[data-section-id]",
        },
        eP = {
            wrapper: "wrapper",
            arrowsForceTop: "flickity-force-arrows-top",
            arrowsOnSide: "not-moved-arrows",
            hide: "hide",
            flickityEnabled: "flickity-enabled",
            hiddenArrows: "hidden-arrows",
            flickityStatic: "flickity-static",
        },
        e9 = { additionalOffsetWrapper: 112 },
        eM = class e extends HTMLElement {
            connectedCallback() {
                (this.carousel = this.container.querySelector(eI.carousel)),
                    (this.carouselTrack = this.container.querySelector(eI.carouselTrack)),
                    (this.wrapper = this.container.closest(eI.wrapper)),
                    (this.section = this.container.closest(eI.sectionHolder)),
                    (this.slidesVisible = null),
                    (this.carouselInstance = null),
                    (this.carouselPrev = null),
                    (this.carouselNext = null),
                    (this.customOptions = {}),
                    (this.toggleWrapperModifierEvent = () => this.toggleWrapperModifier()),
                    this.carousel && this.carousel.hasAttribute(eI.recentlyViewHolder)
                        ? this.section.addEventListener("theme:recent-products:added", () => {
                              this.init();
                          })
                        : this.carousel && this.carousel.hasAttribute(eI.relatedHolder)
                          ? this.section.addEventListener("theme:related-products:added", () => {
                                this.init();
                            })
                          : this.init();
            }
            init() {
                this.carousel &&
                    ((this.slidesTotal = this.carousel.querySelectorAll(eI.carouselSlide).length),
                    this.getGridLayout(),
                    this.trackVisibleSlides(),
                    this.carousel.hasAttribute(eI.carouselOptions) &&
                        (this.customOptions = JSON.parse(
                            decodeURIComponent(this.carousel.getAttribute(eI.carouselOptions))
                        )),
                    this.initCarousel(),
                    this.calculatedArrowsTopPosition(),
                    this.toggleWrapperModifier(),
                    document.addEventListener("theme:resize:width", this.toggleWrapperModifierEvent),
                    this.carousel.hasAttribute(eI.carouselWithProgress) && this.progressBarCalculate(),
                    this.carousel.hasAttribute(eI.carouselCustomScrollbar) && new eC(this.container));
            }
            initCarousel() {
                (this.options = {
                    accessibility: !0,
                    contain: !0,
                    freeScroll: !0,
                    prevNextButtons: !0,
                    wrapArround: !1,
                    groupCells: !1,
                    autoPlay: !1,
                    pageDots: !1,
                    cellAlign: window.isRTL ? "right" : "left",
                    rightToLeft: window.isRTL,
                    dragThreshold: 10,
                    arrowShape: { x0: 10, x1: 60, y1: 50, x2: 67.5, y2: 42.5, x3: 25 },
                    on: {
                        ready: () => {
                            this.removeIncorrectAria();
                        },
                        resize: () => {
                            this.toggleArrows(),
                                this.calculatedArrowsTopPosition(),
                                setTimeout(() => {
                                    this.visibleSlides();
                                }, 100);
                        },
                    },
                    ...this.customOptions,
                }),
                    (this.carouselInstance = new s(this.carousel, this.options)),
                    (this.carouselPrev = this.carousel.querySelector(eI.carouselPrev)),
                    (this.carouselNext = this.carousel.querySelector(eI.carouselNext)),
                    this.container.addEventListener("theme:tab:change", () => {
                        this.carouselInstance.resize(),
                            (this.carouselPrev = this.carousel.querySelector(eI.carouselPrev)),
                            (this.carouselNext = this.carousel.querySelector(eI.carouselNext));
                    }),
                    this.carouselInstance.on("dragStart", () => {
                        (this.carouselInstance.slider.style.pointerEvents = "none"), eT.isMobile || this.containDrag();
                    }),
                    this.carouselInstance.on("dragEnd", () => {
                        (this.carouselInstance.slider.style.pointerEvents = "auto"), eT.isMobile || this.containDrag();
                    }),
                    this.carouselInstance.on("change", (e) => this.lockArrows(e)),
                    setTimeout(() => {
                        this.visibleSlides();
                    }, 100),
                    Shopify.designMode &&
                        setTimeout(() => {
                            this.carouselInstance.options.watchCSS &&
                            !this.carousel.classList.contains(eP.flickityEnabled)
                                ? (this.carouselInstance.destroy(),
                                  (this.carouselInstance = new s(this.carousel, this.options)),
                                  this.carouselInstance.resize(),
                                  (this.carouselPrev = this.carousel.querySelector(eI.carouselPrev)),
                                  (this.carouselNext = this.carousel.querySelector(eI.carouselNext)))
                                : this.carouselInstance.resize();
                        }, 10),
                    this.carousel.classList.toggle(
                        eP.flickityStatic,
                        this.smallItems === this.carousel.querySelectorAll(eI.carouselSlide).length
                    ),
                    new eg(this.container);
            }
            calculatedArrowsTopPosition() {
                let e = this.container.querySelector(eI.carouselFirstSlidePhoto),
                    t = this.container.querySelector(eI.pgiFirstSlidePhoto);
                if (t) {
                    let i = t.offsetHeight / 2;
                    this.carousel.style.setProperty("--buttons-top", `${i}px`);
                } else if (e) {
                    let s = e.offsetHeight / 2;
                    this.carousel.style.setProperty("--buttons-top", `${s}px`);
                }
            }
            toggleWrapperModifier() {
                if (!this.wrapper) return;
                let e = Number(
                        getComputedStyle(document.documentElement)
                            .getPropertyValue("--scrollbar-width")
                            .replace("px", "")
                    ),
                    t = this.wrapper.clientWidth;
                (this.wrapperWidthWithGutter = t + e9.additionalOffsetWrapper + e),
                    window.innerWidth >= this.wrapperWidthWithGutter &&
                        (this.wrapper.classList.remove(eP.arrowsForceTop), this.section.classList.add(eP.arrowsOnSide)),
                    window.innerWidth < this.wrapperWidthWithGutter &&
                        (this.wrapper.classList.add(eP.arrowsForceTop), this.section.classList.remove(eP.arrowsOnSide));
            }
            progressBarCalculate() {
                null !== this.carouselInstance &&
                    this.carouselTrack &&
                    this.carouselInstance.on("scroll", (e) => {
                        (e = 100 * Math.max(0, Math.min(1, e)) + "%"), (this.carouselTrack.style.width = e);
                    });
            }
            getGridLayout() {
                (this.largeItems = Number(getComputedStyle(this.carousel).getPropertyValue("--grid-large-items")) || 3),
                    (this.mediumItems =
                        Number(getComputedStyle(this.carousel).getPropertyValue("--grid-medium-items")) ||
                        this.largeItems),
                    (this.smallItems =
                        Number(getComputedStyle(this.carousel).getPropertyValue("--grid-small-items")) ||
                        this.mediumItems ||
                        this.largeItems);
            }
            visibleSlides() {
                if (!this.carousel) return;
                this.getGridLayout();
                let e = this.carousel.clientWidth || this.carouselInstance.size.width,
                    t =
                        null !== this.carouselInstance && this.carouselInstance.selectedElement
                            ? this.carouselInstance.selectedElement.clientWidth
                            : this.carousel.querySelector(eI.carouselSlide).clientWidth,
                    i =
                        null !== this.carouselInstance && this.carouselInstance.slides
                            ? this.carouselInstance.slides.length
                            : this.carousel.querySelectorAll(eI.carouselSlide).length,
                    s = Math.floor(e / t);
                this.section.classList.remove(eP.hiddenArrows),
                    this.carouselPrev &&
                        this.carouselNext &&
                        (this.carouselPrev.classList.remove(eP.hide), this.carouselNext.classList.remove(eP.hide)),
                    window.innerWidth > window.theme.sizes.large &&
                        !this.options.groupCells &&
                        s <= this.largeItems &&
                        i <= this.largeItems &&
                        this.carouselPrev &&
                        this.carouselNext &&
                        this.hideArrows(),
                    window.innerWidth >= window.theme.sizes.medium &&
                        window.innerWidth <= window.theme.sizes.large &&
                        !this.options.groupCells &&
                        s <= this.mediumItems &&
                        i <= this.mediumItems &&
                        this.carouselPrev &&
                        this.carouselNext &&
                        this.hideArrows(),
                    window.innerWidth < window.theme.sizes.medium &&
                        !this.options.groupCells &&
                        s <= this.smallItems &&
                        i <= this.smallItems &&
                        this.carouselPrev &&
                        this.carouselNext &&
                        this.hideArrows();
            }
            trackVisibleSlides() {
                let e = window.matchMedia(`(max-width: ${window.theme.sizes.medium - 1}px)`),
                    t = window.matchMedia(
                        `(min-width: ${window.theme.sizes.medium}px) and (max-width: ${window.theme.sizes.large - 1}px)`
                    ),
                    i = window.matchMedia(`(min-width: ${window.theme.sizes.large}px)`);
                e.addEventListener("change", (e) => {
                    e.matches && (this.slidesVisible = this.smallItems);
                }),
                    e.matches && (this.slidesVisible = this.smallItems),
                    t.addEventListener("change", (e) => {
                        e.matches && (this.slidesVisible = this.mediumItems);
                    }),
                    t.matches && (this.slidesVisible = this.mediumItems),
                    i.addEventListener("change", (e) => {
                        e.matches && (this.slidesVisible = this.largeItems);
                    }),
                    i.matches && (this.slidesVisible = this.largeItems);
            }
            containDrag() {
                let e = this.slidesTotal - this.slidesVisible;
                this.carouselInstance.selectedIndex >= e &&
                    (this.carouselInstance.select(e), this.lockArrows(this.carouselInstance.selectedIndex));
            }
            lockArrows(e) {
                if (this.options.wrapAround || this.options.groupCells) return;
                let t = parseInt(e),
                    i = this.slidesTotal - this.slidesVisible;
                this.carouselNext.disabled = t >= i;
            }
            showArrows() {
                this.carouselPrev.classList.remove(eP.hide),
                    this.carouselNext.classList.remove(eP.hide),
                    this.section.classList.remove(eP.hiddenArrows);
            }
            hideArrows() {
                this.carouselPrev.classList.add(eP.hide),
                    this.carouselNext.classList.add(eP.hide),
                    this.section.classList.add(eP.hiddenArrows);
            }
            toggleArrows() {
                this.carouselPrev &&
                    this.carouselNext &&
                    (this.carouselPrev.disabled && this.carouselNext.disabled ? this.hideArrows() : this.showArrows());
            }
            removeIncorrectAria() {
                let e = this.carousel.querySelectorAll('[aria-hidden="true"]');
                e.forEach((e) => e.removeAttribute("aria-hidden"));
            }
            constructor() {
                super(), (this.container = this);
            }
        };
    customElements.get("flickity-carousel") || customElements.define("flickity-carousel", eM);
    let eD = {
            templateAddresses: "[data-address-wrapper]",
            addressNewForm: "[data-new-address-form]",
            addressNewFormInner: "[new-address-form-inner]",
            btnNew: ".address-new-toggle",
            btnEdit: ".address-edit-toggle",
            btnDelete: ".address-delete",
            classHide: "hide",
            dataFormId: "data-form-id",
            dataConfirmMessage: "data-confirm-message",
            defaultConfirmMessage: "Are you sure you wish to delete this address?",
            editAddress: "#EditAddress",
            addressCountryNew: "AddressCountryNew",
            addressProvinceNew: "AddressProvinceNew",
            addressProvinceContainerNew: "AddressProvinceContainerNew",
            addressCountryOption: ".address-country-option",
            addressCountry: "AddressCountry",
            addressProvince: "AddressProvince",
            addressProvinceContainer: "AddressProvinceContainer",
        },
        eO = class e {
            init() {
                if (this.addressNewForm) {
                    let e = this.section,
                        t = this.addressNewForm.querySelector(eD.addressNewFormInner);
                    this.customerAddresses();
                    let i = e.querySelectorAll(eD.btnNew);
                    i.length &&
                        i.forEach((e) => {
                            e.addEventListener("click", function () {
                                t.classList.toggle(eD.classHide);
                            });
                        });
                    let s = e.querySelectorAll(eD.btnEdit);
                    s.length &&
                        s.forEach((t) => {
                            t.addEventListener("click", function () {
                                let t = this.getAttribute(eD.dataFormId);
                                e.querySelector(`${eD.editAddress}_${t}`).classList.toggle(eD.classHide);
                            });
                        });
                    let r = e.querySelectorAll(eD.btnDelete);
                    r.length &&
                        r.forEach((e) => {
                            e.addEventListener("click", function () {
                                let e = this.getAttribute(eD.dataFormId),
                                    t = this.getAttribute(eD.dataConfirmMessage);
                                confirm(t || eD.defaultConfirmMessage) &&
                                    Shopify.postLink(window.theme.routes.account_addresses_url + "/" + e, {
                                        parameters: { _method: "delete" },
                                    });
                            });
                        });
                }
            }
            customerAddresses() {
                Shopify.CountryProvinceSelector &&
                    new Shopify.CountryProvinceSelector(eD.addressCountryNew, eD.addressProvinceNew, {
                        hideElement: eD.addressProvinceContainerNew,
                    });
                let e = this.section.querySelectorAll(eD.addressCountryOption);
                e.forEach((e) => {
                    let t = e.getAttribute(eD.dataFormId),
                        i = `${eD.addressCountry}_${t}`,
                        s = `${eD.addressProvince}_${t}`,
                        r = `${eD.addressProvinceContainer}_${t}`;
                    new Shopify.CountryProvinceSelector(i, s, { hideElement: r });
                });
            }
            constructor(e) {
                (this.section = e), (this.addressNewForm = this.section.querySelector(eD.addressNewForm)), this.init();
            }
        },
        eF = document.querySelector(eD.templateAddresses);
    eF && new eO(eF),
        document.querySelector("#RecoverPassword") &&
            (function e() {
                var t = {
                    recoverPasswordForm: "#RecoverPassword",
                    hideRecoverPasswordLink: "#HideRecoverPasswordLink",
                };
                function i(e) {
                    e.preventDefault(), s();
                }
                function s() {
                    var e = document.querySelector("#CustomerEmail").value;
                    (document.querySelector("#RecoverEmail").value = e),
                        document.querySelector("#RecoverPasswordForm").classList.toggle("display-none"),
                        document.querySelector("#CustomerLoginForm").classList.toggle("display-none");
                }
                "#recover" === window.location.hash && s(),
                    document.querySelector(".reset-password-success") &&
                        document.querySelector("#ResetSuccess").classList.remove("display-none"),
                    document.querySelector(t.recoverPasswordForm).addEventListener("click", i),
                    document.querySelector(t.hideRecoverPasswordLink).addEventListener("click", i);
            })(),
        (window.Shopify = window.Shopify || {}),
        (window.Shopify.theme = window.Shopify.theme || {}),
        (window.Shopify.theme.sections = window.Shopify.theme.sections || {}),
        (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {}),
        (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);
    let eB = window.Shopify.theme.sections.registered,
        eV = window.Shopify.theme.sections.instances,
        eH = { id: "data-section-id", type: "data-section-type" },
        eW = class e {
            getStack() {
                return this.callStack;
            }
            constructor(e = null, t = []) {
                (this.type = e),
                    (this.components = (function e(t) {
                        if ((void 0 !== t && "object" != typeof t) || null === t)
                            throw TypeError("Theme Sections: The components object provided is not a valid");
                        return t;
                    })(t)),
                    (this.callStack = {
                        onLoad: [],
                        onUnload: [],
                        onSelect: [],
                        onDeselect: [],
                        onBlockSelect: [],
                        onBlockDeselect: [],
                        onReorder: [],
                    }),
                    t.forEach((e) => {
                        for (let [t, i] of Object.entries(e)) {
                            let s = this.callStack[t];
                            Array.isArray(s) && "function" == typeof i
                                ? s.push(i)
                                : (console.warn(`Unregisted function: '${t}' in component: '${this.type}'`),
                                  console.warn(i));
                        }
                    });
            }
        },
        eR = class e {
            callFunctions(e, t = null) {
                this.callStack[e].forEach((e) => {
                    let i = { id: this.id, type: this.type, container: this.container };
                    t ? e.call(i, t) : e.call(i);
                });
            }
            onLoad() {
                this.callFunctions("onLoad");
            }
            onUnload() {
                this.callFunctions("onUnload");
            }
            onSelect(e) {
                this.callFunctions("onSelect", e);
            }
            onDeselect(e) {
                this.callFunctions("onDeselect", e);
            }
            onBlockSelect(e) {
                this.callFunctions("onBlockSelect", e);
            }
            onBlockDeselect(e) {
                this.callFunctions("onBlockDeselect", e);
            }
            onReorder(e) {
                this.callFunctions("onReorder", e);
            }
            constructor(e, t) {
                (this.container = (function e(t) {
                    if (!(t instanceof Element))
                        throw TypeError(
                            "Theme Sections: Attempted to load section. The section container provided is not a DOM element."
                        );
                    if (null === t.getAttribute(eH.id))
                        throw Error(
                            "Theme Sections: The section container provided does not have an id assigned to the " +
                                eH.id +
                                " attribute."
                        );
                    return t;
                })(e)),
                    (this.id = e.getAttribute(eH.id)),
                    (this.type = t.type),
                    (this.callStack = t.getStack());
                try {
                    this.onLoad();
                } catch (i) {
                    console.warn(`Error in section: ${this.id}`), console.warn(this), console.error(i);
                }
            }
        };
    function eN(e, t) {
        if ("string" != typeof e)
            throw TypeError(
                "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered"
            );
        if (void 0 !== eB[e])
            throw Error(
                'Theme Sections: A section of type "' +
                    e +
                    '" has already been registered. You cannot register the same section type twice'
            );
        Array.isArray(t) || (t = [t]);
        let i = new eW(e, t);
        return (eB[e] = i), eB;
    }
    function ez(e, t) {
        (e = eU(e)),
            void 0 === t && (t = document.querySelectorAll("[" + eH.type + "]")),
            (t = e3(t)),
            e.forEach(function (e) {
                let i = eB[e];
                void 0 !== i &&
                    (t = t.filter(function (t) {
                        var s;
                        return (
                            (s = t),
                            !(e0(s).length > 0) &&
                                null !== t.getAttribute(eH.type) &&
                                (t.getAttribute(eH.type) !== e || (eV.push(new eR(t, i)), !1))
                        );
                    }));
            });
    }
    function e0(e) {
        var t = [];
        if (NodeList.prototype.isPrototypeOf(e) || Array.isArray(e)) var i = e[0];
        return (
            e instanceof Element || i instanceof Element
                ? e3(e).forEach(function (e) {
                      t = t.concat(
                          eV.filter(function (t) {
                              return t.container === e;
                          })
                      );
                  })
                : ("string" == typeof e || "string" == typeof i) &&
                  eU(e).forEach(function (e) {
                      t = t.concat(
                          eV.filter(function (t) {
                              return t.type === e;
                          })
                      );
                  }),
            t
        );
    }
    function ej(e) {
        for (var t, i = 0; i < eV.length; i++)
            if (eV[i].id === e) {
                t = eV[i];
                break;
            }
        return t;
    }
    function eU(e) {
        return (
            "*" === e
                ? (e = Object.keys(eB))
                : "string" == typeof e
                  ? (e = [e])
                  : e.constructor === eR
                    ? (e = [e.prototype.type])
                    : Array.isArray(e) &&
                      e[0].constructor === eR &&
                      (e = e.map(function (e) {
                          return e.type;
                      })),
            (e = e.map(function (e) {
                return e.toLowerCase();
            }))
        );
    }
    function e3(e) {
        return (
            NodeList.prototype.isPrototypeOf(e) && e.length > 0
                ? (e = Array.prototype.slice.call(e))
                : NodeList.prototype.isPrototypeOf(e) && 0 === e.length
                  ? (e = [])
                  : null === e
                    ? (e = [])
                    : !Array.isArray(e) && e instanceof Element && (e = [e]),
            e
        );
    }
    function eG(e, t) {
        function i(s) {
            s.target.removeEventListener(s.type, i), void 0 !== t.className && e.classList.remove(t.className);
        }
        (t = t || {}), e.focus(), void 0 !== t.className && e.classList.add(t.className), e.addEventListener("blur", i);
    }
    function e1(e) {
        e = e || {};
        var t = window.location.hash,
            i = document.getElementById(t.slice(1));
        if (i && e.ignore && i.matches(e.ignore)) return !1;
        t && i && eG(i, e);
    }
    function eK(e) {
        var t;
        return (
            (e = e || {}),
            Array.prototype.slice.call(document.querySelectorAll('a[href^="#"]')).filter(function (t) {
                if (
                    "#" === t.hash ||
                    "" === t.hash ||
                    (e.ignore && t.matches(e.ignore)) ||
                    ((i = t.hash.substr(1)), null === document.getElementById(i))
                )
                    return !1;
                var i,
                    s = document.querySelector(t.hash);
                return (
                    !!s &&
                    (t.addEventListener("click", function () {
                        eG(s, e);
                    }),
                    !0)
                );
            })
        );
    }
    function e2(e) {
        return Array.prototype.slice
            .call(
                e.querySelectorAll(
                    "[tabindex],[draggable],a[href],area,button:enabled,input:not([type=hidden]):enabled,object,select:enabled,textarea:enabled[data-focus-element]"
                )
            )
            .filter(function (e) {
                return Boolean(e.offsetWidth || e.offsetHeight || e.getClientRects().length);
            });
    }
    window.Shopify.designMode &&
        (document.addEventListener("shopify:section:load", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector("[" + eH.id + '="' + t + '"]');
            null !== i && ez(i.getAttribute(eH.type), i);
        }),
        document.addEventListener("shopify:section:reorder", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector("[" + eH.id + '="' + t + '"]');
            "object" == typeof e0(i)[0] &&
                (function e(t) {
                    e0(t).forEach(function (e) {
                        e.onReorder();
                    });
                })(i);
        }),
        document.addEventListener("shopify:section:unload", function (e) {
            var t = e.detail.sectionId,
                i = e.target.querySelector("[" + eH.id + '="' + t + '"]');
            "object" == typeof e0(i)[0] &&
                (function e(t) {
                    e0(t).forEach(function (e) {
                        var t = eV
                            .map(function (e) {
                                return e.id;
                            })
                            .indexOf(e.id);
                        eV.splice(t, 1), e.onUnload();
                    });
                })(i);
        }),
        document.addEventListener("shopify:section:select", function (e) {
            var t = ej(e.detail.sectionId);
            "object" == typeof t && t.onSelect(e);
        }),
        document.addEventListener("shopify:section:deselect", function (e) {
            var t = ej(e.detail.sectionId);
            "object" == typeof t && t.onDeselect(e);
        }),
        document.addEventListener("shopify:block:select", function (e) {
            var t = ej(e.detail.sectionId);
            "object" == typeof t && t.onBlockSelect(e);
        }),
        document.addEventListener("shopify:block:deselect", function (e) {
            var t = ej(e.detail.sectionId);
            "object" == typeof t && t.onBlockDeselect(e);
        }));
    var e4 = {};
    function eX(e, t) {
        t = t || {};
        var i = e2(e),
            s = t.elementToFocus || e,
            r = i[0],
            n = i[i.length - 1];
        eY(),
            (e4.focusin = function (t) {
                e !== t.target && !e.contains(t.target) && r && r === t.target && r.focus(),
                    (t.target === e || t.target === n || t.target === r) &&
                        document.addEventListener("keydown", e4.keydown);
            }),
            (e4.focusout = function () {
                document.removeEventListener("keydown", e4.keydown);
            }),
            (e4.keydown = function (t) {
                "Tab" === t.code &&
                    (t.target !== n || t.shiftKey || (t.preventDefault(), r.focus()),
                    (t.target === e || t.target === r) && t.shiftKey && (t.preventDefault(), n.focus()));
            }),
            document.addEventListener("focusout", e4.focusout),
            document.addEventListener("focusin", e4.focusin),
            eG(s, t);
    }
    function eY() {
        document.removeEventListener("focusin", e4.focusin),
            document.removeEventListener("focusout", e4.focusout),
            document.removeEventListener("keydown", e4.keydown);
    }
    var e6 = Object.freeze({
        __proto__: null,
        accessibleLinks: function e(t, i) {
            if ("string" != typeof t) throw TypeError(t + " is not a String.");
            if (0 !== (t = document.querySelectorAll(t)).length) {
                (i = i || {}).messages = i.messages || {};
                var s,
                    r,
                    n,
                    a = {
                        newWindow: i.messages.newWindow || "Opens in a new window.",
                        external: i.messages.external || "Opens external website.",
                        newWindowExternal: i.messages.newWindowExternal || "Opens external website in a new window.",
                    },
                    o = i.prefix || "a11y",
                    l = {
                        newWindow: o + "-new-window-message",
                        external: o + "-external-message",
                        newWindowExternal: o + "-new-window-external-message",
                    };
                t.forEach(function (e) {
                    var t,
                        i = e.getAttribute("target"),
                        s = e.getAttribute("rel"),
                        r = (t = e).hostname !== window.location.hostname,
                        n = "_blank" === i,
                        a = null === s || -1 === s.indexOf("noopener");
                    n && a && e.setAttribute("rel", null === s ? "noopener" : s + " noopener"),
                        r && n
                            ? e.setAttribute("aria-describedby", l.newWindowExternal)
                            : r
                              ? e.setAttribute("aria-describedby", l.external)
                              : n && e.setAttribute("aria-describedby", l.newWindow);
                }),
                    (s = a),
                    (r = document.createElement("ul")),
                    (n = Object.keys(s).reduce(function (e, t) {
                        return e + ("<li id=" + l[t] + ">" + s[t]) + "</li>";
                    }, "")),
                    r.setAttribute("hidden", !0),
                    (r.innerHTML = n),
                    document.body.appendChild(r);
            }
        },
        bindInPageLinks: eK,
        focusHash: e1,
        focusable: e2,
        forceFocus: eG,
        removeTrapFocus: eY,
        trapFocus: eX,
    });
    let eJ = { focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])' };
    function eQ(e) {
        let t = `data-popup-${e}`;
        r.init({
            openTrigger: t,
            disableScroll: !0,
            onShow(e, t, i) {
                i.preventDefault();
                let s = e.querySelector(eJ.focusable);
                eX(e, { elementToFocus: s });
            },
            onClose(e, t, i) {
                i.preventDefault(), eY(), t.focus();
            },
        });
    }
    let e7 = { trigger: "[data-toggle-password-modal]", errors: ".storefront-password-form .errors" },
        e5 = {},
        eZ = class e {
            init() {
                eQ("password"), this.errors && this.trigger.click();
            }
            constructor(e) {
                (this.container = e.container),
                    (this.trigger = this.container.querySelector(e7.trigger)),
                    (this.errors = this.container.querySelector(e7.errors)),
                    this.init();
            }
        };
    eN("password", {
        onLoad() {
            e5[this.id] = new eZ(this);
        },
    }),
        (function () {
            var e = { qrCode: "#QrCode", giftCardCode: ".giftcard__code" };
            let t = document.querySelector(e.qrCode);
            t &&
                window.addEventListener("load", function e() {
                    let i = t.getAttribute("data-identifier");
                    new QRCode(t, { text: i, width: 120, height: 120 });
                });
            let i = document.querySelector(e.giftCardCode);
            i &&
                i.addEventListener(
                    "click",
                    (function e() {
                        var t = document.querySelector("#GiftCardDigits"),
                            i = "";
                        if (document.body.createTextRange)
                            (i = document.body.createTextRange()).moveToElementText(t), i.select();
                        else if (window.getSelection) {
                            var s = window.getSelection();
                            (i = document.createRange()).selectNodeContents(t), s.removeAllRanges(), s.addRange(i);
                        }
                    })()
                );
        })();
    let te = { parallaxWrapper: "[data-parallax-wrapper]", parallaxImg: "[data-parallax-img]" },
        tt = {},
        ti = {
            onLoad() {
                tt[this.id] = [];
                let e = this.container.querySelectorAll(te.parallaxWrapper);
                e.forEach((e) => {
                    let t = e.querySelector(te.parallaxImg);
                    tt[this.id].push(new n(t, { center: !0, round: !0, frame: e }));
                });
            },
            onUnload: function () {
                tt[this.id].forEach((e) => {
                    "function" == typeof e.destroy && e.destroy();
                });
            },
        };
    eN("article", ti);
    let ts = { frame: "[data-ticker-frame]", scale: "[data-ticker-scale]", text: "[data-ticker-text]" },
        tr = { clone: "data-clone", ariaHidden: "aria-hidden" },
        tn = {
            animationClass: "ticker--animated",
            unloadedClass: "ticker--unloaded",
            comparitorClass: "ticker__comparitor",
        },
        ta = {},
        to = class e {
            init() {
                this.addComparitor(), (this.resizeEvent = U(() => this.checkWidth(), 300)), this.listen();
            }
            addComparitor() {
                (this.comparitor = this.text.cloneNode(!0)),
                    this.comparitor.classList.add(tn.comparitorClass),
                    this.frame.appendChild(this.comparitor),
                    this.scale.classList.remove(tn.unloadedClass);
            }
            unload() {
                document.removeEventListener("theme:resize", this.resizeEvent);
            }
            listen() {
                document.addEventListener("theme:resize", this.resizeEvent), this.checkWidth();
            }
            checkWidth() {
                let e = 2 * window.getComputedStyle(this.frame).paddingLeft.replace("px", "");
                if (
                    (Array.from(this.text.parentNode.children).forEach((e) => {
                        e.classList.add(tn.animationClass);
                    }),
                    this.frame.clientWidth - e < this.comparitor.clientWidth || this.stopClone)
                ) {
                    if (
                        1 === this.scale.childElementCount &&
                        ((this.clone = this.text.cloneNode(!0)),
                        this.clone.setAttribute(tr.ariaHidden, !0),
                        this.clone.setAttribute(tr.clone, ""),
                        this.scale.appendChild(this.clone),
                        this.stopClone)
                    )
                        for (let t = 0; t < 10; t++) {
                            let i = this.text.cloneNode(!0);
                            i.setAttribute(tr.ariaHidden, !0), i.setAttribute(tr.clone, ""), this.scale.appendChild(i);
                        }
                    let s = (this.text.clientWidth / this.space) * this.timeIndex;
                    this.scale.style.setProperty("--animation-time", `${s}s`);
                } else {
                    let r = this.scale.querySelector(`[${tr.clone}]`);
                    r && this.scale.removeChild(r), this.text.classList.remove(tn.animationClass);
                }
            }
            constructor(e, t = !1) {
                (this.frame = e),
                    (this.stopClone = t),
                    (this.scale = this.frame.querySelector(ts.scale)),
                    (this.text = this.frame.querySelector(ts.text)),
                    (this.space = 100),
                    (this.timeIndex = 1.63),
                    this.init();
            }
        },
        tl = {
            frame: "[data-ticker-frame]",
            slideValue: "data-slide",
            tickerScale: "[data-ticker-scale]",
            tickerText: "[data-ticker-text]",
        },
        td = { trickerAnimated: "ticker--animated" },
        tc = {},
        th = class e {
            init() {
                this.initTickers(!0);
            }
            initTickers(e = !1) {
                let t = this.container.querySelector(tl.frame);
                t && new to(t, e);
            }
            toggleTicker(e, t) {
                let i = this.container.querySelector(tl.tickerScale),
                    s = this.container.querySelector(`[${tl.slideValue}="${e.detail.blockId}"]`);
                if (s && i) {
                    if (t) {
                        let r = Number(getComputedStyle(s).getPropertyValue("--gutter").replace("px", "")),
                            n = -(s.offsetLeft - r);
                        i.setAttribute("data-stop", ""),
                            i.querySelectorAll(tl.tickerText).forEach((e) => {
                                e.classList.remove(td.trickerAnimated),
                                    (e.style.transform = `translate3d(${n}px, 0, 0)`);
                            });
                    }
                    t ||
                        (i.querySelectorAll(tl.tickerText).forEach((e) => {
                            e.classList.add(td.trickerAnimated), e.removeAttribute("style");
                        }),
                        i.removeAttribute("data-stop"));
                }
            }
            onBlockSelect(e) {
                this.toggleTicker(e, !0);
            }
            onBlockDeselect(e) {
                this.toggleTicker(e, !1);
            }
            constructor(e) {
                (this.container = e.container), this.init();
            }
        };
    eN("logos", {
        onLoad() {
            (tc[this.id] = []), tc[this.id].push(new th(this));
        },
        onBlockSelect(e) {
            tc[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
            });
        },
        onBlockDeselect(e) {
            tc[this.id].forEach((t) => {
                "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
            });
        },
    }),
        eN("blog", ti);
    var tu = {
            drawerWrappper: "[data-drawer]",
            drawerScrolls: "[data-drawer-scrolls]",
            input: "[data-predictive-search-input]",
            underlay: "[data-drawer-underlay]",
            stagger: "[data-stagger-animation]",
            drawerToggle: "data-drawer-toggle",
            firstFocus: "data-first-focus",
            children: ":scope > * > [data-animates]",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        },
        tp = { isVisible: "drawer--visible", displayNone: "display-none" },
        tm = {};
    let tf = class e {
            unload() {}
            connectToggle() {
                this.buttons.forEach((e) => {
                    e.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault(),
                                this.drawer.dispatchEvent(new CustomEvent("theme:drawer:toggle", { bubbles: !1 }));
                        }.bind(this)
                    );
                });
            }
            connectDrawer() {
                this.drawer.addEventListener(
                    "theme:drawer:toggle",
                    function () {
                        this.drawer.classList.contains(tp.isVisible)
                            ? this.drawer.dispatchEvent(new CustomEvent("theme:drawer:close", { bubbles: !1 }))
                            : this.drawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                    }.bind(this)
                ),
                    this.drawer.addEventListener("theme:drawer:close", this.hideDrawer.bind(this)),
                    this.drawer.addEventListener("theme:drawer:open", this.showDrawer.bind(this));
            }
            staggerChildAnimations() {
                this.staggers.forEach((e) => {
                    let t = e.querySelectorAll(tu.children);
                    t.forEach((e, t) => {
                        e.style.transitionDelay = `${50 * t + 10}ms`;
                    });
                });
            }
            closers() {
                this.drawer.addEventListener(
                    "keyup",
                    function (e) {
                        "Escape" === e.code && this.hideDrawer();
                    }.bind(this)
                ),
                    this.underlay.addEventListener(
                        "click",
                        function () {
                            this.hideDrawer();
                        }.bind(this)
                    );
            }
            setFocus() {
                let e = this.drawer.querySelector(tu.firstFocus);
                eX(this.drawer, { elementToFocus: e });
            }
            showDrawer() {
                this.drawer.classList.remove(tp.displayNone),
                    setTimeout(() => {
                        this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                            this.drawer.classList.add(tp.isVisible),
                            document.dispatchEvent(
                                new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.drawerScrolls })
                            ),
                            this.drawer.addEventListener("transitionend", this.setFocus.bind(this), { once: !0 }),
                            this.drawer.addEventListener("transitioncancel", this.setFocus.bind(this), { once: !0 });
                    }, 1);
            }
            hideDrawer() {
                (window.theme.state.cartOpen = !1),
                    this.buttons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                    this.drawer.classList.remove(tp.isVisible),
                    this.drawerScrolls.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                    document.dispatchEvent(new CustomEvent("theme:sliderule:close", { bubbles: !1 })),
                    eY(),
                    this.buttons[0].focus(),
                    setTimeout(() => {
                        this.drawer.classList.contains(tp.isVisible) || this.drawer.classList.add(tp.displayNone);
                    }, 800);
            }
            constructor(e) {
                (this.drawer = e),
                    (this.drawerScrolls = this.drawer.querySelector(tu.drawerScrolls)),
                    (this.underlay = this.drawer.querySelector(tu.underlay)),
                    (this.key = this.drawer.dataset.drawer);
                let t = `[${tu.drawerToggle}='${this.key}']`;
                (this.buttons = document.querySelectorAll(t)),
                    (this.staggers = this.drawer.querySelectorAll(tu.stagger)),
                    this.connectToggle(),
                    this.connectDrawer(),
                    this.closers(),
                    this.staggerChildAnimations();
            }
        },
        tg = {
            onLoad() {
                tm[this.id] = [];
                let e = this.container.querySelectorAll(tu.drawerWrappper);
                e.forEach((e) => {
                    tm[this.id].push(new tf(e));
                });
            },
            onUnload: function () {
                tm[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        ty = {
            announcement: "[data-announcement-bar]",
            transparent: "data-header-transparent",
            header: "[data-header-wrapper] header",
        },
        tv = {
            stuck: "js__header__stuck",
            stuckAnimated: "js__header__stuck--animated",
            triggerAnimation: "js__header__stuck--trigger-animation",
            stuckBackdrop: "js__header__stuck__backdrop",
        },
        tb = {},
        t$ = class e {
            unload() {
                document.removeEventListener("theme:scroll", this.listen),
                    document.removeEventListener("theme:scroll:up", this.scrollUpDirectional),
                    document.removeEventListener("theme:scroll:down", this.scrollDownDirectional);
            }
            listen() {
                (this.sticks || this.animated) &&
                    document.addEventListener("theme:scroll", (e) => {
                        e.detail.down
                            ? (!this.currentlyStuck && e.detail.position > this.stickDown && this.stickSimple(),
                              !this.currentlyBlurred && e.detail.position > this.blur && this.addBlur())
                            : (e.detail.position <= this.stickUp && this.unstickSimple(),
                              e.detail.position <= this.blur && this.removeBlur());
                    }),
                    this.animated &&
                        (document.addEventListener("theme:scroll:up", this.scrollUpDirectional.bind(this)),
                        document.addEventListener("theme:scroll:down", this.scrollDownDirectional.bind(this)));
            }
            stickSimple() {
                this.animated && this.cls.add(tv.stuckAnimated),
                    this.cls.add(tv.stuck),
                    this.wrapper.setAttribute(ty.transparent, !1),
                    (this.currentlyStuck = !0);
            }
            unstickSimple() {
                this.cls.remove(tv.stuck),
                    this.wrapper.setAttribute(ty.transparent, this.transparent),
                    this.animated && this.cls.remove(tv.stuckAnimated),
                    (this.currentlyStuck = !1);
            }
            scrollDownInit() {
                window.scrollY > this.stickDown && this.stickSimple(), window.scrollY > this.blur && this.addBlur();
            }
            stickDirectional() {
                this.cls.add(tv.triggerAnimation);
            }
            unstickDirectional() {
                this.cls.remove(tv.triggerAnimation);
            }
            scrollDownDirectional() {
                this.unstickDirectional();
            }
            scrollUpDirectional() {
                window.scrollY <= this.stickDown ? this.unstickDirectional() : this.stickDirectional();
            }
            addBlur() {
                this.cls.add(tv.stuckBackdrop), (this.currentlyBlurred = !0);
            }
            removeBlur() {
                this.cls.remove(tv.stuckBackdrop), (this.currentlyBlurred = !1);
            }
            constructor(e) {
                (this.wrapper = e),
                    (this.type = this.wrapper.dataset.headerSticky),
                    (this.transparent = this.wrapper.dataset.headerTransparent),
                    (this.sticks = "sticky" === this.type),
                    (this.animated = "directional" === this.type),
                    (this.currentlyStuck = !1),
                    (this.cls = this.wrapper.classList);
                let t = document.querySelector(ty.announcement),
                    i = t ? t.clientHeight : 0,
                    s = document.querySelector(ty.header).clientHeight;
                (this.blur = s + i),
                    (this.stickDown = s + i),
                    (this.stickUp = i),
                    "false" !== this.wrapper.getAttribute(ty.transparent) && (this.blur = i),
                    this.sticks && ((this.stickDown = i), this.scrollDownInit()),
                    this.listen();
            }
        },
        tw = {
            disclosureToggle: "data-hover-disclosure-toggle",
            disclosureWrappper: "[data-hover-disclosure]",
            link: "[data-top-link]",
            wrapper: "[data-header-wrapper]",
            stagger: "[data-stagger]",
            staggerPair: "[data-stagger-first]",
            staggerAfter: "[data-stagger-second]",
            staggerImage: "[data-grid-item], [data-header-image]",
        },
        t8 = { isVisible: "is-visible", meganavVisible: "meganav--visible", grandparent: "grandparent" },
        tS = {},
        tE = {},
        tx = class e {
            onBlockSelect(e) {
                this.disclosure.contains(e.target) && this.showDisclosure();
            }
            onBlockDeselect(e) {
                this.disclosure.contains(e.target) && this.hideDisclosure();
            }
            showDisclosure() {
                this.grandparent
                    ? this.wrapper.classList.add(t8.meganavVisible)
                    : this.wrapper.classList.remove(t8.meganavVisible),
                    this.trigger.setAttribute("aria-expanded", !0),
                    this.trigger.classList.add(t8.isVisible),
                    this.disclosure.classList.add(t8.isVisible);
            }
            hideDisclosure() {
                this.disclosure.classList.remove(t8.isVisible),
                    this.trigger.classList.remove(t8.isVisible),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.wrapper.classList.remove(t8.meganavVisible);
            }
            staggerChildAnimations() {
                let e = this.disclosure.querySelectorAll(tw.stagger);
                e.forEach((e, t) => {
                    e.style.transitionDelay = `${50 * t + 10}ms`;
                });
                let t = this.disclosure.querySelectorAll(tw.staggerPair);
                t.forEach((e, t) => {
                    let i = 150 * t;
                    (e.style.transitionDelay = `${i}ms`),
                        e.parentElement.querySelectorAll(tw.staggerAfter).forEach((e, t) => {
                            e.style.transitionDelay = `${i + 20 * (t + 1)}ms`;
                        });
                });
                let i = this.disclosure.querySelectorAll(tw.staggerImage);
                i.forEach((e, t) => {
                    e.style.transitionDelay = `${(t + 1) * 80}ms`;
                });
            }
            handleTablets() {
                this.trigger.addEventListener(
                    "touchstart",
                    function (e) {
                        let t = this.disclosure.classList.contains(t8.isVisible);
                        t || (e.preventDefault(), this.showDisclosure());
                    }.bind(this),
                    { passive: !0 }
                );
            }
            connectHoverToggle() {
                this.trigger.addEventListener("pointerenter", this.showDisclosure.bind(this)),
                    this.link.addEventListener("focus", this.showDisclosure.bind(this)),
                    this.trigger.addEventListener("pointerleave", this.hideDisclosure.bind(this)),
                    this.trigger.addEventListener(
                        "focusout",
                        function (e) {
                            let t = this.trigger.contains(e.relatedTarget);
                            t || this.hideDisclosure();
                        }.bind(this)
                    ),
                    this.disclosure.addEventListener(
                        "keyup",
                        function (e) {
                            "Escape" === e.code && this.hideDisclosure();
                        }.bind(this)
                    );
            }
            constructor(e) {
                (this.disclosure = e), (this.wrapper = e.closest(tw.wrapper)), (this.key = this.disclosure.id);
                let t = `[${tw.disclosureToggle}='${this.key}']`;
                (this.trigger = document.querySelector(t)),
                    (this.link = this.trigger.querySelector(tw.link)),
                    (this.grandparent = this.trigger.classList.contains(t8.grandparent)),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.connectHoverToggle(),
                    this.handleTablets(),
                    this.staggerChildAnimations();
            }
        },
        tk = {
            item: "[data-main-menu-text-item]",
            wrapper: "[data-text-items-wrapper]",
            text: ".navtext",
            isActive: "data-menu-active",
            sectionOuter: "[data-header-wrapper]",
            underlineCurrent: "data-underline-current",
            defaultItem: ".menu__item.main-menu--active .navtext, .header__desktop__button.main-menu--active .navtext",
        },
        tT = {},
        tL = null,
        t_ = class e {
            init() {
                if (this.itemList.length) {
                    if ((this.listen(), this.listenResize(), (this.textBottom = null), this.setHeight(), tL)) {
                        if (this.defaultItem) {
                            let e = Math.round(this.defaultItem.getBoundingClientRect().left) || 0;
                            this.sectionOuter.style.setProperty("--bar-left", `${e}px`);
                        }
                        this.reset();
                    } else {
                        let t = Math.round(this.sectionOuter.querySelector(tk.item).getBoundingClientRect().left);
                        this.sectionOuter.style.setProperty("--bar-left", `${t}px`),
                            this.sectionOuter.style.setProperty("--bar-width", "0px");
                    }
                    this.sectionOuter.style.setProperty("--bar-opacity", "1");
                }
            }
            unload() {
                document.removeEventListener("theme:resize", this.reset), (tL = null);
            }
            listenResize() {
                document.addEventListener("theme:resize", this.reset.bind(this));
            }
            setDefault() {
                this.defaultItem &&
                    (tL = {
                        left: Math.round(this.defaultItem.getBoundingClientRect().left) || null,
                        width: this.defaultItem.clientWidth || null,
                    });
            }
            setHeight() {
                let e = this.wrapper.clientHeight,
                    t = this.itemList[0].querySelector(tk.text),
                    i = t.clientHeight,
                    s = Math.floor(e / 2 - i / 2) - 4;
                this.textBottom !== s &&
                    (this.sectionOuter.style.setProperty("--bar-text", `${i}px`),
                    this.sectionOuter.style.setProperty("--bar-bottom", `${s}px`),
                    (this.textBottom = s));
            }
            listen() {
                this.itemList.forEach((e) => {
                    e.addEventListener("pointerenter", (e) => {
                        let t = e.target.querySelector(tk.text);
                        this.startBar(t);
                    });
                }),
                    this.wrapper.addEventListener("pointerleave", this.clearBar.bind(this));
            }
            startBar(e) {
                this.setHeight();
                let t = "false" !== this.sectionOuter.getAttribute(tk.isActive),
                    i = Math.round(e.getBoundingClientRect().left),
                    s = e.clientWidth;
                t
                    ? this.render(s, i)
                    : (this.sectionOuter.setAttribute(tk.isActive, !0),
                      this.render(0, i),
                      setTimeout(() => {
                          this.render(s, i);
                      }, 10));
            }
            render(e, t) {
                this.sectionOuter.style.setProperty("--bar-left", `${t}px`),
                    this.sectionOuter.style.setProperty("--bar-width", `${e}px`);
            }
            reset() {
                this.setDefault(),
                    tL && tL.left && tL.width
                        ? (this.sectionOuter.style.setProperty("--bar-left", `${tL.left}px`),
                          this.sectionOuter.style.setProperty("--bar-width", `${tL.width}px`))
                        : this.sectionOuter.style.setProperty("--bar-width", "0px");
            }
            clearBar() {
                this.sectionOuter.setAttribute(tk.isActive, !1),
                    setTimeout(() => {
                        "false" !== this.sectionOuter.getAttribute(tk.isActive) || this.reset();
                    }, 150);
            }
            constructor(e) {
                (this.wrapper = e),
                    (this.itemList = this.wrapper.querySelectorAll(tk.item)),
                    (this.sectionOuter = document.querySelector(tk.sectionOuter)),
                    (this.underlineCurrent = "true" === this.sectionOuter.getAttribute(tk.underlineCurrent)),
                    (this.defaultItem = null),
                    this.underlineCurrent && (this.defaultItem = this.wrapper.querySelector(tk.defaultItem)),
                    this.setDefault(),
                    document.fonts.ready.then(() => {
                        this.init();
                    });
            }
        },
        tA = { price: "data-header-cart-price", count: "data-header-cart-count", dot: "data-header-cart-full" },
        tC = class e {
            listen() {
                document.addEventListener(
                    "theme:cart:change",
                    function (e) {
                        (this.cart = e.detail.cart), this.update();
                    }.bind(this)
                );
            }
            update() {
                this.cart &&
                    (this.prices.forEach((e) => {
                        e.setAttribute(tA.price, this.cart.total_price);
                        let t = a.formatMoney(this.cart.total_price, theme.moneyFormat);
                        e.innerHTML = t;
                    }),
                    this.counts.forEach((e) => {
                        e.setAttribute(tA.count, this.cart.item_count), (e.innerHTML = `(${this.cart.item_count})`);
                    }),
                    this.dots.forEach((e) => {
                        let t = this.cart.item_count > 0;
                        e.setAttribute(tA.dot, t);
                    }));
            }
            constructor(e) {
                (this.section = e),
                    (this.counts = this.section.querySelectorAll(`[${tA.count}]`)),
                    (this.prices = this.section.querySelectorAll(`[${tA.price}]`)),
                    (this.dots = this.section.querySelectorAll(`[${tA.dot}]`)),
                    (this.cart = null),
                    this.listen();
            }
        },
        tq = {
            wrapper: "[data-search-popdown-wrap]",
            popdownTrigger: "data-popdown-toggle",
            close: "[data-close-popdown]",
            input: "[data-predictive-search-input]",
            underlay: "[data-search-underlay]",
        },
        tI = { underlayVisible: "underlay--visible", isVisible: "is-visible" },
        tP = {},
        t9 = class e {
            initTriggerEvents() {
                this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.trigger.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault(), this.showPopdown();
                        }.bind(this)
                    ),
                    this.trigger.addEventListener(
                        "keyup",
                        function (e) {
                            "Space" === e.code && this.showPopdown();
                        }.bind(this)
                    );
            }
            initPopdownEvents() {
                this.popdown.addEventListener(
                    "keyup",
                    function (e) {
                        "Escape" === e.code && this.hidePopdown();
                    }.bind(this)
                ),
                    this.close.addEventListener(
                        "click",
                        function () {
                            this.hidePopdown();
                        }.bind(this)
                    ),
                    this.underlay.addEventListener(
                        "click",
                        function () {
                            this.hidePopdown();
                        }.bind(this)
                    );
            }
            hidePopdown() {
                this.popdown.classList.remove(tI.isVisible),
                    this.underlay.classList.remove(tI.underlayVisible),
                    this.trigger.focus(),
                    eY(),
                    this.popdown.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }));
            }
            showPopdown() {
                this.popdown.classList.add(tI.isVisible),
                    this.underlay.classList.add(tI.underlayVisible),
                    eX(this.popdown, { elementToFocus: this.input }),
                    this.popdown.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
            }
            constructor(e) {
                (this.trigger = e),
                    (this.key = this.trigger.getAttribute(tq.popdownTrigger)),
                    (this.popdown = document.querySelector(`[id='${this.key}']`)),
                    (this.input = this.popdown.querySelector(tq.input)),
                    (this.close = this.popdown.querySelector(tq.close)),
                    (this.wrapper = this.popdown.closest(tq.wrapper)),
                    (this.underlay = this.wrapper.querySelector(tq.underlay)),
                    this.initTriggerEvents(),
                    this.initPopdownEvents();
            }
        },
        tM = {
            wrapper: "[data-product-add-popdown-wrapper]",
            closeDrawer: "[data-close-popdown]",
            apiContent: "[data-api-content]",
            cartAjaxEnabled: '[data-ajax-disable="false"]',
            cartAjaxDisabled: '[data-ajax-disable="true"]',
            cartToggleButton: '[data-drawer-toggle="drawer-cart"]',
            cartDrawer: '[data-drawer="drawer-cart"]',
        },
        tD = { visible: "is-visible", focusEnable: "focus-enabled" },
        tO,
        tF = class e {
            renderPopdown(e) {
                let t = e.detail.variant,
                    i = `${window.theme.routes.root_url}variants/${t.id}/?section_id=api-product-popdown`,
                    s = this;
                o.get(i)
                    .then(function (e) {
                        let t = document.createElement("div");
                        if (
                            ((t.innerHTML = e.data),
                            (s.popdown.innerHTML = t.querySelector(tM.apiContent).innerHTML),
                            s.connectCartButton(),
                            s.connectCloseButton(),
                            document.body.classList.contains(tD.focusEnable))
                        ) {
                            let i = s.popdown.querySelector(tM.cartToggleButton);
                            setTimeout(() => {
                                i.focus();
                            }, 0);
                        }
                    })
                    .catch(function (e) {
                        console.warn(e);
                    });
            }
            connectCloseButton() {
                this.popdown.classList.add(tD.visible);
                let e = this.popdown.querySelector(tM.closeDrawer);
                e.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault(), this.popdown.classList.remove(tD.visible);
                    }.bind(this)
                ),
                    this.popdownTimer();
            }
            connectCartButton() {
                let e = this.popdown.querySelector(tM.cartToggleButton),
                    t = document.querySelector(tM.cartDrawer);
                t &&
                    e.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault(),
                                this.popdown.classList.remove(tD.visible),
                                t.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: !1 }));
                        }.bind(this)
                    );
            }
            popdownTimer() {
                clearTimeout(tO),
                    (tO = setTimeout(() => {
                        this.popdown.contains(document.activeElement)
                            ? this.popdownTimer()
                            : this.popdown.classList.remove(tD.visible);
                    }, 5e3));
            }
            constructor() {
                (this.popdown = document.querySelector(tM.wrapper)),
                    (this.cartAjaxEnabled = document.querySelector(tM.cartAjaxEnabled)),
                    (this.cartAjaxDisabled = document.querySelector(tM.cartAjaxDisabled)),
                    document.addEventListener("theme:cart:popdown", (e) => {
                        this.cartAjaxEnabled
                            ? this.cartAjaxEnabled.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }))
                            : this.cartAjaxDisabled
                              ? window.location.reload()
                              : this.renderPopdown(e);
                    });
            }
        },
        tB = {};
    function tV(e = {}) {
        if ((e.type || (e.type = "json"), e.url))
            return tB[e.url]
                ? tB[e.url]
                : (function e(t, i) {
                      let s = new Promise((e, s) => {
                          if ("text" === i)
                              fetch(t)
                                  .then((e) => e.text())
                                  .then((t) => {
                                      e(t);
                                  })
                                  .catch((e) => {
                                      s(e);
                                  });
                          else {
                              var r, n, a;
                              let o, l, d;
                              (r = t),
                                  (n = function () {
                                      e();
                                  }),
                                  (a = function () {
                                      s();
                                  }),
                                  (o = document.getElementsByTagName("head")[0]),
                                  (l = !1),
                                  ((d = document.createElement("script")).src = r),
                                  (d.onload = d.onreadystatechange =
                                      function () {
                                          l ||
                                          (this.readyState &&
                                              "loaded" != this.readyState &&
                                              "complete" != this.readyState)
                                              ? a()
                                              : ((l = !0), n());
                                      }),
                                  o.appendChild(d);
                          }
                      });
                      return (tB[t] = s), s;
                  })(e.url, e.type);
        if (e.json) {
            if (tB[e.json]) return Promise.resolve(tB[e.json]);
            {
                let t = window
                    .fetch(e.json)
                    .then((e) => e.json())
                    .then((t) => ((tB[e.json] = t), t))
                    .catch((t) => {
                        tB[e.json] = null;
                    });
                return (tB[e.json] = t), t;
            }
        }
        if (!e.name) return Promise.reject();
        {
            let i = "".concat(e.name, e.version);
            return tB[i]
                ? tB[i]
                : (function e(t) {
                      let i = "".concat(t.name, t.version),
                          s = new Promise((e, i) => {
                              try {
                                  window.Shopify.loadFeatures([
                                      {
                                          name: t.name,
                                          version: t.version,
                                          onLoad(t) {
                                              var s, r, n;
                                              (s = e), (r = i), (n = t), n ? r(n) : s();
                                          },
                                      },
                                  ]);
                              } catch (s) {
                                  i(s);
                              }
                          });
                      return (tB[i] = s), s;
                  })(e);
        }
    }
    let tH = { wrapper: "[data-swapper-wrapper]", target: "[data-swapper-target]", hover: "data-swapper-hover" },
        tW = {},
        tR = class e {
            init() {
                this.hovers.forEach((e) => {
                    e.addEventListener(
                        "mouseenter",
                        function () {
                            let t = e.getAttribute(tH.hover);
                            this.target.innerHTML = `${t}`;
                        }.bind(this)
                    );
                }),
                    this.hovers.forEach((e) => {
                        e.addEventListener(
                            "mouseleave",
                            function () {
                                this.target.innerHTML = this.deafaultContent;
                            }.bind(this)
                        );
                    }),
                    this.hovers.forEach((e) => {
                        e.addEventListener(
                            "click",
                            function () {
                                let t = e.getAttribute(tH.hover);
                                this.deafaultContent = `${t}`;
                            }.bind(this)
                        );
                    });
            }
            constructor(e) {
                (this.container = e),
                    (this.target = this.container.querySelector(tH.target)),
                    (this.hovers = this.container.querySelectorAll(`[${tH.hover}]`)),
                    this.target && this.hovers.length && ((this.deafaultContent = this.target.innerHTML), this.init());
            }
        };
    function tN(e) {
        tW[e.id] = [];
        let t = e.querySelectorAll(tH.wrapper);
        t.forEach((t) => {
            tW[e.id].push(new tR(t));
        });
    }
    let tz = {
            swatch: "data-swatch",
            outerGrid: "[data-grid-item]",
            dataGridImageDefault: "data-grid-image-default",
            dataGridImageTarget: "data-grid-image-target",
            image: "data-swatch-image",
            imageId: "data-swatch-image-id",
            variant: "data-swatch-variant",
        },
        t0 = { fade: "is-fade" },
        tj = class e extends HTMLElement {
            init() {
                this.variant &&
                    this.outer &&
                    this.outer.addEventListener("theme:quickview:media", (e) => {
                        e && e.detail && e.detail.media && (this.media = e.detail.media);
                    });
            }
            setStyles() {
                this.colorMatch.hex && this.element.style.setProperty("--swatch", `${this.colorMatch.hex}`),
                    this.colorMatch.path &&
                        (this.element.style.setProperty("background-image", `url(${this.colorMatch.path})`),
                        this.element.style.setProperty("background-size", "cover"));
            }
            replaceImage() {
                if (this.imageReplace && this.imageSlide && this.imageId) {
                    if (
                        this.imageSlide.hasAttribute(tz.dataGridImageTarget) &&
                        this.imageSlide.getAttribute(tz.dataGridImageTarget) !== this.imageId
                    ) {
                        this.imageSlide.classList.add(t0.fade);
                        let e =
                            1e3 *
                            parseFloat(window.getComputedStyle(this.imageSlide).getPropertyValue("animation-duration"));
                        setTimeout(() => {
                            this.imageSlide.classList.remove(t0.fade);
                        }, e);
                    }
                    this.imageSlide.setAttribute(tz.dataGridImageTarget, this.imageId),
                        this.imageSlide.style.setProperty("background-color", "#fff"),
                        this.imageSlide.hasAttribute(tz.dataGridImageDefault) ||
                            this.imageSlide.setAttribute(
                                tz.dataGridImageDefault,
                                window.getComputedStyle(this.imageSlide).backgroundImage
                            ),
                        this.imageSlide.style.setProperty("background-image", this.imageReplace);
                }
            }
            constructor() {
                if (
                    (super(),
                    (this.element = this.querySelector(`[${tz.swatch}]`)),
                    (this.colorString = this.element.getAttribute(tz.swatch)),
                    (this.image = this.element.getAttribute(tz.image)),
                    (this.imageId = this.element.getAttribute(tz.imageId)),
                    (this.variant = this.element.getAttribute(tz.variant)),
                    (this.outer = this.element.closest(tz.outerGrid)),
                    (this.media = null),
                    (this.imageSlide = null),
                    (this.imageDefault = null),
                    (this.stopSlideAnimation = !1),
                    "" != this.element.getAttribute(tz.swatch))
                ) {
                    let e = new (class e {
                        getColor() {
                            return this.match;
                        }
                        init() {
                            let e = tV({ json: window.theme.assets.swatches });
                            return e
                                .then((e) => this.matchColors(e, this.settings.color))
                                .catch((e) => {
                                    console.log("failed to load swatch colors script"), console.log(e);
                                });
                        }
                        matchColors(e, t) {
                            let i = "#E5E5E5",
                                s = null,
                                r = window.theme.assets.base || "/",
                                n = t.toLowerCase().replace(/\s/g, ""),
                                a = e.colors;
                            if (a) {
                                let o = (e) => {
                                        let t = Object.keys(e).toString(),
                                            i = t.toLowerCase().replace(/\s/g, "");
                                        return i === n;
                                    },
                                    l = a.findIndex(o);
                                if (l > -1) {
                                    let d = Object.values(a[l])[0],
                                        c = d.toLowerCase();
                                    c.includes(".jpg") ||
                                    c.includes(".jpeg") ||
                                    c.includes(".png") ||
                                    c.includes(".svg")
                                        ? ((s = `${r}${encodeURIComponent(d)}`), (i = "#888888"))
                                        : (i = d);
                                }
                            }
                            return { color: this.settings.color, path: s, hex: i };
                        }
                        constructor(e = {}) {
                            (this.settings = { color: "ash", ...e }), (this.match = this.init());
                        }
                    })({ color: this.colorString });
                    e.getColor().then((e) => {
                        (this.colorMatch = e), this.setStyles();
                    });
                }
                this.init();
            }
        },
        tU = {
            onLoad() {
                tN(this.container);
            },
        },
        t3 = {
            dataGridItemVariant: "data-grid-item-variant",
            dataGridImageTarget: "data-grid-image-target",
            dataSwatchGridImageIndex: "data-grid-image",
            dataGridImage: "data-grid-image",
            dataSwatchImageId: "data-swatch-image-id",
            dataSwatchIndex: "data-swatch-index",
        },
        tG = class e extends HTMLElement {
            connectedCallback() {
                this.gridItemVariantLinks.length &&
                    this.gridItemVariantLinks.forEach((e) => {
                        e.hasAttribute(t3.dataGridItemVariant) && (this.swatchHoverEvent(e), this.swatchClickEvent(e));
                    });
            }
            swatchHoverEvent(e) {
                e.addEventListener("mouseenter", () => {
                    if (e.hasAttribute(t3.dataGridItemVariant)) {
                        let t = e.getAttribute(t3.dataGridItemVariant);
                        this.container
                            .querySelectorAll(
                                `product-grid-item-variant[${t3.dataGridItemVariant}="${t}"] product-grid-item-image`
                            )
                            .forEach((e) => {
                                e.setAttribute("loading", "eager");
                            });
                    }
                });
            }
            swatchClickEvent(e) {
                e.addEventListener("click", (t) => {
                    if (
                        (t.preventDefault(),
                        this.container
                            .querySelectorAll(`a[${t3.dataGridItemVariant}]`)
                            .forEach((e) => e.removeAttribute("aria-selected")),
                        e.setAttribute("aria-selected", "true"),
                        e.hasAttribute(t3.dataGridItemVariant))
                    ) {
                        let i = e.getAttribute(t3.dataGridItemVariant);
                        this.container
                            .querySelectorAll(`product-grid-item-variant[${t3.dataGridItemVariant}]`)
                            .forEach((e) => {
                                let t = e.getAttribute(t3.dataGridItemVariant);
                                t === i ? e.removeAttribute("hidden") : e.setAttribute("hidden", "");
                            });
                    }
                });
            }
            constructor() {
                super(),
                    (this.container = this),
                    (this.gridItemVariantLinks = this.container.querySelectorAll(`a[${t3.dataGridItemVariant}]`));
            }
        },
        t1 = {
            productGridItemLink: "[data-grid-link]",
            dataGridImages: "data-grid-images",
            dataGridImage: "data-grid-image",
            dataGridImageTarget: "data-grid-image-target",
            dataGridCurrentImage: "data-grid-current-image",
            dataGridPagination: "data-grid-pagination",
            dataGridPage: "data-grid-page",
            dataGridItemVariant: "data-grid-item-variant",
            dataSlideForFilterSelectedVariant: "data-slide-for-filter-selected-variant",
            dataSlideForVariantMedia: "data-slide-for-variant-media",
            dataSlideshowStyle: "data-slideshow-style",
            styleWidth: "--width",
        },
        tK = {
            fade: "is-fade",
            active: "is-active",
            mobile: "is-mobile",
            pagination: "product-grid-item__pagination",
            productGridItemImage: "product-grid-item__image",
        },
        t2 = class e extends HTMLElement {
            static get observedAttributes() {
                return ["hidden"];
            }
            preloadImage(e) {
                if (this.isMobile) return;
                let t = [...this.images][e];
                if (!t) throw Error(`No child element at index ${e}`);
                t.setAttribute("loading", "eager");
            }
            preloadImages() {
                [...this.imagesHolder.children].forEach((e, t) => this.preloadImage(t));
            }
            connectedCallback() {
                this.toggleMobile(),
                    document.addEventListener("theme:resize:width", () => this.toggleMobile()),
                    this.isMobile ||
                        (this.imageCount > 1 &&
                            (this.createPaging(),
                            this.container.addEventListener("theme:swatch:change", this.swatchChangeEvent),
                            this.container.addEventListener("mouseenter", this.mouseEnterEvent),
                            this.container.addEventListener("mouseleave", this.mouseLeaveEvent)),
                        this.intersectionObserver.observe(this.container));
            }
            disconnectedCallback() {
                this.container.removeEventListener("theme:swatch:change", this.swatchChangeEvent),
                    this.container.removeEventListener("mouseenter", this.mouseEnterEvent),
                    this.container.removeEventListener("mouseleave", this.mouseLeaveEvent);
            }
            swatchChangeEvent(e) {
                let t = e.detail.id,
                    i = this.container.querySelector(`[${t1.dataGridImageTarget}="${t}"]`);
                if (i) {
                    let s = i.getAttribute(t1.dataGridImage);
                    (this.pagingProgressCounter = 0),
                        this.changeImage(s),
                        e.detail.stopSlideAnimation && this.stopPaging();
                }
            }
            mouseEnterEvent() {
                switch ((this.preloadImages(), this.slideshowStyle)) {
                    case "cycle_images":
                        (this.pagingProgressPause = this.isMobile), this.progressPaging();
                        break;
                    case "second_immediately":
                        this.changeImage(this.getNextIndex());
                        break;
                    case "disabled":
                        break;
                    default:
                        throw Error(`Unknown option ${this.slideshowStyle}`);
                }
            }
            mouseLeaveEvent() {
                (this.pagingProgressPause = !0), this.resetSlideshow(), this.progressPaging();
            }
            attributeChangedCallback(e, t, i) {
                "hidden" === e && null == t && null != i && this.showVariant();
            }
            toggleMobile() {
                this.container.classList.toggle(tK.mobile, this.isMobile);
            }
            get isMobile() {
                let e = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
                return e < window.theme.sizes.medium;
            }
            resetSlideshow() {
                let e = this.container.querySelector(`[${t1.dataSlideForFilterSelectedVariant}]`);
                if (e) {
                    let t = Number(e.getAttribute(t1.dataGridImage));
                    this.changeImage(t);
                } else this.changeImage(0);
                this.pagingProgressPause = !0;
            }
            showVariant() {
                let e = this.container.querySelector(`[${t1.dataSlideForVariantMedia}]`);
                if (e) {
                    let t = Number(e.getAttribute(t1.dataGridImage));
                    this.changeImage(t);
                } else this.changeImage(0);
                this.pagingProgressPause = !0;
            }
            getNextIndex() {
                let e = this.container.querySelector(`[${t1.dataGridImage}][${t1.dataGridCurrentImage}]`);
                if (!e) return 0;
                {
                    let t = Number(e.getAttribute(t1.dataGridImage)),
                        i = (t + 1) % this.imageCount;
                    return i;
                }
            }
            changeImage(e) {
                let t = this.images[e % this.imageCount];
                t &&
                    (this.activeImages.forEach((e) => e.removeAttribute(t1.dataGridCurrentImage)),
                    t.setAttribute(t1.dataGridCurrentImage, "true"),
                    "cycle_images" === this.slideshowStyle && this.changePaging(e));
            }
            changePaging(e = 0) {
                let t = this.container.querySelector(`[${t1.dataGridPage}].${tK.active}`),
                    i = this.container.querySelector(`[${t1.dataGridPage}="${e}"]`);
                t && (t.style.setProperty(t1.styleWidth, "100%"), t.classList.remove(tK.active)),
                    i && (i.classList.add(tK.active), this.progressPaging());
            }
            progressPaging() {
                let e = this.container.querySelector(`[${t1.dataGridPage}].${tK.active}`);
                e &&
                    !this.isMobile &&
                    (this.stopPaging(),
                    0 === this.pagingProgressCounter && e.style.setProperty(t1.styleWidth, "0%"),
                    (this.interval = setInterval(() => {
                        this.pagingProgressCounter >= 100 && !this.pagingProgressPause
                            ? (this.stopPaging(),
                              (this.pagingProgressCounter = 0),
                              this.changeImage(this.getNextIndex()))
                            : this.pagingProgressPause ||
                              (this.pagingProgressCounter++,
                              e.style.setProperty(t1.styleWidth, `${this.pagingProgressCounter}%`));
                    }, this.timeout / 100)));
            }
            stopPaging() {
                this.interval && clearInterval(this.interval);
            }
            createPaging() {
                if (this.imagesHolder && "cycle_images" === this.slideshowStyle) {
                    let e = "";
                    for (let t = 0; t < this.imageCount; t++) {
                        let i = "";
                        0 === t && (i = `class="${tK.active}"`),
                            (e += `<span ${i} ${t1.dataGridPage}="${t}">${t + 1}</span>`);
                    }
                    if ("" !== e) {
                        let s = this.container.querySelector(`[${t1.dataGridPagination}]`);
                        s ||
                            (((s = document.createElement("div")).className = tK.pagination),
                            s.setAttribute(t1.dataGridPagination, "")),
                            (s.innerHTML = e),
                            this.imagesHolder.parentElement.prepend(s);
                    }
                }
            }
            removePaging() {
                let e = this.container.querySelector(`[${t1.dataGridPagination}]`);
                e && e.remove();
            }
            get imagesHolder() {
                return this.container.querySelector(`[${t1.dataGridImages}]`);
            }
            get images() {
                return this.imagesHolder.querySelectorAll(`[${t1.dataGridImage}]`);
            }
            get activeImages() {
                return this.imagesHolder.querySelectorAll(`[${t1.dataGridImage}][${t1.dataGridCurrentImage}]`);
            }
            get links() {
                return this.container.querySelectorAll(t1.productGridItemLink);
            }
            get slideshowStyle() {
                return this.container.getAttribute(t1.dataSlideshowStyle);
            }
            get imageCount() {
                return this.images.length;
            }
            constructor() {
                super(),
                    (this.container = this),
                    (this.mobileStopSlideshow = "true"),
                    (this.timeout = 1e3 * window.theme.settings.cycle_images_hover_delay || 1500),
                    (this.interval = null),
                    (this.pagingProgressPause = !1),
                    (this.pagingProgressCounter = 0),
                    (this.siblingsFetchCounter = 0),
                    (this.siblingLoadImageIndex = null),
                    (this.intersectionObserver = new IntersectionObserver(
                        (e) => {
                            e.forEach((e) => {
                                e.isIntersecting && this.imageCount > 1 && this.preloadImage(1);
                            });
                        },
                        { threshold: 0.1 }
                    ));
            }
        },
        t4 = { dataGridCurrentImage: "data-grid-current-image" },
        tX = { active: "is-active" },
        tY = class e extends HTMLElement {
            static get observedAttributes() {
                return ["loading", t4.dataGridCurrentImage];
            }
            connectedCallback() {
                null === this.getAttribute(t4.dataGridCurrentImage) ? this.hide() : this.show();
            }
            attributeChangedCallback(e, t, i) {
                switch (e) {
                    case "loading":
                        (null === i || "eager" === i) && this.eagerLoad();
                        break;
                    case t4.dataGridCurrentImage:
                        null === i ? this.hide() : this.show();
                }
            }
            show() {
                this.classList.add(tX.active);
            }
            hide() {
                this.classList.remove(tX.active);
            }
            eagerLoad() {
                let e = this.firstElementChild;
                switch (e.nodeName) {
                    case "TEMPLATE":
                        let t = e,
                            i = t.content;
                        i.querySelectorAll("img").forEach((e) => {
                            e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high");
                        }),
                            t.replaceWith(i);
                        break;
                    case "IMG":
                        e.setAttribute("loading", "eager"), e.setAttribute("fetchpriority", "high");
                }
            }
        },
        t6 = {
            popoutWrapper: "[data-popout]",
            popoutList: "[data-popout-list]",
            popoutListScroll: "data-popout-list-scroll",
            popoutToggle: "data-popout-toggle",
            popoutInput: "[data-popout-input]",
            popoutOptions: "[data-popout-option]",
            popoutPrevent: "data-popout-prevent",
            popoutQuantity: "data-quantity-field",
            dataValue: "data-value",
            ariaExpanded: "aria-expanded",
            ariaCurrent: "aria-current",
        },
        tJ = { listVisible: "popout-list--visible", currentSuffix: "--current" },
        tQ = class e extends HTMLElement {
            unload() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((e) => {
                        e.removeEventListener("theme:popout:click", this.popupOptionsClick.bind(this)),
                            e.removeEventListener("click", this._connectOptionsDispatch.bind(this));
                    }),
                    this.popoutToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                    this.popoutToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)),
                    this.popoutList.removeEventListener("focusout", this.popupListFocusout.bind(this)),
                    this.container.removeEventListener("keyup", this.containerKeyup.bind(this)),
                    this.outsidePopupToggle &&
                        (this.outsidePopupToggle.removeEventListener("click", this.popupToggleClick.bind(this)),
                        this.outsidePopupToggle.removeEventListener("focusout", this.popupToggleFocusout.bind(this)));
            }
            popupToggleClick(e) {
                let t = "true" === e.currentTarget.getAttribute(t6.ariaExpanded);
                e.currentTarget.setAttribute(t6.ariaExpanded, !t),
                    this.popoutList.classList.toggle(tJ.listVisible),
                    this.popupListMaxWidth(),
                    this.popoutList.hasAttribute(t6.popoutListScroll) &&
                        setTimeout(() => {
                            this.popoutList.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                        }, 1);
            }
            popupToggleFocusout(e) {
                let t = this.container.contains(e.relatedTarget);
                t || this._hideList();
            }
            popupListFocusout(e) {
                let t = e.currentTarget.contains(e.relatedTarget),
                    i = this.popoutList.classList.contains(tJ.listVisible);
                i && !t && this._hideList();
            }
            popupListMaxWidth() {
                this.popoutList.style.maxWidth = `${parseInt(document.body.clientWidth - this.popoutList.getBoundingClientRect().left)}px`;
            }
            popupOptionsClick(e) {
                let t = e.target.closest(t6.popoutOptions);
                if ("#" === t.attributes.href.value) {
                    e.preventDefault();
                    let i = "";
                    if (
                        (e.currentTarget.getAttribute(t6.dataValue) && (i = e.currentTarget.getAttribute(t6.dataValue)),
                        (this.popoutInput.value = i),
                        this.popoutPrevent)
                    ) {
                        this.popoutInput.dispatchEvent(new Event("change")),
                            !e.detail.preventTrigger &&
                                this.popoutInput.hasAttribute(t6.popoutQuantity) &&
                                this.popoutInput.dispatchEvent(new Event("input"));
                        let s = this.popoutList.querySelector(`[class*="${tJ.currentSuffix}"]`),
                            r = tJ.currentSuffix;
                        if (s && s.classList.length) {
                            for (let n of s.classList)
                                if (n.includes(tJ.currentSuffix)) {
                                    r = n;
                                    break;
                                }
                        }
                        let a = this.popoutList.querySelector(`.${r}`);
                        a && (a.classList.remove(`${r}`), e.currentTarget.parentElement.classList.add(`${r}`));
                        let o = this.popoutList.querySelector(`[${t6.ariaCurrent}]`);
                        o &&
                            o.hasAttribute(`${t6.ariaCurrent}`) &&
                            (o.removeAttribute(`${t6.ariaCurrent}`),
                            e.currentTarget.setAttribute(`${t6.ariaCurrent}`, "true")),
                            "" !== i &&
                                (this.replaceTextContent(this.popoutToggle, i),
                                this.outsidePopupToggle && this.replaceTextContent(this.outsidePopupToggle, i)),
                            this.popupToggleFocusout(e),
                            this.popupListFocusout(e);
                    } else this._submitForm(i);
                }
            }
            replaceTextContent(e, t) {
                Array.from(e.childNodes).forEach((e) => {
                    e.nodeType === Node.TEXT_NODE && (e.textContent = t);
                });
            }
            updatePopout(e) {
                let t = this.popoutList.querySelector(`[${t6.dataValue}="${this.popoutInput.value}"]`);
                t &&
                    t.dispatchEvent(
                        new CustomEvent("theme:popout:click", {
                            cancelable: !0,
                            bubbles: !0,
                            detail: { preventTrigger: !0 },
                        })
                    );
            }
            containerKeyup(e) {
                "Escape" === e.code && (this._hideList(), this.popoutToggle.focus());
            }
            bodyClick(e) {
                let t = this.container.contains(e.target),
                    i = this.popoutList.classList.contains(tJ.listVisible);
                this.outsidePopupToggle, e.target, i && !t && this._hideList();
            }
            _connectToggle() {
                this.popoutToggle.addEventListener("click", this.popupToggleClick.bind(this)),
                    this.outsidePopupToggle &&
                        this.outsidePopupToggle.addEventListener("click", this.popupToggleClick.bind(this));
            }
            _connectOptions() {
                this.popoutOptions.length &&
                    this.popoutOptions.forEach((e) => {
                        e.addEventListener("theme:popout:click", this.popupOptionsClick.bind(this)),
                            e.addEventListener("click", this._connectOptionsDispatch.bind(this));
                    });
            }
            _connectOptionsDispatch(e) {
                let t = new CustomEvent("theme:popout:click", {
                    cancelable: !0,
                    bubbles: !0,
                    detail: { preventTrigger: !1 },
                });
                e.target.dispatchEvent(t) || e.preventDefault();
            }
            _onFocusOut() {
                this.popoutToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                    this.outsidePopupToggle &&
                        this.outsidePopupToggle.addEventListener("focusout", this.popupToggleFocusout.bind(this)),
                    this.popoutList.addEventListener("focusout", this.popupListFocusout.bind(this)),
                    this.container.addEventListener("keyup", this.containerKeyup.bind(this)),
                    document.body.addEventListener("click", this.bodyClick.bind(this));
            }
            _submitForm(e) {
                let t = this.container.closest("form");
                t && t.submit();
            }
            _hideList() {
                this.popoutList.classList.remove(tJ.listVisible),
                    this.popoutToggle.setAttribute(t6.ariaExpanded, !1),
                    this.outsidePopupToggle && this.outsidePopupToggle.setAttribute(t6.ariaExpanded, !1);
            }
            constructor() {
                super(),
                    (this.container = this.querySelector(t6.popoutWrapper)),
                    (this.popoutList = this.container.querySelector(t6.popoutList)),
                    (this.popoutToggle = this.container.querySelector(`[${t6.popoutToggle}]`)),
                    (this.outsidePopupToggle = document.querySelector(`[${t6.popoutToggle}="${this.popoutList.id}"]`)),
                    (this.popoutInput = this.container.querySelector(t6.popoutInput)),
                    (this.popoutOptions = this.container.querySelectorAll(t6.popoutOptions)),
                    (this.popoutPrevent = "true" === this.container.getAttribute(t6.popoutPrevent)),
                    this._connectOptions(),
                    this._connectToggle(),
                    this._onFocusOut(),
                    this.popupListMaxWidth(),
                    this.popoutInput &&
                        this.popoutInput.hasAttribute(t6.popoutQuantity) &&
                        document.addEventListener("theme:popout:update", this.updatePopout.bind(this)),
                    document.addEventListener("theme:resize", () => {
                        this.popupListMaxWidth();
                    });
            }
        },
        t7 = (e, t = 500, i = !0) => {
            let s = window.getComputedStyle(e).display;
            if (i && "none" !== s) return;
            e.style.removeProperty("display"), "none" === s && (s = "block"), (e.style.display = s);
            let r = e.offsetHeight;
            (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                e.offsetHeight,
                (e.style.boxSizing = "border-box"),
                (e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.height = r + "px"),
                e.style.removeProperty("padding-top"),
                e.style.removeProperty("padding-bottom"),
                e.style.removeProperty("margin-top"),
                e.style.removeProperty("margin-bottom"),
                window.setTimeout(() => {
                    e.style.removeProperty("height"),
                        e.style.removeProperty("overflow"),
                        e.style.removeProperty("transition-duration"),
                        e.style.removeProperty("transition-property"),
                        e.style.removeProperty("transition-timing-function");
                }, t);
        },
        t5 = (e, t = 500) => {
            (e.style.transitionProperty = "height, margin, padding"),
                (e.style.transitionTimingFunction = "cubic-bezier(0.215, 0.61, 0.355, 1)"),
                (e.style.transitionDuration = t + "ms"),
                (e.style.boxSizing = "border-box"),
                (e.style.height = e.offsetHeight + "px"),
                e.offsetHeight,
                (e.style.overflow = "hidden"),
                (e.style.height = 0),
                (e.style.paddingTop = 0),
                (e.style.paddingBottom = 0),
                (e.style.marginTop = 0),
                (e.style.marginBottom = 0),
                window.setTimeout(() => {
                    (e.style.display = "none"),
                        e.style.removeProperty("height"),
                        e.style.removeProperty("padding-top"),
                        e.style.removeProperty("padding-bottom"),
                        e.style.removeProperty("margin-top"),
                        e.style.removeProperty("margin-bottom"),
                        e.style.removeProperty("overflow"),
                        e.style.removeProperty("transition-duration"),
                        e.style.removeProperty("transition-property"),
                        e.style.removeProperty("transition-timing-function");
                }, t);
        },
        tZ = {
            accordionGroup: "[data-accordion-group]",
            accordionToggle: "data-accordion-trigger",
            accordionBody: "[data-accordion-body]",
            accordionBodyMobile: "data-accordion-body-mobile",
            rangeSlider: "data-range-holder",
            section: "[data-section-id]",
        },
        ie = { open: "accordion-is-open" },
        it = {},
        ii = class e {
            mobileAccordions() {
                window.innerWidth < window.theme.sizes.medium
                    ? (this.init(), this.setDefaultState())
                    : (this.resetMobileAccordions(), this.body.removeAttribute("style")),
                    document.addEventListener("theme:resize", () => {
                        window.innerWidth < window.theme.sizes.medium
                            ? (this.init(), this.setDefaultState())
                            : (this.resetMobileAccordions(), this.body.removeAttribute("style"));
                    });
            }
            init() {
                this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.setDefaultState(),
                    this.trigger.addEventListener("click", this.toggleEvent),
                    this.body.addEventListener("keyup", this.keyboardEvent),
                    this.body.addEventListener("theme:accordion:close", this.hideEvent);
            }
            hideEvents() {
                this.hideAccordion();
            }
            clickEvents(e) {
                e.preventDefault(), this.toggleState();
            }
            keyboardEvents(e) {
                "Escape" === e.code && (this.hideAccordion(), this.trigger.focus());
            }
            resetMobileAccordions() {
                this.trigger.removeEventListener("click", this.toggleEvent),
                    this.body.removeEventListener("keyup", this.keyboardEvent),
                    this.body.removeEventListener("theme:accordion:close", this.hideEvent);
            }
            setDefaultState() {
                this.trigger.classList.contains(ie.open) ? ec(this.body) : this.hideAccordion();
            }
            getSiblings() {
                let e = this.body.closest(tZ.section),
                    t = [...e.querySelectorAll(tZ.accordionGroup)],
                    i = t.filter((e) => e.contains(this.body)).shift();
                if (!i) return [];
                {
                    let s = [...i.querySelectorAll(tZ.accordionBody)],
                        r = s.filter((e) => !e.contains(this.body));
                    return r;
                }
            }
            closeSiblings() {
                this.syncBodies.forEach((e) => {
                    e.dispatchEvent(new CustomEvent("theme:accordion:close", { bubbles: !1 }));
                });
            }
            toggleState() {
                this.trigger.classList.contains(ie.open)
                    ? this.hideAccordion()
                    : (this.showAccordion(),
                      this.closeSiblings(),
                      this.body.hasAttribute(tZ.rangeSlider) &&
                          setTimeout(() => {
                              document.dispatchEvent(new CustomEvent("theme:price-range:reset", { bubbles: !1 }));
                          }, 400));
            }
            hideAccordion() {
                this.trigger.classList.remove(ie.open), t5(this.body);
            }
            showAccordion() {
                this.trigger.classList.add(ie.open),
                    t7(this.body),
                    setTimeout(() => {
                        this.checkInViewportAndScrollTo();
                    }, 600);
            }
            checkInViewportAndScrollTo() {
                let e = this.trigger.getBoundingClientRect(),
                    t =
                        (window.pageYOffset || document.documentElement.scrollTop) -
                        (document.documentElement.clientTop || 0),
                    i =
                        e.top >= 0 &&
                        e.left >= 0 &&
                        e.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        e.right <= (window.innerWidth || document.documentElement.clientWidth);
                i || window.scrollTo({ top: t + e.top, left: 0, behavior: "smooth" });
            }
            onBlockSelect(e) {
                this.body.contains(e.target) && this.showAccordion();
            }
            onBlockDeselect(e) {
                this.body.contains(e.target) && this.hideAccordion();
            }
            constructor(e) {
                (this.body = e), (this.key = this.body.id);
                let t = `[${tZ.accordionToggle}='${this.key}']`;
                (this.trigger = document.querySelector(t)),
                    (this.toggleEvent = (e) => this.clickEvents(e)),
                    (this.keyboardEvent = (e) => this.keyboardEvents(e)),
                    (this.hideEvent = () => this.hideEvents()),
                    (this.syncBodies = this.getSiblings()),
                    this.body.hasAttribute(tZ.accordionBodyMobile) ? this.mobileAccordions() : this.init();
            }
        },
        is = {
            onLoad() {
                it[this.id] = [];
                let e = this.container.querySelectorAll(tZ.accordionBody);
                e.forEach((e) => {
                    it[this.id].push(new ii(e));
                });
            },
            onUnload: function () {
                it[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
            onSelect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${tZ.accordionToggle}]`).click();
            },
            onDeselect: function () {
                "accordion-single" === this.type && this.container.querySelector(`[${tZ.accordionToggle}]`).click();
            },
            onBlockSelect(e) {
                it[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                it[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockDeselect(e);
                });
            },
        },
        ir = (e) => {
            e && (e.style.display = "none");
        },
        ia = {
            inputSearch: 'input[type="search"]',
            focusedElements: '[aria-selected="true"] a',
            resetButton: 'button[type="reset"]',
        },
        io = { hidden: "is-hidden" },
        il = class e extends HTMLElement {
            toggleResetButton() {
                let e = this.resetButton.classList.contains(io.hidden);
                this.input.value.length > 0 && e
                    ? this.resetButton.classList.remove(io.hidden)
                    : 0 !== this.input.value.length || e || this.resetButton.classList.add(io.hidden);
            }
            onChange() {
                this.toggleResetButton();
            }
            shouldResetForm() {
                return !document.querySelector(ia.focusedElements);
            }
            onFormReset(e) {
                e.preventDefault(),
                    this.shouldResetForm() &&
                        ((this.input.value = ""),
                        this.toggleResetButton(),
                        e.target.querySelector(ia.inputSearch).focus());
            }
            constructor() {
                super(),
                    (this.input = this.querySelector(ia.inputSearch)),
                    (this.resetButton = this.querySelector(ia.resetButton)),
                    this.input &&
                        (this.input.form.addEventListener("reset", this.onFormReset.bind(this)),
                        this.input.addEventListener(
                            "input",
                            U((e) => {
                                this.onChange(e);
                            }, 300).bind(this)
                        ));
            }
        };
    customElements.define("header-search-form", il);
    let id = {
            allVisibleElements: '[role="option"]',
            ariaSelected: '[aria-selected="true"]',
            predictiveSearch: "predictive-search",
            predictiveSearchResults: "[data-predictive-search-results]",
            predictiveSearchStatus: "[data-predictive-search-status]",
            searchInput: "[data-predictive-search-input]",
            searchResultsLiveRegion: "[data-predictive-search-live-region-count-value]",
            searchResultsGroupsWrapper: "data-search-results-groups-wrapper",
            searchForText: "[data-predictive-search-search-for-text]",
            sectionPredictiveSearch: "#shopify-section-predictive-search",
            selectedLink: '[aria-selected="true"] a',
            selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
            loader: "[data-loading-indicator]",
        },
        ic = class e extends il {
            connectedCallback() {
                this.input.addEventListener("focus", this.onFocus.bind(this)),
                    this.input.form.addEventListener("submit", this.onFormSubmit.bind(this)),
                    this.addEventListener("focusout", this.onFocusOut.bind(this)),
                    this.addEventListener("keyup", this.onKeyup.bind(this)),
                    this.addEventListener("keydown", this.onKeydown.bind(this));
            }
            getQuery() {
                return this.input.value.trim();
            }
            onChange() {
                super.onChange();
                let e = this.getQuery();
                if (!this.searchTerm || !e.startsWith(this.searchTerm)) {
                    var t;
                    null === (t = this.querySelector(id.searchResultsGroupsWrapper)) || void 0 === t || t.remove();
                }
                if ((this.updateSearchForTerm(this.searchTerm, e), (this.searchTerm = e), !this.searchTerm.length)) {
                    this.reset();
                    return;
                }
                this.getSearchResults(this.searchTerm);
            }
            onFormSubmit(e) {
                (!this.getQuery().length || this.querySelector(id.selectedLink)) && e.preventDefault();
            }
            onFormReset(e) {
                super.onFormReset(e),
                    super.shouldResetForm() &&
                        ((this.searchTerm = ""),
                        this.abortController.abort(),
                        (this.abortController = new AbortController()),
                        this.closeResults(!0));
            }
            shouldResetForm() {
                return !document.querySelector(id.selectedLink);
            }
            onFocus() {
                let e = this.getQuery();
                e.length &&
                    (this.searchTerm !== e
                        ? this.onChange()
                        : "true" === this.getAttribute("results")
                          ? this.open()
                          : this.getSearchResults(this.searchTerm));
            }
            onFocusOut() {
                setTimeout(() => {
                    this.contains(document.activeElement) || this.close();
                });
            }
            onKeyup(e) {
                switch ((this.getQuery().length || this.close(!0), e.preventDefault(), e.code)) {
                    case "ArrowUp":
                        this.switchOption("up");
                        break;
                    case "ArrowDown":
                        this.switchOption("down");
                        break;
                    case "Enter":
                        this.selectOption();
                }
            }
            onKeydown(e) {
                ("ArrowUp" === e.code || "ArrowDown" === e.code) && e.preventDefault();
            }
            updateSearchForTerm(e, t) {
                let i = this.querySelector(id.searchForText),
                    s = null == i ? void 0 : i.innerText;
                if (s) {
                    var r;
                    if ((null === (r = s.match(e)) || void 0 === r ? void 0 : r.length) > 1) return;
                    let n = s.replace(e, t);
                    i.innerText = n;
                }
            }
            switchOption(e) {
                if (!this.getAttribute("open")) return;
                let t = "up" === e,
                    i = this.querySelector(id.ariaSelected),
                    s = Array.from(this.querySelectorAll(id.allVisibleElements)).filter((e) => null !== e.offsetParent),
                    r = 0;
                if (t && !i) return;
                let n = -1,
                    a = 0;
                for (; -1 === n && a <= s.length; ) s[a] === i && (n = a), a++;
                if (
                    ((this.statusElement.textContent = ""),
                    !t && i ? (r = n === s.length - 1 ? 0 : n + 1) : t && (r = 0 === n ? s.length - 1 : n - 1),
                    r === n)
                )
                    return;
                let o = s[r];
                o.setAttribute("aria-selected", !0),
                    i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", o.id);
            }
            selectOption() {
                let e = this.querySelector(id.selectedOption);
                e && e.click();
            }
            getSearchResults(e) {
                let t = e.replace(" ", "-").toLowerCase();
                if ((this.setLiveRegionLoadingState(), this.cachedResults[t])) {
                    this.renderSearchResults(this.cachedResults[t]);
                    return;
                }
                ec(this.loader),
                    fetch(
                        `${theme.routes.predictive_search_url}?q=${encodeURIComponent(e)}&section_id=predictive-search`,
                        { signal: this.abortController.signal }
                    )
                        .then(this.handleErrors)
                        .then((e) => e.text())
                        .then((e) => {
                            let i = new DOMParser()
                                .parseFromString(e, "text/html")
                                .querySelector(id.sectionPredictiveSearch).innerHTML;
                            this.allPredictiveSearchInstances.forEach((e) => {
                                e.cachedResults[t] = i;
                            }),
                                this.renderSearchResults(i);
                        })
                        .catch((e) => {
                            console.error(e);
                        })
                        .finally(() => {
                            ir(this.loader);
                        });
            }
            setLiveRegionLoadingState() {
                (this.statusElement = this.statusElement || this.querySelector(id.predictiveSearchStatus)),
                    (this.loadingText = this.loadingText || this.getAttribute("data-loading-text")),
                    this.setLiveRegionText(this.loadingText),
                    this.setAttribute("loading", !0);
            }
            setLiveRegionText(e) {
                this.statusElement.setAttribute("aria-hidden", "false"),
                    (this.statusElement.textContent = e),
                    setTimeout(() => {
                        this.statusElement.setAttribute("aria-hidden", "true");
                    }, 1e3);
            }
            renderSearchResults(e) {
                (this.predictiveSearchResults.innerHTML = e),
                    this.setAttribute("results", !0),
                    this.setLiveRegionResults(),
                    this.open();
            }
            setLiveRegionResults() {
                this.removeAttribute("loading"),
                    this.setLiveRegionText(this.querySelector(id.searchResultsLiveRegion).textContent);
            }
            open() {
                this.setAttribute("open", !0), this.input.setAttribute("aria-expanded", !0), (this.isOpen = !0);
            }
            close(e = !1) {
                this.closeResults(e), (this.isOpen = !1);
            }
            closeResults(e = !1) {
                var t;
                e && ((this.input.value = ""), this.removeAttribute("results"));
                let i = this.querySelector(id.ariaSelected);
                i && i.setAttribute("aria-selected", !1),
                    this.input.setAttribute("aria-activedescendant", ""),
                    this.removeAttribute("loading"),
                    this.removeAttribute("open"),
                    this.input.setAttribute("aria-expanded", !1),
                    null === (t = this.predictiveSearchResults) || void 0 === t || t.removeAttribute("style");
            }
            reset() {
                (this.predictiveSearchResults.innerHTML = ""), (this.input.val = ""), this.a11y.removeTrapFocus();
            }
            handleErrors(e) {
                return e.ok
                    ? e
                    : e.json().then(function (t) {
                          let i = new eh({ status: e.statusText, headers: e.headers, json: t });
                          throw i;
                      });
            }
            constructor() {
                super(),
                    (this.wrapper = this),
                    (this.a11y = e6),
                    (this.abortController = new AbortController()),
                    (this.allPredictiveSearchInstances = document.querySelectorAll(id.predictiveSearch)),
                    (this.cachedResults = {}),
                    (this.input = this.wrapper.querySelector(id.searchInput)),
                    (this.isOpen = !1),
                    (this.predictiveSearchResults = this.querySelector(id.predictiveSearchResults)),
                    (this.searchTerm = ""),
                    (this.loader = this.wrapper.querySelector(id.loader));
            }
        };
    function ih() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    }
    let iu = class e extends il {
            setupEventListeners() {
                let e = [];
                this.allSearchInputs.forEach((t) => e.push(t.form)),
                    this.input.addEventListener("focus", this.onInputFocus.bind(this)),
                    e.length < 2 ||
                        (e.forEach((e) => e.addEventListener("reset", this.onFormReset.bind(this))),
                        this.allSearchInputs.forEach((e) => e.addEventListener("input", this.onInput.bind(this))));
            }
            onFormReset(e) {
                super.onFormReset(e), super.shouldResetForm() && this.keepInSync("", this.input);
            }
            onInput(e) {
                let t = e.target;
                this.keepInSync(t.value, t);
            }
            onInputFocus() {
                ih() >= window.theme.sizes.small || this.scrollIntoView({ behavior: "smooth" });
            }
            keepInSync(e, t) {
                this.allSearchInputs.forEach((i) => {
                    i !== t && (i.value = e);
                });
            }
            constructor() {
                super(),
                    (this.allSearchInputs = document.querySelectorAll('input[type="search"]')),
                    this.setupEventListeners();
            }
        },
        ip = {
            drawer: "data-drawer-scrolls",
            slideruleOpen: "data-sliderule-open",
            slideruleClose: "data-sliderule-close",
            sliderulePane: "data-sliderule-pane",
            slideruleWrappper: "[data-sliderule]",
            dataAnimates: "data-animates",
            children: `:scope > [data-animates],
             :scope > * > [data-animates],
             :scope > * > * >[data-animates],
             :scope .sliderule-grid  > *`,
        },
        im = { isVisible: "is-visible", isHiding: "is-hiding", isHidden: "is-hidden" },
        ig = {},
        iy = class e {
            clickEvents() {
                this.trigger.addEventListener(
                    "click",
                    function () {
                        this.showSliderule();
                    }.bind(this)
                ),
                    this.exit.forEach((e) => {
                        e.addEventListener(
                            "click",
                            function () {
                                this.hideSliderule();
                            }.bind(this)
                        );
                    });
            }
            keyboardEvents() {
                this.trigger.addEventListener(
                    "keyup",
                    function (e) {
                        "Space" === e.code && this.showSliderule();
                    }.bind(this)
                ),
                    this.sliderule.addEventListener(
                        "keyup",
                        function (e) {
                            "Escape" === e.code && (this.hideSliderule(), this.buttons[0].focus());
                        }.bind(this)
                    );
            }
            staggerChildAnimations(e = !1) {
                let t = e ? Array.prototype.slice.call(this.children).slice().reverse() : this.children;
                t.forEach((e, t) => {
                    e.style.transitionDelay = 50 * t + 10 + "ms";
                });
            }
            hideSliderule(e = !1) {
                let t = window.getComputedStyle(this.pane),
                    i = 1e3 * parseFloat(t.getPropertyValue("transition-duration")),
                    s = e ? this.pane.querySelectorAll(`.${im.isVisible}`) : this.children;
                this.pane.style.setProperty("--sliderule-height", "auto"),
                    this.staggerChildAnimations(!0),
                    this.pane.classList.add(im.isHiding),
                    this.sliderule.classList.add(im.isHiding),
                    this.sliderule.classList.remove(im.isVisible),
                    s.forEach((e) => {
                        e.classList.remove(im.isVisible);
                    });
                let r = parseInt(this.pane.dataset.sliderulePane, 10) - 1;
                this.pane.setAttribute(ip.sliderulePane, r);
                let n = e ? `[${ip.dataAnimates}].${im.isHidden}` : `[${ip.dataAnimates}="${r}"].${im.isHidden}`,
                    a = this.pane.querySelectorAll(n);
                a.length &&
                    a.forEach((e) => {
                        e.classList.remove(im.isHidden);
                    }),
                    setTimeout(() => {
                        this.pane.classList.remove(im.isHiding),
                            this.sliderule.classList.remove(im.isHiding),
                            this.staggerChildAnimations();
                    }, i);
            }
            showSliderule() {
                this.pane.style.setProperty("--sliderule-height", "auto"),
                    this.sliderule.classList.add(im.isVisible),
                    this.children.forEach((e) => {
                        e.classList.add(im.isVisible);
                    });
                let e = parseInt(this.pane.dataset.sliderulePane, 10);
                this.pane.setAttribute(ip.sliderulePane, e + 1);
                let t = this.pane.querySelectorAll(`[${ip.dataAnimates}="${e}"]`);
                if (t.length) {
                    let i = 1e3 * parseFloat(window.getComputedStyle(t[0]).getPropertyValue("transition-duration"));
                    setTimeout(() => {
                        t.forEach((e) => {
                            e.classList.add(im.isHidden);
                        });
                    }, i);
                }
                let s = parseInt(this.trigger.nextElementSibling.offsetHeight);
                this.pane.style.setProperty("--sliderule-height", `${s}px`);
                let r = this.drawer.scrollTop,
                    n = this.pane.offsetTop,
                    a = n < r && this.pane.offsetHeight >= this.drawer.offsetHeight;
                a && this.drawer.scrollTo({ top: n, left: 0, behavior: "smooth" });
            }
            closeSliderule() {
                this.pane &&
                    this.pane.hasAttribute(ip.sliderulePane) &&
                    parseInt(this.pane.getAttribute(ip.sliderulePane)) > 0 &&
                    (this.hideSliderule(!0),
                    parseInt(this.pane.getAttribute(ip.sliderulePane)) > 0 &&
                        this.pane.setAttribute(ip.sliderulePane, 0));
            }
            constructor(e) {
                (this.sliderule = e), (this.wrapper = e.closest(ip.wrapper)), (this.key = this.sliderule.id);
                let t = `[${ip.slideruleOpen}='${this.key}']`,
                    i = `[${ip.slideruleClose}='${this.key}']`;
                (this.trigger = document.querySelector(t)),
                    (this.drawer = document.querySelector(`[${ip.drawer}]`)),
                    (this.exit = document.querySelectorAll(i)),
                    (this.pane = document.querySelector(`[${ip.sliderulePane}]`)),
                    (this.children = this.sliderule.querySelectorAll(ip.children)),
                    this.trigger.setAttribute("aria-haspopup", !0),
                    this.trigger.setAttribute("aria-expanded", !1),
                    this.trigger.setAttribute("aria-controls", this.key),
                    this.clickEvents(),
                    this.staggerChildAnimations(),
                    document.addEventListener("theme:sliderule:close", this.closeSliderule.bind(this));
            }
        },
        iv = {
            widthContent: "[data-takes-space]",
            desktop: "[data-header-desktop]",
            cloneClass: "js__header__clone",
            showMobileClass: "js__show__mobile",
            backfill: "[data-header-backfill]",
            transparent: "data-header-transparent",
            overrideBorder: "header-override-border",
            firstSectionHasImage: ".main-content > .shopify-section:first-child [data-overlay-header]",
            preventTransparentHeader: ".main-content > .shopify-section:first-child [data-prevent-transparent-header]",
            deadLink: '.navlink[href="#"]',
        },
        ib = { hasOverlay: "has-overlay" },
        i$ = {},
        iw = class e {
            unload() {
                document.removeEventListener("theme:resize", this.checkWidth);
            }
            checkForImage() {
                this.overlayedImages = document.querySelectorAll(iv.firstSectionHasImage);
                let e = document.querySelectorAll(iv.preventTransparentHeader).length;
                this.overlayedImages.length && !e && this.transparent
                    ? ((document.querySelector(iv.backfill).style.display = "none"), this.listenOverlay())
                    : this.wrapper.setAttribute(iv.transparent, !1),
                    !this.overlayedImages.length ||
                        e ||
                        this.transparent ||
                        (this.wrapper.classList.add(iv.overrideBorder), this.subtractHeaderHeight());
            }
            listenOverlay() {
                document.addEventListener("theme:resize", this.checkWidth.bind(this)),
                    this.subtractAnnouncementHeight();
            }
            listenWidth() {
                document.addEventListener("theme:resize", this.checkWidth.bind(this)), this.checkWidth();
            }
            killDeadLinks() {
                this.deadLinks.forEach((e) => {
                    e.onclick = (e) => {
                        e.preventDefault();
                    };
                });
            }
            subtractAnnouncementHeight() {
                let { windowHeight: e, announcementHeight: t } = V();
                this.overlayedImages.forEach((i) => {
                    i.style.setProperty("--full-screen", `${e - t}px`), i.classList.add(ib.hasOverlay);
                });
            }
            subtractHeaderHeight() {
                let { windowHeight: e, headerHeight: t } = V();
                this.overlayedImages.forEach((i) => {
                    i.style.setProperty("--full-screen", `${e - t}px`);
                });
            }
            checkWidth() {
                document.body.clientWidth < this.minWidth
                    ? this.wrapper.classList.add(iv.showMobileClass)
                    : this.wrapper.classList.remove(iv.showMobileClass);
            }
            getMinWidth() {
                var e;
                let t = this.wrapper.cloneNode(!0);
                t.classList.add(iv.cloneClass), document.body.appendChild(t);
                let i = t.querySelectorAll(iv.widthContent),
                    s = 0,
                    r;
                return (
                    (s =
                        3 === i.length
                            ? (function e(t) {
                                  let i = [];
                                  t.forEach((e) => {
                                      i.push(e.clientWidth);
                                  }),
                                      i[0] > i[2] ? (i[2] = i[0]) : (i[0] = i[2]);
                                  let s = i.reduce((e, t) => e + t);
                                  return s;
                              })(i)
                            : ((e = i),
                              (r = 0),
                              e.forEach((e) => {
                                  r += e.clientWidth;
                              }),
                              r)),
                    document.body.removeChild(t),
                    s + 20 * i.length
                );
            }
            constructor(e) {
                (this.wrapper = e),
                    (this.style = this.wrapper.dataset.style),
                    (this.desktop = this.wrapper.querySelector(iv.desktop)),
                    (this.transparent = "false" !== this.wrapper.getAttribute(iv.transparent)),
                    (this.overlayedImages = document.querySelectorAll(iv.firstSectionHasImage)),
                    (this.deadLinks = document.querySelectorAll(iv.deadLink)),
                    this.killDeadLinks(),
                    "drawer" !== this.style &&
                        this.desktop &&
                        ((this.minWidth = this.getMinWidth()), this.listenWidth()),
                    this.checkForImage(),
                    window.dispatchEvent(new Event("resize")),
                    document.addEventListener("theme:header:check", this.checkForImage.bind(this));
            }
        };
    eN("header", [
        {
            onLoad() {
                i$ = new iw(this.container);
            },
            onUnload: function () {
                "function" == typeof i$.unload && i$.unload();
            },
        },
        tg,
        {
            onLoad() {
                ig[this.id] = [];
                let e = this.container.querySelectorAll(ip.slideruleWrappper);
                e.forEach((e) => {
                    ig[this.id].push(new iy(e));
                });
            },
        },
        {
            onLoad() {
                tb = new t$(this.container);
            },
            onUnload: function () {
                "function" == typeof tb.unload && tb.unload();
            },
        },
        {
            onLoad() {
                (tS[this.id] = []),
                    (tE = this.container.querySelectorAll(tw.disclosureWrappper)).forEach((e) => {
                        tS[this.id].push(new tx(e));
                    });
            },
            onBlockSelect(e) {
                tS[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                tS[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
            onUnload: function () {
                tS[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        {
            onLoad() {
                tT[this.id] = [];
                let e = this.container.querySelectorAll(tk.wrapper);
                e.forEach((e) => {
                    tT[this.id].push(new t_(e));
                });
            },
            onUnload: function () {
                tT[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                }),
                    delete tT[this.id];
            },
        },
        {
            onLoad() {
                new tC(this.container);
            },
        },
        {
            onLoad() {
                tP[this.id] = {};
                let e = this.container.querySelector(`[${tq.popdownTrigger}]`);
                e && (tP[this.id] = new t9(e));
            },
            onUnload: function () {
                "function" == typeof tP[this.id].unload && tP[this.id].unload();
            },
        },
        {
            onLoad() {
                new tF(this);
            },
        },
        tU,
        is,
        {
            onLoad() {
                ta[this.id] = [];
                let e = this.container.querySelectorAll(ts.frame);
                e.forEach((e) => {
                    ta[this.id].push(new to(e));
                });
            },
            onUnload() {
                ta[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", tQ),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY),
        customElements.get("predictive-search") || customElements.define("predictive-search", ic),
        customElements.get("main-search") || customElements.define("main-search", iu);
    let i8 = { newsletterForm: "[data-newsletter-form]" },
        iS = { success: "has-success", error: "has-error" },
        iE = {},
        ix = class e {
            init() {
                this.newsletter.addEventListener("submit", this.newsletterSubmit), this.showMessage();
            }
            newsletterSubmitEvent(e) {
                this.stopSubmit &&
                    (e.preventDefault(),
                    e.stopImmediatePropagation(),
                    this.removeStorage(),
                    this.writeStorage(),
                    (this.stopSubmit = !1),
                    this.newsletter.submit());
            }
            checkForChallengePage() {
                this.isChallengePage = "/challenge" === window.location.pathname;
            }
            writeStorage() {
                void 0 !== this.sessionStorage && this.sessionStorage.setItem("newsletter_form_id", this.newsletter.id);
            }
            readStorage() {
                this.formID = this.sessionStorage.getItem("newsletter_form_id");
            }
            removeStorage() {
                this.sessionStorage.removeItem("newsletter_form_id");
            }
            showMessage() {
                if ((this.readStorage(), this.newsletter.id === this.formID)) {
                    let e = document.getElementById(this.formID);
                    -1 !== window.location.search.indexOf("?customer_posted=true")
                        ? (e.classList.remove(iS.error), e.classList.add(iS.success))
                        : -1 !== window.location.search.indexOf("accepts_marketing") &&
                          (e.classList.remove(iS.success), e.classList.add(iS.error)),
                        this.removeStorage(),
                        this.scrollToForm(e);
                }
            }
            scrollToForm(e) {
                let t = e.getBoundingClientRect(),
                    i =
                        t.top >= 0 &&
                        t.left >= 0 &&
                        t.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                        t.right <= (window.innerWidth || document.documentElement.clientWidth);
                i ||
                    setTimeout(() => {
                        window.scroll({ top: t.top, left: 0, behavior: "smooth" });
                    }, 400);
            }
            unload() {
                this.newsletter.removeEventListener("submit", this.newsletterSubmit);
            }
            constructor(e) {
                (this.sessionStorage = window.sessionStorage),
                    (this.newsletter = e),
                    (this.stopSubmit = !0),
                    (this.isChallengePage = !1),
                    (this.formID = null),
                    this.checkForChallengePage(),
                    (this.newsletterSubmit = (e) => this.newsletterSubmitEvent(e)),
                    this.isChallengePage || this.init();
            }
        },
        ik = {
            onLoad() {
                iE[this.id] = [];
                let e = this.container.querySelectorAll(i8.newsletterForm);
                e.forEach((e) => {
                    iE[this.id].push(new ix(e));
                });
            },
            onUnload() {
                iE[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        iT = {
            shopPayWrapper: "[data-shop-pay-wrapper]",
            shopLoginButton: "shop-login-button",
            shopFollowButton: "shop-follow-button",
            followOnShopButton: "follow-on-shop-button",
            heartIcon: "heart-icon",
            shopLogo: "shop-logo",
        },
        iL = {},
        i_ = class e {
            init() {
                this.shopLoginButton &&
                    this.shopPayWrapper &&
                    ((this.mainButtonStyles = `
      :host {
        --bg-color: ${this.shopPayWrapper.dataset.bg};
        --text-color: ${this.shopPayWrapper.dataset.text};
        --hover-color: ${this.shopPayWrapper.dataset.hover};
      }

      .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--text-color);
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }

      .button {
        background: transparent;
        color: var(--text-color);
      }

      .following-text {
        color: var(--text-color);
      }

      .button--following:focus-visible,
      .button--following:hover {
        background: var(--bg-color);
      }

      .button:not(.button--following):focus-visible .follow-icon-wrapper:before,
      .button:not(.button--following):hover .follow-icon-wrapper:before {
        background: var(--bg-color);
        border-color: var(--hover-color);
      }
    `),
                    (this.svgIconsStyles = `
      :host {
        color: ${this.shopPayWrapper.dataset.text};
      }
    `),
                    customElements.whenDefined(iT.shopLoginButton).then((e) => {
                        requestAnimationFrame(() => {
                            let e = this.shopLoginButton.shadowRoot,
                                t = null == e ? void 0 : e.querySelector(iT.shopFollowButton),
                                i = null == t ? void 0 : t.shadowRoot,
                                s = null == i ? void 0 : i.querySelector(iT.followOnShopButton),
                                r = null == s ? void 0 : s.shadowRoot;
                            r && this.overwriteStyles(r.host.shadowRoot, this.mainButtonStyles);
                            let n = r.querySelector(iT.heartIcon),
                                a = null == n ? void 0 : n.shadowRoot,
                                o = r.querySelector(iT.shopLogo),
                                l = null == o ? void 0 : o.shadowRoot;
                            a && this.overwriteStyles(a.host.shadowRoot, this.svgIconsStyles),
                                l && this.overwriteStyles(l.host.shadowRoot, this.svgIconsStyles);
                        });
                    }));
            }
            overwriteStyles(e, t) {
                let i = document.createElement("style");
                (i.innerHTML = t), e.appendChild(i);
            }
            constructor(e) {
                (this.container = e),
                    (this.shopPayWrapper = document.querySelector(iT.shopPayWrapper)),
                    (this.shopLoginButton = document.querySelector(iT.shopLoginButton)),
                    this.init();
            }
        };
    eN("footer", [
        is,
        ik,
        {
            onLoad() {
                iL[this.id] = new i_(this.container);
            },
        },
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", tQ);
    let iA = {
            cc_load_policy: 1,
            iv_load_policy: 3,
            modestbranding: 1,
            playsinline: 1,
            controls: 1,
            showinfo: 0,
            ecver: 2,
            fs: 1,
            rel: 0,
        },
        iC = { player: "iframe, [data-replace]", videoId: "data-video-id" };
    function iq(e, t) {
        let i = { ...iA, ...t },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(iC.player),
            n = s.querySelector(`[${iC.videoId}]`).getAttribute(iC.videoId);
        tV({ url: "https://www.youtube.com/iframe_api" });
        let a = window.youtubeLoaderPromise
            .then(() => {
                let e = new window.YT.Player(r, {
                    videoId: n,
                    playerVars: { ...i },
                    events: {
                        onStateChange(e) {
                            1 == e.data
                                ? s.dispatchEvent(new CustomEvent("play"))
                                : 2 == e.data && s.dispatchEvent(new CustomEvent("pause"));
                        },
                    },
                });
                return (
                    s.addEventListener("pause", () => {
                        try {
                            e.pauseVideo();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("play", () => {
                        try {
                            e.playVideo
                                ? e.playVideo()
                                : e.addEventListener("onReady", () => {
                                      e.playVideo();
                                  });
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("destroy", () => {
                        try {
                            e.destroy && e.destroy();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    e
                );
            })
            .catch((e) => {
                console.error(e);
            });
        return a;
    }
    window.youtubeLoaderPromise = new Promise((e) => {
        window.onYouTubeIframeAPIReady = function () {
            e();
        };
    });
    let iI = { autoplay: !0, loop: !0, controls: !0, muted: !1, playsinline: !0 },
        iP = { player: "iframe, [data-replace]", videoId: "data-video-id" };
    function i9(e, t) {
        let i = { ...iI, ...t },
            s = document.querySelector(`[data-player="${e}"]`),
            r = s.querySelector(iP.player),
            n = s.querySelector(`[${iP.videoId}]`).getAttribute(iP.videoId),
            a = tV({ url: "https://player.vimeo.com/api/player.js" }),
            o = `select-${e}`;
        r.setAttribute("id", o);
        let l = a
            .then(() => {
                let e = new window.Vimeo.Player(o, { ...i, id: n });
                return (
                    e.on("play", () => {
                        s.dispatchEvent(new CustomEvent("play"));
                    }),
                    e.on("pause", () => {
                        s.dispatchEvent(new CustomEvent("pause"));
                    }),
                    s.addEventListener("pause", () => {
                        try {
                            e.pause && e.pause();
                        } catch (t) {
                            console.warn(t);
                        }
                    }),
                    s.addEventListener("play", () => {
                        e.play &&
                            e.getPaused().then((t) => {
                                t && e.play();
                            });
                    }),
                    s.addEventListener("destroy", () => {
                        try {
                            e.destroy && e.destroy();
                        } catch (t) {
                            console.log(t);
                        }
                    }),
                    e
                );
            })
            .catch((e) => {
                console.error(e);
            });
        return l;
    }
    let iM = {
            videoPopup: "[data-video-popup]",
            videoAutoplay: "[data-video-autoplay]",
            attrUnique: "data-unique",
            attrVideoId: "data-video-id",
            attrVideoType: "data-video-type",
            attrPlayer: "data-player",
        },
        iD = class e {
            init() {
                this.triggers.forEach((e) => {
                    let t = e.getAttribute(iM.attrUnique),
                        i = e.getAttribute(iM.attrVideoId),
                        s = e.getAttribute(iM.attrVideoType),
                        n = `${i}-${t}`,
                        a = document.querySelector(`[${iM.attrPlayer}="${n}"]`);
                    r.init({
                        onShow: () => {
                            this.backgroundVideo &&
                                "function" == typeof this.backgroundVideo.pause &&
                                this.backgroundVideo.pause();
                            let e = {};
                            "youtube" === s ? (e = iq(n)) : "vimeo" === s && (e = i9(n)),
                                e.then(() => {
                                    a.dispatchEvent(new CustomEvent("play"));
                                });
                        },
                        onClose: (e, t, i) => {
                            i.preventDefault(),
                                a.dispatchEvent(new CustomEvent("destroy")),
                                this.backgroundVideo &&
                                    "function" == typeof this.backgroundVideo.play &&
                                    this.backgroundVideo.play();
                        },
                        openTrigger: `data-trigger-${i}-${t}`,
                    });
                });
            }
            constructor(e) {
                (this.container = e.container),
                    (this.triggers = this.container.querySelectorAll(iM.videoPopup)),
                    (this.backgroundVideo = this.container.querySelector(iM.videoAutoplay)),
                    this.init();
            }
        },
        iO = {
            onLoad() {
                new iD(this);
            },
        },
        iF = { button: "[data-scroll-down]" },
        iB = class e {
            init() {
                let e = this.wrapper.querySelectorAll(iF.button);
                e &&
                    e.forEach((e) => {
                        e.addEventListener("click", this.scroll.bind(this));
                    });
            }
            scroll() {
                let e = this.wrapper.offsetTop + this.wrapper.clientHeight;
                window.scroll({ top: e, left: 0, behavior: "smooth" });
            }
            constructor(e) {
                (this.wrapper = e), this.init();
            }
        },
        iV = {
            onLoad() {
                this.scrollButton = new iB(this.container);
            },
            onUnload: function () {
                delete this.scrollButton;
            },
        };
    eN("video", [ti, iV, iO]), eN("page-faq", is), eN("hero", [ti, iV, eq]);
    let iH = {
            slider: "[data-slider]",
            photo: "[data-grid-slide]",
            wrapper: "[data-wrapper]",
            carouselCustomScrollbar: "data-custom-scrollbar-items",
        },
        iW = { wrapper: "wrapper", wrapperModifier: "wrapper--full", hide: "hide" },
        iR = { scrollbarWidth: window.innerWidth - document.documentElement.clientWidth, additionalOffsetWrapper: 112 },
        iN = {},
        iz = class e {
            init() {
                let e = this,
                    t = {
                        initialIndex: 0,
                        accessibility: !0,
                        autoPlay: !1,
                        contain: !0,
                        pageDots: this.pageDots,
                        adaptiveHeight: !1,
                        wrapAround: !1,
                        groupCells: !1,
                        cellAlign: "left",
                        freeScroll: !0,
                        prevNextButtons: !0,
                        draggable: !0,
                        rightToLeft: window.isRTL,
                        watchCSS: !0,
                        arrowShape: { x0: 10, x1: 60, y1: 50, x2: 67.5, y2: 42.5, x3: 25 },
                        on: {
                            ready: function () {
                                e.removeIncorrectAria();
                            },
                        },
                    };
                (this.flkty = new s(this.slideshow, t)),
                    this.container.addEventListener("theme:tab:change", () => {
                        this.flkty.resize();
                    }),
                    this.toggleWrapperModifier(),
                    document.addEventListener("theme:resize:width", this.toggleWrapperModifier.bind(this)),
                    this.slideshow.hasAttribute(iH.carouselCustomScrollbar) && new eC(this.container),
                    new eg(this.container);
            }
            toggleWrapperModifier() {
                this.wrapper.classList.contains(iW.wrapper) &&
                    this.wrapper.classList.toggle(iW.wrapperModifier, this.wrapperWidthWithGutter >= window.innerWidth);
            }
            removeIncorrectAria() {
                let e = this.slideshow.querySelectorAll('[aria-hidden="true"]');
                e.forEach((e) => e.removeAttribute("aria-hidden"));
            }
            onUnload() {
                this.slideshow && this.flkty && ((this.flkty.options.watchCSS = !1), this.flkty.destroy());
            }
            constructor(e, t) {
                if (
                    ((this.container = e),
                    (this.slideshow = t),
                    (this.wrapper = this.container.querySelector(iH.wrapper)),
                    (this.wrapperWidth = Number(
                        getComputedStyle(document.documentElement).getPropertyValue("--LAYOUT-WIDTH").replace("px", "")
                    )),
                    (this.wrapperWidthWithGutter = this.wrapperWidth + iR.additionalOffsetWrapper + iR.scrollbarWidth),
                    (this.pageDots = "true" === this.slideshow.getAttribute("data-show-dots")),
                    (this.firstPhoto = this.container.querySelector(iH.photo)),
                    this.firstPhoto)
                ) {
                    let i = this.firstPhoto.offsetHeight / 2;
                    this.slideshow.style.setProperty("--buttons-top", `${i}px`);
                }
                if (!this.slideshow) return;
                (this.flkty = null), this.init();
            }
        },
        i0 = {
            onLoad() {
                iN[this.id] = [];
                let e = this.container.querySelectorAll(iH.slider);
                e.forEach((e) => {
                    iN[this.id].push(new iz(this.container, e));
                });
            },
            onUnload(e) {
                iN[this.id].forEach((t) => {
                    "function" == typeof t.onUnload && t.onUnload(e);
                });
            },
        };
    eN("custom-content", [ti, iO, tU, i0]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY);
    let ij = [],
        iU = {
            wrapper: "[data-slideshow-wrapper]",
            speed: "data-slideshow-speed",
            autoplay: "data-slideshow-autoplay",
            slideCount: "data-slideshow-slides",
            prevButton: "[data-slide-custom-prev]",
            nextButton: "[data-slide-custom-next]",
            slideshoIndex: "data-slideshow-index",
        },
        i3 = { isEnable: "flickity-enabled" },
        iG = class e {
            init() {
                let e = {
                    autoPlay: !!this.autoplay && !!this.speed && parseInt(this.speed),
                    contain: !1,
                    pageDots: !0,
                    adaptiveHeight: !0,
                    accessibility: !0,
                    wrapAround: 2 !== this.slideCount,
                    prevNextButtons: !1,
                    draggable: !0,
                    fade: !0,
                    rightToLeft: window.isRTL,
                };
                (this.flkty = new t(this.wrapper, e)),
                    this.prevButtons.length &&
                        this.prevButtons.forEach((e) => {
                            e.onclick = () => {
                                this.flkty.previous(!0, !1);
                            };
                        }),
                    this.nextButtons.length &&
                        this.nextButtons.forEach((e) => {
                            e.onclick = () => {
                                this.flkty.next(!0, !1);
                            };
                        }),
                    document.addEventListener("theme:scroll", this.scrollEvent);
            }
            scrollEvents() {
                if (this.flkty && this.autoplay && this.speed) {
                    let e = this.flkty.element,
                        t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                    window.pageYOffset > t
                        ? "playing" === this.flkty.player.state && this.flkty.pausePlayer()
                        : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                }
            }
            unload() {
                document.removeEventListener("theme:scroll", this.scrollEvent),
                    this.flkty && this.wrapper && this.wrapper.classList.contains(i3.isEnable) && this.flkty.destroy();
            }
            onBlockSelect(e) {
                let t = e.target.closest(`[${iU.slideshoIndex}]`),
                    i = t.getAttribute(iU.slideshoIndex),
                    s = parseInt(i);
                this.flkty.selectCell(s), this.flkty.stopPlayer();
            }
            onBlockDeselect() {
                this.autoplay && this.flkty.playPlayer();
            }
            constructor(e) {
                (this.container = e.container),
                    (this.wrapper = e.container.querySelector(iU.wrapper)),
                    (this.speed = this.wrapper.getAttribute(iU.speed)),
                    (this.autoplay = "true" === this.wrapper.getAttribute(iU.autoplay)),
                    (this.slideCount = parseInt(this.wrapper.getAttribute(iU.slideCount), 10)),
                    (this.prevButtons = this.wrapper.querySelectorAll(iU.prevButton)),
                    (this.nextButtons = this.wrapper.querySelectorAll(iU.nextButton)),
                    (this.flkty = null),
                    (this.scrollEvent = () => this.scrollEvents()),
                    this.init();
            }
        };
    eN("slideshow", [
        {
            onLoad() {
                ij[this.id] = new iG(this);
            },
            onUnload() {
                "function" == typeof ij[this.id].unload && ij[this.id].unload();
            },
            onBlockSelect(e) {
                "function" == typeof ij[this.id].onBlockSelect && ij[this.id].onBlockSelect(e);
            },
            onBlockDeselect(e) {
                "function" == typeof ij[this.id].onBlockSelect && ij[this.id].onBlockDeselect(e);
            },
        },
        ti,
        iV,
    ]);
    let i1 = {
            rangeSlider: "[data-range-slider]",
            rangeDotLeft: "[data-range-left]",
            rangeDotRight: "[data-range-right]",
            rangeLine: "[data-range-line]",
            rangeHolder: "[data-range-holder]",
            dataMin: "data-se-min",
            dataMax: "data-se-max",
            dataMinValue: "data-se-min-value",
            dataMaxValue: "data-se-max-value",
            dataStep: "data-se-step",
            dataFilterUpdate: "data-range-filter-update",
            priceMin: "[data-field-price-min]",
            priceMax: "[data-field-price-max]",
        },
        iK = { isInitialized: "is-initialized" },
        i2 = class e {
            init() {
                this.setDefaultValues(),
                    this.touchLeft.addEventListener("mousedown", this.onStartEvent),
                    this.touchRight.addEventListener("mousedown", this.onStartEvent),
                    this.touchLeft.addEventListener("touchstart", this.onStartEvent),
                    this.touchRight.addEventListener("touchstart", this.onStartEvent),
                    this.slider.classList.add(iK.isInitialized);
            }
            setDefaultValues() {
                let e = this.min;
                this.slider.hasAttribute(i1.dataMinValue) &&
                    (e = parseFloat(this.slider.getAttribute(i1.dataMinValue)));
                let t = this.max;
                this.slider.hasAttribute(i1.dataMaxValue) &&
                    (t = parseFloat(this.slider.getAttribute(i1.dataMaxValue))),
                    e < this.min && (e = this.min),
                    t > this.max && (t = this.max),
                    e > t && (e = t),
                    this.slider.getAttribute(i1.dataStep) &&
                        (this.step = Math.abs(parseFloat(this.slider.getAttribute(i1.dataStep)))),
                    this.reset(),
                    (this.maxX = this.slider.offsetWidth - this.touchRight.offsetWidth),
                    (this.selectedTouch = null),
                    (this.initialValue = this.lineSpan.offsetWidth - this.normalizeFact),
                    this.setMinValue(e),
                    this.setMaxValue(t);
            }
            reset() {
                (this.touchLeft.style.left = "0px"),
                    (this.touchRight.style.left = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                    (this.lineSpan.style.marginLeft = "0px"),
                    (this.lineSpan.style.width = this.slider.offsetWidth - this.touchLeft.offsetWidth + "px"),
                    (this.startX = 0),
                    (this.x = 0);
            }
            setMinValue(e) {
                let t = (e - this.min) / (this.max - this.min);
                (this.touchLeft.style.left =
                    Math.ceil(t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact))) +
                    "px"),
                    (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                    (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                    this.slider.setAttribute(i1.dataMinValue, e);
            }
            setMaxValue(e) {
                let t = (e - this.min) / (this.max - this.min);
                (this.touchRight.style.left =
                    Math.ceil(
                        t * (this.slider.offsetWidth - (this.touchLeft.offsetWidth + this.normalizeFact)) +
                            this.normalizeFact
                    ) + "px"),
                    (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                    (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                    this.slider.setAttribute(i1.dataMaxValue, e);
            }
            onStart(e) {
                e.preventDefault();
                let t = e;
                e.touches && (t = e.touches[0]),
                    e.currentTarget === this.touchLeft
                        ? (this.x = this.touchLeft.offsetLeft)
                        : e.currentTarget === this.touchRight && (this.x = this.touchRight.offsetLeft),
                    (this.startX = t.pageX - this.x),
                    (this.selectedTouch = e.currentTarget),
                    document.addEventListener("mousemove", this.onMoveEvent),
                    document.addEventListener("mouseup", this.onStopEvent),
                    document.addEventListener("touchmove", this.onMoveEvent),
                    document.addEventListener("touchend", this.onStopEvent);
            }
            onMove(e) {
                let t = e;
                if (
                    (e.touches && (t = e.touches[0]),
                    (this.x = t.pageX - this.startX),
                    this.selectedTouch === this.touchLeft
                        ? (this.x > this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10
                              ? (this.x = this.touchRight.offsetLeft - this.selectedTouch.offsetWidth + 10)
                              : this.x < 0 && (this.x = 0),
                          (this.selectedTouch.style.left = this.x + "px"))
                        : this.selectedTouch === this.touchRight &&
                          (this.x < this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10
                              ? (this.x = this.touchLeft.offsetLeft + this.touchLeft.offsetWidth - 10)
                              : this.x > this.maxX && (this.x = this.maxX),
                          (this.selectedTouch.style.left = this.x + "px")),
                    (this.lineSpan.style.marginLeft = this.touchLeft.offsetLeft + "px"),
                    (this.lineSpan.style.width = this.touchRight.offsetLeft - this.touchLeft.offsetLeft + "px"),
                    this.calculateValue(),
                    this.slider.getAttribute("on-change"))
                ) {
                    let i = Function("min, max", this.slider.getAttribute("on-change"));
                    i(this.slider.getAttribute(i1.dataMinValue), this.slider.getAttribute(i1.dataMaxValue));
                }
                this.onChange(this.slider.getAttribute(i1.dataMinValue), this.slider.getAttribute(i1.dataMaxValue));
            }
            onStop(e) {
                document.removeEventListener("mousemove", this.onMoveEvent),
                    document.removeEventListener("mouseup", this.onStopEvent),
                    document.removeEventListener("touchmove", this.onMoveEvent),
                    document.removeEventListener("touchend", this.onStopEvent),
                    (this.selectedTouch = null),
                    this.calculateValue(),
                    this.onChanged(
                        this.slider.getAttribute(i1.dataMinValue),
                        this.slider.getAttribute(i1.dataMaxValue)
                    );
            }
            onChange(e, t) {
                let i = this.slider.closest(i1.rangeHolder);
                if (i) {
                    let s = i.querySelector(i1.priceMin),
                        r = i.querySelector(i1.priceMax);
                    s && r && ((s.value = e), (r.value = t));
                }
            }
            onChanged(e, t) {
                this.slider.hasAttribute(i1.dataFilterUpdate) &&
                    this.slider.dispatchEvent(new CustomEvent("theme:range:update", { bubbles: !0 }));
            }
            calculateValue() {
                let e = (this.lineSpan.offsetWidth - this.normalizeFact) / this.initialValue,
                    t = this.lineSpan.offsetLeft / this.initialValue,
                    i = t + e;
                if (
                    ((t = t * (this.max - this.min) + this.min),
                    (i = i * (this.max - this.min) + this.min),
                    0 !== this.step)
                ) {
                    let s = Math.floor(t / this.step);
                    (t = this.step * s), (s = Math.floor(i / this.step)), (i = this.step * s);
                }
                this.selectedTouch === this.touchLeft && this.slider.setAttribute(i1.dataMinValue, t),
                    this.selectedTouch === this.touchRight && this.slider.setAttribute(i1.dataMaxValue, i);
            }
            constructor(e) {
                (this.container = e.container),
                    (this.slider = e.querySelector(i1.rangeSlider)),
                    this.slider &&
                        ((this.onMoveEvent = (e) => this.onMove(e)),
                        (this.onStopEvent = (e) => this.onStop(e)),
                        (this.onStartEvent = (e) => this.onStart(e)),
                        (this.startX = 0),
                        (this.x = 0),
                        (this.touchLeft = this.slider.querySelector(i1.rangeDotLeft)),
                        (this.touchRight = this.slider.querySelector(i1.rangeDotRight)),
                        (this.lineSpan = this.slider.querySelector(i1.rangeLine)),
                        (this.min = parseFloat(this.slider.getAttribute(i1.dataMin))),
                        (this.max = parseFloat(this.slider.getAttribute(i1.dataMax))),
                        (this.step = 0),
                        (this.normalizeFact = 26),
                        this.init(),
                        document.addEventListener("theme:price-range:reset", () => {
                            this.setDefaultValues();
                        }));
            }
        },
        i4 = (e, t) => {
            let i, s;
            return function r(...n) {
                let a = Date.now();
                (s = clearTimeout(s)),
                    !i || a - i >= t ? (e.apply(null, n), (i = a)) : (s = setTimeout(r.bind(null, ...n), t - (a - i)));
            };
        },
        iX = {
            filtersWrappper: "data-filters",
            underlay: "[data-filters-underlay]",
            filtersHideDesktop: "data-default-hide",
            filtersToggle: "data-filters-toggle",
            focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
            groupHeading: "data-group-heading",
            showMore: "data-show-more",
        },
        iY = {
            show: "drawer--visible",
            defaultVisible: "filters--default-visible",
            hide: "hidden",
            expand: "is-expanded",
            hidden: "is-hidden",
            focusEnable: "focus-enabled",
        },
        i6 = {},
        iJ = class e {
            unload() {
                this.filtersToggleButtons.length &&
                    this.filtersToggleButtons.forEach((e) => {
                        e.removeEventListener("click", this.connectToggleMemory);
                    }),
                    this.showMoreButtons.length &&
                        this.showMoreButtons.forEach((e) => {
                            e.removeEventListener("click", this.connectShowHiddenOptions);
                        });
            }
            expandingEvents() {
                this.showMoreButtons.length &&
                    this.showMoreButtons.forEach((e) => {
                        e.addEventListener("click", i4(this.connectShowHiddenOptions, 500));
                    });
            }
            showHiddenOptions(e) {
                let t = e.target.hasAttribute(iX.showMore) ? e.target : e.target.closest(`[${iX.showMore}]`);
                t.classList.add(iY.hidden),
                    t.previousElementSibling.querySelectorAll(`.${iY.hidden}`).forEach((e) => {
                        e.classList.remove(iY.hidden);
                    });
            }
            connectToggle(e = !1) {
                this.filtersToggleButtons.forEach((t) => {
                    let i = null !== t.closest(`[${iX.filtersWrappper}]`);
                    ((i && e) || (i && !e) || (!i && !e)) &&
                        t.addEventListener("click", this.connectToggleMemory.bind(this));
                });
            }
            connectToggleFunction(e) {
                let t = "true" === e.currentTarget.getAttribute("aria-expanded");
                t ? this.hideFilters() : this.showFilters();
            }
            onFocusOut() {
                this.container.addEventListener(
                    "focusout",
                    function (e) {
                        if (window.innerWidth >= window.theme.sizes.medium) return;
                        let t = e.currentTarget.contains(e.relatedTarget),
                            i = this.container.classList.contains(iY.show),
                            s = document.body.classList.contains(iY.focusEnable);
                        s && i && !t && this.hideFilters();
                    }.bind(this)
                ),
                    this.container.addEventListener(
                        "keyup",
                        function (e) {
                            "Escape" === e.code && (this.hideFilters(), this.filtersToggleButtons[0].focus());
                        }.bind(this)
                    ),
                    this.underlay.addEventListener(
                        "click",
                        function () {
                            this.hideFilters();
                        }.bind(this)
                    );
            }
            getShowOnLoad() {
                let e = `[${iX.filtersHideDesktop}='false']`,
                    t = document.querySelector(e),
                    i = window.innerWidth >= window.theme.sizes.medium;
                return !!t && !!i;
            }
            showFilters() {
                (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                    this.container.classList.remove(iY.hide),
                    setTimeout(() => {
                        this.filtersToggleButtons.forEach((e) => e.setAttribute("aria-expanded", !0)),
                            this.filtersToggleButtons.forEach((e) => e.classList.add(iY.show)),
                            this.container.classList.add(iY.show),
                            this.container.querySelector(iX.focusable).focus();
                    }, 1);
            }
            hideFilters() {
                (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                    this.filtersToggleButtons.forEach((e) => e.setAttribute("aria-expanded", !1)),
                    this.container.classList.remove(iY.show),
                    this.container.classList.remove(iY.defaultVisible),
                    this.filtersToggleButtons.forEach((e) => e.classList.remove(iY.show)),
                    this.filtersToggleButtons.forEach((e) => e.classList.remove(iY.defaultVisible)),
                    setTimeout(() => {
                        this.container.classList.contains(iY.show) || this.container.classList.add(iY.hide);
                    }, 800);
            }
            constructor(e, t = !1) {
                (this.container = e),
                    (this.underlay = this.container.querySelector(iX.underlay)),
                    (this.groupHeadings = this.container.querySelectorAll(`[${iX.groupHeading}]`)),
                    (this.showMoreButtons = this.container.querySelectorAll(`[${iX.showMore}]`)),
                    (this.triggerKey = this.container.getAttribute(iX.filtersWrappper)),
                    (this.selector = `[${iX.filtersToggle}='${this.triggerKey}']`),
                    (this.filtersToggleButtons = document.querySelectorAll(this.selector)),
                    (this.connectToggleMemory = (e) => this.connectToggleFunction(e)),
                    (this.connectShowHiddenOptions = (e) => this.showHiddenOptions(e)),
                    this.connectToggle(t),
                    this.onFocusOut(),
                    this.expandingEvents(),
                    this.getShowOnLoad() ? this.showFilters() : this.hideFilters();
            }
        },
        iQ = {
            onLoad() {
                i6[this.id] = [];
                let e = this.container.querySelectorAll(`[${iX.filtersWrappper}]`);
                e.forEach((e) => {
                    i6[this.id].push(new iJ(e));
                });
            },
            onUnload: function () {
                i6[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        i7 = {
            collectionSidebar: "[data-collection-sidebar]",
            form: "[data-sidebar-filter-form]",
            inputs: "input, select, label, textarea",
            priceMin: "data-field-price-min",
            priceMax: "data-field-price-max",
            rangeMin: "data-se-min-value",
            rangeMax: "data-se-max-value",
            rangeMinDefault: "data-se-min",
            rangeMaxDefault: "data-se-max",
            productsContainer: "[data-products-grid]",
            filterUpdateUrlButton: "[data-filter-update-url]",
            activeFiltersHolder: "[data-active-filters]",
            activeFiltersCount: "[data-active-filters-count]",
            productsCount: "[data-products-count]",
            dataSort: "data-sort-enabled",
            collectionTools: "[data-collection-tools]",
            filtersWrappper: "[data-filters]",
            headerSticky: '[data-header-sticky="sticky"]',
            headerHeight: "[data-header-height]",
            gridLarge: "data-grid-large",
            gridSmall: "data-grid-small",
            accordionBody: "[data-accordion-body]",
            checkedOption: "input:checked",
            optionHolder: "[data-option-holder]",
        },
        i5 = { classHidden: "is-hidden", classLoading: "is-loading" },
        iZ = { loadingDelay: 1e3, scrollTime: 1e3 },
        se = class e {
            init() {
                this.showAllOptions(),
                    this.form &&
                        (new i2(this.form),
                        this.sidebar.addEventListener(
                            "input",
                            U((e) => {
                                let t = e.type,
                                    i = e.target;
                                if (!i7.inputs.includes(t) || !this.form || "function" != typeof this.form.submit)
                                    return;
                                let s = this.form.querySelector(`[${i7.priceMin}]`),
                                    r = this.form.querySelector(`[${i7.priceMax}]`);
                                if (i.hasAttribute(i7.priceMin) || i.hasAttribute(i7.priceMax)) {
                                    let n = this.form.querySelector(`[${i7.rangeMin}]`),
                                        a = this.form.querySelector(`[${i7.rangeMax}]`),
                                        o = parseInt(n.getAttribute(i7.rangeMinDefault)),
                                        l = parseInt(a.getAttribute(i7.rangeMaxDefault));
                                    s.value && !r.value && (r.value = l),
                                        r.value && !s.value && (s.value = o),
                                        s.value <= o &&
                                            r.value >= l &&
                                            ((s.placeholder = o), (r.placeholder = l), (s.value = ""), (r.value = ""));
                                }
                                this.filtering(e);
                            }, 1500)
                        ),
                        this.form.addEventListener("theme:range:update", (e) => this.updateRange(e))),
                    this.sidebar && this.sidebar.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                    this.activeFiltersHolder &&
                        this.activeFiltersHolder.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                    this.productsContainer &&
                        this.productsContainer.addEventListener("click", (e) => this.updateFilterFromUrl(e)),
                    tN(this.sidebar);
            }
            updateRange(e) {
                if (this.form && "function" == typeof this.form.submit) {
                    let t = this.form.querySelector(`[${i7.rangeMin}]`),
                        i = this.form.querySelector(`[${i7.rangeMax}]`),
                        s = this.form.querySelector(`[${i7.priceMin}]`),
                        r = this.form.querySelector(`[${i7.priceMax}]`),
                        n = t && i && s && r;
                    if (n && t.hasAttribute(i7.rangeMin) && i.hasAttribute(i7.rangeMax)) {
                        let a = parseInt(s.placeholder),
                            o = parseInt(r.placeholder),
                            l = parseInt(t.getAttribute(i7.rangeMin)),
                            d = parseInt(i.getAttribute(i7.rangeMax));
                        (a !== l || o !== d) && ((s.value = l), (r.value = d), this.filtering(e));
                    }
                }
            }
            updateFilterFromUrl(e) {
                let t = e.target;
                if (t.matches(i7.filterUpdateUrlButton) || (t.closest(i7.filterUpdateUrlButton) && t)) {
                    e.preventDefault();
                    let i = t.matches(i7.filterUpdateUrlButton) ? t : t.closest(i7.filterUpdateUrlButton);
                    this.filtering(e, i.getAttribute("href"));
                }
            }
            addToHistory(e, t = "") {
                let i = this.sort ? this.sort.getAttribute(i7.dataSort) : "";
                if (!e || (e && "popstate" !== e.type)) {
                    if ("" === t) {
                        let s = new window.URL(window.location.href).searchParams,
                            r = Object.fromEntries(s),
                            n = s.toString();
                        if (n.includes("filter.") || n.includes("sort_by") || n.includes("page"))
                            for (let a in r)
                                (a.includes("filter.") || a.includes("sort_by") || a.includes("page")) && s.delete(a);
                        if (this.form) {
                            let o = new URLSearchParams(new FormData(this.form));
                            for (let [l, d] of o.entries()) l.includes("filter.") && d && s.append(l, d);
                            let c = this.form.querySelector(`[${i7.rangeMin}]`),
                                h = this.form.querySelector(`[${i7.rangeMax}]`),
                                u = this.form.querySelector(`[${i7.priceMin}]`),
                                p = this.form.querySelector(`[${i7.priceMax}]`);
                            if (
                                c &&
                                h &&
                                u &&
                                p &&
                                c.hasAttribute(i7.rangeMinDefault) &&
                                h.hasAttribute(i7.rangeMaxDefault)
                            ) {
                                let m = parseFloat(c.getAttribute(i7.rangeMinDefault), 10),
                                    f = parseFloat(h.getAttribute(i7.rangeMaxDefault), 10),
                                    g = "" === u.value ? parseFloat(u.placeholder, 10) : parseFloat(u.value, 10),
                                    y = "" === p.value ? parseFloat(p.placeholder, 10) : parseFloat(p.value, 10);
                                g <= m && y >= f && (s.delete("filter.v.price.gte"), s.delete("filter.v.price.lte"));
                            }
                        }
                        if (i || (e && e.detail && e.detail.href)) {
                            let v = i || e.detail.params;
                            s.set("sort_by", v);
                        }
                        let b = s.toString(),
                            $ = b ? `?${b}` : location.pathname;
                        window.history.pushState(null, "", $);
                        return;
                    }
                    window.history.pushState(null, "", t);
                }
            }
            getFilterResult() {
                this.productsContainer.classList.add(i5.classLoading), this.getGridValues();
                let e = new window.URL(window.location.href),
                    t = e.searchParams;
                t.set("section_id", this.section.id),
                    fetch(`${window.location.pathname}${e.search}`)
                        .then((e) => e.text())
                        .then((e) => {
                            let t = document.createElement("div");
                            (t.innerHTML = e),
                                this.sidebar &&
                                    (this.sidebar.innerHTML = t.querySelector(i7.collectionSidebar).innerHTML),
                                this.activeFiltersCount &&
                                    (this.activeFiltersCount.innerHTML = t.querySelector(
                                        i7.activeFiltersCount
                                    ).innerHTML),
                                (this.productsContainer.innerHTML = t.querySelector(i7.productsContainer).innerHTML),
                                (this.activeFiltersHolder.innerHTML = t.querySelector(
                                    i7.activeFiltersHolder
                                ).innerHTML),
                                this.activeFiltersHolder.parentNode.classList.toggle(
                                    i5.classHidden,
                                    "" === this.activeFiltersHolder.innerHTML
                                ),
                                this.productsCount &&
                                    (this.productsCount.innerHTML = t.querySelector(i7.productsCount).innerHTML),
                                this.setGridValues(),
                                this.refreshFunctionalities(),
                                setTimeout(() => {
                                    this.productsContainer.classList.remove(i5.classLoading);
                                }, iZ.loadingDelay);
                        });
            }
            refreshFunctionalities() {
                (this.form = this.container.querySelector(i7.form)),
                    this.form &&
                        (new i2(this.form),
                        this.form.addEventListener("theme:range:update", (e) => this.updateRange(e)));
                let e = this.container.querySelectorAll(i7.filtersWrappper);
                e.forEach((e) => {
                    new iJ(e, !0);
                });
                let t = this.container.querySelectorAll(i7.accordionBody);
                t.forEach((e) => {
                    new ii(e);
                }),
                    new eg(this.container),
                    this.sidebar && tN(this.sidebar),
                    this.showAllOptions();
            }
            getGridValues() {
                this.layoutLarge && (this.layoutLargeValue = this.layoutLarge.getAttribute(i7.gridLarge)),
                    this.layoutSmall && (this.layoutSmallValue = this.layoutSmall.getAttribute(i7.gridSmall));
            }
            setGridValues() {
                this.layoutLarge &&
                    ((this.layoutLarge = this.container.querySelector(`[${i7.gridLarge}]`)),
                    this.layoutLarge.setAttribute(i7.gridLarge, this.layoutLargeValue)),
                    this.layoutSmall &&
                        ((this.layoutSmall = this.container.querySelector(`[${i7.gridSmall}]`)),
                        this.layoutSmall.setAttribute(i7.gridSmall, this.layoutSmallValue));
            }
            showAllOptions() {
                let e = this.container.querySelectorAll(i7.checkedOption);
                e.forEach((e) => {
                    if (e.closest(i7.optionHolder) && e.closest(i7.optionHolder).classList.contains(i5.classHidden)) {
                        let t = e.closest(i7.accordionBody).nextElementSibling;
                        t.classList.contains(i7.classHidden) || t.dispatchEvent(new Event("click"));
                    }
                });
            }
            filtering(e, t = "") {
                if (null === e.state) return;
                let i = this.headerIsSticky
                        ? document.querySelector(i7.headerHeight).getBoundingClientRect().height
                        : 0,
                    s = this.container.offsetTop - i,
                    r = { root: null, rootMargin: `${i}px`, threshold: 1 },
                    n = (i) => {
                        let [r] = i;
                        setTimeout(
                            () => {
                                this.addToHistory(e, t), this.getFilterResult();
                            },
                            r.isIntersecting ? 10 : iZ.scrollTime
                        ),
                            a.unobserve(this.productsContainer),
                            r.isIntersecting || window.scrollTo({ top: s, left: 0, behavior: "smooth" });
                    },
                    a = new IntersectionObserver(n, r);
                a.observe(this.productsContainer);
            }
            constructor(e) {
                (this.section = e),
                    (this.container = this.section.container),
                    (this.sidebar = this.container.querySelector(i7.collectionSidebar)),
                    (this.form = e.container.querySelector(i7.form)),
                    (this.sort = this.container.querySelector(`[${i7.dataSort}]`)),
                    (this.productsContainer = this.container.querySelector(i7.productsContainer)),
                    (this.activeFiltersHolder = this.container.querySelector(i7.activeFiltersHolder)),
                    (this.activeFiltersCount = this.container.querySelector(i7.activeFiltersCount)),
                    (this.productsCount = this.container.querySelector(i7.productsCount)),
                    (this.headerIsSticky = null !== document.querySelector(i7.headerSticky)),
                    (this.layoutLarge = this.container.querySelector(`[${i7.gridLarge}]`)),
                    (this.layoutSmall = this.container.querySelector(`[${i7.gridSmall}]`)),
                    this.productsContainer && this.sidebar && this.init(),
                    this.sort && this.container.addEventListener("theme:form:filter", (e) => this.filtering(e)),
                    (this.sidebar || this.sort) && window.addEventListener("popstate", (e) => this.filtering(e));
            }
        },
        st = {
            onLoad() {
                this.filterForm = new se(this);
            },
            onUnload() {
                this.filterForm && "function" == typeof this.filterForm.unload && this.filterForm.unload();
            },
        };
    eN("search-page", [iQ, st, tU, is]),
        customElements.get("popout-select") || customElements.define("popout-select", tQ),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY);
    let si = {
            zoomImage: "[data-image-zoom]",
            modalContainer: "[data-modal-container]",
            attrUnique: "data-unique",
            image: "data-src",
        },
        ss = class e {
            init() {
                this.triggers.forEach((e) => {
                    let t = e.getAttribute(si.attrUnique),
                        i = this.modalContainer.querySelector(`#zoom-${t}`);
                    if (i) {
                        let s = this.container.querySelector(`#zoom-${t}`);
                        s && (i.parentNode.removeChild(i), this.modalContainer.appendChild(s));
                    }
                    r.init({
                        disableScroll: !0,
                        openTrigger: `data-popup-${t}`,
                        onShow(e) {
                            e.querySelectorAll(`[${si.image}]`, e).forEach((e) => {
                                if (null === e.getAttribute("src")) {
                                    let t = e.getAttribute(si.image);
                                    e.setAttribute("src", t);
                                }
                            });
                        },
                        onClose(e, t, i) {
                            i.preventDefault();
                        },
                    });
                });
            }
            constructor(e) {
                (this.container = e),
                    (this.triggers = this.container.querySelectorAll(si.zoomImage)),
                    (this.modalContainer = document.querySelector(si.modalContainer)),
                    this.init();
            }
        };
    eN("gallery", [
        {
            onLoad() {
                new ss(this.container);
            },
        },
        iO,
        eq,
    ]);
    let sr = (e, t) => {
            let { el: i, elStyle: s, elHeight: r, rowsLimit: n, rowsWrapped: a, options: o } = e,
                l = e.buffer,
                d = l;
            if (a === n + 1) return { ...e };
            let c = l,
                h = a,
                u = r;
            return ((i.innerHTML = d = l.length ? `${l}${o.delimiter}${t}${o.replaceStr}` : `${t}${o.replaceStr}`),
            parseFloat(s.height) > parseFloat(r) && (h++, (u = s.height), h === n + 1))
                ? ((i.innerHTML = d =
                      "." === c[c.length - 1] && "..." === o.replaceStr ? `${c}..` : `${c}${o.replaceStr}`),
                  { ...e, elHeight: u, rowsWrapped: h })
                : ((i.innerHTML = d = c.length ? `${c}${o.delimiter}${t}` : `${t}`),
                  { ...e, buffer: d, elHeight: u, rowsWrapped: h });
        },
        sn = (e = "", t = 1, i = {}) => {
            let s = { replaceStr: "...", debounceDelay: 250, delimiter: " ", ...i },
                r = e && (e instanceof NodeList ? e : 1 === e.nodeType ? [e] : document.querySelectorAll(e));
            for (let n = 0; n < r.length; n++) {
                let a = r[n],
                    o = a.innerHTML,
                    l = /<!--[\s\S]*?-->/g,
                    d = o.replace(l, ""),
                    c = d.split(s.delimiter);
                a.innerHTML = "";
                let h = window.getComputedStyle(a);
                c.reduce(sr, {
                    el: a,
                    buffer: a.innerHTML,
                    elStyle: h,
                    elHeight: 0,
                    rowsLimit: t,
                    rowsWrapped: 0,
                    options: s,
                });
            }
        };
    !(function e() {
        let t = "ontouchstart" in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
        return document.documentElement.classList.toggle("supports-touch", t), t;
    })();
    let sa = {},
        so = {},
        sl = {},
        sd = {
            productSlideshow: "[data-product-slideshow]",
            productXr: "[data-shopify-xr]",
            dataMediaId: "data-media-id",
            dataModelId: "data-model-id",
            modelViewer: "model-viewer",
            dataModel3d: "data-shopify-model3d-id",
            modelJson: "#ModelJson-",
        };
    function sc(e) {
        if (e) {
            console.warn(e);
            return;
        }
        for (let t in so)
            if (so.hasOwnProperty(t)) {
                let i = so[t];
                i.modelViewerUi || (i.modelViewerUi = new Shopify.ModelViewerUI(i.$element)), sh(i);
            }
    }
    function sh(e) {
        let t = sl[e.sectionId];
        e.$container.addEventListener("pause", function () {
            e.modelViewerUi.pause && e.modelViewerUi.pause();
        }),
            e.$container.addEventListener("play", function () {
                e.modelViewerUi.play &&
                    (e.modelViewerUi.play(),
                    t &&
                        t.$element &&
                        e &&
                        e.modelId &&
                        sd.dataModel3d &&
                        t.$element.setAttribute(sd.dataModel3d, e.modelId));
            }),
            e.$element.addEventListener("shopify_model_viewer_ui_toggle_play", () => {
                e.$container.dispatchEvent(new CustomEvent("theme:media:play"));
            }),
            e.$element.addEventListener("shopify_model_viewer_ui_toggle_pause", () => {
                e.$container.dispatchEvent(new CustomEvent("theme:media:pause"));
            });
    }
    async function su(e) {
        let t = document.querySelector(`[data-player="${e}"]`),
            i = t.querySelector("video");
        await tV({ name: "video-ui", version: "1.0" });
        let s = new window.Shopify.Plyr(i);
        return (
            t.addEventListener("pause", () => {
                s.pause && s.pause();
            }),
            t.addEventListener("play", () => {
                try {
                    s.play
                        ? s.paused && s.play()
                        : s.addEventListener("onReady", () => {
                              s.play();
                          });
                } catch (e) {
                    console.warn(e);
                }
            }),
            t.addEventListener("destroy", () => {
                try {
                    s.destroy && s.destroy();
                } catch (e) {
                    console.warn(e);
                }
            }),
            s
        );
    }
    let sp = {
            productSlideshow: "[data-product-slideshow]",
            slideshowMobileStyle: "data-slideshow-mobile-style",
            slideshowDesktopStyle: "data-slideshow-desktop-style",
            productThumbs: "[data-product-thumbs]",
            leftThumbsHolder: "[data-thumbs-holder]",
            thumbImage: "[data-slideshow-thumbnail]",
            mediaSlide: "[data-media-slide]",
            dataMediaId: "data-media-id",
            dataMediaSelect: "data-media-select",
            mediaType: "data-type",
            videoPlayerExternal: '[data-type="external_video"]',
            videoPlayerNative: '[data-type="video"]',
            modelViewer: '[data-type="model"]',
            modelViewerTag: "model-viewer",
            allPlayers: "[data-player]",
            loopVideo: "data-enable-video-looping",
            verticalAlignment: "[data-thumbnails-left]",
            arrowPrev: "[data-thumbs-arrow-prev]",
            arrowNext: "[data-thumbs-arrow-next]",
            aspectRatio: "data-aspect-ratio",
            flickitylockHeight: "flickity-lock-height",
        },
        sm = {
            flickityDisableClass: "flickity-disabled-mobile",
            flickityEnabled: "flickity-enabled",
            selected: "is-selected",
            active: "is-activated",
            show: "show",
            enableVideoDraggable: "enable-video-draggable",
            hide: "hide",
        },
        sf = class e {
            init() {
                this.storeEvents(),
                    this.connectSliderMediaEvents(),
                    this.detectVideos(),
                    this.detect3d(),
                    this.scrollThumbs(),
                    document.addEventListener("theme:resize:width", () => {
                        this.scrollThumbs();
                    }),
                    eT.onChange(() => {
                        this.connectSliderMediaEvents();
                    });
            }
            connectSliderMediaEvents() {
                eT.isMobile() ? this.createMobileSlider() : this.createDesktopSlider();
            }
            createMobileSlider() {
                this.hasDesktopSlider && this.flkty && (this.destroySlider(), (this.hasDesktopSlider = !1));
                let e = {
                    autoPlay: !1,
                    prevNextButtons: !1,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    accessibility: !0,
                    watchCSS: !1,
                    wrapAround: !0,
                    rightToLeft: window.isRTL,
                    dragThreshold: 80,
                    contain: !0,
                    fade: !0,
                };
                "carousel" == this.mobileStyle && ((e.contain = !1), (e.dragThreshold = 10), (e.fade = !1)),
                    "slideshow" == this.mobileStyle && ((e.pageDots = !0), (e.fade = !1), (e.dragThreshold = 10)),
                    "none" != this.mobileStyle && (this.createSlider(e), (this.hasMobileSlider = !0));
            }
            createDesktopSlider() {
                if (
                    (this.hasMobileSlider && this.flkty && (this.destroySlider(), (this.hasMobileSlider = !1)),
                    "none" == this.desktopStyle)
                )
                    return;
                let e = {
                    autoPlay: !1,
                    prevNextButtons: !1,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    accessibility: !0,
                    watchCSS: !1,
                    wrapAround: !0,
                    rightToLeft: window.isRTL,
                    dragThreshold: 80,
                    contain: !0,
                    fade: !0,
                };
                this.createSlider(e), (this.hasDesktopSlider = !0);
            }
            createSlider(e) {
                (this.flkty = new s(this.slideshow, e)),
                    this.flkty.resize(),
                    (this.currentSlide = this.slideshow.querySelectorAll(sp.mediaSlide)[0]),
                    this.setDraggable(),
                    this.addEventListeners();
            }
            destroySlider() {
                this.removeEventListeners(), this.flkty.destroy();
            }
            storeEvents() {
                (this.storeFlktyChange = (e) => this.doFlktyChange(e)),
                    (this.storeFlktySettle = (e) => this.doFlktySettle(e)),
                    (this.storeImageChange = (e) => this.doImageChange(e)),
                    (this.storeArrowPrevClick = (e) => this.doArrowPrevClick(e)),
                    (this.storeArrowNextClick = (e) => this.doArrowNextClick(e)),
                    (this.storeThumbClick = (e) => this.doThumbClick(e)),
                    (this.storeThumbContainerScroll = (e) => this.doThumbContainerScroll(e));
            }
            addEventListeners() {
                var e, t, i;
                this.flkty.on("change", this.storeFlktyChange),
                    this.flkty.on("settle", this.storeFlktySettle),
                    this.slideshow.addEventListener("theme:image:change", this.storeImageChange),
                    null === (e = this.arrowPrev) ||
                        void 0 === e ||
                        e.addEventListener("click", this.storeArrowPrevClick),
                    null === (t = this.arrowNext) ||
                        void 0 === t ||
                        t.addEventListener("click", this.storeArrowNextClick),
                    null === (i = this.thumbs) ||
                        void 0 === i ||
                        i.addEventListener("scroll", this.storeThumbContainerScroll),
                    this.thumbImages.forEach((e) => {
                        e.addEventListener("click", this.storeThumbClick);
                    });
            }
            removeEventListeners() {
                var e, t, i;
                this.flkty.on("change", this.storeFlktyChange),
                    this.flkty.on("settle", this.storeFlktySettle),
                    this.slideshow.removeEventListener("theme:image:change", this.storeImageChange),
                    null === (e = this.arrowPrev) ||
                        void 0 === e ||
                        e.removeEventListener("click", this.storeArrowPrevClick),
                    null === (t = this.arrowNext) ||
                        void 0 === t ||
                        t.removeEventListener("click", this.storeArrowNextClick),
                    null === (i = this.thumbs) ||
                        void 0 === i ||
                        i.removeEventListener("scroll", this.storeThumbContainerScroll),
                    this.thumbImages.forEach((e) => {
                        e.removeEventListener("click", this.storeThumbClick);
                    });
            }
            addMediaEventListeners(e) {
                e &&
                    (e.addEventListener("play", () => {
                        (eT.isMobile() || eT.isTouch()) && this.updateDraggable(!1);
                    }),
                    e.addEventListener("pause", () => {
                        (eT.isMobile() || eT.isTouch()) && this.updateDraggable(!0);
                    }));
            }
            doFlktyChange(e) {
                var t, i;
                ("model" === this.mediaType || "video" === this.mediaType || "external_video" === this.mediaType) &&
                    this.currentSlide.dispatchEvent(new CustomEvent("pause")),
                    (this.currentSlide = this.flkty.cells[e].element),
                    this.slideshow.classList.remove(sp.flickitylockHeight);
                let s = this.currentSlide.getAttribute(sp.dataMediaId),
                    r =
                        null === (t = this.thumbWrapper) || void 0 === t
                            ? void 0
                            : t.querySelector(`[${sp.dataMediaSelect}="${s}"]`);
                null === (i = this.thumbWrapper) ||
                    void 0 === i ||
                    i.querySelector(`.${sm.active}`).classList.remove(sm.active),
                    null == r || r.classList.add(sm.active),
                    this.scrollThumbs(),
                    setTimeout(() => {
                        if (
                            (null == r ? void 0 : r.classList.contains(sm.hide)) ||
                            this.currentSlide.classList.contains(sm.hide)
                        ) {
                            let t = this.flkty.cells.length,
                                i = this.flkty.dragStartPosition < this.flkty.dragX;
                            for (let s = 0; s < t; s++) {
                                let n = i ? e - s : e + s;
                                n < 0 && (n += t), n >= t && (n -= t);
                                let a = this.flkty.cells[n].element;
                                if (!a.classList.contains(sm.hide)) {
                                    this.lastMediaSelect = a.getAttribute(sp.dataMediaId);
                                    break;
                                }
                            }
                            this.lastMediaSelect
                                ? this.slideshow.dispatchEvent(
                                      new CustomEvent("theme:image:change", { detail: { id: this.lastMediaSelect } })
                                  )
                                : window.location.reload();
                        }
                    });
            }
            doFlktySettle(e) {
                (this.allSlides = this.flkty.cells),
                    (this.currentSlide = this.flkty.cells[e].element),
                    this.setDraggable();
                let t = document.body.classList.contains(sp.focusEnabled);
                t && this.currentSlide.dispatchEvent(new Event("focus")), this.scrollThumbs();
            }
            doImageChange(e) {
                var t = e.detail.id;
                this.lastMediaSelect = t;
                let i = `[${sp.dataMediaId}="${t}"]`,
                    s = (e) => e.element.matches(i),
                    r = this.flkty.cells.findIndex(s);
                this.flkty.select(r), this.scrollThumbs();
            }
            doThumbContainerScroll() {
                this.scrollThumbs("scroll");
            }
            doArrowPrevClick() {
                this.scrollThumbs("clickPrev");
            }
            doArrowNextClick() {
                this.scrollThumbs("clickNext");
            }
            doThumbClick(e) {
                let t = e.currentTarget.getAttribute(sp.dataMediaSelect);
                this.slideshow.dispatchEvent(new CustomEvent("theme:image:change", { detail: { id: t } }));
            }
            setDraggable() {
                this.currentSlide &&
                    ((this.mediaType = this.currentSlide.getAttribute(sp.mediaType)),
                    "model" === this.mediaType || "video" === this.mediaType || "external_video" === this.mediaType
                        ? eT.isMobile() && eT.isTouch()
                            ? this.updateDraggable(!0)
                            : (this.currentSlide.dispatchEvent(new CustomEvent("play")), this.updateDraggable(!1))
                        : this.updateDraggable(!0));
            }
            updateDraggable(e) {
                this.flkty &&
                    ((this.flkty.options.draggable = e),
                    this.flkty.updateDraggable(),
                    this.slideshow.classList.toggle(sm.enableVideoDraggable, e));
            }
            detect3d() {
                let e = this.container.querySelectorAll(sp.modelViewer);
                e &&
                    (e.forEach((e) => {
                        (function e(t, i) {
                            sa[i] = { loaded: !1 };
                            let s = t.getAttribute(sd.dataMediaId),
                                r = t.querySelector(sd.modelViewer),
                                n = r.getAttribute(sd.dataModelId);
                            if (null !== t.closest(sd.productSlideshow)) {
                                let a = t.closest(sd.productSlideshow).parentElement.querySelector(sd.productXr);
                                sl[i] = { $element: a, defaultId: n };
                            }
                            (so[s] = { modelId: n, mediaId: s, sectionId: i, $container: t, $element: r }),
                                window.Shopify.loadFeatures([
                                    {
                                        name: "shopify-xr",
                                        version: "1.0",
                                        onLoad: function e(t) {
                                            if (t) {
                                                console.warn(t);
                                                return;
                                            }
                                            if (!window.ShopifyXR) {
                                                document.addEventListener("shopify_xr_initialized", function () {
                                                    e();
                                                });
                                                return;
                                            }
                                            for (let i in sa)
                                                if (sa.hasOwnProperty(i)) {
                                                    let s = sa[i];
                                                    if (s.loaded) continue;
                                                    let r = document.querySelector(`${sd.modelJson}${i}`);
                                                    r &&
                                                        (window.ShopifyXR.addModels(JSON.parse(r.innerHTML)),
                                                        (s.loaded = !0));
                                                }
                                            window.ShopifyXR.setupXRElements();
                                        },
                                    },
                                    { name: "model-viewer-ui", version: "1.0", onLoad: sc },
                                ]);
                        })(e, this.section.id),
                            e.addEventListener("theme:media:play", () => {
                                this.updateDraggable(!1);
                            }),
                            e.addEventListener("theme:media:pause", () => {
                                this.updateDraggable(!0);
                            });
                    }),
                    document.addEventListener(
                        "shopify_xr_launch",
                        function () {
                            this.container.querySelectorAll(sp.allPlayers).forEach((e) => {
                                e.dispatchEvent(new CustomEvent("pause"));
                            });
                        }.bind(this)
                    ));
            }
            detectVideos() {
                let e = this.section.container.querySelectorAll(`${sp.videoPlayerExternal}, ${sp.videoPlayerNative}`);
                for (var t of e) {
                    let i = t.dataset.player,
                        s = t.dataset.host,
                        r;
                    (r = "youtube" === s ? iq(i) : "vimeo" === s ? i9(i) : su(i)),
                        !0 === this.loopVideo &&
                            r
                                .then((e) => (s ? sg(e, s) : ((e.loop = !0), e)))
                                .catch((e) => {
                                    console.error(e);
                                }),
                        this.addMediaEventListeners(t);
                }
            }
            pauseAllMedia() {
                let e = this.container.querySelector(sp.mediaSlide);
                e.dispatchEvent(new CustomEvent("pause"));
            }
            pauseOtherMedia(e) {
                let t = this.container.querySelector(`${sp.mediaSlide}:not([data-player="${e}"])`);
                t.dispatchEvent(new CustomEvent("pause"));
            }
            destroy() {
                this.container.querySelectorAll(sp.allPlayers).forEach((e) => {
                    e.dispatchEvent(new CustomEvent("destroy"));
                });
            }
            scrollThumbs(e) {
                (this.thumbs = this.container.querySelector(sp.productThumbs)),
                    this.thumbs &&
                        ((this.thumb = this.thumbs.querySelector(`.${sm.active}`)),
                        (this.thumbItems = this.container.querySelectorAll(sp.thumbImage)),
                        (this.lastThumb = this.thumbItems[this.thumbItems.length - 1]),
                        this.thumb &&
                            ((this.thumbsScrollTop = this.thumbs.scrollTop),
                            (this.thumbsScrollLeft = this.thumbs.scrollLeft),
                            (this.thumbsWidth = this.thumbs.offsetWidth),
                            (this.thumbsHeight = this.slideshow.offsetWidth / this.thumb.getAttribute(sp.aspectRatio)),
                            (this.thumbsPositionBottom = this.thumbsScrollTop + this.thumbsHeight),
                            (this.thumbsPositionRight = this.thumbsScrollLeft + this.thumbsWidth),
                            this.checkThumbPositions(),
                            this.toggleToActiveThumb(e),
                            this.toggleArrows()));
            }
            checkThumbPositions() {
                (this.thumbWidth = this.thumb.offsetWidth),
                    (this.thumbHeight = this.thumb.offsetHeight),
                    (this.thumbPosTop = this.thumb.offsetTop),
                    (this.thumbPosLeft = this.thumb.offsetLeft),
                    (this.lastThumbRightPos = this.lastThumb.offsetLeft + this.thumbWidth),
                    (this.lastThumbBottomPos = this.lastThumb.offsetTop + this.thumbHeight),
                    (this.scrollTopPosition = this.thumbPosTop + this.thumbHeight / 2 - this.thumbsHeight / 2),
                    (this.scrollLeftPosition = this.thumbPosLeft + this.thumbWidth / 2 - this.thumbsWidth / 2),
                    (this.topCheck = this.thumbsScrollTop > 0),
                    (this.bottomCheck = this.thumbsPositionBottom < this.lastThumbBottomPos),
                    (this.leftCheck = this.thumbsScrollLeft > 0),
                    (this.rightCheck = this.thumbsPositionRight < this.lastThumbRightPos),
                    (this.verticalCheck = this.bottomCheck || this.topCheck),
                    (this.horizontalCheck = this.rightCheck || this.leftCheck);
            }
            toggleToActiveThumb(e) {
                "scroll" !== e &&
                    ("clickPrev" == e &&
                        (this.verticalCheck
                            ? ((this.scrollTopPosition = this.thumbsScrollTop - this.thumbsHeight),
                              (this.scrollLeftPosition = 0))
                            : ((this.scrollTopPosition = 0),
                              (this.scrollLeftPosition = this.thumbsScrollLeft - this.thumbsWidth))),
                    "clickNext" == e &&
                        (this.verticalCheck
                            ? ((this.scrollTopPosition = this.thumbsScrollTop + this.thumbsHeight),
                              (this.scrollLeftPosition = 0))
                            : ((this.scrollTopPosition = 0),
                              (this.scrollLeftPosition = this.thumbsScrollLeft + this.thumbsWidth))),
                    this.thumbs.scrollTo({
                        top: this.scrollTopPosition,
                        left: this.scrollLeftPosition,
                        behavior: "smooth",
                    }));
            }
            toggleArrows() {
                (this.verticalCheck || (this.verticalAlignment && !this.verticalCheck)) &&
                    (this.arrowPrev.classList.toggle(sm.show, this.topCheck),
                    this.arrowNext.classList.toggle(sm.show, this.bottomCheck)),
                    (!this.horizontalCheck && (this.verticalAlignment || this.horizontalCheck)) ||
                        (this.arrowPrev.classList.toggle(sm.show, this.leftCheck),
                        this.arrowNext.classList.toggle(sm.show, this.rightCheck));
            }
            constructor(e) {
                var t, i;
                (this.section = e),
                    (this.container = e.container),
                    (this.slideshow = this.container.querySelector(sp.productSlideshow)),
                    (this.mobileStyle =
                        (null === (t = this.slideshow) || void 0 === t
                            ? void 0
                            : t.getAttribute(sp.slideshowMobileStyle)) || "none"),
                    (this.desktopStyle =
                        (null === (i = this.slideshow) || void 0 === i
                            ? void 0
                            : i.getAttribute(sp.slideshowDesktopStyle)) || "none"),
                    (this.arrowPrev = this.container.querySelector(sp.arrowPrev)),
                    (this.arrowNext = this.container.querySelector(sp.arrowNext)),
                    (this.leftThumbsHolder = this.container.querySelector(sp.leftThumbsHolder)),
                    (this.thumbWrapper = this.container.querySelector(sp.productThumbs)),
                    (this.thumbImages = this.container.querySelectorAll(sp.thumbImage)),
                    (this.loopVideo = "true" === this.container.getAttribute(sp.loopVideo)),
                    (this.verticalAlignment = Boolean(this.container.querySelector(sp.verticalAlignment))),
                    (this.flkty = null),
                    (this.lastMediaSelect = null),
                    (this.thumbs = this.container.querySelector(sp.productThumbs)),
                    (this.currentSlide = null),
                    (this.mediaType = null),
                    (this.hasMobileSlider = !1),
                    (this.hasDesktopSlider = !1),
                    this.init();
            }
        };
    function sg(e, t) {
        return (
            "youtube" === t
                ? e.addEventListener("onStateChange", (e) => {
                      0 === e.data && e.target.playVideo();
                  })
                : "vimeo" === t &&
                  e.on("ended", () => {
                      e.play();
                  }),
            e
        );
    }
    let sy = {
            pickupContainer: "data-store-availability-container",
            shopifySection: "[data-api-content]",
            drawer: "[data-pickup-drawer]",
            drawerOpen: "[data-pickup-drawer-open]",
            drawerClose: "[data-pickup-drawer-close]",
            drawerBody: "[data-pickup-body]",
        },
        sv = { isVisible: "drawer--visible", isHidden: "hide", isPickupVisible: "is-pickup-visible" },
        sb = {},
        s$ = class e {
            fetchPickupAvailability(e) {
                let t = this.container.querySelector(`[${sy.pickupContainer}]`);
                if (!t) return;
                let i = e && e.detail.variant ? e.detail.variant.id : t.getAttribute(sy.pickupContainer);
                if (e && !e.detail.variant) {
                    t.classList.add(sv.isHidden);
                    return;
                }
                i &&
                    fetch(`${window.theme.routes.root_url}variants/${i}/?section_id=api-pickup-availability`)
                        .then(this.handleErrors)
                        .then((e) => e.text())
                        .then((e) => {
                            let i = new DOMParser()
                                .parseFromString(e, "text/html")
                                .querySelector(sy.shopifySection).innerHTML;
                            (t.innerHTML = i),
                                t.classList.remove(sv.isHidden),
                                (this.drawer = this.container.querySelector(sy.drawer)),
                                (this.buttonDrawerOpen = this.container.querySelector(sy.drawerOpen)),
                                (this.buttonDrawerClose = this.container.querySelectorAll(sy.drawerClose)),
                                (this.drawerBody = this.container.querySelector(sy.drawerBody)),
                                this.buttonDrawerOpen &&
                                    this.buttonDrawerOpen.addEventListener("click", () => this.openDrawer()),
                                this.buttonDrawerClose.length &&
                                    this.buttonDrawerClose.forEach((e) => {
                                        e.addEventListener("click", () => this.closeDrawer());
                                    });
                        })
                        .catch((e) => {
                            console.error(e);
                        });
            }
            openDrawer() {
                this.drawer &&
                    (document.body.classList.add(sv.isPickupVisible),
                    this.drawer.classList.add(sv.isVisible),
                    this.drawer.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                    this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })));
            }
            closeDrawer() {
                this.drawer &&
                    (document.body.classList.remove(sv.isPickupVisible),
                    this.drawer.classList.remove(sv.isVisible),
                    this.drawer.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                    this.drawerBody.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })));
            }
            handleErrors(e) {
                return e.ok
                    ? e
                    : e.json().then(function (t) {
                          let i = new eh({ status: e.statusText, headers: e.headers, json: t });
                          throw i;
                      });
            }
            constructor(e) {
                (this.container = e.container),
                    (this.drawer = null),
                    (this.buttonDrawerOpen = null),
                    (this.buttonDrawerClose = null),
                    (this.drawerBody = null),
                    this.fetchPickupAvailability(),
                    this.container.addEventListener("theme:variant:change", (e) => this.fetchPickupAvailability(e));
            }
        };
    function sw() {
        this.entries = [];
    }
    function s8(e) {
        if ("object" != typeof e) throw TypeError(e + " is not an object.");
        if (0 === Object.keys(e).length && e.constructor === Object) throw Error(e + " is empty.");
    }
    (sw.prototype.add = function (e, t, i) {
        this.entries.push({ element: e, event: t, fn: i }), e.addEventListener(t, i);
    }),
        (sw.prototype.removeAll = function () {
            this.entries = this.entries.filter(function (e) {
                return e.element.removeEventListener(e.event, e.fn), !1;
            });
        });
    var sS = {
        idInput: '[name="id"]',
        planInput: '[name="selling_plan"]',
        optionInput: '[name^="options"]',
        quantityInput: '[name="quantity"]',
        propertyInput: '[name^="properties"]',
    };
    let sE = class e {
            destroy() {
                this._listeners.removeAll();
            }
            options() {
                return this._serializeInputValues(this.optionInputs, function (e) {
                    return (e.name = /(?:^(options\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                });
            }
            variant() {
                var e, t, i, s, r, n, a, o;
                let l = this.options();
                if (!l.length) return this.product.variants[0];
                return (
                    (e = this.product),
                    (t = l),
                    s8(e),
                    (i =
                        ((s = e),
                        (r = t),
                        s8(s),
                        (function e(t) {
                            if (!Array.isArray(t)) throw TypeError(t + " is not an array.");
                            if (0 === t.length) throw Error(t + " is empty.");
                            if (t[0].hasOwnProperty("name")) {
                                if ("string" != typeof t[0].name)
                                    throw TypeError(
                                        "Invalid value type passed for name of option " +
                                            t[0].name +
                                            ". Value should be string."
                                    );
                            } else throw Error(t[0] + "does not contain name key.");
                        })(r),
                        (n = []),
                        r.forEach(function (e) {
                            for (var t = 0; t < s.options.length; t++)
                                if ((s.options[t].name || s.options[t]).toLowerCase() === e.name.toLowerCase()) {
                                    n[t] = e.value;
                                    break;
                                }
                        }),
                        n)),
                    (a = e),
                    (o = i),
                    s8(a),
                    (function e(t) {
                        if (Array.isArray(t) && "object" == typeof t[0])
                            throw Error(t + "is not a valid array of options.");
                    })(o),
                    a.variants.filter(function (e) {
                        return o.every(function (t, i) {
                            return e.options[i] === t;
                        });
                    })[0] || null
                );
            }
            plan(e) {
                let t = { allocation: null, group: null, detail: null },
                    i = new FormData(this.form),
                    s = i.get("selling_plan");
                if (e && e.selling_plan_allocations && e.selling_plan_allocations.length > 0) {
                    let r = [...new Set(e.selling_plan_allocations.map((e) => e.selling_plan_group_id))],
                        n = this.element.querySelectorAll("[data-subscription-group]");
                    if (!n.length) return;
                    n.forEach((e) => (e.style.display = "none")),
                        r.forEach((e) => {
                            this.element.querySelector(`[data-selling-plan-group="${e}"]`).style.display = "block";
                        });
                }
                return (s &&
                    e &&
                    (t.allocation = e.selling_plan_allocations.find(function (e) {
                        return e.selling_plan_id.toString() === s.toString();
                    })),
                t.allocation &&
                    (t.group = this.product.selling_plan_groups.find(function (e) {
                        return e.id.toString() === t.allocation.selling_plan_group_id.toString();
                    })),
                t.group &&
                    (t.detail = t.group.selling_plans.find(function (e) {
                        return e.id.toString() === s.toString();
                    })),
                t && t.allocation && t.detail && t.allocation)
                    ? t
                    : null;
            }
            properties() {
                return this._serializeInputValues(this.propertyInputs, function (e) {
                    return (e.name = /(?:^(properties\[))(.*?)(?:\])/.exec(e.name)[2]), e;
                });
            }
            quantity() {
                return this.quantityInputs[0] ? Number.parseInt(this.quantityInputs[0].value, 10) : 1;
            }
            getFormState() {
                let e = this.variant();
                return {
                    options: this.options(),
                    variant: e,
                    properties: this.properties(),
                    quantity: this.quantity(),
                    plan: this.plan(e),
                };
            }
            _setIdInputValue(e) {
                e && e.id ? (this.variantElement.value = e.id.toString()) : (this.variantElement.value = ""),
                    this.variantElement.dispatchEvent(new Event("change"));
            }
            _onSubmit(e, t) {
                (t.dataset = this.getFormState()), e.onFormSubmit && e.onFormSubmit(t);
            }
            _onOptionChange(e) {
                this._setIdInputValue(e.dataset.variant);
            }
            _onFormEvent(e) {
                return void 0 === e
                    ? Function.prototype
                    : function (t) {
                          (t.dataset = this.getFormState()), this._setIdInputValue(t.dataset.variant), e(t);
                      }.bind(this);
            }
            _initInputs(e, t) {
                return Array.prototype.slice.call(this.element.querySelectorAll(e)).map(
                    function (e) {
                        return this._listeners.add(e, "change", this._onFormEvent(t)), e;
                    }.bind(this)
                );
            }
            _serializeInputValues(e, t) {
                return e.reduce(function (e, i) {
                    return (
                        (i.checked || ("radio" !== i.type && "checkbox" !== i.type)) &&
                            e.push(t({ name: i.name, value: i.value })),
                        e
                    );
                }, []);
            }
            _validateProductObject(e) {
                if ("object" != typeof e) throw TypeError(e + " is not an object.");
                if (void 0 === e.variants[0].options)
                    throw TypeError(
                        "Product object is invalid. Make sure you use the product object that is output from {{ product | json }} or from the http://[your-product-url].js route"
                    );
                return e;
            }
            constructor(e, t, i, s) {
                (this.element = e),
                    (this.form = "FORM" == t.tagName ? t : t.querySelector("form")),
                    (this.product = this._validateProductObject(i)),
                    (this.variantElement = this.form.querySelector(sS.idInput)),
                    (s = s || {}),
                    (this.clickedElement = null),
                    (this._listeners = new sw()),
                    this._listeners.add(this.element, "submit", this._onSubmit.bind(this, s)),
                    (this.optionInputs = this._initInputs(sS.optionInput, s.onOptionChange)),
                    (this.planInputs = this._initInputs(sS.planInput, s.onPlanChange)),
                    (this.quantityInputs = this._initInputs(sS.quantityInput, s.onQuantityChange)),
                    (this.propertyInputs = this._initInputs(sS.propertyInput, s.onPropertyChange));
            }
        },
        sx = {
            wrapper: "[data-quantity-selector]",
            increase: "[data-increase-quantity]",
            decrease: "[data-decrease-quantity]",
            input: "[data-quantity-input]",
        },
        sk = class e {
            initButtons() {
                this.increase.addEventListener(
                    "click",
                    function (e) {
                        e.preventDefault();
                        let t = parseInt(this.input.value, 10);
                        (t = isNaN(t) ? 0 : t),
                            t++,
                            (this.input.value = t),
                            this.input.dispatchEvent(new Event("change"));
                    }.bind(this)
                ),
                    this.decrease.addEventListener(
                        "click",
                        function (e) {
                            e.preventDefault();
                            let t = parseInt(this.input.value, 10);
                            (t = isNaN(t) ? 0 : t),
                                t--,
                                (t = Math.max(this.min, t)),
                                (this.input.value = t),
                                this.input.dispatchEvent(new Event("change"));
                        }.bind(this)
                    );
            }
            constructor(e) {
                (this.wrapper = e),
                    (this.increase = this.wrapper.querySelector(sx.increase)),
                    (this.decrease = this.wrapper.querySelector(sx.decrease)),
                    (this.input = this.wrapper.querySelector(sx.input)),
                    (this.min = parseInt(this.input.getAttribute("min"), 10)),
                    this.initButtons();
            }
        };
    function sT(e) {
        let t = e.querySelectorAll(sx.wrapper);
        t.forEach((e) => {
            new sk(e);
        });
    }
    let sL = {
            form: "[data-product-form]",
            optionPosition: "data-option-position",
            optionInput: '[name^="options"], [data-popout-option]',
            selectOptionValue: "data-value",
        },
        s_ = { soldOut: "sold-out", unavailable: "unavailable" },
        sA = class e {
            init() {
                this.update();
            }
            update() {
                this.getCurrentState(),
                    this.optionElements.forEach((e) => {
                        let t = e.value || e.getAttribute(sL.selectOptionValue),
                            i = e.closest(`[${sL.optionPosition}]`).getAttribute(sL.optionPosition),
                            s = parseInt(i, 10) - 1,
                            r = [...this.selections];
                        r[s] = t;
                        let n = this.productJSON.variants.find((e) => {
                            let t = !0;
                            for (let i = 0; i < r.length; i++) e.options[i] !== r[i] && (t = !1);
                            return t;
                        });
                        e.classList.remove(s_.soldOut, s_.unavailable),
                            void 0 === n
                                ? e.classList.add(s_.unavailable)
                                : n && !1 === n.available && e.classList.add(s_.soldOut);
                    });
            }
            getCurrentState() {
                for (var e of ((this.formData = new FormData(this.form)),
                (this.selections = []),
                this.formData.entries()))
                    e[0].includes("options[") && this.selections.push(e[1]);
            }
            constructor(e, t) {
                (this.container = e),
                    (this.productJSON = t),
                    (this.form = this.container.querySelector(sL.form)),
                    (this.formData = new FormData(this.form)),
                    (this.optionElements = this.container.querySelectorAll(sL.optionInput)),
                    this.productJSON && this.form && this.init();
            }
        },
        sC = {
            outerSection: "[data-section-id]",
            quickviewModal: "[data-quickview-modal]",
            productFormWrapper: "[data-product-form-wrapper]",
            productForm: "[data-product-form]",
            productSlideshow: "[data-product-slideshow]",
            productSlideshowDesktop: '[data-slideshow-desktop-style="slideshow"]',
            addToCart: "[data-add-to-cart]",
            addToCartText: "[data-add-to-cart-text]",
            comparePrice: "[data-compare-price]",
            buttonsWrapper: "[data-buttons-wrapper]",
            originalSelectorId: "[data-product-select]",
            priceWrapper: "[data-price-wrapper]",
            priceButton: "[data-button-price]",
            productJson: "[data-product-json]",
            productPrice: "[data-product-price]",
            unitPrice: "[data-product-unit-price]",
            unitBase: "[data-product-base]",
            unitWrapper: "[data-product-unit]",
            dataEnableHistoryState: "data-enable-history-state",
            optionPosition: "data-option-position",
            optionValue: "[data-option-value]",
            subPrices: "[data-subscription-watch-price]",
            subSelectors: "[data-subscription-selectors]",
            priceOffWrap: "[data-price-off]",
            priceOffType: "[data-price-off-type]",
            priceOffAmount: "[data-price-off-amount]",
            subsToggle: "[data-toggles-group]",
            subsChild: "data-group-toggle",
            subDescription: "[data-plan-description]",
            remainingCount: "[data-remaining-count]",
            remainingMax: "data-remaining-max",
            remainingWrapper: "[data-remaining-wrapper]",
            remainingJSON: "[data-product-remaining-json]",
            isPreOrder: "[data-product-preorder]",
        },
        sq = {
            hide: "hide",
            variantSoldOut: "variant--soldout",
            variantUnavailable: "variant--unavailable",
            productPriceSale: "product__price--sale",
            remainingLow: "count-is-low",
            remainingIn: "count-is-in",
            remainingOut: "count-is-out",
            remainingUnavailable: "count-is-unavailable",
        },
        sI = class e extends HTMLElement {
            connectedCallback() {
                (this.outerSection = this.container.closest(sC.outerSection)),
                    (this.quickview = this.container.closest(sC.quickviewModal)),
                    (this.outerWrapper = this.quickview ? this.quickview : this.outerSection),
                    (this.productFormWrapper = this.container.closest(sC.productFormWrapper)),
                    (this.productFormElement = this.container.querySelector(sC.productForm)),
                    (this.productForm = this.container.querySelector(sC.productForm)),
                    (this.slideshow = this.outerWrapper.querySelector(sC.productSlideshow)),
                    (this.slideshowDesktop = this.outerWrapper.querySelector(sC.productSlideshowDesktop)),
                    (this.enableHistoryState =
                        !!(this.outerSection && this.outerSection.hasAttribute(sC.dataEnableHistoryState)) &&
                        "true" === this.outerSection.getAttribute(sC.dataEnableHistoryState)),
                    (this.hasUnitPricing = this.outerWrapper.querySelector(sC.unitWrapper)),
                    (this.subSelectors = this.outerWrapper.querySelector(sC.subSelectors)),
                    (this.subPrices = this.outerWrapper.querySelector(sC.subPrices)),
                    (this.priceOffWrap = this.outerWrapper.querySelector(sC.priceOffWrap)),
                    (this.priceOffAmount = this.outerWrapper.querySelector(sC.priceOffAmount)),
                    (this.priceOffType = this.outerWrapper.querySelector(sC.priceOffType)),
                    (this.planDecription = this.outerWrapper.querySelector(sC.subDescription)),
                    (this.isPreOrder = this.container.querySelector(sC.isPreOrder)),
                    (this.remainingWrapper = this.outerWrapper.querySelector(sC.remainingWrapper));
                let e = this.outerWrapper.querySelector(`[${sC.remainingMax}]`);
                (this.sellout = null),
                    this.remainingWrapper &&
                        e &&
                        ((this.remainingMaxInt = parseInt(e.getAttribute(sC.remainingMax), 10)),
                        (this.remainingCount = this.outerWrapper.querySelector(sC.remainingCount)),
                        (this.remainingJSONWrapper = this.outerWrapper.querySelector(sC.remainingJSON)),
                        (this.remainingJSON = null),
                        this.remainingJSONWrapper && "" !== this.remainingJSONWrapper.innerHTML
                            ? (this.remainingJSON = JSON.parse(this.remainingJSONWrapper.innerHTML))
                            : console.warn("Missing product quantity JSON")),
                    sT(this.outerWrapper);
                let t = null;
                this.productJSON = null;
                let i = this.outerWrapper.querySelector(sC.productJson);
                i && (t = i.innerHTML),
                    t && this.productForm
                        ? ((this.productJSON = JSON.parse(t)),
                          (this.sellout = new sA(this.outerWrapper, this.productJSON)),
                          this.linkForm())
                        : console.warn("Missing product form or product JSON"),
                    this.productJSON && new ek(this.productJSON.handle);
            }
            destroy() {
                this.productForm.destroy();
            }
            linkForm() {
                (this.productForm = new sE(this.outerWrapper, this.productFormElement, this.productJSON, {
                    onOptionChange: this.onOptionChange.bind(this),
                    onPlanChange: this.onPlanChange.bind(this),
                    onQuantityChange: this.onQuantityChange.bind(this),
                })),
                    this.pushState(this.productForm.getFormState(), !0),
                    this.subsToggleListeners();
            }
            onOptionChange(e) {
                this.pushState(e.dataset),
                    !this.slideshowDesktop &&
                        window.innerWidth >= window.theme.sizes.medium &&
                        this.updateProductImage(e.dataset);
            }
            onPlanChange(e) {
                this.subPrices && this.pushState(e.dataset);
            }
            onQuantityChange(e) {
                let t = e.dataset;
                (this.productState = this.setProductState(t)), this.updateButtonPrices(t);
            }
            pushState(e, t = !1) {
                (this.productState = this.setProductState(e)),
                    this.updateAddToCartState(e),
                    this.updateProductPrices(e),
                    this.updateSaleText(e),
                    this.updateSubscriptionText(e),
                    this.updateLegend(e),
                    this.updateRemaining(e),
                    this.fireHookEvent(e),
                    this.sellout && this.sellout.update(e),
                    this.enableHistoryState && !t && this.updateHistoryState(e);
                let i = () => {
                    let t = new URLSearchParams(location.search).get("variant");
                    t && this.updateProductImage(e);
                };
                this.initCallbackAfterSlideshowReady(i);
            }
            initCallbackAfterSlideshowReady(e) {
                if (this.slideshow.classList.contains("flickity-enabled")) e();
                else {
                    let t = new MutationObserver((i) => {
                        for (let s of i)
                            if ("class" === s.attributeName && this.slideshow.classList.contains("flickity-enabled")) {
                                t.disconnect(), e();
                                break;
                            }
                    });
                    t.observe(this.slideshow, { attributes: !0 });
                }
            }
            updateAddToCartState(e) {
                let t = e.variant,
                    i = theme.strings.addToCart,
                    s = this.outerWrapper.querySelectorAll(sC.priceWrapper),
                    r = this.outerWrapper.querySelector(sC.buttonsWrapper),
                    n = null == r ? void 0 : r.querySelectorAll(sC.addToCart),
                    a = null == r ? void 0 : r.querySelectorAll(sC.addToCartText);
                if (
                    (this.isPreOrder && (i = theme.strings.preOrder),
                    s.length &&
                        t &&
                        s.forEach((e) => {
                            e.classList.remove(sq.hide);
                        }),
                    (null == n ? void 0 : n.length) &&
                        n.forEach((e) => {
                            t && t.available ? (e.disabled = !1) : (e.disabled = !0);
                        }),
                    (null == a ? void 0 : a.length) &&
                        a.forEach((e) => {
                            t
                                ? t.available
                                    ? (e.innerHTML = i)
                                    : (e.innerHTML = theme.strings.soldOut)
                                : (e.innerHTML = theme.strings.unavailable);
                        }),
                    r && t)
                ) {
                    let o = r.querySelector(sC.originalSelectorId);
                    o && (o.value = t.id);
                }
                r &&
                    this.productFormWrapper &&
                    (t
                        ? t.available
                            ? this.productFormWrapper.classList.remove(sq.variantSoldOut, sq.variantUnavailable)
                            : (this.productFormWrapper.classList.add(sq.variantSoldOut),
                              this.productFormWrapper.classList.remove(sq.variantUnavailable))
                        : (this.productFormWrapper.classList.add(sq.variantUnavailable),
                          this.productFormWrapper.classList.remove(sq.variantSoldOut)));
            }
            updateLegend(e) {
                let t = e.variant;
                if (t) {
                    let i = this.container.parentNode.querySelectorAll(sC.optionValue);
                    i.forEach((e) => {
                        let i = e.closest(`[${sC.optionPosition}]`);
                        if (i) {
                            let s = i.getAttribute(sC.optionPosition),
                                r = parseInt(s, 10) - 1;
                            (this.newValue = t.options[r]), (e.innerHTML = this.newValue);
                        }
                    });
                }
            }
            updateHistoryState(e) {
                let t = e.variant,
                    i = e.plan,
                    s = window.location.href;
                if (t && s.includes("/product")) {
                    let r = new window.URL(s),
                        n = r.searchParams;
                    n.set("variant", t.id),
                        i && i.detail && i.detail.id && this.productState.hasPlan
                            ? n.set("selling_plan", i.detail.id)
                            : n.delete("selling_plan"),
                        (r.search = n.toString());
                    let a = r.toString();
                    window.history.replaceState({ path: a }, "", a);
                }
            }
            updateRemaining(e) {
                let t = e.variant;
                if (t && this.remainingWrapper && this.remainingJSON && this.remainingCount) {
                    let i = this.remainingJSON[t.id];
                    i && i <= this.remainingMaxInt && i > 0
                        ? (this.remainingWrapper.classList.remove(
                              sq.remainingIn,
                              sq.remainingOut,
                              sq.remainingUnavailable
                          ),
                          this.remainingWrapper.classList.add(sq.remainingLow),
                          (this.remainingCount.innerHTML = i))
                        : this.productState.soldOut
                          ? (this.remainingWrapper.classList.remove(
                                sq.remainingLow,
                                sq.remainingIn,
                                sq.remainingUnavailable
                            ),
                            this.remainingWrapper.classList.add(sq.remainingOut))
                          : this.productState.available &&
                            (this.remainingWrapper.classList.remove(
                                sq.remainingLow,
                                sq.remainingOut,
                                sq.remainingUnavailable
                            ),
                            this.remainingWrapper.classList.add(sq.remainingIn));
                } else
                    this.remainingWrapper &&
                        (this.remainingWrapper.classList.remove(sq.remainingIn, sq.remainingOut, sq.remainingLow),
                        this.remainingWrapper.classList.add(sq.remainingUnavailable));
            }
            getBaseUnit(e) {
                return 1 === e.unit_price_measurement.reference_value
                    ? e.unit_price_measurement.reference_unit
                    : e.unit_price_measurement.reference_value + e.unit_price_measurement.reference_unit;
            }
            subsToggleListeners() {
                let e = this.outerWrapper.querySelectorAll(sC.subsToggle);
                e.forEach((e) => {
                    e.addEventListener(
                        "change",
                        function (e) {
                            let t = e.target.value.toString(),
                                i = this.outerWrapper.querySelector(`[${sC.subsChild}="${t}"]`),
                                s = this.outerWrapper.querySelectorAll(`[${sC.subsChild}]`);
                            if (i) {
                                i.classList.remove(sq.hide);
                                let r = i.querySelector('[name="selling_plan"]');
                                (r.checked = !0), r.dispatchEvent(new Event("change"));
                            }
                            s.forEach((e) => {
                                if (e !== i) {
                                    e.classList.add(sq.hide);
                                    let t = e.querySelectorAll('[name="selling_plan"]');
                                    t.forEach((e) => {
                                        (e.checked = !1), e.dispatchEvent(new Event("change"));
                                    });
                                }
                            });
                        }.bind(this)
                    );
                });
            }
            updateSaleText(e) {
                this.productState.planSale
                    ? this.updateSaleTextSubscription(e)
                    : this.productState.onSale
                      ? this.updateSaleTextStandard(e)
                      : this.priceOffWrap && this.priceOffWrap.classList.add(sq.hide);
            }
            updateSaleTextStandard(e) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.sale || "sale";
                let t = e.variant;
                if (window.theme.settings.badge_sale_type && "percentage" === window.theme.settings.badge_sale_type) {
                    let i = (t.compare_at_price - t.price) / t.compare_at_price;
                    this.priceOffAmount.innerHTML = `${Math.floor(100 * i)}%`;
                } else {
                    let s = t.compare_at_price - t.price;
                    this.priceOffAmount.innerHTML = this.formattingMoney(s);
                }
                this.priceOffWrap.classList.remove(sq.hide);
            }
            updateSaleTextSubscription(e) {
                if (!this.priceOffType) return;
                this.priceOffType.innerHTML = window.theme.strings.subscription || "subscripton";
                let t = e.variant,
                    i = e.plan.detail.price_adjustments[0],
                    s = i.value;
                i && "percentage" === i.value_type
                    ? (this.priceOffAmount.innerHTML = `${s}%`)
                    : i && "price" === i.value_type
                      ? (this.priceOffAmount.innerHTML = this.formattingMoney(t.price - i.value))
                      : (this.priceOffAmount.innerHTML = this.formattingMoney(s)),
                    this.priceOffWrap.classList.remove(sq.hide);
            }
            updateSubscriptionText(e) {
                e.plan && this.planDecription && null !== e.plan.detail.description
                    ? ((this.planDecription.innerHTML = e.plan.detail.description),
                      this.planDecription.classList.remove(sq.hide))
                    : this.planDecription && this.planDecription.classList.add(sq.hide);
            }
            getPrices(e) {
                let t = e.variant,
                    i = e.plan,
                    s = "",
                    r = "";
                return (
                    this.productState.available && ((s = t.compare_at_price), (r = t.price)),
                    this.productState.hasPlan && (r = i.allocation.price),
                    this.productState.planSale && ((s = i.allocation.compare_at_price), (r = i.allocation.price)),
                    { price: r, comparePrice: s }
                );
            }
            updateButtonPrices(e) {
                let t = this.outerWrapper.querySelectorAll(sC.priceButton),
                    { price: i } = this.getPrices(e);
                t.length &&
                    t.forEach((t) => {
                        if (null !== i && "" !== i) {
                            let s = e.quantity * i;
                            t.innerHTML = this.formattingMoney(s);
                        } else t.innerHTML = "";
                    });
            }
            updateProductPrices(e) {
                let t = e.variant,
                    i = this.outerWrapper.querySelectorAll(sC.priceWrapper),
                    s = this.outerWrapper.querySelectorAll(sC.priceButton),
                    { price: r, comparePrice: n } = this.getPrices(e);
                i.forEach((e) => {
                    let i = e.querySelector(sC.productPrice),
                        s = e.querySelector(sC.comparePrice);
                    this.productState.onSale || this.productState.planSale
                        ? (i.classList.add(sq.productPriceSale), null == s || s.classList.remove(sq.hide))
                        : (i.classList.remove(sq.productPriceSale), null == s || s.classList.add(sq.hide)),
                        s && (s.innerHTML = this.formattingMoney(n)),
                        i &&
                            (t && null !== r && "" !== r
                                ? (i.innerHTML = this.formattingMoney(r))
                                : (i.innerHTML = "&nbsp;"));
                }),
                    s.length &&
                        s.forEach((t) => {
                            if (null !== r && "" !== r) {
                                let i = e.quantity * r;
                                t.innerHTML = this.formattingMoney(i);
                            } else t.innerHTML = "";
                        }),
                    this.hasUnitPricing && this.updateProductUnits(e);
            }
            updateProductUnits(e) {
                let t = e.variant,
                    i = e.plan,
                    s = null;
                if (
                    (t && t.unit_price && (s = t.unit_price),
                    i && i.allocation && i.allocation.unit_price && (s = i.allocation.unit_price),
                    s)
                ) {
                    let r = this.getBaseUnit(t);
                    (this.outerWrapper.querySelector(sC.unitPrice).innerHTML = this.formattingMoney(s)),
                        (this.outerWrapper.querySelector(sC.unitBase).innerHTML = r),
                        ec(this.outerWrapper.querySelector(sC.unitWrapper));
                } else ir(this.outerWrapper.querySelector(sC.unitWrapper));
            }
            fireHookEvent(e) {
                let t = e.variant;
                this.container.dispatchEvent(
                    new CustomEvent("theme:variant:change", { detail: { variant: t }, bubbles: !0 })
                );
            }
            setProductState(e) {
                let t = e.variant,
                    i = e.plan,
                    s = {
                        available: !0,
                        soldOut: !1,
                        onSale: !1,
                        showUnitPrice: !1,
                        requiresPlan: !1,
                        hasPlan: !1,
                        planPerDelivery: !1,
                        planSale: !1,
                    };
                return (
                    t && (!t.requires_selling_plan || i)
                        ? (t.available || (s.soldOut = !0),
                          t.compare_at_price > t.price && (s.onSale = !0),
                          t.unit_price && (s.showUnitPrice = !0),
                          this.productJSON && this.productJSON.requires_selling_plan && (s.requiresPlan = !0),
                          i &&
                              this.subPrices &&
                              ((s.hasPlan = !0),
                              i.allocation.per_delivery_price !== i.allocation.price && (s.planPerDelivery = !0),
                              i.allocation.compare_at_price > i.allocation.price && (s.planSale = !0)))
                        : (s.available = !1),
                    s
                );
            }
            updateProductImage(e) {
                let t = e.variant;
                t &&
                    this.slideshow &&
                    t.featured_media &&
                    t.featured_media.id &&
                    (this.slideshow.dispatchEvent(
                        new CustomEvent("theme:image:change", { detail: { id: t.featured_media.id } })
                    ),
                    this.scrollImageViewport(t));
            }
            scrollImageViewport(e) {
                let t = eT.isDesktop() || eT.isTablet();
                if (t && this.slideshow.hasAttribute("data-vertical-images")) {
                    let i = this.slideshow.querySelector(`[data-media-id="${e.featured_media.id}"]`),
                        s = i.getBoundingClientRect(),
                        r = s.top,
                        n = s.bottom,
                        a = s.height < window.innerHeight;
                    if (r < 0 || (a && n > window.innerHeight)) {
                        let o = r + window.scrollY;
                        r < 0
                            ? (o = r + window.scrollY)
                            : n > window.innerHeight && (o = r + window.scrollY - (window.innerHeight - s.height)),
                            window.scrollTo({ top: o, left: 0, behavior: "smooth" });
                    }
                }
            }
            formattingMoney(e) {
                return theme.settings.currency_code_enable
                    ? a.formatMoney(e, theme.moneyFormat) + ` ${theme.currencyCode}`
                    : a.formatMoney(e, theme.moneyFormat);
            }
            constructor() {
                super(), (this.container = this);
            }
        },
        sP = class e extends HTMLElement {
            connectedCallback() {
                fetch(this.dataset.url)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = document.createElement("div");
                        t.innerHTML = e;
                        let i = t.querySelector("[data-api-content]");
                        i && (this.innerHTML = i.innerHTML);
                        let s = this.closest("[data-product-complimentary-loaded]");
                        s && "" !== i.innerHTML.trim() && s.classList.remove("js-unloaded");
                    })
                    .catch((e) => {
                        console.error(e);
                    });
            }
            constructor() {
                super();
            }
        },
        s9 = {
            slideshow: "[data-product-slideshow]",
            singeImage: "[data-product-image]",
            zoomButton: "[data-zoom-button]",
            zoomWrapper: "[data-zoom-wrapper]",
            mediaId: "data-media-id",
        },
        sM = {
            body: "body",
            dataRelatedSectionElem: "[data-related-section]",
            dataTabsHolder: "[data-tabs-holder]",
            dataTab: "data-tab",
            dataTabIndex: "data-tab-index",
            blockId: "data-block-id",
            tabsLi: ".tabs > button",
            tabLink: ".tab-link",
            tabLinkRecent: ".tab-link__recent",
            tabContent: ".tab-content",
            scrollbarHolder: "[data-scrollbar]",
            scrollbarArrowPrev: "[data-scrollbar-arrow-prev]",
            scrollbarArrowNext: "[data-scrollbar-arrow-next]",
            firstElement: "a:first-child, input:first-child",
        },
        sD = { classCurrent: "current", classHide: "hide", classAlt: "alt", isFocused: "is-focused" },
        sO = {},
        sF = class e {
            init() {
                let e = this.container,
                    t = e.querySelectorAll(sM.tabsLi),
                    i = e.querySelector(`${sM.tabLink}-0`),
                    s = e.querySelector(`${sM.tabContent}-0`);
                s && s.classList.add(sD.classCurrent),
                    i && i.classList.add(sD.classCurrent),
                    this.checkVisibleTabLinks(),
                    this.container.addEventListener("theme:tabs:check", () => this.checkRecentTab()),
                    this.container.addEventListener("theme:tabs:hide", () => this.hideRelatedTab()),
                    t.length &&
                        t.forEach((t) => {
                            let i = parseInt(t.getAttribute(sM.dataTab)),
                                s = e.querySelector(`${sM.tabContent}-${i}`);
                            t.addEventListener("click", () => {
                                this.tabChange(t, s);
                            }),
                                t.addEventListener("keyup", (e) => {
                                    ("Space" === e.code || "Enter" === e.code) &&
                                        this.body.classList.contains(sD.isFocused) &&
                                        (this.tabChange(t, s),
                                        s.querySelector("a, input") &&
                                            ((this.accessibility.lastFocused = t),
                                            this.accessibility.a11y.trapFocus(s, {
                                                elementToFocus: s.querySelector(sM.firstElement),
                                            })));
                                });
                        });
            }
            tabChange(e, t) {
                this.container.querySelector(`${sM.tabsLi}.${sD.classCurrent}`).classList.remove(sD.classCurrent),
                    this.container
                        .querySelector(`${sM.tabContent}.${sD.classCurrent}`)
                        .classList.remove(sD.classCurrent),
                    e.classList.add(sD.classCurrent),
                    t.classList.add(sD.classCurrent),
                    e.classList.contains(sD.classHide) && t.classList.add(sD.classHide),
                    this.checkVisibleTabLinks(),
                    this.container.dispatchEvent(new CustomEvent("theme:tab:change"));
            }
            initNativeScrollbar() {
                this.scrollbarHolder.length &&
                    this.scrollbarHolder.forEach((e) => {
                        new ef(e);
                    });
            }
            checkVisibleTabLinks() {
                let e = this.container.querySelectorAll(sM.tabsLi),
                    t = this.container.querySelectorAll(`${sM.tabLink}.${sD.classHide}`),
                    i = e.length - t.length;
                i < 2 ? this.container.classList.add(sD.classAlt) : this.container.classList.remove(sD.classAlt);
            }
            checkRecentTab() {
                let e = this.container.querySelector(sM.tabLinkRecent);
                if (e) {
                    e.classList.remove(sD.classHide);
                    let t = parseInt(e.getAttribute(sM.dataTab)),
                        i = this.container.querySelector(`${sM.tabContent}[${sM.dataTabIndex}="${t}"]`);
                    i && i.classList.remove(sD.classHide), this.checkVisibleTabLinks(), this.initNativeScrollbar();
                }
            }
            hideRelatedTab() {
                let e = this.container.querySelector(sM.dataRelatedSectionElem);
                if (!e) return;
                let t = e.closest(`${sM.tabContent}.${sD.classCurrent}`);
                if (!t) return;
                let i = parseInt(t.getAttribute(sM.dataTabIndex)),
                    s = this.container.querySelectorAll(sM.tabsLi);
                if (s.length > i) {
                    let r = s[i].nextElementSibling;
                    r &&
                        (s[i].classList.add(sD.classHide),
                        r.dispatchEvent(new Event("click")),
                        this.initNativeScrollbar());
                }
            }
            onBlockSelect(e) {
                let t = this.container.querySelector(`${sM.tabLink}[${sM.blockId}="${e.detail.blockId}"]`);
                t &&
                    (t.dispatchEvent(new Event("click")),
                    t.parentNode.scrollTo({ top: 0, left: t.offsetLeft - t.clientWidth, behavior: "smooth" }));
            }
            constructor(e) {
                (this.container = e),
                    (this.body = document.querySelector(sM.body)),
                    (this.accessibility = window.accessibility),
                    this.container &&
                        ((this.scrollbarHolder = this.container.querySelectorAll(sM.scrollbarHolder)),
                        this.init(),
                        this.initNativeScrollbar());
            }
        },
        sB = {
            onLoad() {
                sO[this.id] = [];
                let e = this.container.querySelectorAll(sM.dataTabsHolder);
                e.forEach((e) => {
                    sO[this.id].push(new sF(e));
                });
            },
            onBlockSelect(e) {
                sO[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
        },
        sV = {
            urlInput: "[data-share-url]",
            section: "data-section-type",
            shareDetails: "[data-share-details]",
            shareSummary: "[data-share-summary]",
            shareCopy: "[data-share-copy]",
            shareButton: "[data-share-button]",
            closeButton: "[data-close-button]",
            successMessage: "[data-success-message]",
            shareHolder: "[data-share-holder]",
        },
        sH = { hidden: "is-hidden" },
        sW = class e extends HTMLElement {
            init() {
                navigator.share
                    ? (this.mainDetailsToggle.classList.add(sH.hidden),
                      this.shareButton.classList.remove(sH.hidden),
                      this.shareButton.addEventListener("click", () => {
                          navigator.share({ url: this.urlToShare, title: document.title });
                      }))
                    : (this.mainDetailsToggle.addEventListener("toggle", this.toggleDetails.bind(this)),
                      this.mainDetailsToggle.addEventListener("focusout", () => {
                          setTimeout(() => {
                              this.contains(document.activeElement) || this.close();
                          });
                      }),
                      this.shareCopy.addEventListener("click", this.copyToClipboard.bind(this)),
                      this.closeButton.addEventListener("click", this.close.bind(this)),
                      this.container.addEventListener("keyup", this.keyboardEvents.bind(this)));
            }
            updateShareLink() {
                "product" == this.container.getAttribute(sV.section) &&
                    this.container.addEventListener("theme:variant:change", (e) => {
                        e.detail.variant &&
                            ((this.urlToShare = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`),
                            this.urlInput &&
                                (this.urlInput.value = `${this.urlToShare.split("?")[0]}?variant=${e.detail.variant.id}`));
                    });
            }
            toggleDetails() {
                this.mainDetailsToggle.open ||
                    (this.successMessage.classList.add(sH.hidden),
                    (this.successMessage.textContent = ""),
                    this.closeButton.classList.add(sH.hidden),
                    this.shareCopy.focus());
            }
            copyToClipboard() {
                navigator.clipboard.writeText(this.urlInput.value).then(() => {
                    this.successMessage.classList.remove(sH.hidden),
                        (this.successMessage.textContent = theme.strings.successMessage),
                        this.closeButton.classList.remove(sH.hidden),
                        this.closeButton.focus();
                });
            }
            close() {
                this.mainDetailsToggle.removeAttribute("open"), this.shareSummary.setAttribute("aria-expanded", !1);
            }
            keyboardEvents(e) {
                "Escape" === e.code && (this.mainDetailsToggle.focus(), this.close());
            }
            constructor() {
                super(),
                    (this.container = this.closest(`[${sV.section}]`)),
                    (this.mainDetailsToggle = this.querySelector(sV.shareDetails)),
                    (this.shareButton = this.querySelector(sV.shareButton)),
                    (this.shareCopy = this.querySelector(sV.shareCopy)),
                    (this.shareSummary = this.querySelector(sV.shareSummary)),
                    (this.closeButton = this.querySelector(sV.closeButton)),
                    (this.successMessage = this.querySelector(sV.successMessage)),
                    (this.shareHolder = this.querySelector(sV.shareHolder)),
                    (this.urlInput = this.querySelector(sV.urlInput)),
                    (this.urlToShare = this.urlInput ? this.urlInput.value : document.location.href),
                    this.init(),
                    this.updateShareLink();
            }
        },
        sR = {
            groupImage: "data-image-filter",
            slider: "[data-product-slideshow]",
            thumbSlider: "[data-product-thumbs]",
            thumbs: "[data-slideshow-thumbnail]",
            slides: "[data-media-slide]",
        },
        sN = { hide: "hide", flickityEnable: "flickity-enabled" },
        sz = { sizeButton: "[data-size-button]", mediaHolder: "[data-media-slide]" },
        s0 = { classExpanded: "is-expanded" },
        sj = class e {
            init() {
                this.sizeButtons.forEach((e) => {
                    e.addEventListener("click", () => {
                        e.classList.toggle(s0.classExpanded),
                            e.closest(sz.mediaHolder).classList.toggle(s0.classExpanded);
                    });
                });
            }
            constructor(e) {
                (this.container = e),
                    (this.sizeButtons = this.container.querySelectorAll(sz.sizeButton)),
                    this.sizeButtons.length > 0 && this.init();
            }
        },
        sU = {
            productJson: "[data-product-json]",
            zoomButton: "[data-zoom-button]",
            toggleTruncateHolder: "[data-truncated-holder]",
            toggleTruncateButton: "[data-truncated-button]",
            toggleTruncateContent: "data-truncated-content",
        },
        s3 = { classExpanded: "is-expanded", classVisible: "is-visible" },
        sG = [],
        s1 = class e {
            init() {
                (this.zoomEnabled = null !== this.container.querySelector(sU.zoomButton)),
                    this.zoomEnabled &&
                        (function e(t, i) {
                            let s = tV({ url: window.theme.assets.photoswipe }),
                                r = s
                                    .then(() => {
                                        let e = window.themePhotoswipe.PhotoSwipe.default,
                                            s = window.themePhotoswipe.PhotoSwipeUI.default,
                                            r = t.querySelectorAll(s9.zoomButton);
                                        r.forEach((r) => {
                                            r.addEventListener("click", (r) => {
                                                let n = t.querySelector(s9.zoomWrapper),
                                                    a = r.target
                                                        .closest(`[${s9.mediaId}]`)
                                                        .getAttribute(s9.mediaId)
                                                        .toString(),
                                                    o = [];
                                                for (let l = 0; l < i.media.length; l++)
                                                    "image" === i.media[l].media_type &&
                                                        (o[o.length] = {
                                                            src: i.media[l].src,
                                                            w: i.media[l].width,
                                                            h: i.media[l].height,
                                                            id: i.media[l].id,
                                                        });
                                                let d = (e) => e.id.toString() === a,
                                                    c = o.findIndex(d);
                                                n.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 }));
                                                let h = new e(n, s, o, {
                                                    index: c,
                                                    showHideOpacity: !0,
                                                    showAnimationDuration: 150,
                                                    hideAnimationDuration: 250,
                                                    bgOpacity: 1,
                                                    spacing: 0,
                                                    allowPanToNext: !1,
                                                    maxSpreadZoom: 3,
                                                    history: !1,
                                                    loop: !0,
                                                    pinchToClose: !1,
                                                    modal: !1,
                                                    closeOnScroll: !1,
                                                    closeOnVerticalDrag: !0,
                                                    getDoubleTapZoom: function e(t, i) {
                                                        return t ? 1.67 : i.initialZoomLevel < 0.7 ? 1 : 1.3;
                                                    },
                                                    getThumbBoundsFn: function e() {
                                                        let i = t.querySelector(s9.slideshow);
                                                        i || (i = t.querySelector(s9.singeImage));
                                                        let s =
                                                                window.pageYOffset ||
                                                                document.documentElement.scrollTop,
                                                            r = i.getBoundingClientRect();
                                                        return { x: r.left, y: r.top + s, w: r.width };
                                                    },
                                                });
                                                h.init(),
                                                    h.listen("close", function () {
                                                        document.dispatchEvent(
                                                            new CustomEvent("theme:scroll:unlock", { bubbles: !0 })
                                                        );
                                                    });
                                            });
                                        });
                                    })
                                    .catch((e) => console.error(e));
                            return r;
                        })(this.container, this.product),
                    this.truncateElementHolder &&
                        this.truncateElement &&
                        (setTimeout(this.resizeEventTruncate, 50),
                        document.addEventListener("theme:resize", this.resizeEventTruncate)),
                    new sj(this.container);
            }
            truncateText() {
                if (this.truncateElementHolder.classList.contains(s3.classVisible)) return;
                let e = this.truncateElement.querySelectorAll("style");
                e.length &&
                    e.forEach((e) => {
                        this.truncateElementHolder.prepend(e);
                    });
                let t = this.truncateElement.cloneNode(!0),
                    i = this.truncateElement.getAttribute(sU.toggleTruncateContent),
                    s = this.truncateElement.nextElementSibling;
                s && s.remove(), this.truncateElement.parentElement.append(t);
                let r = this.truncateElement.nextElementSibling;
                r.classList.add(i),
                    r.removeAttribute(sU.toggleTruncateContent),
                    ec(r),
                    sn(r, 5, { replaceStr: "", delimiter: " " }),
                    ir(r),
                    this.truncateElement.innerHTML !== r.innerHTML
                        ? this.truncateElementHolder.classList.add(s3.classExpanded)
                        : (r.remove(), this.truncateElementHolder.classList.remove(s3.classExpanded)),
                    this.toggleTruncatedContent(this.truncateElementHolder);
            }
            toggleTruncatedContent(e) {
                let t = e.querySelector(sU.toggleTruncateButton);
                t &&
                    t.addEventListener("click", (t) => {
                        t.preventDefault(), e.classList.remove(s3.classExpanded), e.classList.add(s3.classVisible);
                    });
            }
            onBlockSelect(e) {
                let t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                t && t.dispatchEvent(new Event("click"));
            }
            onBlockDeselect(e) {
                let t = this.container.querySelector(`[data-block-id="${e.detail.blockId}"]`);
                t && t.dispatchEvent(new Event("click"));
            }
            onUnload() {
                this.media.destroy(),
                    this.truncateElementHolder &&
                        this.truncateElement &&
                        document.removeEventListener("theme:resize", this.resizeEventTruncate);
            }
            constructor(e) {
                (this.section = e),
                    (this.id = e.id),
                    (this.container = e.container),
                    (this.settings = e.settings),
                    eQ(this.id),
                    (this.media = new sf(e)),
                    new (class e {
                        listen() {
                            this.container.addEventListener("theme:variant:change", (e) => {
                                e.detail.variant &&
                                    ((this.variantImage = e.detail.variant.featured_image), this.filterImages());
                            });
                        }
                        filterImages() {
                            null !== this.variantImage && null !== this.variantImage.alt
                                ? ((this.variantImageAlt = this.variantImage.alt.split("#")[1]), this.showImages())
                                : this.resetImages(),
                                this.refreshSliders();
                        }
                        resetImages() {
                            this.thumbs.forEach((e) => e.classList.remove(sN.hide)),
                                this.slides.forEach((e) => e.classList.remove(sN.hide));
                        }
                        showImages() {
                            this.thumbs.forEach((e) => {
                                "" === e.getAttribute(sR.groupImage) ||
                                e.getAttribute(sR.groupImage) === this.variantImageAlt
                                    ? e.classList.remove(sN.hide)
                                    : e.classList.add(sN.hide);
                            }),
                                this.slides.forEach((e) => {
                                    "" === e.getAttribute(sR.groupImage) ||
                                    e.getAttribute(sR.groupImage) === this.variantImageAlt
                                        ? e.classList.remove(sN.hide)
                                        : e.classList.add(sN.hide);
                                });
                        }
                        refreshSliders() {
                            if (null !== this.slider && this.slider.classList.contains(sN.flickityEnable)) {
                                let e = t.data(this.slider);
                                void 0 !== e && e.reloadCells();
                            }
                            if (null !== this.thumbSlider && this.thumbSlider.classList.contains(sN.flickityEnable)) {
                                let i = l.data(this.thumbSlider);
                                void 0 !== i && i.reloadCells();
                            }
                        }
                        constructor(e) {
                            (this.section = e),
                                (this.container = e.container),
                                (this.slider = this.container.querySelector(sR.slider)),
                                (this.thumbSlider = this.container.querySelector(sR.thumbSlider)),
                                (this.thumbs = this.container.querySelectorAll(sR.thumbs)),
                                (this.slides = this.container.querySelectorAll(sR.slides)),
                                (this.variantImage = null),
                                this.listen();
                        }
                    })(e);
                let i = this.container.querySelector(sU.productJson);
                if (i && "" !== i.innerHTML) this.product = JSON.parse(i.innerHTML);
                else {
                    console.error("Missing product JSON");
                    return;
                }
                (this.truncateElementHolder = this.container.querySelector(sU.toggleTruncateHolder)),
                    (this.truncateElement = this.container.querySelector(`[${sU.toggleTruncateContent}]`)),
                    (this.resizeEventTruncate = () => this.truncateText()),
                    this.init();
            }
        };
    eN("product", [
        {
            onLoad() {
                sG[this.id] = new s1(this);
            },
            onUnload() {
                "function" == typeof sG[this.id].unload && sG[this.id].unload();
            },
            onBlockSelect(e) {
                "function" == typeof sG[this.id].onBlockSelect && sG[this.id].onBlockSelect(e);
            },
            onBlockDeselect(e) {
                "function" == typeof sG[this.id].onBlockDeselect && sG[this.id].onBlockDeselect(e);
            },
        },
        {
            onLoad() {
                sb[this.id] = new s$(this);
            },
        },
        is,
        sB,
        {
            onLoad() {
                tN(this.container);
            },
        },
    ]),
        customElements.get("product-form") || customElements.define("product-form", sI),
        customElements.get("product-complimentary") || customElements.define("product-complimentary", sP),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("popout-select") || customElements.define("popout-select", tQ),
        customElements.get("share-button") || customElements.define("share-button", sW);
    let sK = { toggle: "data-toggle-grid", large: "data-grid-large", small: "data-grid-small" },
        s2 = { active: "is-active" },
        s4 = { breakpoint: window.theme.sizes.small };
    var sX = {};
    let sY = class e {
            init() {
                this.toggle.addEventListener("click", this.toggleFunction),
                    document.addEventListener("theme:resize:width", this.toggleFunction),
                    this.toggleEvent(!1);
            }
            unload() {
                this.toggle.removeEventListener("click", this.toggleFunction),
                    document.removeEventListener("theme:resize:width", this.toggleFunction);
            }
            toggleEvent(e = !0) {
                let t = e && "click" === e.type,
                    i = window.innerWidth >= s4.breakpoint,
                    s = i ? sK.large : sK.small,
                    r = this.container.querySelector(`[${s}]`),
                    n = r.getAttribute(s),
                    a = this.toggle.parentElement.querySelector(`[${sK.toggle}].${s2.active}`),
                    o = this.toggle.parentElement.querySelector(`[${sK.toggle}="${n}"]`);
                t && ((o = this.toggle), r.setAttribute(s, this.value)),
                    a && a.classList.remove(s2.active),
                    o && o.classList.add(s2.active);
            }
            constructor(e, t) {
                (this.container = t || document),
                    (this.toggle = e),
                    (this.value = this.toggle.getAttribute(sK.toggle)),
                    (this.toggleFunction = (e) => this.toggleEvent(e)),
                    this.init();
            }
        },
        s6 = {
            sort: "data-sort-enabled",
            sortLinks: "[data-sort-link]",
            sortButtonText: "[data-sort-button-text]",
            sortValue: "data-value",
        },
        sJ = { active: "popout-list__item--current" },
        sQ = class e {
            init() {
                this.sortLinks.forEach((e) => {
                    e.addEventListener("click", (e) => {
                        e.preventDefault(), this.sortingResults(e);
                    });
                });
            }
            sortingResults(e) {
                let t = e.currentTarget,
                    i = t.getAttribute(s6.sortValue),
                    s = t.innerText;
                (this.sortButtonText.innerText = s),
                    this.sortButtonText.parentNode.dispatchEvent(new Event("click")),
                    this.sort.querySelector(`.${sJ.active}`).classList.remove(sJ.active),
                    t.parentNode.classList.add(sJ.active),
                    this.sort.setAttribute(s6.sort, i),
                    this.container.dispatchEvent(
                        new CustomEvent("theme:form:filter", { bubbles: !0, detail: { params: i } })
                    );
            }
            constructor(e) {
                (this.container = e.container),
                    (this.sort = this.container.querySelector(`[${s6.sort}]`)),
                    (this.sortLinks = this.container.querySelectorAll(s6.sortLinks)),
                    (this.sortButtonText = this.container.querySelector(s6.sortButtonText)),
                    this.sort && this.init();
            }
        },
        s7 = class e {
            init() {
                new sQ(this.section);
            }
            constructor(e) {
                (this.section = e),
                    (this.container = this.section.container),
                    (this.swatches = this.container.querySelectorAll("[data-swatch]")),
                    this.init();
            }
        };
    eN("collection", [
        {
            onLoad() {
                this.collection = new s7(this);
            },
        },
        iQ,
        st,
        {
            onLoad() {
                sX[this.id] = [];
                let e = this.container.querySelectorAll(`[${sK.toggle}]`);
                e.forEach((e) => {
                    sX[this.id].push(new sY(e, this.container));
                });
            },
            onUnload: function () {
                sX[this.id].forEach((e) => {
                    "function" == typeof e.unload && e.unload();
                });
            },
        },
        tU,
        is,
        ey,
    ]),
        customElements.get("popout-select") || customElements.define("popout-select", tQ),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY),
        eN("collection-row", [tU, ey, eq, ti]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY),
        eN("collection-tabs", [sB, i0, tU]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY);
    var s5 = {};
    function sZ(e) {
        return s5[e];
    }
    (s5.basic = []),
        (s5.light = [
            {
                featureType: "administrative",
                elementType: "labels",
                stylers: [{ visibility: "on" }, { lightness: "64" }, { hue: "#ff0000" }],
            },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
            },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
            },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            {
                featureType: "road",
                elementType: "labels",
                stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }],
            },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
            },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            {
                featureType: "road.local",
                elementType: "geometry.stroke",
                stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [{ visibility: "simplified" }, { weight: "0.01" }, { lightness: "39" }],
            },
            {
                featureType: "road.local",
                elementType: "labels.text.stroke",
                stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
            },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (s5.light_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            {
                featureType: "administrative",
                elementType: "labels",
                stylers: [{ visibility: "off" }, { lightness: "64" }, { hue: "#ff0000" }],
            },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#bdbdbd" }] },
            { featureType: "administrative", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
                featureType: "landscape",
                elementType: "all",
                stylers: [{ color: "#f0f0f0" }, { visibility: "simplified" }],
            },
            { featureType: "landscape.natural.landcover", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "landscape.natural.terrain", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry.fill", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "labels", stylers: [{ lightness: "100" }] },
            { featureType: "poi.park", elementType: "all", stylers: [{ visibility: "on" }] },
            {
                featureType: "poi.park",
                elementType: "geometry",
                stylers: [{ saturation: "-41" }, { color: "#e8ede7" }],
            },
            { featureType: "poi.park", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: "-100" }] },
            {
                featureType: "road",
                elementType: "labels",
                stylers: [{ lightness: "25" }, { gamma: "1.06" }, { saturation: "-100" }, { visibility: "off" }],
            },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ gamma: "10.00" }] },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ weight: "0.01" }, { visibility: "simplified" }],
            },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.01" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.fill", stylers: [{ weight: "0.01" }] },
            {
                featureType: "road.local",
                elementType: "geometry.stroke",
                stylers: [{ gamma: "10.00" }, { lightness: "100" }, { weight: "0.4" }],
            },
            {
                featureType: "road.local",
                elementType: "labels",
                stylers: [{ visibility: "off" }, { weight: "0.01" }, { lightness: "39" }],
            },
            {
                featureType: "road.local",
                elementType: "labels.text.stroke",
                stylers: [{ weight: "0.50" }, { gamma: "10.00" }, { lightness: "100" }],
            },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#cfe5ee" }, { visibility: "on" }] },
        ]),
        (s5.white_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#444444" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (s5.white_label = [
            { featureType: "all", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            {
                featureType: "administrative",
                elementType: "labels",
                stylers: [{ gamma: "3.86" }, { lightness: "100" }],
            },
            { featureType: "administrative", elementType: "labels.text.fill", stylers: [{ color: "#cccccc" }] },
            { featureType: "landscape", elementType: "all", stylers: [{ color: "#f2f2f2" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "road", elementType: "all", stylers: [{ saturation: -100 }, { lightness: 45 }] },
            { featureType: "road.highway", elementType: "all", stylers: [{ visibility: "simplified" }] },
            { featureType: "road.highway", elementType: "geometry.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "geometry.stroke", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "road.highway", elementType: "labels.text.fill", stylers: [{ weight: "0.8" }] },
            { featureType: "road.highway", elementType: "labels.text.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0" }] },
            { featureType: "road.arterial", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels.text", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "water", elementType: "all", stylers: [{ color: "#e4e4e4" }, { visibility: "on" }] },
        ]),
        (s5.dark_blank = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
            },
            {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }],
            },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [{ color: "#000000" }, { lightness: 20 }],
            },
            {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
            },
            { featureType: "administrative", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "off" }] },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
            },
            {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{ color: "#000000" }, { lightness: 18 }],
            },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (s5.dark_label = [
            { featureType: "all", elementType: "labels", stylers: [{ visibility: "off" }] },
            {
                featureType: "all",
                elementType: "labels.text.fill",
                stylers: [{ saturation: 36 }, { color: "#000000" }, { lightness: 40 }],
            },
            {
                featureType: "all",
                elementType: "labels.text.stroke",
                stylers: [{ visibility: "on" }, { color: "#000000" }, { lightness: 16 }],
            },
            { featureType: "all", elementType: "labels.icon", stylers: [{ visibility: "off" }] },
            {
                featureType: "administrative",
                elementType: "geometry.fill",
                stylers: [{ color: "#000000" }, { lightness: 20 }],
            },
            {
                featureType: "administrative",
                elementType: "geometry.stroke",
                stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: 1.2 }],
            },
            {
                featureType: "administrative",
                elementType: "labels",
                stylers: [{ visibility: "simplified" }, { lightness: "-82" }],
            },
            {
                featureType: "administrative",
                elementType: "labels.text.stroke",
                stylers: [{ invert_lightness: !0 }, { weight: "7.15" }],
            },
            { featureType: "landscape", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 20 }] },
            { featureType: "landscape", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "poi", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 21 }] },
            { featureType: "road", elementType: "labels", stylers: [{ visibility: "simplified" }] },
            {
                featureType: "road.highway",
                elementType: "geometry.fill",
                stylers: [{ color: "#000000" }, { lightness: 17 }, { weight: "0.8" }],
            },
            {
                featureType: "road.highway",
                elementType: "geometry.stroke",
                stylers: [{ color: "#000000" }, { lightness: 29 }, { weight: "0.01" }],
            },
            { featureType: "road.highway", elementType: "labels", stylers: [{ visibility: "off" }] },
            {
                featureType: "road.arterial",
                elementType: "geometry",
                stylers: [{ color: "#000000" }, { lightness: 18 }],
            },
            { featureType: "road.arterial", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 16 }] },
            { featureType: "road.local", elementType: "geometry.stroke", stylers: [{ weight: "0.01" }] },
            { featureType: "road.local", elementType: "labels", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "all", stylers: [{ visibility: "off" }] },
            { featureType: "transit", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 19 }] },
            { featureType: "water", elementType: "geometry", stylers: [{ color: "#000000" }, { lightness: 17 }] },
        ]),
        (window.theme.allMaps = window.theme.allMaps || {});
    let re = window.theme.allMaps,
        rt = {
            mapContainer: "[data-map-container]",
            style: "data-style",
            apiKey: "data-api-key",
            zoom: "data-zoom",
            address: "data-address",
            latLongCorrection: "data-latlong-correction",
            lat: "data-lat",
            long: "data-long",
        },
        ri = class e {
            initMaps() {
                let e = `https://maps.googleapis.com/maps/api/js?key=${this.key}`;
                tV({ url: e })
                    .then(() => {
                        var e;
                        return "true" === this.enableCorrection && "" !== this.lat && "" !== this.long
                            ? new window.google.maps.LatLng(this.lat, this.long)
                            : ((e = this.address),
                              new Promise((t, i) => {
                                  new window.google.maps.Geocoder().geocode({ address: e }, function (e, s) {
                                      "OK" == s
                                          ? t({ lat: e[0].geometry.location.lat(), lng: e[0].geometry.location.lng() })
                                          : i(s);
                                  });
                              }));
                    })
                    .then((e) => {
                        var t,
                            i,
                            s,
                            r,
                            n,
                            a = parseInt(this.zoomString, 10);
                        let o = s5[(t = this.styleString)],
                            l =
                                ((i = this.mapWrap),
                                (s = {
                                    zoom: a,
                                    styles: o,
                                    center: e,
                                    draggable: !0,
                                    clickableIcons: !1,
                                    scrollwheel: !1,
                                    zoomControl: !1,
                                    disableDefaultUI: !0,
                                }),
                                (r = new window.google.maps.Map(i, s)),
                                (n = r.getCenter()),
                                new window.google.maps.Marker({ map: r, position: n }),
                                window.google.maps.event.addDomListener(window, "resize", function () {
                                    window.google.maps.event.trigger(r, "resize"), r.setCenter(n);
                                }),
                                r);
                        return l;
                    })
                    .then((e) => {
                        (this.map = e), (re[this.id] = e);
                    })
                    .catch((e) => {
                        console.log("Failed to load Google Map"), console.log(e);
                    });
            }
            onUnload() {
                void 0 !== window.google && window.google.maps.event.clearListeners(this.map, "resize");
            }
            constructor(e) {
                (this.container = e.container),
                    (this.mapWrap = this.container.querySelector(rt.mapContainer)),
                    (this.styleString = this.container.getAttribute(rt.style) || ""),
                    (this.key = this.container.getAttribute(rt.apiKey)),
                    (this.zoomString = this.container.getAttribute(rt.zoom) || 14),
                    (this.address = this.container.getAttribute(rt.address)),
                    (this.enableCorrection = this.container.getAttribute(rt.latLongCorrection)),
                    (this.lat = this.container.getAttribute(rt.lat)),
                    (this.long = this.container.getAttribute(rt.long)),
                    this.key && this.initMaps();
            }
        };
    eN("section-map", [
        {
            onLoad() {
                re[this.id] = new ri(this);
            },
            onUnload() {
                "function" == typeof re[this.id].unload && re[this.id].unload();
            },
        },
        ti,
    ]),
        eN("section-columns", [iO, eq]);
    let rs = {
            dataRelatedSectionElem: "[data-related-section]",
            dataRelatedProduct: "[data-grid-item]",
            carousel: "[data-carousel]",
            dataLimit: "data-limit",
            dataMinimum: "data-minimum",
            dataLargeLayout: "data-layout-desktop",
            dataMediumLayout: "data-layout-tablet",
            dataSmallLayout: "data-layout-mobile",
            recentlyViewed: "[data-recent-wrapper]",
            recentlyViewedWrapper: "[data-recently-viewed-wrapper]",
            productId: "data-product-id",
        },
        rr = class e {
            init() {
                let e = this.container.querySelector(rs.dataRelatedSectionElem);
                if (!e) return;
                let t = e.getAttribute(rs.productId),
                    i = e.getAttribute(rs.dataLimit),
                    s = e.getAttribute(rs.dataLargeLayout),
                    r = e.getAttribute(rs.dataMediumLayout),
                    n = e.getAttribute(rs.dataSmallLayout),
                    a = window.theme.routes.product_recommendations_url || "/recommendations/products/",
                    l = `${a}?section_id=related&limit=${i}&product_id=${t}`;
                o.get(l)
                    .then((t) => {
                        let i = document.createElement("div");
                        i.innerHTML = t.data;
                        let a = i.querySelector(rs.dataRelatedSectionElem);
                        if (a.querySelector(rs.dataRelatedProduct)) {
                            let o = a.innerHTML;
                            (e.innerHTML = o),
                                e.querySelector(rs.carousel).style.setProperty("--grid-large-items", s),
                                e.querySelector(rs.carousel).style.setProperty("--grid-medium-items", r),
                                e.querySelector(rs.carousel).style.setProperty("--grid-small-items", n),
                                e.dispatchEvent(new CustomEvent("theme:related-products:added", { bubbles: !0 }));
                        } else e.dispatchEvent(new CustomEvent("theme:tabs:hide", { bubbles: !0 }));
                    })
                    .catch(function (e) {
                        console.warn(e);
                    });
            }
            recent() {
                let e = this.container.querySelector(rs.recentlyViewed),
                    t = this.container.querySelector(rs.recentlyViewedWrapper),
                    i = this.container.querySelectorAll(rs.dataRelatedProduct),
                    s = e.hasAttribute(rs.dataMinimum) ? parseInt(e.getAttribute(rs.dataMinimum)) : 4,
                    r = !t && i.length > 0,
                    n = t && i.length >= s;
                (r || n) && e.dispatchEvent(new CustomEvent("theme:tabs:check", { bubbles: !0 }));
            }
            constructor(e) {
                (this.section = e),
                    (this.container = e.container),
                    this.init(),
                    this.container.addEventListener("theme:recent-products:added", () => {
                        this.recent();
                    });
            }
        };
    eN("related", [
        {
            onLoad() {
                this.section = new rr(this);
            },
        },
        sB,
        {
            onLoad() {
                eS[this.id] = new ex(this);
            },
        },
    ]),
        customElements.get("radio-swatch") || customElements.define("radio-swatch", tj),
        customElements.get("product-grid-item") || customElements.define("product-grid-item", tG),
        customElements.get("product-grid-item-variant") || customElements.define("product-grid-item-variant", t2),
        customElements.get("product-grid-item-image") || customElements.define("product-grid-item-image", tY);
    class rn {
        initInputs() {
            this.inputs.forEach((e) => {
                e.addEventListener(
                    "input",
                    U(
                        function (e) {
                            let t = e.target.value.toString() || "";
                            this.saveNotes(t);
                        }.bind(this),
                        300
                    )
                );
            });
        }
        saveNotes(e) {
            window
                .fetch(`${window.theme.routes.cart}/update.js`, {
                    method: "post",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({ note: e }),
                })
                .catch((e) => {
                    console.error(e);
                });
        }
        constructor(e) {
            (this.inputs = e.querySelectorAll("[data-cart-note]")), this.initInputs();
        }
    }
    let ra = (e, t = [], i = !1) => {
            let s = Object.keys(e)
                .map((s) => {
                    let r = e[s];
                    if ("[object Object]" === Object.prototype.toString.call(r) || Array.isArray(r))
                        return Array.isArray(e) ? t.push("") : t.push(s), ra(r, t, Array.isArray(r));
                    {
                        let n = s;
                        return (t.length > 0 &&
                            (n = (i ? t : [...t, s]).reduce((e, t) => ("" === e ? t : `${e}[${t}]`), "")),
                        i)
                            ? `${n}[]=${r}`
                            : `${n}=${r}`;
                    }
                })
                .join("&");
            return t.pop(), s;
        },
        ro = {
            html: "html",
            submitButton: "[data-submit-shipping]",
            form: "[data-shipping-estimate-form]",
            template: "[data-response-template]",
            country: "#estimate_address_country",
            province: "#estimate_address_province",
            zip: "#estimate_address_zip",
            wrapper: "[data-response-wrapper]",
            defaultData: "data-default-fullname",
            lang: "lang",
            defaultData: "data-default",
        },
        rl = { success: "shipping--success", error: "errors", disable: "disabled" };
    class rd {
        enableButtons() {
            this.button.removeAttribute("disabled"), this.button.classList.remove(rl.disable);
        }
        disableButtons() {
            this.button.setAttribute("disabled", "disabled"), this.button.classList.add(rl.disable);
        }
        render(e) {
            if (this.template && this.ratesWrapper) {
                let t = M.render(this.template, e);
                this.ratesWrapper.innerHTML = t;
            }
            this.enableButtons(), this.ratesWrapper.style.removeProperty("display");
        }
        estimate(e) {
            let t = encodeURI(ra({ shipping_address: e })),
                i = `${window.theme.routes.cart}/shipping_rates.json?${t}`,
                s = this;
            o.get(i)
                .then(function (e) {
                    let t = s.sanitize(e);
                    s.render(t), s.enableButtons(), s.ratesWrapper.style.removeProperty("display");
                })
                .catch(function (e) {
                    let t = s.sanitizeErrors(e);
                    s.render(t);
                });
        }
        sanitize(e) {
            let t = {};
            if (((t.class = rl.success), (t.items = []), e.data.shipping_rates && e.data.shipping_rates.length > 0)) {
                let i = e.data.shipping_rates;
                i.forEach((e) => {
                    let i = {};
                    (i.title = e.presentment_name),
                        (i.value = a.formatMoney(e.price, theme.moneyFormat)),
                        t.items.push(i);
                });
            } else t.items[0] = { value: theme.strings.noShippingAvailable };
            return t;
        }
        sanitizeErrors(e) {
            let t = {};
            if (((t.class = rl.error), (t.items = []), "object" == typeof e.data))
                for (let [i, s] of Object.entries(e.data)) {
                    let r = {};
                    (r.title = i.toString()), (r.value = s.toString()), t.items.push(r);
                }
            else t.items[0] = { value: theme.strings.noShippingAvailable };
            return t;
        }
        init() {
            let e = document.querySelector(ro.html),
                t = "en";
            e.hasAttribute(ro.lang) && "" !== e.getAttribute(ro.lang) && (t = e.getAttribute(ro.lang)),
                this.form && d.AddressForm(this.form, t, { shippingCountriesOnly: !0 }),
                this.country &&
                    this.country.hasAttribute(ro.defaultData) &&
                    this.province &&
                    this.province.hasAttribute(ro.defaultData) &&
                    this.country.addEventListener("change", function () {
                        this.country.removeAttribute(ro.defaultData), this.province.removeAttribute(ro.defaultData);
                    }),
                this.button &&
                    this.button.addEventListener(
                        "click",
                        function (e) {
                            for (e.preventDefault(), this.disableButtons(); this.ratesWrapper.firstChild; )
                                this.ratesWrapper.removeChild(this.ratesWrapper.firstChild);
                            this.ratesWrapper.style.display = "none";
                            let t = {},
                                i = this.country.value,
                                s = this.province.value,
                                r = this.country.getAttribute(ro.defaultData);
                            "" === i && r && "" !== r && (i = r);
                            let n = this.province.getAttribute(ro.defaultData);
                            "" === s && n && "" !== n && (s = n),
                                (t.zip = this.zip.value || ""),
                                (t.country = i || ""),
                                (t.province = s || ""),
                                this.estimate(t);
                        }.bind(this)
                    );
        }
        constructor(e) {
            (this.button = e.container.querySelector(ro.submitButton)),
                (this.template = e.container.querySelector(ro.template).innerHTML),
                (this.ratesWrapper = e.container.querySelector(ro.wrapper)),
                (this.form = e.container.querySelector(ro.form)),
                (this.country = e.container.querySelector(ro.country)),
                (this.province = e.container.querySelector(ro.province)),
                (this.zip = e.container.querySelector(ro.zip)),
                this.init();
        }
    }
    let rc = {
            cartMessage: "[data-cart-message]",
            cartMessageValue: "data-cart-message",
            leftToSpend: "[data-left-to-spend]",
            cartProgress: "[data-cart-progress]",
            limit: "data-limit",
            percent: "data-percent",
        },
        rh = { isHidden: "is-hidden", isSuccess: "is-success" },
        ru = class e {
            init() {
                (this.cartFreeLimitShipping = 100 * Number(this.cartMessage[0].getAttribute(rc.limit)) * this.rate),
                    (this.shippingAmount = 0),
                    (this.circumference = 28 * Math.PI),
                    this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount),
                    this.cartBarProgress(),
                    this.listen();
            }
            listen() {
                document.addEventListener(
                    "theme:cart:change",
                    function (e) {
                        (this.cart = e.detail.cart), this.render();
                    }.bind(this)
                );
            }
            render() {
                let e = this.cart.total_price;
                this.freeShippingMessageHandle(e),
                    this.cart &&
                        this.cart.total_price &&
                        this.cartMessage.length > 0 &&
                        ((this.shippingAmount = e), this.updateProgress());
            }
            freeShippingMessageHandle(e) {
                this.cartMessage.length > 0 &&
                    this.container.querySelectorAll(rc.cartMessage).forEach((t) => {
                        let i =
                            t.hasAttribute(rc.cartMessageValue) &&
                            "true" === t.getAttribute(rc.cartMessageValue) &&
                            e >= this.cartFreeLimitShipping &&
                            0 !== e;
                        t.classList.toggle(rh.isSuccess, i);
                    });
            }
            cartBarProgress(e = null) {
                this.container.querySelectorAll(rc.cartProgress).forEach((t) => {
                    this.setProgress(t, null === e ? t.getAttribute(rc.percent) : e);
                });
            }
            setProgress(e, t) {
                let i = this.circumference - ((t / 100) * this.circumference) / 2;
                e.style.strokeDashoffset = i;
            }
            updateProgress() {
                let e = (this.shippingAmount / this.cartFreeLimitShipping) * 100;
                this.exchangeRateConversions(this.cartFreeLimitShipping, this.shippingAmount),
                    this.cartBarProgress(e > 100 ? 100 : e);
            }
            exchangeRateConversions(e, t) {
                let i = theme.settings.currency_code_enable
                    ? a.formatMoney(e - t, theme.moneyFormat) + ` ${theme.currencyCode}`
                    : a.formatMoney(e - t, theme.moneyFormat);
                this.container.querySelectorAll(rc.leftToSpend).forEach((e) => {
                    e.innerHTML = i.replace(".00", "");
                });
            }
            constructor(e) {
                (this.container = e),
                    (this.cartMessage = this.container.querySelectorAll(rc.cartMessage)),
                    (this.rate = window.Shopify.currency.rate),
                    this.cartMessage.length > 0 && this.init();
            }
        },
        rp = {
            drawer: '[data-drawer="drawer-cart"]',
            shipping: "[data-shipping-estimate-form]",
            loader: "[data-cart-loading]",
            form: "[data-cart-form]",
            emptystate: "[data-cart-empty]",
            progress: "[data-cart-progress]",
            items: "[data-line-items]",
            subtotal: "[data-cart-subtotal]",
            bottom: "[data-cart-bottom]",
            quantity: "[data-quantity-selector]",
            errors: "[data-form-errors]",
            item: "[data-cart-item]",
            finalPrice: "[data-cart-final]",
            finalSavings: "[data-cart-savings]",
            key: "data-update-cart",
            remove: "data-remove-key",
            pageUpsellWrapper: "[data-cart-page-upsell-wrapper]",
            cartPage: '[data-section-type="cart"]',
            bar: "[data-cart-bar]",
            ship: "[data-cart-message]",
            itemLoadbar: "[data-item-loadbar]",
            cartMessageContainer: "[data-cart-message-container]",
            apiContent: "[data-api-content]",
        },
        rm = { hidden: "cart--hidden", loading: "cart--loading" },
        rf = class e {
            listen() {
                document.addEventListener(
                    "theme:cart:change",
                    function (e) {
                        (this.cart = e.detail.cart), (this.stale = !0);
                    }.bind(this)
                ),
                    document.addEventListener(
                        "theme:cart:init",
                        function () {
                            this.init();
                        }.bind(this)
                    ),
                    document.addEventListener(
                        "theme:cart:reload",
                        function () {
                            (this.stale = !0), this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML());
                        }.bind(this)
                    ),
                    this.drawer &&
                        (this.drawer.addEventListener(
                            "theme:drawer:open",
                            function () {
                                this.cart ? this.loadHTML() : this.init().then(() => this.loadHTML()),
                                    (window.theme.state.cartOpen = !0);
                            }.bind(this)
                        ),
                        this.drawer.addEventListener("theme:drawer:close", function () {
                            window.theme.state.cartOpen = !1;
                        })),
                    new rn(this.container),
                    new ru(this.container);
            }
            init() {
                return window
                    .fetch(`${window.theme.routes.cart}.js`)
                    .then(this.handleErrors)
                    .then((e) => e.json())
                    .then((e) => ((this.cart = e), this.fireChange(e), e))
                    .catch((e) => {
                        console.error(e);
                    });
            }
            loadHTML(e = !1) {
                this.stale &&
                    (this.cart && this.cart.item_count > 0
                        ? this.loadForm(e)
                        : (this.showEmpty(),
                          this.cartMessages.forEach((e) => {
                              new ru(e);
                          }))),
                    (this.stale = !1);
            }
            initInputs() {
                (this.inputs = this.container.querySelectorAll(`[${rp.key}]`)),
                    this.inputs.forEach((e) => {
                        let t = e.getAttribute(rp.key);
                        e.addEventListener(
                            "change",
                            function (e) {
                                let i = parseInt(e.target.value, 10);
                                (this.latestClick = e.target.closest(rp.item)), this.lockState(), this.updateCart(t, i);
                            }.bind(this)
                        );
                    });
            }
            initRemove() {
                (this.removers = this.container.querySelectorAll(`[${rp.remove}]`)),
                    this.removers.forEach((e) => {
                        let t = e.getAttribute(rp.remove);
                        e.addEventListener(
                            "click",
                            function (e) {
                                e.preventDefault(),
                                    (this.latestClick = e.target.closest(rp.item)),
                                    this.lockState(),
                                    this.updateCart(t, 0);
                            }.bind(this)
                        );
                    });
            }
            lockState() {
                (this.latestClick.querySelector(rp.itemLoadbar).style.display = "block"),
                    this.loader.classList.add(rm.loading);
            }
            updateCart(e, t) {
                window
                    .fetch(`${window.theme.routes.cart}/change.js`, {
                        method: "post",
                        headers: { "Content-Type": "application/json" },
                        body: JSON.stringify({ id: e, quantity: t }),
                    })
                    .then(this.handleErrors)
                    .then((e) => e.json())
                    .then((e) => {
                        (this.cart = e), t5(this.errors), this.fireChange(e), (this.stale = !0), this.loadHTML();
                    })
                    .catch((e) => {
                        if (e instanceof eh) {
                            var t, i;
                            let s = window.theme.strings.stockout || "Could not update cart, please reload",
                                r = (null === (t = e.json) || void 0 === t ? void 0 : t.message) || e.message || s,
                                n = (null === (i = e.json) || void 0 === i ? void 0 : i.description) || "",
                                a = r === n ? `<p>${r}</p>` : `<p>${r}</p> <p>${n}</p>`;
                            this.showError(a), this.loadForm();
                        } else {
                            let o = `<p>${e.message || defaultMessage}</p>`;
                            throw (this.showError(o), e);
                        }
                    });
            }
            fireChange(e) {
                document.dispatchEvent(new CustomEvent("theme:cart:change", { detail: { cart: e }, bubbles: !0 }));
            }
            // updateTotal() {
            //     if (this.cart && void 0 != this.cart.total_price) {
            //         let e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
            //         this.finalPrice.innerHTML = e + ` ${theme.currencyCode}`;
            //     }
            //     this.subtotal &&
            //         this.cart &&
            //         window
            //             .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
            //             .then(this.handleErrors)
            //             .then((e) => e.text())
            //             .then((e) => {
            //                 let t = document.createElement("div");
            //                 (t.innerHTML = e), (this.subtotal.innerHTML = t.querySelector(rp.apiContent).innerHTML);
            //             });
            // }
           updateTotal() {
    let newTotalHTML = "";
    if (this.cart && void 0 != this.cart.total_price) {
        let e = a.formatMoney(this.cart.total_price, theme.moneyFormat);
        newTotalHTML = e + ` ${theme.currencyCode}`;
    }

    this.subtotal &&
        this.cart &&
        window
            .fetch(`${window.theme.routes.root_url}?section_id=api-cart-subtotal`)
            .then(this.handleErrors)
            .then((e) => e.text())
            .then((e) => {
                let t = document.createElement("div");
                (t.innerHTML = e);
                
                if (this.subtotal && t.querySelector(rp.apiContent)) {
                    this.subtotal.innerHTML = t.querySelector(rp.apiContent).innerHTML;
                }
                
                let fetchedSavings = t.querySelector(rp.finalSavings);
                if (this.finalSavings && fetchedSavings) {
                    this.finalSavings.innerHTML = fetchedSavings.innerHTML;
                    let savingsRow = this.finalSavings.closest('.cart-drawer__savings__row');
                    
                    if (savingsRow) {
                        if (fetchedSavings.innerHTML.trim() === "") {
                            savingsRow.style.display = "none";
                        } else {
                            savingsRow.style.display = "flex";
                        }
                    }
                }

                if (this.finalPrice && newTotalHTML !== "") {
                    this.finalPrice.innerHTML = newTotalHTML;
                }
            });
}
            showError(e) {
                t5(this.errors),
                    (this.errors.innerHTML = e),
                    window.setTimeout(() => {
                        t7(this.errors);
                    }, 600);
            }
            loadForm(e = !1) {
                if (e) {
                    this.showForm(), this.initQuantity(), this.initQuickview(), this.updateTotal();
                    return;
                }
                window
                    .fetch(`${window.theme.routes.root_url}?section_id=api-cart-items`)
                    .then(this.handleErrors)
                    .then((e) => e.text())
                    .then((e) => {
                        let t = document.createElement("div");
                        (t.innerHTML = e),
                            (this.items.innerHTML = t.querySelector(rp.apiContent).innerHTML),
                            this.showForm(),
                            this.initQuantity(),
                            this.initQuickview(),
                            this.updateTotal();
                    });
            }
            initQuickview() {
                let e = this.items.querySelector(rp.pageUpsellWrapper),
                    t = this.bottom.querySelector(rp.pageUpsellWrapper);
                t && t.remove(),
                    this.cartPage &&
                        e &&
                        (this.bottom.insertBefore(e, this.bottom.firstChild), Alpine.initTree(this.bottom));
            }
            initQuantity() {
                sT(this.container), this.initInputs(), this.initRemove();
            }
            showForm() {
                this.bar && this.bar.classList.remove(rm.hidden),
                    this.ship && this.ship.classList.remove(rm.hidden),
                    this.progress && this.progress.classList.remove(rm.hidden),
                    this.form.classList.remove(rm.hidden),
                    this.bottom.classList.remove(rm.hidden),
                    this.loader.classList.remove(rm.loading),
                    this.emptystate.classList.add(rm.hidden);
            }
            showEmpty() {
                this.bar && this.bar.classList.add(rm.hidden),
                    this.ship && this.ship.classList.add(rm.hidden),
                    this.progress && this.progress.classList.add(rm.hidden),
                    this.emptystate.classList.remove(rm.hidden),
                    this.loader.classList.remove(rm.loading),
                    this.form.classList.add(rm.hidden),
                    this.bottom.classList.add(rm.hidden);
            }
            handleErrors(e) {
                return e.ok
                    ? e
                    : e.json().then(function (t) {
                          let i = new eh({ status: e.statusText, headers: e.headers, json: t });
                          throw i;
                      });
            }
            constructor(e) {
                (this.section = e),
                    (this.container = e.container),
                    (this.cartMessages = document.querySelectorAll(rp.cartMessageContainer)),
                    (this.bar = this.container.querySelector(rp.bar)),
                    (this.ship = this.container.querySelector(rp.ship)),
                    (this.drawer = this.container.querySelector(rp.drawer)),
                    (this.form = this.container.querySelector(rp.form)),
                    (this.loader = this.container.querySelector(rp.loader)),
                    (this.bottom = this.container.querySelector(rp.bottom)),
                    (this.items = this.container.querySelector(rp.items)),
                    (this.subtotal = this.container.querySelector(rp.subtotal)),
                    (this.errors = this.container.querySelector(rp.errors)),
                    (this.finalPrice = this.container.querySelector(rp.finalPrice)),
                    (this.finalSavings = this.container.querySelector(rp.finalSavings)),
                    (this.emptystate = this.container.querySelector(rp.emptystate)),
                    (this.progress = this.container.querySelector(rp.progress)),
                    (this.latestClick = null),
                    (this.cart = null),
                    (this.stale = !0),
                    (this.cartPage = document.querySelector(rp.cartPage)),
                    this.listen();
            }
        },
        rg = {
            ajaxDisable: "data-ajax-disable",
            shipping: "[data-shipping-estimate-form]",
            input: "[data-update-cart]",
            update: "[data-update-button]",
            bottom: "[data-cart-bottom]",
            upsellWrapper: "[data-cart-page-upsell-wrapper]",
        },
        ry = { dirty: "cart--dirty", heartBeat: "heart-beat" },
        rv = class e {
            initQuantity() {
                sT(this.container);
            }
            moveUpsell() {
                let e = this.container.querySelector(rg.bottom);
                e.insertBefore(this.upsellWrapper, e.firstChild);
            }
            initInputs() {
                this.inputs.forEach((e) => {
                    e.addEventListener(
                        "change",
                        function () {
                            this.updateBtn.classList.add(ry.dirty),
                                this.updateBtn.classList.add(ry.heartBeat),
                                setTimeout(
                                    function () {
                                        this.updateBtn.classList.remove(ry.heartBeat);
                                    }.bind(this),
                                    1300
                                );
                        }.bind(this)
                    );
                });
            }
            constructor(e) {
                (window.theme.state.cartOpen = !0),
                    (this.section = e),
                    (this.container = e.container),
                    (this.inputs = this.container.querySelectorAll(rg.input)),
                    (this.quantityWrappers = this.container.querySelectorAll(rg.qty)),
                    (this.updateBtn = this.container.querySelector(rg.update)),
                    (this.upsellWrapper = this.container.querySelector(rg.upsellWrapper)),
                    this.initQuantity(),
                    this.initInputs(),
                    this.upsellWrapper && this.moveUpsell(),
                    document.addEventListener(
                        "theme:cart:reload",
                        function () {
                            window.location.reload();
                        }.bind(this)
                    );
            }
        };
    eN("cart", [
        {
            onLoad() {
                let e = this.container.querySelector(rg.shipping);
                if (
                    (e && new rd(this),
                    (this.disabled = "true" == this.container.getAttribute(rg.ajaxDisable)),
                    this.disabled)
                ) {
                    this.cart = new rv(this);
                    return;
                }
                this.cart = new rf(this);
                let t = this.cart.init();
                t.then(() => {
                    this.cart.loadHTML(!0);
                });
            },
        },
        is,
    ]),
        eN("cart-drawer", [
            tg,
            {
                onLoad() {
                    let e = document.querySelector(rp.drawer);
                    e && (this.cart = new rf(this));
                    let t = this.container.querySelector(rp.shipping);
                    t && new rd(this);
                },
                onUnload: function () {
                    this.cart && "function" == typeof this.cart.unload && this.cart.unload();
                },
            },
            is,
        ]),
        eN("accordion-single", is);
    let rb = (e, t, i = null) => {
            (e.style.opacity = 0),
                (e.style.display = "block"),
                (function t() {
                    let s = parseFloat(e.style.opacity);
                    (s += 0.1) > 1 || ((e.style.opacity = s), requestAnimationFrame(t)),
                        1 === s && "function" == typeof i && i();
                })();
        },
        r$ = (e, t = null) => {
            (e.style.opacity = 1),
                (function i() {
                    (e.style.opacity -= 0.1) < 0 ? (e.style.display = "none") : requestAnimationFrame(i),
                        0 === parseFloat(e.style.opacity) && "function" == typeof t && t();
                })();
        },
        rw = {
            tracking: "[data-tracking-consent]",
            trackingAccept: "[data-confirm-cookies]",
            close: "[data-close-modal]",
            popupInner: "[data-popup-inner]",
            newsletterPopup: "[data-newsletter]",
            newsletterPopupHolder: "[data-newsletter-holder]",
            newsletterField: "[data-newsletter-field]",
            newsletterForm: "[data-newsletter-form]",
            promoPopup: "[data-promo-text]",
            delayAttribite: "data-popup-delay",
            cookieNameAttribute: "data-cookie-name",
            dataTargetReferrer: "data-target-referrer",
        },
        r8 = {
            hide: "hide",
            hasValue: "has-value",
            success: "has-success",
            error: "has-error",
            desktop: "desktop",
            mobile: "mobile",
        },
        rS = {},
        rE = class e {
            write() {
                let e =
                    -1 !== document.cookie.indexOf("; ") &&
                    !document.cookie.split("; ").find((e) => e.startsWith(this.name));
                (e || -1 === document.cookie.indexOf("; ")) &&
                    (document.cookie = `${this.name}=${this.value}; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            read() {
                if (
                    !(
                        -1 !== document.cookie.indexOf("; ") &&
                        document.cookie.split("; ").find((e) => e.startsWith(this.name))
                    )
                )
                    return !1;
                {
                    let e = document.cookie
                        .split("; ")
                        .find((e) => e.startsWith(this.name))
                        .split("=")[1];
                    return e;
                }
            }
            destroy() {
                document.cookie.split("; ").find((e) => e.startsWith(this.name)) &&
                    (document.cookie = `${this.name}=null; expires=${this.configuration.expires}; path=${this.configuration.path}; domain=${this.configuration.domain}`);
            }
            constructor(e, t) {
                (this.configuration = { expires: null, path: "/", domain: window.location.hostname }),
                    (this.name = e),
                    (this.value = t);
            }
        },
        rx = class e {
            hide() {
                this.show = !1;
            }
            always() {
                this.show && rb(this.element);
            }
            delayed() {
                setTimeout(() => {
                    this.always();
                }, 1e4);
            }
            bottom() {
                let e,
                    t = () => {
                        e && window.cancelAnimationFrame(e),
                            (e = window.requestAnimationFrame(() => {
                                window.requestIdleCallback(
                                    () => {
                                        Math.round(window.scrollY + window.innerHeight) >=
                                            Math.round(document.body.clientHeight) &&
                                            (this.always(), window.removeEventListener("scroll", t, { passive: !0 }));
                                    },
                                    { timeout: 300 }
                                );
                            }));
                    };
                window.addEventListener("scroll", t, { passive: !0 });
            }
            onScroll() {}
            idle() {
                let e = 0,
                    t = [
                        "mousemove",
                        "mousedown",
                        "click",
                        "touchmove",
                        "touchstart",
                        "touchend",
                        "keydown",
                        "keypress",
                    ],
                    i = ["load", "resize", "scroll"],
                    s = () => {
                        (e = setTimeout(() => {
                            (e = 0), this.always();
                        }, 6e4)),
                            t.forEach((e) => {
                                document.addEventListener(e, r);
                            }),
                            i.forEach((e) => {
                                window.addEventListener(e, r);
                            });
                    },
                    r = () => {
                        e && clearTimeout(e),
                            t.forEach((e) => {
                                document.removeEventListener(e, r);
                            }),
                            i.forEach((e) => {
                                window.removeEventListener(e, r);
                            }),
                            s();
                    };
                s();
            }
            constructor(e, t) {
                (this.show = !0),
                    (this.element = t),
                    (this.delay = e.getAttribute(rw.delayAttribite)),
                    "always" === this.delay && this.always(),
                    "delayed" === this.delay && this.delayed(),
                    "bottom" === this.delay && this.bottom(),
                    "idle" === this.delay && this.idle();
            }
        },
        rk = class e {
            init() {
                -1 !== this.locationPath.indexOf(this.el.getAttribute(rw.dataTargetReferrer)) ||
                    window.Shopify.designMode ||
                    this.el.parentNode.removeChild(this.el);
            }
            constructor(e) {
                if (((this.el = e), (this.locationPath = location.href), !this.el.hasAttribute(rw.dataTargetReferrer)))
                    return;
                this.init();
            }
        },
        rT = class e {
            init() {
                this.showPopup && rb(this.modalInner), this.clickEvents();
            }
            clickEvents() {
                this.close.addEventListener("click", (e) => {
                    e.preventDefault(),
                        window.Shopify.customerPrivacy.setTrackingConsent(!1, () => r$(this.modalInner));
                }),
                    this.acceptButton.addEventListener("click", (e) => {
                        e.preventDefault(),
                            window.Shopify.customerPrivacy.setTrackingConsent(!0, () => r$(this.modalInner));
                    }),
                    document.addEventListener("trackingConsentAccepted", function () {
                        console.log("trackingConsentAccepted event fired");
                    });
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && this.showPopup && rb(this.modalInner);
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && r$(this.modalInner);
            }
            constructor(e) {
                (this.popup = e),
                    (this.modal = document.querySelector(rw.tracking)),
                    (this.modalInner = this.popup.querySelector(rw.popupInner)),
                    (this.close = this.modal.querySelector(rw.close)),
                    (this.acceptButton = this.modal.querySelector(rw.trackingAccept)),
                    (this.enable = "true" === this.modal.getAttribute("data-enable")),
                    (this.showPopup = !1),
                    window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (e) => {
                        if (e) throw e;
                        let t = window.Shopify.customerPrivacy.userCanBeTracked(),
                            i = window.Shopify.customerPrivacy.getTrackingConsent();
                        (this.showPopup = !t && "no_interaction" === i && this.enable),
                            window.Shopify.designMode && (this.showPopup = !0),
                            this.init();
                    });
            }
        },
        rL = class e {
            init() {
                let e = !1 !== this.cookie.read();
                (!e || window.Shopify.designMode) &&
                    (window.Shopify.designMode ? rb(this.popupInner) : new rx(this.popup, this.popupInner),
                    this.clickEvents());
            }
            clickEvents() {
                this.close.addEventListener("click", (e) => {
                    e.preventDefault(), r$(this.popupInner), this.cookie.write();
                });
            }
            onBlockSelect(e) {
                this.popup.classList.contains(r8.mobile) && (this.hasDeviceClass = r8.mobile),
                    this.popup.classList.contains(r8.desktop) && (this.hasDeviceClass = r8.desktop),
                    "" !== this.hasDeviceClass && this.popup.classList.remove(this.hasDeviceClass),
                    this.popup.contains(e.target) && rb(this.popupInner);
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && r$(this.popupInner),
                    "" !== this.hasDeviceClass && this.popup.classList.add(this.hasDeviceClass);
            }
            constructor(e) {
                (this.popup = e),
                    (this.popupInner = this.popup.querySelector(rw.popupInner)),
                    (this.close = this.popup.querySelector(rw.close)),
                    (this.cookie = new rE(this.popup.getAttribute(rw.cookieNameAttribute), "user_has_closed")),
                    (this.isTargeted = new rk(this.popup)),
                    (this.hasDeviceClass = ""),
                    this.init();
            }
        },
        r_ = class e {
            init() {
                let e = !1 !== this.cookie.read();
                (!e || window.Shopify.designMode) && (this.show(), this.checkForSuccess());
            }
            show() {
                window.Shopify.designMode
                    ? rb(this.popupInner)
                    : (this.delayShow = new rx(this.popup, this.popupInner)),
                    this.inputField(),
                    this.closePopup();
            }
            preventDelayShow() {
                this.delayShow && this.delayShow.hide();
            }
            checkForSuccess() {
                let e = this.form.classList.contains(r8.error),
                    t = this.form.classList.contains(r8.success);
                (t || e) && (rb(this.popupInner), this.preventDelayShow(), t && this.cookie.write());
            }
            closePopup() {
                this.close.addEventListener("click", (e) => {
                    e.preventDefault(), r$(this.popupInner), this.cookie.write(), this.preventDelayShow();
                });
            }
            inputField() {
                this.newsletterField.addEventListener("input", () => {
                    "" !== this.newsletterField.value &&
                        this.holder.classList.add(r8.hasValue, "" !== this.newsletterField.value);
                }),
                    this.newsletterField.addEventListener("focus", () => {
                        "" !== this.newsletterField.value &&
                            this.holder.classList.add(r8.hasValue, "" !== this.newsletterField.value);
                    }),
                    this.newsletterField.addEventListener("focusout", () => {
                        setTimeout(() => {
                            this.holder.classList.remove(r8.hasValue);
                        }, 2e3);
                    });
            }
            onBlockSelect(e) {
                this.popup.contains(e.target) && rb(this.popupInner);
            }
            onBlockDeselect(e) {
                this.popup.contains(e.target) && r$(this.popupInner);
            }
            constructor(e) {
                (this.popup = e),
                    (this.popupInner = this.popup.querySelector(rw.popupInner)),
                    (this.holder = this.popup.querySelector(rw.newsletterPopupHolder)),
                    (this.close = this.popup.querySelector(rw.close)),
                    (this.newsletterField = this.popup.querySelector(rw.newsletterField)),
                    (this.cookie = new rE(this.popup.getAttribute(rw.cookieNameAttribute), "newsletter_is_closed")),
                    (this.form = this.popup.querySelector(rw.newsletterForm)),
                    (this.isTargeted = new rk(this.popup)),
                    (this.delayShow = null),
                    this.init();
            }
        };
    eN("popups", [
        ik,
        {
            onLoad() {
                rS[this.id] = [];
                let e = this.container.querySelectorAll(rw.tracking);
                e.forEach((e) => {
                    rS[this.id].push(new rT(e));
                });
                let t = this.container.querySelectorAll(rw.newsletterPopup);
                t.forEach((e) => {
                    rS[this.id].push(new r_(e));
                });
                let i = this.container.querySelectorAll(rw.promoPopup);
                i.forEach((e) => {
                    rS[this.id].push(new rL(e));
                });
            },
            onBlockSelect(e) {
                rS[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                rS[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
        },
    ]);
    let rA = {
            dot: "data-look-dot",
            productsHolder: "data-products-holder",
            slider: "[data-carousel]",
            buttonClose: "[data-button-close-holder]",
            slideIndex: "data-carousel-index",
            blockId: "data-block-id",
            focusable: "button",
        },
        rC = { active: "is-active", expand: "is-expanded" },
        rq = {},
        rI = class e {
            init() {
                (this.keyEvents = (e) => this.keyboardEventShowProductHolder(e)),
                    (this.keyCloseEvent = (e) => this.hideProductsHolder(e)),
                    (this.clickEventsDot = (e) => this.clickEventShowProductsHolder(e)),
                    (this.clickEventToClose = (e) => this.clickEventCloseProductsHolder(e)),
                    (this.toggleOnResize = (e) => U(this.onResize(e), 200)),
                    this.initSlider(),
                    this.addEvents();
            }
            initSlider() {
                this.slider &&
                    ((this.carousel = s.data(this.slider)),
                    (this.carousel.options.wrapAround = !0),
                    (this.carousel.options.freeScroll = !1),
                    this.carousel.resize(),
                    this.carousel.on("change", (e) => {
                        (this.currentDot = this.container.querySelector(`[${rA.dot}="${e}"]`)),
                            this.currentDot.classList.add(rC.active),
                            this.removeClassOnSiblingDots();
                    }));
            }
            addEvents() {
                this.dots.forEach((e) => {
                    e.addEventListener("click", this.clickEventsDot), e.addEventListener("keyup", this.keyEvents);
                }),
                    document.addEventListener("keyup", this.keyCloseEvent),
                    document.addEventListener("theme:resize", this.toggleOnResize),
                    this.buttonClose && this.buttonClose.addEventListener("click", this.clickEventToClose);
            }
            showProductsHolder() {
                let e = !this.productsHolder.classList.contains(rC.expand);
                this.currentDot.classList.toggle(rC.active),
                    this.productsHolder.classList.toggle(rC.expand, this.currentDot.classList.contains(rC.active)),
                    ih() < window.theme.sizes.small &&
                        this.productsHolder.dispatchEvent(new CustomEvent("theme:scroll:lock", { bubbles: !0 })),
                    this.currentDot.classList.contains(rC.active) &&
                        ((this.hasDefaultOpen = !0),
                        this.carousel.selectCell(Number(this.currentDot.getAttribute(rA.dot)), !0, e)),
                    this.removeClassOnSiblingDots();
            }
            hideProductsHolder(e) {
                "Escape" === e.code && (this.removeClasses(), eY(), this.currentDot.focus());
            }
            removeClasses() {
                this.productsHolder.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 })),
                    this.productsHolder.classList.remove(rC.expand),
                    this.currentDot.classList.remove(rC.active),
                    (this.hasDefaultOpen = !1);
            }
            clickEventShowProductsHolder(e) {
                (this.currentDot = e.currentTarget), this.showProductsHolder();
            }
            clickEventCloseProductsHolder() {
                this.removeClasses();
            }
            keyboardEventShowProductHolder(e) {
                ("Enter" === e.code || "Space" === e.code) &&
                    setTimeout(() => {
                        let e = this.productsHolder.querySelector(rA.focusable);
                        eX(this.productsHolder, { elementToFocus: e });
                    }, 400);
            }
            onResize() {
                this.currentDot &&
                    (window.innerWidth < window.theme.sizes.medium
                        ? this.removeClasses()
                        : this.hasDefaultOpen &&
                          (this.currentDot.classList.add(rC.active), this.productsHolder.classList.add(rC.expand)));
            }
            removeEvents() {
                this.dots.forEach((e) => {
                    e.removeEventListener("click", this.clickEventsDot), e.removeEventListener("keyup", this.keyEvents);
                }),
                    document.removeEventListener("keyup", this.keyCloseEvent),
                    document.removeEventListener("theme:resize", this.toggleOnResize),
                    this.buttonClose && this.buttonClose.removeEventListener("click", this.clickEventToClose);
            }
            removeClassOnSiblingDots() {
                for (let e of this.currentDot.parentNode.children)
                    e !== this.currentDot && e.classList.remove(rC.active);
            }
            onUnload() {
                this.slider && this.carousel && this.carousel.destroy(), this.removeEvents();
            }
            onBlockSelect(e) {
                if (this.slider && this.carousel) {
                    let t = this.container.querySelector(`[${rA.blockId}="${e.detail.blockId}"]`);
                    this.productsHolder.classList.add(rC.expand),
                        this.carousel.selectCell(Number(t.getAttribute(rA.slideIndex)), !0, !0);
                }
            }
            onBlockDeselect() {
                window.innerWidth < window.theme.sizes.medium &&
                    (this.productsHolder.classList.remove(rC.expand), this.currentDot.classList.remove(rC.active));
            }
            constructor(e) {
                (this.section = e),
                    (this.container = this.section.container),
                    (this.dots = this.container.querySelectorAll(`[${rA.dot}]`)),
                    (this.productsHolder = this.container.querySelector(`[${rA.productsHolder}]`)),
                    (this.slider = this.container.querySelector(rA.slider)),
                    (this.buttonClose = this.container.querySelector(rA.buttonClose)),
                    (this.currentDot = this.container.querySelector(`[${rA.dot}].${rC.active}`)),
                    (this.hasDefaultOpen = Boolean(this.currentDot)),
                    this.init();
            }
        };
    eN("look", [
        {
            onLoad() {
                (rq[this.id] = []), rq[this.id].push(new rI(this));
            },
            onUnload() {
                rq[this.id].forEach((e) => {
                    "function" == typeof e.onUnload && e.onUnload();
                });
            },
            onBlockSelect(e) {
                rq[this.id].forEach((t) => {
                    "function" == typeof t.onBlockSelect && t.onBlockSelect(e);
                });
            },
            onBlockDeselect(e) {
                rq[this.id].forEach((t) => {
                    "function" == typeof t.onBlockDeselect && t.onBlockDeselect(e);
                });
            },
        },
    ]),
        eN("featured-article", ti);
    let rP = (e, t = "", i) => (
        (i = i || document.createElement("div")).classList.add(t), e.parentNode.insertBefore(i, e), i.appendChild(e)
    );
    window.theme.settings.animate_scroll && e.init({ once: !0 }),
        document.addEventListener("DOMContentLoaded", function () {
            let e = document.querySelector("[data-header-height]");
            if (e) {
                let t = e.clientHeight || 0;
                document.documentElement.style.setProperty("--menu-height", `${t}px`);
            }
            ez("*"), window.theme.settings.animate_hover && document.body.classList.add("theme-animate-hover");
            let i = document.querySelectorAll(".rte table");
            i.forEach((e) => {
                rP(e, "rte__table-wrapper");
            });
            let s = document.querySelectorAll(
                '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"], .rte iframe#admin_bar_iframe'
            );
            s.forEach((e) => {
                rP(e, "rte__video-wrapper");
            }),
                document.addEventListener("mousedown", () => {
                    document.body.classList.remove("focus-enabled");
                }),
                document.addEventListener("keyup", (e) => {
                    "Tab" === e.code && document.body.classList.add("focus-enabled");
                }),
                window.navigator.cookieEnabled &&
                    (document.documentElement.className = document.documentElement.className.replace(
                        "supports-no-cookies",
                        "supports-cookies"
                    )),
                e1(),
                eK();
            "scrollBehavior" in document.documentElement.style || tV({ url: window.theme.assets.smoothscroll });
        });
    var r9 = [
            "input",
            "select",
            "textarea",
            "a[href]",
            "button",
            "[tabindex]",
            "audio[controls]",
            "video[controls]",
            '[contenteditable]:not([contenteditable="false"])',
            "details>summary:first-of-type",
            "details",
        ],
        rM = r9.join(","),
        rD =
            "undefined" == typeof Element
                ? function () {}
                : Element.prototype.matches ||
                  Element.prototype.msMatchesSelector ||
                  Element.prototype.webkitMatchesSelector,
        rO = function e(t, i, s) {
            var r = Array.prototype.slice.apply(t.querySelectorAll(rM));
            return i && rD.call(t, rM) && r.unshift(t), (r = r.filter(s));
        },
        rF = function e(t) {
            var i,
                s = parseInt(t.getAttribute("tabindex"), 10);
            return isNaN(s)
                ? "true" === (i = t).contentEditable ||
                  (("AUDIO" === t.nodeName || "VIDEO" === t.nodeName || "DETAILS" === t.nodeName) &&
                      null === t.getAttribute("tabindex"))
                    ? 0
                    : t.tabIndex
                : s;
        },
        rB = function e(t, i) {
            return t.tabIndex === i.tabIndex ? t.documentOrder - i.documentOrder : t.tabIndex - i.tabIndex;
        },
        rV = function e(t) {
            return "INPUT" === t.tagName;
        },
        rH = function e(t, i) {
            for (var s = 0; s < t.length; s++) if (t[s].checked && t[s].form === i) return t[s];
        },
        rW = function e(t) {
            if (!t.name) return !0;
            var i,
                s = t.form || t.ownerDocument,
                r = function e(t) {
                    return s.querySelectorAll('input[type="radio"][name="' + t + '"]');
                };
            if ("undefined" != typeof window && void 0 !== window.CSS && "function" == typeof window.CSS.escape)
                i = r(window.CSS.escape(t.name));
            else
                try {
                    i = r(t.name);
                } catch (n) {
                    return (
                        console.error(
                            "Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s",
                            n.message
                        ),
                        !1
                    );
                }
            var a = rH(i, t.form);
            return !a || a === t;
        },
        rR = function e(t) {
            var i;
            return rV((i = t)) && "radio" === i.type && !rW(t);
        },
        rN = function e(t, i) {
            if ("hidden" === getComputedStyle(t).visibility) return !0;
            var s = rD.call(t, "details>summary:first-of-type") ? t.parentElement : t;
            if (rD.call(s, "details:not([open]) *")) return !0;
            if (i && "full" !== i) {
                if ("non-zero-area" === i) {
                    var r = t.getBoundingClientRect(),
                        n = r.width,
                        a = r.height;
                    return 0 === n && 0 === a;
                }
            } else
                for (; t; ) {
                    if ("none" === getComputedStyle(t).display) return !0;
                    t = t.parentElement;
                }
            return !1;
        },
        rz = function e(t) {
            if (rV(t) || "SELECT" === t.tagName || "TEXTAREA" === t.tagName || "BUTTON" === t.tagName)
                for (var i = t.parentElement; i; ) {
                    if ("FIELDSET" === i.tagName && i.disabled) {
                        for (var s = 0; s < i.children.length; s++) {
                            var r = i.children.item(s);
                            if ("LEGEND" === r.tagName) {
                                if (r.contains(t)) return !1;
                                break;
                            }
                        }
                        return !0;
                    }
                    i = i.parentElement;
                }
            return !1;
        },
        r0 = function e(t, i) {
            var s, r;
            return !(
                i.disabled ||
                (rV((s = i)) && "hidden" === s.type) ||
                rN(i, t.displayCheck) ||
                ((r = i),
                "DETAILS" === r.tagName &&
                    Array.prototype.slice.apply(r.children).some(function (e) {
                        return "SUMMARY" === e.tagName;
                    })) ||
                rz(i)
            );
        },
        rj = function e(t, i) {
            return !(!r0(t, i) || rR(i) || 0 > rF(i));
        },
        rU = function e(t, i) {
            var s = [],
                r = [];
            return (
                rO(t, (i = i || {}).includeContainer, rj.bind(null, i)).forEach(function (e, t) {
                    var i = rF(e);
                    0 === i ? s.push(e) : r.push({ documentOrder: t, tabIndex: i, node: e });
                }),
                r
                    .sort(rB)
                    .map(function (e) {
                        return e.node;
                    })
                    .concat(s)
            );
        },
        r3 = r9.concat("iframe").join(","),
        rG = function e(t, i) {
            if (((i = i || {}), !t)) throw Error("No node provided");
            return !1 !== rD.call(t, r3) && r0(i, t);
        };
    function r1(e, t) {
        var i = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var s = Object.getOwnPropertySymbols(e);
            t &&
                (s = s.filter(function (t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })),
                i.push.apply(i, s);
        }
        return i;
    }
    function rK(e, t, i) {
        return (
            t in e
                ? Object.defineProperty(e, t, { value: i, enumerable: !0, configurable: !0, writable: !0 })
                : (e[t] = i),
            e
        );
    }
    var r2,
        r4 =
            ((r2 = []),
            {
                activateTrap: function e(t) {
                    if (r2.length > 0) {
                        var i = r2[r2.length - 1];
                        i !== t && i.pause();
                    }
                    var s = r2.indexOf(t);
                    -1 === s || r2.splice(s, 1), r2.push(t);
                },
                deactivateTrap: function e(t) {
                    var i = r2.indexOf(t);
                    -1 !== i && r2.splice(i, 1), r2.length > 0 && r2[r2.length - 1].unpause();
                },
            }),
        rX = function e(t) {
            return t.tagName && "input" === t.tagName.toLowerCase() && "function" == typeof t.select;
        },
        rY = function e(t) {
            return "Escape" === t.key || "Esc" === t.key || 27 === t.keyCode;
        },
        r6 = function e(t) {
            return "Tab" === t.key || 9 === t.keyCode;
        },
        rJ = function e(t) {
            return setTimeout(t, 0);
        },
        rQ = function e(t, i) {
            var s = -1;
            return (
                t.every(function (e, t) {
                    return !i(e) || ((s = t), !1);
                }),
                s
            );
        },
        r7 = function e(t) {
            for (var i = arguments.length, s = Array(i > 1 ? i - 1 : 0), r = 1; r < i; r++) s[r - 1] = arguments[r];
            return "function" == typeof t ? t.apply(void 0, s) : t;
        },
        r5 = function e(t, i) {
            var s,
                r = document,
                n = (function e(t) {
                    for (var i = 1; i < arguments.length; i++) {
                        var s = null != arguments[i] ? arguments[i] : {};
                        i % 2
                            ? r1(Object(s), !0).forEach(function (e) {
                                  rK(t, e, s[e]);
                              })
                            : Object.getOwnPropertyDescriptors
                              ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(s))
                              : r1(Object(s)).forEach(function (e) {
                                    Object.defineProperty(t, e, Object.getOwnPropertyDescriptor(s, e));
                                });
                    }
                    return t;
                })({ returnFocusOnDeactivate: !0, escapeDeactivates: !0, delayInitialFocus: !0 }, i),
                a = {
                    containers: [],
                    tabbableGroups: [],
                    nodeFocusedBeforeActivation: null,
                    mostRecentlyFocusedNode: null,
                    active: !1,
                    paused: !1,
                    delayInitialFocusTimer: void 0,
                },
                o = function e(t, i, s) {
                    return t && void 0 !== t[i] ? t[i] : n[s || i];
                },
                l = function e(t) {
                    return a.containers.some(function (e) {
                        return e.contains(t);
                    });
                },
                d = function e(t) {
                    var i = n[t];
                    if (!i) return null;
                    var s = i;
                    if ("string" == typeof i && !(s = r.querySelector(i)))
                        throw Error("`".concat(t, "` refers to no known node"));
                    if ("function" == typeof i && !(s = i())) throw Error("`".concat(t, "` did not return a node"));
                    return s;
                },
                c = function e() {
                    var t;
                    if (!1 === o({}, "initialFocus")) return !1;
                    if (null !== d("initialFocus")) t = d("initialFocus");
                    else if (l(r.activeElement)) t = r.activeElement;
                    else {
                        var i = a.tabbableGroups[0];
                        t = (i && i.firstTabbableNode) || d("fallbackFocus");
                    }
                    if (!t) throw Error("Your focus-trap needs to have at least one focusable element");
                    return t;
                },
                h = function e() {
                    if (
                        ((a.tabbableGroups = a.containers
                            .map(function (e) {
                                var t = rU(e);
                                if (t.length > 0)
                                    return { container: e, firstTabbableNode: t[0], lastTabbableNode: t[t.length - 1] };
                            })
                            .filter(function (e) {
                                return !!e;
                            })),
                        a.tabbableGroups.length <= 0 && !d("fallbackFocus"))
                    )
                        throw Error(
                            "Your focus-trap must have at least one container with at least one tabbable node in it at all times"
                        );
                },
                u = function e(t) {
                    if (!1 !== t && t !== r.activeElement) {
                        if (!t || !t.focus) {
                            e(c());
                            return;
                        }
                        t.focus({ preventScroll: !!n.preventScroll }),
                            (a.mostRecentlyFocusedNode = t),
                            rX(t) && t.select();
                    }
                },
                p = function e(t) {
                    var i;
                    return d("setReturnFocus") || t;
                },
                m = function e(t) {
                    if (!l(t.target)) {
                        if (r7(n.clickOutsideDeactivates, t)) {
                            s.deactivate({ returnFocus: n.returnFocusOnDeactivate && !rG(t.target) });
                            return;
                        }
                        !r7(n.allowOutsideClick, t) && t.preventDefault();
                    }
                },
                f = function e(t) {
                    var i = l(t.target);
                    i || t.target instanceof Document
                        ? i && (a.mostRecentlyFocusedNode = t.target)
                        : (t.stopImmediatePropagation(), u(a.mostRecentlyFocusedNode || c()));
                },
                g = function e(t) {
                    h();
                    var i = null;
                    if (a.tabbableGroups.length > 0) {
                        var s = rQ(a.tabbableGroups, function (e) {
                            return e.container.contains(t.target);
                        });
                        if (s < 0)
                            i = t.shiftKey
                                ? a.tabbableGroups[a.tabbableGroups.length - 1].lastTabbableNode
                                : a.tabbableGroups[0].firstTabbableNode;
                        else if (t.shiftKey) {
                            var r = rQ(a.tabbableGroups, function (e) {
                                var i = e.firstTabbableNode;
                                return t.target === i;
                            });
                            if ((r < 0 && a.tabbableGroups[s].container === t.target && (r = s), r >= 0)) {
                                var n = 0 === r ? a.tabbableGroups.length - 1 : r - 1;
                                i = a.tabbableGroups[n].lastTabbableNode;
                            }
                        } else {
                            var o = rQ(a.tabbableGroups, function (e) {
                                var i = e.lastTabbableNode;
                                return t.target === i;
                            });
                            if ((o < 0 && a.tabbableGroups[s].container === t.target && (o = s), o >= 0)) {
                                var l = o === a.tabbableGroups.length - 1 ? 0 : o + 1;
                                i = a.tabbableGroups[l].firstTabbableNode;
                            }
                        }
                    } else i = d("fallbackFocus");
                    i && (t.preventDefault(), u(i));
                },
                y = function e(t) {
                    if (rY(t) && !1 !== r7(n.escapeDeactivates)) {
                        t.preventDefault(), s.deactivate();
                        return;
                    }
                    if (r6(t)) {
                        g(t);
                        return;
                    }
                },
                v = function e(t) {
                    !(r7(n.clickOutsideDeactivates, t) || l(t.target) || r7(n.allowOutsideClick, t)) &&
                        (t.preventDefault(), t.stopImmediatePropagation());
                },
                b = function e() {
                    if (a.active)
                        return (
                            r4.activateTrap(s),
                            (a.delayInitialFocusTimer = n.delayInitialFocus
                                ? rJ(function () {
                                      u(c());
                                  })
                                : u(c())),
                            r.addEventListener("focusin", f, !0),
                            r.addEventListener("mousedown", m, { capture: !0, passive: !1 }),
                            r.addEventListener("touchstart", m, { capture: !0, passive: !1 }),
                            r.addEventListener("click", v, { capture: !0, passive: !1 }),
                            r.addEventListener("keydown", y, { capture: !0, passive: !1 }),
                            s
                        );
                },
                $ = function e() {
                    if (a.active)
                        return (
                            r.removeEventListener("focusin", f, !0),
                            r.removeEventListener("mousedown", m, !0),
                            r.removeEventListener("touchstart", m, !0),
                            r.removeEventListener("click", v, !0),
                            r.removeEventListener("keydown", y, !0),
                            s
                        );
                };
            return (
                (s = {
                    activate: function e(t) {
                        if (a.active) return this;
                        var i = o(t, "onActivate"),
                            s = o(t, "onPostActivate"),
                            n = o(t, "checkCanFocusTrap");
                        n || h(),
                            (a.active = !0),
                            (a.paused = !1),
                            (a.nodeFocusedBeforeActivation = r.activeElement),
                            i && i();
                        var l = function e() {
                            n && h(), b(), s && s();
                        };
                        return n ? (n(a.containers.concat()).then(l, l), this) : (l(), this);
                    },
                    deactivate: function e(t) {
                        if (!a.active) return this;
                        clearTimeout(a.delayInitialFocusTimer),
                            (a.delayInitialFocusTimer = void 0),
                            $(),
                            (a.active = !1),
                            (a.paused = !1),
                            r4.deactivateTrap(s);
                        var i = o(t, "onDeactivate"),
                            r = o(t, "onPostDeactivate"),
                            n = o(t, "checkCanReturnFocus");
                        i && i();
                        var l = o(t, "returnFocus", "returnFocusOnDeactivate"),
                            d = function e() {
                                rJ(function () {
                                    l && u(p(a.nodeFocusedBeforeActivation)), r && r();
                                });
                            };
                        return l && n ? (n(p(a.nodeFocusedBeforeActivation)).then(d, d), this) : (d(), this);
                    },
                    pause: function e() {
                        return a.paused || !a.active || ((a.paused = !0), $()), this;
                    },
                    unpause: function e() {
                        return a.paused && a.active && ((a.paused = !1), h(), b()), this;
                    },
                    updateContainerElements: function e(t) {
                        var i = [].concat(t).filter(Boolean);
                        return (
                            (a.containers = i.map(function (e) {
                                return "string" == typeof e ? r.querySelector(e) : e;
                            })),
                            a.active && h(),
                            this
                        );
                    },
                }).updateContainerElements(t),
                s
            );
        };
    function rZ(e) {
        let t = [];
        return (
            (function e(t, i) {
                !t.isSameNode(document.body) &&
                    t.parentNode &&
                    Array.from(t.parentNode.children).forEach((s) => {
                        s.isSameNode(t) ? e(t.parentNode, i) : i(s);
                    });
            })(e, (e) => {
                let i = e.hasAttribute("aria-hidden");
                e.setAttribute("aria-hidden", "true"), t.push(() => i || e.removeAttribute("aria-hidden"));
            }),
            () => {
                for (; t.length; ) t.pop()();
            }
        );
    }
    var ne = function e(t) {
        let i, s;
        window.addEventListener("focusin", () => {
            (i = s), (s = document.activeElement);
        }),
            t.magic("focus", (e) => {
                let t = e;
                return {
                    __noscroll: !1,
                    __wrapAround: !1,
                    within(e) {
                        return (t = e), this;
                    },
                    withoutScrolling() {
                        return (this.__noscroll = !0), this;
                    },
                    noscroll() {
                        return (this.__noscroll = !0), this;
                    },
                    withWrapAround() {
                        return (this.__wrapAround = !0), this;
                    },
                    wrap() {
                        return this.withWrapAround();
                    },
                    focusable: (e) => rG(e),
                    previouslyFocused: () => i,
                    lastFocused: () => i,
                    focused: () => s,
                    focusables() {
                        var e, i;
                        return Array.isArray(t)
                            ? t
                            : ((e = t),
                              (i = { displayCheck: "none" }),
                              rO(e, (i = i || {}).includeContainer, r0.bind(null, i)));
                    },
                    all() {
                        return this.focusables();
                    },
                    isFirst(e) {
                        let t = this.all();
                        return t[0] && t[0].isSameNode(e);
                    },
                    isLast(e) {
                        let t = this.all();
                        return t.length && t.slice(-1)[0].isSameNode(e);
                    },
                    getFirst() {
                        return this.all()[0];
                    },
                    getLast() {
                        return this.all().slice(-1)[0];
                    },
                    getNext() {
                        let e = this.all(),
                            t = document.activeElement;
                        if (-1 !== e.indexOf(t))
                            return this.__wrapAround && e.indexOf(t) === e.length - 1 ? e[0] : e[e.indexOf(t) + 1];
                    },
                    getPrevious() {
                        let e = this.all(),
                            t = document.activeElement;
                        if (-1 !== e.indexOf(t))
                            return this.__wrapAround && 0 === e.indexOf(t) ? e.slice(-1)[0] : e[e.indexOf(t) - 1];
                    },
                    first() {
                        this.focus(this.getFirst());
                    },
                    last() {
                        this.focus(this.getLast());
                    },
                    next() {
                        this.focus(this.getNext());
                    },
                    previous() {
                        this.focus(this.getPrevious());
                    },
                    prev() {
                        return this.previous();
                    },
                    focus(e) {
                        e &&
                            setTimeout(() => {
                                e.hasAttribute("tabindex") || e.setAttribute("tabindex", "0"),
                                    e.focus({ preventScroll: this._noscroll });
                            });
                    },
                };
            }),
            t.directive(
                "trap",
                t.skipDuringClone(
                    (e, { expression: t, modifiers: i }, { effect: s, evaluateLater: r, cleanup: n }) => {
                        let a = r(t),
                            o = !1,
                            l = r5(e, {
                                escapeDeactivates: !1,
                                allowOutsideClick: !0,
                                fallbackFocus: () => e,
                                initialFocus: e.querySelector("[autofocus]"),
                            }),
                            d = () => {},
                            c = () => {},
                            h = () => {
                                d(),
                                    (d = () => {}),
                                    c(),
                                    (c = () => {}),
                                    l.deactivate({ returnFocus: !i.includes("noreturn") });
                            };
                        s(() =>
                            a((t) => {
                                o !== t &&
                                    (t &&
                                        !o &&
                                        setTimeout(() => {
                                            let t, s, r;
                                            i.includes("inert") && (d = rZ(e)),
                                                i.includes("noscroll") &&
                                                    (c =
                                                        ((t = document.documentElement.style.overflow),
                                                        (s = document.documentElement.style.paddingRight),
                                                        (r = window.innerWidth - document.documentElement.clientWidth),
                                                        (document.documentElement.style.overflow = "hidden"),
                                                        (document.documentElement.style.paddingRight = `${r}px`),
                                                        () => {
                                                            (document.documentElement.style.overflow = t),
                                                                (document.documentElement.style.paddingRight = s);
                                                        })),
                                                l.activate();
                                        }),
                                    !t && o && h(),
                                    (o = !!t));
                            })
                        ),
                            n(h);
                    },
                    (e, { expression: t, modifiers: i }, { evaluate: s }) => {
                        i.includes("inert") && s(t) && rZ(e);
                    }
                )
            );
    };
    function nt(e) {
        let t = e.match(/^(-?[0-9]+)(px|%)?$/);
        return t ? t[1] + (t[2] || "px") : void 0;
    }
    var ni = function e(t) {
        t.directive(
            "intersect",
            t.skipDuringClone((e, { value: t, expression: i, modifiers: s }, { evaluateLater: r, cleanup: n }) => {
                let a = r(i),
                    o = {
                        rootMargin: (function e(t) {
                            let i = "0px 0px 0px 0px",
                                s = t.indexOf("margin");
                            if (-1 === s) return i;
                            let r = [];
                            for (let n = 1; n < 5; n++) r.push(nt(t[s + n] || ""));
                            return (r = r.filter((e) => void 0 !== e)).length ? r.join(" ").trim() : i;
                        })(s),
                        threshold: (function e(t) {
                            if (t.includes("full")) return 0.99;
                            if (t.includes("half")) return 0.5;
                            if (!t.includes("threshold")) return 0;
                            let i = t[t.indexOf("threshold") + 1];
                            return "100" === i ? 1 : "0" === i ? 0 : Number(`.${i}`);
                        })(s),
                    },
                    l = new IntersectionObserver((e) => {
                        e.forEach((e) => {
                            e.isIntersecting !== ("leave" === t) && (a(), s.includes("once") && l.disconnect());
                        });
                    }, o);
                l.observe(e),
                    n(() => {
                        l.disconnect();
                    });
            })
        );
    };
    function ns(e, t, i) {
        if (-1 === e.indexOf(t)) return i;
        let s = e[e.indexOf(t) + 1];
        if (!s) return i;
        if ("duration" === t) {
            let r = s.match(/([0-9]+)ms/);
            if (r) return r[1];
        }
        if ("min" === t) {
            let n = s.match(/([0-9]+)px/);
            if (n) return n[1];
        }
        return s;
    }
    var nr = function e(t) {
            function i(e, { modifiers: i }) {
                let s = ns(i, "duration", 250) / 1e3,
                    r = ns(i, "min", 0),
                    n = !i.includes("min");
                e._x_isShown || (e.style.height = `${r}px`),
                    !e._x_isShown && n && (e.hidden = !0),
                    e._x_isShown || (e.style.overflow = "hidden");
                let a = (e, i) => {
                        let s = t.setStyles(e, i);
                        return i.height ? () => {} : s;
                    },
                    o = {
                        transitionProperty: "height",
                        transitionDuration: `${s}s`,
                        transitionTimingFunction: "cubic-bezier(0.4, 0.0, 0.2, 1)",
                    };
                e._x_transition = {
                    in(i = () => {}, s = () => {}) {
                        n && (e.hidden = !1), n && (e.style.display = null);
                        let a = e.getBoundingClientRect().height;
                        e.style.height = "auto";
                        let l = e.getBoundingClientRect().height;
                        a === l && (a = r),
                            t.transition(
                                e,
                                t.setStyles,
                                { during: o, start: { height: a + "px" }, end: { height: l + "px" } },
                                () => (e._x_isShown = !0),
                                () => {
                                    1 > Math.abs(e.getBoundingClientRect().height - l) && (e.style.overflow = null);
                                }
                            );
                    },
                    out(i = () => {}, s = () => {}) {
                        let l = e.getBoundingClientRect().height;
                        t.transition(
                            e,
                            a,
                            { during: o, start: { height: l + "px" }, end: { height: r + "px" } },
                            () => (e.style.overflow = "hidden"),
                            () => {
                                (e._x_isShown = !1),
                                    e.style.height == `${r}px` && n && ((e.style.display = "none"), (e.hidden = !0));
                            }
                        );
                    },
                };
            }
            t.directive("collapse", i),
                (i.inline = (e, { modifiers: t }) => {
                    t.includes("min") && ((e._x_doShow = () => {}), (e._x_doHide = () => {}));
                });
        },
        nn = !1,
        na = !1,
        no = [],
        nl = -1;
    function nd(e) {
        nc(e);
    }
    function nc(e) {
        no.includes(e) || no.push(e), na || nn || ((nn = !0), queueMicrotask(nu));
    }
    function nh(e) {
        let t = no.indexOf(e);
        -1 !== t && t > nl && no.splice(t, 1);
    }
    function nu() {
        (nn = !1), (na = !0);
        for (let e = 0; e < no.length; e++) no[e](), (nl = e);
        (no.length = 0), (nl = -1), (na = !1);
    }
    var np = !0;
    function nm(e) {
        _ = e;
    }
    function nf(e, t) {
        let i = !0,
            s,
            r = _(() => {
                let r = e();
                JSON.stringify(r),
                    i
                        ? (s = r)
                        : queueMicrotask(() => {
                              t(r, s), (s = r);
                          }),
                    (i = !1);
            });
        return () => A(r);
    }
    var ng = [],
        ny = [],
        nv = [];
    function nb(e, t) {
        "function" == typeof t ? (e._x_cleanups || (e._x_cleanups = []), e._x_cleanups.push(t)) : ((t = e), ny.push(t));
    }
    function n$(e) {
        ng.push(e);
    }
    function nw(e, t, i) {
        e._x_attributeCleanups || (e._x_attributeCleanups = {}),
            e._x_attributeCleanups[t] || (e._x_attributeCleanups[t] = []),
            e._x_attributeCleanups[t].push(i);
    }
    function n8(e, t) {
        e._x_attributeCleanups &&
            Object.entries(e._x_attributeCleanups).forEach(([i, s]) => {
                (void 0 === t || t.includes(i)) && (s.forEach((e) => e()), delete e._x_attributeCleanups[i]);
            });
    }
    var nS = new MutationObserver(nC),
        nE = !1;
    function nx() {
        nS.observe(document, { subtree: !0, childList: !0, attributes: !0, attributeOldValue: !0 }), (nE = !0);
    }
    function nk() {
        let e, t;
        (e = nS.takeRecords()),
            nT.push(() => e.length > 0 && nC(e)),
            (t = nT.length),
            queueMicrotask(() => {
                if (nT.length === t) for (; nT.length > 0; ) nT.shift()();
            }),
            nS.disconnect(),
            (nE = !1);
    }
    var nT = [];
    function nL(e) {
        if (!nE) return e();
        nk();
        let t = e();
        return nx(), t;
    }
    var n_ = !1,
        nA = [];
    function nC(e) {
        if (n_) {
            nA = nA.concat(e);
            return;
        }
        let t = [],
            i = new Set(),
            s = new Map(),
            r = new Map();
        for (let n = 0; n < e.length; n++)
            if (
                !e[n].target._x_ignoreMutationObserver &&
                ("childList" === e[n].type &&
                    (e[n].removedNodes.forEach((e) => {
                        1 === e.nodeType && e._x_marker && i.add(e);
                    }),
                    e[n].addedNodes.forEach((e) => {
                        if (1 === e.nodeType) {
                            if (i.has(e)) {
                                i.delete(e);
                                return;
                            }
                            e._x_marker || t.push(e);
                        }
                    })),
                "attributes" === e[n].type)
            ) {
                let a = e[n].target,
                    o = e[n].attributeName,
                    l = e[n].oldValue,
                    d = () => {
                        s.has(a) || s.set(a, []), s.get(a).push({ name: o, value: a.getAttribute(o) });
                    },
                    c = () => {
                        r.has(a) || r.set(a, []), r.get(a).push(o);
                    };
                a.hasAttribute(o) && null === l ? d() : a.hasAttribute(o) ? (c(), d()) : c();
            }
        for (let h of (r.forEach((e, t) => {
            n8(t, e);
        }),
        s.forEach((e, t) => {
            ng.forEach((i) => i(t, e));
        }),
        i))
            t.some((e) => e.contains(h)) || ny.forEach((e) => e(h));
        for (let u of t) u.isConnected && nv.forEach((e) => e(u));
        (t = null), (i = null), (s = null), (r = null);
    }
    function nq(e) {
        return n9(nP(e));
    }
    function nI(e, t, i) {
        return (
            (e._x_dataStack = [t, ...nP(i || e)]),
            () => {
                e._x_dataStack = e._x_dataStack.filter((e) => e !== t);
            }
        );
    }
    function nP(e) {
        return e._x_dataStack
            ? e._x_dataStack
            : "function" == typeof ShadowRoot && e instanceof ShadowRoot
              ? nP(e.host)
              : e.parentNode
                ? nP(e.parentNode)
                : [];
    }
    function n9(e) {
        return new Proxy({ objects: e }, nM);
    }
    var nM = {
        ownKeys: ({ objects: e }) => Array.from(new Set(e.flatMap((e) => Object.keys(e)))),
        has: ({ objects: e }, t) =>
            t != Symbol.unscopables && e.some((e) => Object.prototype.hasOwnProperty.call(e, t) || Reflect.has(e, t)),
        get: ({ objects: e }, t, i) => ("toJSON" == t ? nD : Reflect.get(e.find((e) => Reflect.has(e, t)) || {}, t, i)),
        set({ objects: e }, t, i, s) {
            let r = e.find((e) => Object.prototype.hasOwnProperty.call(e, t)) || e[e.length - 1],
                n = Object.getOwnPropertyDescriptor(r, t);
            return (null == n ? void 0 : n.set) && (null == n ? void 0 : n.get)
                ? n.set.call(s, i) || !0
                : Reflect.set(r, t, i);
        },
    };
    function nD() {
        return Reflect.ownKeys(this).reduce((e, t) => ((e[t] = Reflect.get(this, t)), e), {});
    }
    function nO(e) {
        let t = (e) => "object" == typeof e && !Array.isArray(e) && null !== e,
            i = (s, r = "") => {
                Object.entries(Object.getOwnPropertyDescriptors(s)).forEach(([n, { value: a, enumerable: o }]) => {
                    if (!1 === o || void 0 === a || ("object" == typeof a && null !== a && a.__v_skip)) return;
                    let l = "" === r ? n : `${r}.${n}`;
                    "object" == typeof a && null !== a && a._x_interceptor
                        ? (s[n] = a.initialize(e, l, n))
                        : !t(a) || a === s || a instanceof Element || i(a, l);
                });
            };
        return i(e);
    }
    function nF(e, t = () => {}) {
        let i = {
            initialValue: void 0,
            _x_interceptor: !0,
            initialize(t, i, s) {
                return e(
                    this.initialValue,
                    () => {
                        var e, s;
                        return (e = t), (s = i), s.split(".").reduce((e, t) => e[t], e);
                    },
                    (e) =>
                        (function e(t, i, s) {
                            if (("string" == typeof i && (i = i.split(".")), 1 === i.length)) t[i[0]] = s;
                            else if (0 !== i.length) return t[i[0]] || (t[i[0]] = {}), e(t[i[0]], i.slice(1), s);
                            else throw error;
                        })(t, i, e),
                    i,
                    s
                );
            },
        };
        return (
            t(i),
            (e) => {
                if ("object" == typeof e && null !== e && e._x_interceptor) {
                    let t = i.initialize.bind(i);
                    i.initialize = (s, r, n) => {
                        let a = e.initialize(s, r, n);
                        return (i.initialValue = a), t(s, r, n);
                    };
                } else i.initialValue = e;
                return i;
            }
        );
    }
    var nB = {};
    function nV(e, t) {
        nB[e] = t;
    }
    function nH(e, t) {
        let i = (function e(t) {
            let [i, s] = ae(t),
                r = { interceptor: nF, ...i };
            return nb(t, s), r;
        })(t);
        return (
            Object.entries(nB).forEach(([s, r]) => {
                Object.defineProperty(e, `$${s}`, { get: () => r(t, i), enumerable: !1 });
            }),
            e
        );
    }
    function nW(e, t, i, ...s) {
        try {
            return i(...s);
        } catch (r) {
            nR(r, e, t);
        }
    }
    function nR(e, t, i) {
        (e = Object.assign(null != e ? e : { message: "No error message given." }, { el: t, expression: i })),
            console.warn(
                `Alpine Expression Error: ${e.message}

${i ? 'Expression: "' + i + '"\n\n' : ""}`,
                t
            ),
            setTimeout(() => {
                throw e;
            }, 0);
    }
    var nN = !0;
    function nz(e) {
        let t = nN;
        nN = !1;
        let i = e();
        return (nN = t), i;
    }
    function n0(e, t, i = {}) {
        let s;
        return nj(e, t)((e) => (s = e), i), s;
    }
    function nj(...e) {
        return nU(...e);
    }
    var nU = nG;
    function n3(e) {
        nU = e;
    }
    function nG(e, t) {
        var i, s, r, n, a;
        let o = {};
        nH(o, e);
        let l,
            d = [o, ...nP(e)],
            c =
                "function" == typeof t
                    ? ((i = d),
                      (s = t),
                      (e = () => {}, { scope: t = {}, params: r = [] } = {}) => {
                          let n = s.apply(n9([t, ...i]), r);
                          nK(e, n);
                      })
                    : ((r = d),
                      (n = t),
                      (a = e),
                      (l = (function e(t, i) {
                          if (n1[t]) return n1[t];
                          let s = Object.getPrototypeOf(async function () {}).constructor,
                              r =
                                  /^[\n\s]*if.*\(.*\)/.test(t.trim()) || /^(let|const)\s/.test(t.trim())
                                      ? `(async()=>{ ${t} })()`
                                      : t,
                              n = (() => {
                                  try {
                                      let e = new s(
                                          ["__self", "scope"],
                                          `with (scope) { __self.result = ${r} }; __self.finished = true; return __self.result;`
                                      );
                                      return Object.defineProperty(e, "name", { value: `[Alpine] ${t}` }), e;
                                  } catch (n) {
                                      return nR(n, i, t), Promise.resolve();
                                  }
                              })();
                          return (n1[t] = n), n;
                      })(n, a)),
                      (e = () => {}, { scope: t = {}, params: i = [] } = {}) => {
                          (l.result = void 0), (l.finished = !1);
                          let s = n9([t, ...r]);
                          if ("function" == typeof l) {
                              let o = l(l, s).catch((e) => nR(e, a, n));
                              l.finished
                                  ? (nK(e, l.result, s, i, a), (l.result = void 0))
                                  : o
                                        .then((t) => {
                                            nK(e, t, s, i, a);
                                        })
                                        .catch((e) => nR(e, a, n))
                                        .finally(() => (l.result = void 0));
                          }
                      });
        return nW.bind(null, e, t, c);
    }
    var n1 = {};
    function nK(e, t, i, s, r) {
        if (nN && "function" == typeof t) {
            let n = t.apply(i, s);
            n instanceof Promise ? n.then((t) => nK(e, t, i, s)).catch((e) => nR(e, r, t)) : e(n);
        } else "object" == typeof t && t instanceof Promise ? t.then((t) => e(t)) : e(t);
    }
    var n2 = "x-";
    function n4(e = "") {
        return n2 + e;
    }
    function nX(e) {
        n2 = e;
    }
    var nY = {};
    function n6(e, t) {
        return (
            (nY[e] = t),
            {
                before(t) {
                    if (!nY[t]) {
                        console.warn(
                            String.raw`Cannot find directive \`${t}\`. \`${e}\` will use the default order of execution`
                        );
                        return;
                    }
                    let i = al.indexOf(t);
                    al.splice(i >= 0 ? i : al.indexOf("DEFAULT"), 0, e);
                },
            }
        );
    }
    function nJ(e, t, i) {
        var s, r;
        if (((t = Array.from(t)), e._x_virtualDirectives)) {
            let n = Object.entries(e._x_virtualDirectives).map(([e, t]) => ({ name: e, value: t })),
                a = nQ(n);
            (n = n.map((e) =>
                a.find((t) => t.name === e.name) ? { name: `x-bind:${e.name}`, value: `"${e.value}"` } : e
            )),
                (t = t.concat(n));
        }
        let o = {};
        return t
            .map(ai((e, t) => (o[e] = t)))
            .filter(an)
            .map(
                ((s = o),
                (r = i),
                ({ name: e, value: t }) => {
                    let i = e.match(aa()),
                        n = e.match(/:([a-zA-Z0-9\-_:]+)/),
                        a = e.match(/\.[^.\]]+(?=[^\]]*$)/g) || [],
                        o = r || s[e] || e;
                    return {
                        type: i ? i[1] : null,
                        value: n ? n[1] : null,
                        modifiers: a.map((e) => e.replace(".", "")),
                        expression: t,
                        original: o,
                    };
                })
            )
            .sort(ad)
            .map((t) =>
                (function e(t, i) {
                    let s = () => {},
                        r = nY[i.type] || s,
                        [n, a] = ae(t);
                    nw(t, i.original, a);
                    let o = () => {
                        t._x_ignore ||
                            t._x_ignoreSelf ||
                            (r.inline && r.inline(t, i, n), (r = r.bind(r, t, i, n)), n7 ? n5.get(nZ).push(r) : r());
                    };
                    return (o.runCleanups = a), o;
                })(e, t)
            );
    }
    function nQ(e) {
        return Array.from(e)
            .map(ai())
            .filter((e) => !an(e));
    }
    var n7 = !1,
        n5 = new Map(),
        nZ = Symbol();
    function ae(e) {
        var t;
        let i = [],
            s = (e) => i.push(e),
            r,
            [n, a] =
                ((t = e),
                (r = () => {}),
                [
                    (e) => {
                        let i = _(e);
                        return (
                            t._x_effects ||
                                ((t._x_effects = new Set()),
                                (t._x_runEffects = () => {
                                    t._x_effects.forEach((e) => e());
                                })),
                            t._x_effects.add(i),
                            (r = () => {
                                void 0 !== i && (t._x_effects.delete(i), A(i));
                            }),
                            i
                        );
                    },
                    () => {
                        r();
                    },
                ]);
        i.push(a);
        let o;
        return [
            { Alpine: aZ, effect: n, cleanup: s, evaluateLater: nj.bind(nj, e), evaluate: n0.bind(n0, e) },
            () => i.forEach((e) => e()),
        ];
    }
    var at =
        (e, t) =>
        ({ name: i, value: s }) => (i.startsWith(e) && (i = i.replace(e, t)), { name: i, value: s });
    function ai(e = () => {}) {
        return ({ name: t, value: i }) => {
            let { name: s, value: r } = as.reduce((e, t) => t(e), { name: t, value: i });
            return s !== t && e(s, t), { name: s, value: r };
        };
    }
    var as = [];
    function ar(e) {
        as.push(e);
    }
    function an({ name: e }) {
        return aa().test(e);
    }
    var aa = () => RegExp(`^${n2}([^:^.]+)\\b`),
        ao = "DEFAULT",
        al = [
            "ignore",
            "ref",
            "data",
            "id",
            "anchor",
            "bind",
            "init",
            "for",
            "model",
            "modelable",
            "transition",
            "show",
            "if",
            ao,
            "teleport",
        ];
    function ad(e, t) {
        let i = -1 === al.indexOf(e.type) ? ao : e.type,
            s = -1 === al.indexOf(t.type) ? ao : t.type;
        return al.indexOf(i) - al.indexOf(s);
    }
    function ac(e, t, i = {}) {
        e.dispatchEvent(new CustomEvent(t, { detail: i, bubbles: !0, composed: !0, cancelable: !0 }));
    }
    function ah(e, t) {
        if ("function" == typeof ShadowRoot && e instanceof ShadowRoot) {
            Array.from(e.children).forEach((e) => ah(e, t));
            return;
        }
        let i = !1;
        if ((t(e, () => (i = !0)), i)) return;
        let s = e.firstElementChild;
        for (; s; ) ah(s, t), (s = s.nextElementSibling);
    }
    function au(e, ...t) {
        console.warn(`Alpine Warning: ${e}`, ...t);
    }
    var ap = !1,
        am = [],
        af = [];
    function ag() {
        return am.map((e) => e());
    }
    function ay() {
        return am.concat(af).map((e) => e());
    }
    function av(e) {
        am.push(e);
    }
    function ab(e) {
        af.push(e);
    }
    function a$(e, t = !1) {
        return aw(e, (e) => {
            let i = t ? ay() : ag();
            if (i.some((t) => e.matches(t))) return !0;
        });
    }
    function aw(e, t) {
        return e
            ? t(e)
                ? e
                : (e._x_teleportBack && (e = e._x_teleportBack), e.parentElement)
                  ? aw(e.parentElement, t)
                  : void 0
            : void 0;
    }
    var a8 = [],
        aS = 1;
    function aE(e, t = ah, i = () => {}) {
        if (!aw(e, (e) => e._x_ignore)) {
            var s;
            let r, n;
            (s = () => {
                t(e, (e, t) => {
                    !e._x_marker &&
                        (i(e, t),
                        a8.forEach((i) => i(e, t)),
                        nJ(e, e.attributes).forEach((e) => e()),
                        e._x_ignore || (e._x_marker = aS++),
                        e._x_ignore && t());
                });
            }),
                (n7 = !0),
                (nZ = r = Symbol()),
                n5.set(r, []),
                s(
                    (n = () => {
                        for (; n5.get(r).length; ) n5.get(r).shift()();
                        n5.delete(r);
                    })
                ),
                (n7 = !1),
                n();
        }
    }
    function ax(e, t = ah) {
        t(e, (e) => {
            !(function e(t) {
                var i, s;
                for (
                    null === (i = t._x_effects) || void 0 === i || i.forEach(nh);
                    null === (s = t._x_cleanups) || void 0 === s ? void 0 : s.length;

                )
                    t._x_cleanups.pop()();
            })(e),
                n8(e),
                delete e._x_marker;
        });
    }
    var ak = [],
        aT = !1;
    function aL(e = () => {}) {
        return (
            queueMicrotask(() => {
                aT ||
                    setTimeout(() => {
                        a_();
                    });
            }),
            new Promise((t) => {
                ak.push(() => {
                    e(), t();
                });
            })
        );
    }
    function a_() {
        for (aT = !1; ak.length; ) ak.shift()();
    }
    function aA(e, t) {
        if (Array.isArray(t)) return aC(e, t.join(" "));
        if ("object" == typeof t && null !== t) {
            var i, s;
            let r, n, a, o, l;
            return (
                (i = e),
                (s = t),
                (r = (e) => e.split(" ").filter(Boolean)),
                (n = Object.entries(s)
                    .flatMap(([e, t]) => !!t && r(e))
                    .filter(Boolean)),
                (a = Object.entries(s)
                    .flatMap(([e, t]) => !t && r(e))
                    .filter(Boolean)),
                (o = []),
                (l = []),
                a.forEach((e) => {
                    i.classList.contains(e) && (i.classList.remove(e), l.push(e));
                }),
                n.forEach((e) => {
                    i.classList.contains(e) || (i.classList.add(e), o.push(e));
                }),
                () => {
                    l.forEach((e) => i.classList.add(e)), o.forEach((e) => i.classList.remove(e));
                }
            );
        }
        return "function" == typeof t ? aA(e, t()) : aC(e, t);
    }
    function aC(e, t) {
        var i, s;
        return (
            (s = (t = !0 === t ? (t = "") : t || "")
                .split(" ")
                .filter((t) => !e.classList.contains(t))
                .filter(Boolean)),
            e.classList.add(...s),
            () => {
                e.classList.remove(...s);
            }
        );
    }
    function aq(e, t) {
        var i, s, r, n;
        let a, o;
        return "object" == typeof t && null !== t
            ? ((i = e),
              (s = t),
              (a = {}),
              Object.entries(s).forEach(([e, t]) => {
                  var s;
                  (a[e] = i.style[e]),
                      e.startsWith("--") || (e = ((s = e), s.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase())),
                      i.style.setProperty(e, t);
              }),
              setTimeout(() => {
                  0 === i.style.length && i.removeAttribute("style");
              }),
              () => {
                  aq(i, a);
              })
            : ((r = e),
              (n = t),
              (o = r.getAttribute("style", n)),
              r.setAttribute("style", n),
              () => {
                  r.setAttribute("style", o || "");
              });
    }
    function aI(e, t = () => {}) {
        let i = !1;
        return function () {
            i ? t.apply(this, arguments) : ((i = !0), e.apply(this, arguments));
        };
    }
    function aP(e, t, i = {}) {
        e._x_transition ||
            (e._x_transition = {
                enter: { during: i, start: i, end: i },
                leave: { during: i, start: i, end: i },
                in(i = () => {}, s = () => {}) {
                    a9(e, t, { during: this.enter.during, start: this.enter.start, end: this.enter.end }, i, s);
                },
                out(i = () => {}, s = () => {}) {
                    a9(e, t, { during: this.leave.during, start: this.leave.start, end: this.leave.end }, i, s);
                },
            });
    }
    function a9(e, t, { during: i, start: s, end: r } = {}, n = () => {}, a = () => {}) {
        var o, l;
        if (
            (e._x_transitioning && e._x_transitioning.cancel(),
            0 === Object.keys(i).length && 0 === Object.keys(s).length && 0 === Object.keys(r).length)
        ) {
            n(), a();
            return;
        }
        let d, c, h, u, p, m, f;
        (o = e),
            (l = {
                start() {
                    d = t(e, s);
                },
                during() {
                    c = t(e, i);
                },
                before: n,
                end() {
                    d(), (h = t(e, r));
                },
                after: a,
                cleanup() {
                    c(), h();
                },
            }),
            (f = aI(() => {
                nL(() => {
                    (u = !0),
                        p || l.before(),
                        m || (l.end(), a_()),
                        l.after(),
                        o.isConnected && l.cleanup(),
                        delete o._x_transitioning;
                });
            })),
            (o._x_transitioning = {
                beforeCancels: [],
                beforeCancel(e) {
                    this.beforeCancels.push(e);
                },
                cancel: aI(function () {
                    for (; this.beforeCancels.length; ) this.beforeCancels.shift()();
                    f();
                }),
                finish: f,
            }),
            nL(() => {
                l.start(), l.during();
            }),
            (aT = !0),
            requestAnimationFrame(() => {
                if (u) return;
                let e = 1e3 * Number(getComputedStyle(o).transitionDuration.replace(/,.*/, "").replace("s", "")),
                    t = 1e3 * Number(getComputedStyle(o).transitionDelay.replace(/,.*/, "").replace("s", ""));
                0 === e && (e = 1e3 * Number(getComputedStyle(o).animationDuration.replace("s", ""))),
                    nL(() => {
                        l.before();
                    }),
                    (p = !0),
                    requestAnimationFrame(() => {
                        u ||
                            (nL(() => {
                                l.end();
                            }),
                            a_(),
                            setTimeout(o._x_transitioning.finish, e + t),
                            (m = !0));
                    });
            });
    }
    function aM(e, t, i) {
        if (-1 === e.indexOf(t)) return i;
        let s = e[e.indexOf(t) + 1];
        if (!s || ("scale" === t && isNaN(s))) return i;
        if ("duration" === t || "delay" === t) {
            let r = s.match(/([0-9]+)ms/);
            if (r) return r[1];
        }
        return "origin" === t && ["top", "right", "left", "center", "bottom"].includes(e[e.indexOf(t) + 2])
            ? [s, e[e.indexOf(t) + 2]].join(" ")
            : s;
    }
    n6("transition", (e, { value: t, modifiers: i, expression: s }, { evaluate: r }) => {
        var n, a, o, l, d, c;
        let h, u, p, m, f, g, y, v, b, $, w, S, E, x;
        "function" == typeof s && (s = r(s)),
            !1 !== s &&
                (s && "boolean" != typeof s
                    ? ((n = e),
                      (a = s),
                      (o = t),
                      aP(n, aA, ""),
                      {
                          enter(e) {
                              n._x_transition.enter.during = e;
                          },
                          "enter-start"(e) {
                              n._x_transition.enter.start = e;
                          },
                          "enter-end"(e) {
                              n._x_transition.enter.end = e;
                          },
                          leave(e) {
                              n._x_transition.leave.during = e;
                          },
                          "leave-start"(e) {
                              n._x_transition.leave.start = e;
                          },
                          "leave-end"(e) {
                              n._x_transition.leave.end = e;
                          },
                      }[o](a))
                    : ((l = e),
                      (d = i),
                      (c = t),
                      aP(l, aq),
                      (h = !d.includes("in") && !d.includes("out") && !c),
                      (u = h || d.includes("in") || ["enter"].includes(c)),
                      (p = h || d.includes("out") || ["leave"].includes(c)),
                      d.includes("in") && !h && (d = d.filter((e, t) => t < d.indexOf("out"))),
                      d.includes("out") && !h && (d = d.filter((e, t) => t > d.indexOf("out"))),
                      (m = !d.includes("opacity") && !d.includes("scale")),
                      (f = m || d.includes("opacity")),
                      (g = m || d.includes("scale")),
                      (y = f ? 0 : 1),
                      (v = g ? aM(d, "scale", 95) / 100 : 1),
                      (b = aM(d, "delay", 0) / 1e3),
                      ($ = aM(d, "origin", "center")),
                      (w = "opacity, transform"),
                      (S = aM(d, "duration", 150) / 1e3),
                      (E = aM(d, "duration", 75) / 1e3),
                      (x = "cubic-bezier(0.4, 0.0, 0.2, 1)"),
                      u &&
                          ((l._x_transition.enter.during = {
                              transformOrigin: $,
                              transitionDelay: `${b}s`,
                              transitionProperty: w,
                              transitionDuration: `${S}s`,
                              transitionTimingFunction: x,
                          }),
                          (l._x_transition.enter.start = { opacity: y, transform: `scale(${v})` }),
                          (l._x_transition.enter.end = { opacity: 1, transform: "scale(1)" })),
                      p &&
                          ((l._x_transition.leave.during = {
                              transformOrigin: $,
                              transitionDelay: `${b}s`,
                              transitionProperty: w,
                              transitionDuration: `${E}s`,
                              transitionTimingFunction: x,
                          }),
                          (l._x_transition.leave.start = { opacity: 1, transform: "scale(1)" }),
                          (l._x_transition.leave.end = { opacity: y, transform: `scale(${v})` }))));
    }),
        (window.Element.prototype._x_toggleAndCascadeWithTransitions = function (e, t, i, s) {
            let r = "visible" === document.visibilityState ? requestAnimationFrame : setTimeout,
                n = () => r(i);
            if (t) {
                e._x_transition && (e._x_transition.enter || e._x_transition.leave)
                    ? e._x_transition.enter &&
                      (Object.entries(e._x_transition.enter.during).length ||
                          Object.entries(e._x_transition.enter.start).length ||
                          Object.entries(e._x_transition.enter.end).length)
                        ? e._x_transition.in(i)
                        : n()
                    : e._x_transition
                      ? e._x_transition.in(i)
                      : n();
                return;
            }
            (e._x_hidePromise = e._x_transition
                ? new Promise((t, i) => {
                      e._x_transition.out(
                          () => {},
                          () => t(s)
                      ),
                          e._x_transitioning &&
                              e._x_transitioning.beforeCancel(() => i({ isFromCancelledTransition: !0 }));
                  })
                : Promise.resolve(s)),
                queueMicrotask(() => {
                    let t = (function e(t) {
                        let i = t.parentNode;
                        if (i) return i._x_hidePromise ? i : e(i);
                    })(e);
                    t
                        ? (t._x_hideChildren || (t._x_hideChildren = []), t._x_hideChildren.push(e))
                        : r(() => {
                              let t = (e) => {
                                  let i = Promise.all([e._x_hidePromise, ...(e._x_hideChildren || []).map(t)]).then(
                                      ([e]) => (null == e ? void 0 : e())
                                  );
                                  return delete e._x_hidePromise, delete e._x_hideChildren, i;
                              };
                              t(e).catch((e) => {
                                  if (!e.isFromCancelledTransition) throw e;
                              });
                          });
                });
        });
    var aD = !1;
    function aO(e, t = () => {}) {
        return (...i) => (aD ? t(...i) : e(...i));
    }
    var aF = [];
    function aB(e) {
        aF.push(e);
    }
    var aV = !1;
    function aH(e) {
        var t, i;
        let s = _;
        (_ = t =
            (e, t) => {
                let i = s(e);
                return A(i), () => {};
            }),
            e(),
            (_ = i = s);
    }
    function aW(e, t, i, s = []) {
        var r, n, a, o, l, d, c, h, u, p, m;
        switch (
            (e._x_bindings || (e._x_bindings = L({})),
            (e._x_bindings[t] = i),
            (t = s.includes("camel") ? ((r = t), r.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase())) : t))
        ) {
            case "value":
                !(function e(t, i) {
                    if (aG(t))
                        void 0 === t.attributes.value && (t.value = i),
                            window.fromModel &&
                                ("boolean" == typeof i
                                    ? (t.checked = az(t.value) === i)
                                    : (t.checked = (function (e, t) {
                                          return e == t;
                                      })(t.value, i)));
                    else if (a3(t))
                        Number.isInteger(i)
                            ? (t.value = i)
                            : Array.isArray(i) || "boolean" == typeof i || [null, void 0].includes(i)
                              ? Array.isArray(i)
                                  ? (t.checked = i.some((e) =>
                                        (function (e, t) {
                                            return e == t;
                                        })(e, t.value)
                                    ))
                                  : (t.checked = !!i)
                              : (t.value = String(i));
                    else if ("SELECT" === t.tagName)
                        !(function e(t, i) {
                            let s = [].concat(i).map((e) => e + "");
                            Array.from(t.options).forEach((e) => {
                                e.selected = s.includes(e.value);
                            });
                        })(t, i);
                    else {
                        if (t.value === i) return;
                        t.value = void 0 === i ? "" : i;
                    }
                })(e, i);
                break;
            case "style":
                (n = e), (a = i), n._x_undoAddedStyles && n._x_undoAddedStyles(), (n._x_undoAddedStyles = aq(n, a));
                break;
            case "class":
                (o = e), (l = i), o._x_undoAddedClasses && o._x_undoAddedClasses(), (o._x_undoAddedClasses = aA(o, l));
                break;
            case "selected":
            case "checked":
                (d = e), (c = t), (h = i), aR(d, c, h), (u = d), (p = c), (m = h), u[p] !== m && (u[p] = m);
                break;
            default:
                aR(e, t, i);
        }
    }
    function aR(e, t, i) {
        var s, r, n, a;
        [null, void 0, !1].includes(i) &&
        ((s = t), !["aria-pressed", "aria-checked", "aria-expanded", "aria-selected"].includes(s))
            ? e.removeAttribute(t)
            : (aj(t) && (i = t), (r = e), (n = t), (a = i), r.getAttribute(n) != a && r.setAttribute(n, a));
    }
    function aN(e, t) {
        return e == t;
    }
    function az(e) {
        return (
            !![1, "1", "true", "on", "yes", !0].includes(e) ||
            (![0, "0", "false", "off", "no", !1].includes(e) && (e ? Boolean(e) : null))
        );
    }
    var a0 = new Set([
        "allowfullscreen",
        "async",
        "autofocus",
        "autoplay",
        "checked",
        "controls",
        "default",
        "defer",
        "disabled",
        "formnovalidate",
        "inert",
        "ismap",
        "itemscope",
        "loop",
        "multiple",
        "muted",
        "nomodule",
        "novalidate",
        "open",
        "playsinline",
        "readonly",
        "required",
        "reversed",
        "selected",
        "shadowrootclonable",
        "shadowrootdelegatesfocus",
        "shadowrootserializable",
    ]);
    function aj(e) {
        return a0.has(e);
    }
    function aU(e, t, i) {
        let s = e.getAttribute(t);
        return null === s ? ("function" == typeof i ? i() : i) : "" === s || (aj(t) ? !![t, "true"].includes(s) : s);
    }
    function a3(e) {
        return "checkbox" === e.type || "ui-checkbox" === e.localName || "ui-switch" === e.localName;
    }
    function aG(e) {
        return "radio" === e.type || "ui-radio" === e.localName;
    }
    function a1(e, t) {
        var i;
        return function () {
            var s = this,
                r = arguments,
                n = function () {
                    (i = null), e.apply(s, r);
                };
            clearTimeout(i), (i = setTimeout(n, t));
        };
    }
    function aK(e, t) {
        let i;
        return function () {
            let s = arguments;
            i || (e.apply(this, s), (i = !0), setTimeout(() => (i = !1), t));
        };
    }
    function a2({ get: e, set: t }, { get: i, set: s }) {
        let r = !0,
            n,
            a = _(() => {
                let a = e(),
                    o = i();
                if (r) s(a4(a)), (r = !1);
                else {
                    let l = JSON.stringify(a),
                        d = JSON.stringify(o);
                    l !== n ? s(a4(a)) : l !== d && t(a4(o));
                }
                (n = JSON.stringify(e())), JSON.stringify(i());
            });
        return () => {
            A(a);
        };
    }
    function a4(e) {
        return "object" == typeof e ? JSON.parse(JSON.stringify(e)) : e;
    }
    var aX = {},
        aY = !1;
    function a6() {
        return aX;
    }
    var aJ = {};
    function aQ(e, t, i) {
        let s = [];
        for (; s.length; ) s.pop()();
        let r = Object.entries(t).map(([e, t]) => ({ name: e, value: t })),
            n = nQ(r);
        return (
            nJ(
                e,
                (r = r.map((e) =>
                    n.find((t) => t.name === e.name) ? { name: `x-bind:${e.name}`, value: `"${e.value}"` } : e
                )),
                i
            ).map((e) => {
                s.push(e.runCleanups), e();
            }),
            () => {
                for (; s.length; ) s.pop()();
            }
        );
    }
    var a7 = {};
    function a5(e, t) {
        a7[e] = t;
    }
    var aZ = {
            get reactive() {
                return L;
            },
            get release() {
                return A;
            },
            get effect() {
                return _;
            },
            get raw() {
                return C;
            },
            version: "3.14.9",
            flushAndStopDeferringMutations: function e() {
                (n_ = !1), nC(nA), (nA = []);
            },
            dontAutoEvaluateFunctions: nz,
            disableEffectScheduling: function e(t) {
                (np = !1), t(), (np = !0);
            },
            startObservingMutations: nx,
            stopObservingMutations: nk,
            setReactivityEngine: function e(t) {
                (L = t.reactive),
                    (A = t.release),
                    (_ = (e) =>
                        t.effect(e, {
                            scheduler(e) {
                                if (np) {
                                    var t;
                                    nc((t = e));
                                } else e();
                            },
                        })),
                    (C = t.raw);
            },
            onAttributeRemoved: nw,
            onAttributesAdded: n$,
            closestDataStack: nP,
            skipDuringClone: aO,
            onlyDuringClone: function e(t) {
                return (...e) => aD && t(...e);
            },
            addRootSelector: av,
            addInitSelector: ab,
            interceptClone: aB,
            addScopeToNode: nI,
            deferMutations: function e() {
                n_ = !0;
            },
            mapAttributes: ar,
            evaluateLater: nj,
            interceptInit: function e(t) {
                a8.push(t);
            },
            setEvaluator: n3,
            mergeProxies: n9,
            extractProp: function e(t, i, s, r = !0) {
                if (t._x_bindings && void 0 !== t._x_bindings[i]) return t._x_bindings[i];
                if (t._x_inlineBindings && void 0 !== t._x_inlineBindings[i]) {
                    let n = t._x_inlineBindings[i];
                    return (n.extract = r), nz(() => n0(t, n.expression));
                }
                return aU(t, i, s);
            },
            findClosest: aw,
            onElRemoved: nb,
            closestRoot: a$,
            destroyTree: ax,
            interceptor: nF,
            transition: a9,
            setStyles: aq,
            mutateDom: nL,
            directive: n6,
            entangle: a2,
            throttle: aK,
            debounce: a1,
            evaluate: n0,
            initTree: aE,
            nextTick: aL,
            prefixed: n4,
            prefix: nX,
            plugin: function e(t) {
                (Array.isArray(t) ? t : [t]).forEach((e) => e(aZ));
            },
            magic: nV,
            store: function e(t, i) {
                if ((aY || ((aX = L(aX)), (aY = !0)), void 0 === i)) return aX[t];
                (aX[t] = i),
                    nO(aX[t]),
                    "object" == typeof i &&
                        null !== i &&
                        i.hasOwnProperty("init") &&
                        "function" == typeof i.init &&
                        aX[t].init();
            },
            start: function e() {
                var t;
                ap &&
                    au(
                        "Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems."
                    ),
                    (ap = !0),
                    document.body ||
                        au(
                            "Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?"
                        ),
                    ac(document, "alpine:init"),
                    ac(document, "alpine:initializing"),
                    nx(),
                    (t = (e) => aE(e, ah)),
                    nv.push(t),
                    nb((e) => ax(e)),
                    n$((e, t) => {
                        nJ(e, t).forEach((e) => e());
                    });
                let i = (e) => !a$(e.parentElement, !0);
                Array.from(document.querySelectorAll(ay().join(",")))
                    .filter(i)
                    .forEach((e) => {
                        aE(e);
                    }),
                    ac(document, "alpine:initialized"),
                    setTimeout(() => {
                        [
                            ["ui", "dialog", ["[x-dialog], [x-popover]"]],
                            ["anchor", "anchor", ["[x-anchor]"]],
                            ["sort", "sort", ["[x-sort]"]],
                        ].forEach(([e, t, i]) => {
                            var s;
                            (s = t),
                                !Object.keys(nY).includes(s) &&
                                    i.some((t) => {
                                        if (document.querySelector(t))
                                            return au(`found "${t}", but missing ${e} plugin`), !0;
                                    });
                        });
                    });
            },
            clone: function e(t, i) {
                i._x_dataStack || (i._x_dataStack = t._x_dataStack),
                    (aD = !0),
                    (aV = !0),
                    aH(() => {
                        var e;
                        let t;
                        (e = i),
                            (t = !1),
                            aE(e, (e, i) => {
                                ah(e, (e, s) => {
                                    var r;
                                    if (t && ((r = e), ag().some((e) => r.matches(e)))) return s();
                                    (t = !0), i(e, s);
                                });
                            });
                    }),
                    (aD = !1),
                    (aV = !1);
            },
            cloneNode: function e(t, i) {
                aF.forEach((e) => e(t, i)),
                    (aD = !0),
                    aH(() => {
                        aE(i, (e, t) => {
                            t(e, () => {});
                        });
                    }),
                    (aD = !1);
            },
            bound: function e(t, i, s) {
                return t._x_bindings && void 0 !== t._x_bindings[i] ? t._x_bindings[i] : aU(t, i, s);
            },
            $data: nq,
            watch: nf,
            walk: ah,
            data: a5,
            bind: function e(t, i) {
                let s = "function" != typeof i ? () => i : i;
                return t instanceof Element ? aQ(t, s()) : ((aJ[t] = s), () => {});
            },
        },
        oe = Object.freeze({}),
        ot = Object.prototype.hasOwnProperty,
        oi = (e, t) => ot.call(e, t),
        os = Array.isArray,
        or = (e) => "[object Map]" === od(e),
        on = (e) => "string" == typeof e,
        oa = (e) => "symbol" == typeof e,
        oo = (e) => null !== e && "object" == typeof e,
        ol = Object.prototype.toString,
        od = (e) => ol.call(e),
        oc = (e) => od(e).slice(8, -1),
        oh = (e) => on(e) && "NaN" !== e && "-" !== e[0] && "" + parseInt(e, 10) === e,
        ou = ((e) => {
            let t = Object.create(null);
            return (i) => {
                let s = t[i];
                return s || (t[i] = e(i));
            };
        })((e) => e.charAt(0).toUpperCase() + e.slice(1)),
        op = (e, t) => e !== t && (e == e || t == t),
        om = new WeakMap(),
        of = [],
        og = Symbol("iterate"),
        oy = Symbol("Map key iterate"),
        ov = 0;
    function ob(e) {
        let { deps: t } = e;
        if (t.length) {
            for (let i = 0; i < t.length; i++) t[i].delete(e);
            t.length = 0;
        }
    }
    var o$ = !0,
        ow = [];
    function o8() {
        let e = ow.pop();
        o$ = void 0 === e || e;
    }
    function oS(e, t, i) {
        if (!o$ || void 0 === q) return;
        let s = om.get(e);
        s || om.set(e, (s = new Map()));
        let r = s.get(i);
        r || s.set(i, (r = new Set())),
            !r.has(q) &&
                (r.add(q),
                q.deps.push(r),
                q.options.onTrack && q.options.onTrack({ effect: q, target: e, type: t, key: i }));
    }
    function oE(e, t, i, s, r, n) {
        let a = om.get(e);
        if (!a) return;
        let o = new Set(),
            l = (e) => {
                e &&
                    e.forEach((e) => {
                        (e !== q || e.allowRecurse) && o.add(e);
                    });
            };
        if ("clear" === t) a.forEach(l);
        else if ("length" === i && os(e))
            a.forEach((e, t) => {
                ("length" === t || t >= s) && l(e);
            });
        else
            switch ((void 0 !== i && l(a.get(i)), t)) {
                case "add":
                    os(e) ? oh(i) && l(a.get("length")) : (l(a.get(og)), or(e) && l(a.get(oy)));
                    break;
                case "delete":
                    !os(e) && (l(a.get(og)), or(e) && l(a.get(oy)));
                    break;
                case "set":
                    or(e) && l(a.get(og));
            }
        let d = (a) => {
            a.options.onTrigger &&
                a.options.onTrigger({ effect: a, target: e, key: i, type: t, newValue: s, oldValue: r, oldTarget: n }),
                a.options.scheduler ? a.options.scheduler(a) : a();
        };
        o.forEach(d);
    }
    var ox = (function e(t, i) {
            let s = Object.create(null),
                r = t.split(",");
            for (let n = 0; n < r.length; n++) s[r[n]] = !0;
            return (e) => !!s[e];
        })("__proto__,__v_isRef,__isVue"),
        ok = new Set(
            Object.getOwnPropertyNames(Symbol)
                .map((e) => Symbol[e])
                .filter(oa)
        ),
        oT = oA(),
        oL = oA(!0),
        o_ = (function e() {
            let t = {};
            return (
                ["includes", "indexOf", "lastIndexOf"].forEach((e) => {
                    t[e] = function (...t) {
                        let i = oZ(this);
                        for (let s = 0, r = this.length; s < r; s++) oS(i, "get", s + "");
                        let n = i[e](...t);
                        return -1 === n || !1 === n ? i[e](...t.map(oZ)) : n;
                    };
                }),
                ["push", "pop", "shift", "unshift", "splice"].forEach((e) => {
                    t[e] = function (...t) {
                        ow.push(o$), (o$ = !1);
                        let i = oZ(this)[e].apply(this, t);
                        return o8(), i;
                    };
                }),
                t
            );
        })();
    function oA(e = !1, t = !1) {
        return function i(s, r, n) {
            if ("__v_isReactive" === r) return !e;
            if ("__v_isReadonly" === r) return e;
            if ("__v_raw" === r && n === (e ? (t ? oJ : o6) : t ? oY : oX).get(s)) return s;
            let a = os(s);
            if (!e && a && oi(o_, r)) return Reflect.get(o_, r, n);
            let o = Reflect.get(s, r, n);
            if ((oa(r) ? ok.has(r) : ox(r)) || (e || oS(s, "get", r), t)) return o;
            if (le(o)) {
                let l = !a || !oh(r);
                return l ? o.value : o;
            }
            return oo(o) ? (e ? o7(o) : oQ(o)) : o;
        };
    }
    var oC = (function e(t = !1) {
            return function e(i, s, r, n) {
                let a = i[s];
                if (!t && ((r = oZ(r)), (a = oZ(a)), !os(i) && le(a) && !le(r))) return (a.value = r), !0;
                let o = os(i) && oh(s) ? Number(s) < i.length : oi(i, s),
                    l = Reflect.set(i, s, r, n);
                return i === oZ(n) && (o ? op(r, a) && oE(i, "set", s, r, a) : oE(i, "add", s, r)), l;
            };
        })(),
        oq = {
            get: oT,
            set: oC,
            deleteProperty: function e(t, i) {
                let s = oi(t, i),
                    r = t[i],
                    n = Reflect.deleteProperty(t, i);
                return n && s && oE(t, "delete", i, void 0, r), n;
            },
            has: function e(t, i) {
                let s = Reflect.has(t, i);
                return (oa(i) && ok.has(i)) || oS(t, "has", i), s;
            },
            ownKeys: function e(t) {
                return oS(t, "iterate", os(t) ? "length" : og), Reflect.ownKeys(t);
            },
        },
        oI = {
            get: oL,
            set: (e, t) => (console.warn(`Set operation on key "${String(t)}" failed: target is readonly.`, e), !0),
            deleteProperty: (e, t) => (
                console.warn(`Delete operation on key "${String(t)}" failed: target is readonly.`, e), !0
            ),
        },
        oP = (e) => (oo(e) ? oQ(e) : e),
        o9 = (e) => (oo(e) ? o7(e) : e),
        oM = (e) => e,
        oD = (e) => Reflect.getPrototypeOf(e);
    function oO(e, t, i = !1, s = !1) {
        e = e.__v_raw;
        let r = oZ(e),
            n = oZ(t);
        t !== n && (i || oS(r, "get", t)), i || oS(r, "get", n);
        let { has: a } = oD(r),
            o = s ? oM : i ? o9 : oP;
        return a.call(r, t) ? o(e.get(t)) : a.call(r, n) ? o(e.get(n)) : void (e !== r && e.get(t));
    }
    function oF(e, t = !1) {
        let i = this.__v_raw,
            s = oZ(i),
            r = oZ(e);
        return e !== r && (t || oS(s, "has", e)), t || oS(s, "has", r), e === r ? i.has(e) : i.has(e) || i.has(r);
    }
    function oB(e, t = !1) {
        return (e = e.__v_raw), t || oS(oZ(e), "iterate", og), Reflect.get(e, "size", e);
    }
    function oV(e) {
        e = oZ(e);
        let t = oZ(this),
            i = oD(t),
            s = i.has.call(t, e);
        return s || (t.add(e), oE(t, "add", e, e)), this;
    }
    function oH(e, t) {
        t = oZ(t);
        let i = oZ(this),
            { has: s, get: r } = oD(i),
            n = s.call(i, e);
        n ? o4(i, s, e) : ((e = oZ(e)), (n = s.call(i, e)));
        let a = r.call(i, e);
        return i.set(e, t), n ? op(t, a) && oE(i, "set", e, t, a) : oE(i, "add", e, t), this;
    }
    function oW(e) {
        let t = oZ(this),
            { has: i, get: s } = oD(t),
            r = i.call(t, e);
        r ? o4(t, i, e) : ((e = oZ(e)), (r = i.call(t, e)));
        let n = s ? s.call(t, e) : void 0,
            a = t.delete(e);
        return r && oE(t, "delete", e, void 0, n), a;
    }
    function oR() {
        let e = oZ(this),
            t = 0 !== e.size,
            i = or(e) ? new Map(e) : new Set(e),
            s = e.clear();
        return t && oE(e, "clear", void 0, void 0, i), s;
    }
    function oN(e, t) {
        return function i(s, r) {
            let n = this,
                a = n.__v_raw,
                o = oZ(a),
                l = t ? oM : e ? o9 : oP;
            return e || oS(o, "iterate", og), a.forEach((e, t) => s.call(r, l(e), l(t), n));
        };
    }
    function oz(e, t, i) {
        return function (...s) {
            let r = this.__v_raw,
                n = oZ(r),
                a = or(n),
                o = "entries" === e || (e === Symbol.iterator && a),
                l = r[e](...s),
                d = i ? oM : t ? o9 : oP;
            return (
                t || oS(n, "iterate", "keys" === e && a ? oy : og),
                {
                    next() {
                        let { value: e, done: t } = l.next();
                        return t ? { value: e, done: t } : { value: o ? [d(e[0]), d(e[1])] : d(e), done: t };
                    },
                    [Symbol.iterator]() {
                        return this;
                    },
                }
            );
        };
    }
    function o0(e) {
        return function (...t) {
            {
                let i = t[0] ? `on key "${t[0]}" ` : "";
                console.warn(`${ou(e)} operation ${i}failed: target is readonly.`, oZ(this));
            }
            return "delete" !== e && this;
        };
    }
    var [oj, oU, o3, oG] = (function e() {
        let t = {
                get(e) {
                    return oO(this, e);
                },
                get size() {
                    return oB(this);
                },
                has: oF,
                add: oV,
                set: oH,
                delete: oW,
                clear: oR,
                forEach: oN(!1, !1),
            },
            i = {
                get(e) {
                    return oO(this, e, !1, !0);
                },
                get size() {
                    return oB(this);
                },
                has: oF,
                add: oV,
                set: oH,
                delete: oW,
                clear: oR,
                forEach: oN(!1, !0),
            },
            s = {
                get(e) {
                    return oO(this, e, !0);
                },
                get size() {
                    return oB(this, !0);
                },
                has(e) {
                    return oF.call(this, e, !0);
                },
                add: o0("add"),
                set: o0("set"),
                delete: o0("delete"),
                clear: o0("clear"),
                forEach: oN(!0, !1),
            },
            r = {
                get(e) {
                    return oO(this, e, !0, !0);
                },
                get size() {
                    return oB(this, !0);
                },
                has(e) {
                    return oF.call(this, e, !0);
                },
                add: o0("add"),
                set: o0("set"),
                delete: o0("delete"),
                clear: o0("clear"),
                forEach: oN(!0, !0),
            },
            n = ["keys", "values", "entries", Symbol.iterator];
        return (
            n.forEach((e) => {
                (t[e] = oz(e, !1, !1)), (s[e] = oz(e, !0, !1)), (i[e] = oz(e, !1, !0)), (r[e] = oz(e, !0, !0));
            }),
            [t, s, i, r]
        );
    })();
    function o1(e, t) {
        let i = e ? oU : oj;
        return (t, s, r) =>
            "__v_isReactive" === s
                ? !e
                : "__v_isReadonly" === s
                  ? e
                  : "__v_raw" === s
                    ? t
                    : Reflect.get(oi(i, s) && s in t ? i : t, s, r);
    }
    var oK = { get: o1(!1) },
        o2 = { get: o1(!0) };
    function o4(e, t, i) {
        let s = oZ(i);
        if (s !== i && t.call(e, s)) {
            let r = oc(e);
            console.warn(
                `Reactive ${r} contains both the raw and reactive versions of the same object${"Map" === r ? " as keys" : ""}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`
            );
        }
    }
    var oX = new WeakMap(),
        oY = new WeakMap(),
        o6 = new WeakMap(),
        oJ = new WeakMap();
    function oQ(e) {
        return e && e.__v_isReadonly ? e : o5(e, !1, oq, oK, oX);
    }
    function o7(e) {
        return o5(e, !0, oI, o2, o6);
    }
    function o5(e, t, i, s, r) {
        var n;
        if (!oo(e)) return console.warn(`value cannot be made reactive: ${String(e)}`), e;
        if (e.__v_raw && !(t && e.__v_isReactive)) return e;
        let a = r.get(e);
        if (a) return a;
        let o =
            (n = e).__v_skip || !Object.isExtensible(n)
                ? 0
                : (function e(t) {
                      switch (t) {
                          case "Object":
                          case "Array":
                              return 1;
                          case "Map":
                          case "Set":
                          case "WeakMap":
                          case "WeakSet":
                              return 2;
                          default:
                              return 0;
                      }
                  })(oc(n));
        if (0 === o) return e;
        let l = new Proxy(e, 2 === o ? s : i);
        return r.set(e, l), l;
    }
    function oZ(e) {
        return (e && oZ(e.__v_raw)) || e;
    }
    function le(e) {
        return Boolean(e && !0 === e.__v_isRef);
    }
    (h = () => aL),
        (nB.nextTick = h),
        (u = (e) => ac.bind(ac, e)),
        (nB.dispatch = u),
        (p =
            (e, { evaluateLater: t, cleanup: i }) =>
            (e, s) => {
                let r = t(e),
                    n = nf(() => {
                        let e;
                        return r((t) => (e = t)), e;
                    }, s);
                i(n);
            }),
        (nB.watch = p),
        (m = a6),
        (nB.store = m),
        (f = (e) => nq(e)),
        (nB.data = f),
        (g = (e) => a$(e)),
        (nB.root = g),
        (y = (e) => {
            var t;
            let i;
            return (
                e._x_refs_proxy ||
                    (e._x_refs_proxy = n9(
                        ((t = e),
                        (i = []),
                        aw(t, (e) => {
                            e._x_refs && i.push(e._x_refs);
                        }),
                        i)
                    )),
                e._x_refs_proxy
            );
        }),
        (nB.refs = y);
    var lt = {};
    function li(e) {
        return lt[e] || (lt[e] = 0), ++lt[e];
    }
    function ls(e, t, i) {
        var s, r;
        (s = t),
            (r = (s) =>
                au(
                    `You can't use [$${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
                    s
                )),
            (nB[s] = r);
    }
    (v =
        (e, { cleanup: t }) =>
        (i, s = null) => {
            let r = `${i}${s ? `-${s}` : ""}`;
            return (function e(t, i, s, r) {
                if ((t._x_id || (t._x_id = {}), t._x_id[i])) return t._x_id[i];
                let n = r();
                return (
                    (t._x_id[i] = n),
                    s(() => {
                        delete t._x_id[i];
                    }),
                    n
                );
            })(e, r, t, () => {
                var t, r;
                let n =
                        ((t = e),
                        (r = i),
                        aw(t, (e) => {
                            if (e._x_ids && e._x_ids[r]) return !0;
                        })),
                    a = n ? n._x_ids[i] : li(i);
                return s ? `${i}-${a}-${s}` : `${i}-${a}`;
            });
        }),
        (nB.id = v),
        aB((e, t) => {
            e._x_id && (t._x_id = e._x_id);
        }),
        (b = (e) => e),
        (nB.el = b),
        ls("Focus", "focus", "focus"),
        ls("Persist", "persist", "persist"),
        n6("modelable", (e, { expression: t }, { effect: i, evaluateLater: s, cleanup: r }) => {
            let n = s(t),
                a = () => {
                    let e;
                    return n((t) => (e = t)), e;
                },
                o = s(`${t} = __placeholder`),
                l = (e) => o(() => {}, { scope: { __placeholder: e } }),
                d = a();
            l(d),
                queueMicrotask(() => {
                    if (!e._x_model) return;
                    e._x_removeModelListeners.default();
                    let t = e._x_model.get,
                        i = e._x_model.set,
                        s = a2(
                            {
                                get: () => t(),
                                set(e) {
                                    i(e);
                                },
                            },
                            {
                                get: () => a(),
                                set(e) {
                                    l(e);
                                },
                            }
                        );
                    r(s);
                });
        }),
        n6("teleport", (e, { modifiers: t, expression: i }, { cleanup: s }) => {
            "template" !== e.tagName.toLowerCase() && au("x-teleport can only be used on a <template> tag", e);
            let r = ln(i),
                n = e.content.cloneNode(!0).firstElementChild;
            (e._x_teleport = n),
                (n._x_teleportBack = e),
                e.setAttribute("data-teleport-template", !0),
                n.setAttribute("data-teleport-target", !0),
                e._x_forwardEvents &&
                    e._x_forwardEvents.forEach((t) => {
                        n.addEventListener(t, (t) => {
                            t.stopPropagation(), e.dispatchEvent(new t.constructor(t.type, t));
                        });
                    }),
                nI(n, {}, e);
            let a = (e, t, i) => {
                i.includes("prepend")
                    ? t.parentNode.insertBefore(e, t)
                    : i.includes("append")
                      ? t.parentNode.insertBefore(e, t.nextSibling)
                      : t.appendChild(e);
            };
            nL(() => {
                a(n, r, t),
                    aO(() => {
                        aE(n);
                    })();
            }),
                (e._x_teleportPutBack = () => {
                    let s = ln(i);
                    nL(() => {
                        a(e._x_teleport, s, t);
                    });
                }),
                s(() =>
                    nL(() => {
                        n.remove(), ax(n);
                    })
                );
        });
    var lr = document.createElement("div");
    function ln(e) {
        let t = aO(
            () => document.querySelector(e),
            () => lr
        )();
        return t || au(`Cannot find x-teleport element for selector: "${e}"`), t;
    }
    var la = () => {};
    function lo(e, t, i, s) {
        var r, n, a;
        let o = e,
            l = (e) => s(e),
            d = {},
            c = (e, t) => (i) => t(e, i);
        if (
            (i.includes("dot") && (t = ((r = t), r.replace(/-/g, "."))),
            i.includes("camel") && (t = ((n = t), n.toLowerCase().replace(/-(\w)/g, (e, t) => t.toUpperCase()))),
            i.includes("passive") && (d.passive = !0),
            i.includes("capture") && (d.capture = !0),
            i.includes("window") && (o = window),
            i.includes("document") && (o = document),
            i.includes("debounce"))
        ) {
            let h = i[i.indexOf("debounce") + 1] || "invalid-wait",
                u = ll(h.split("ms")[0]) ? Number(h.split("ms")[0]) : 250;
            l = a1(l, u);
        }
        if (i.includes("throttle")) {
            let p = i[i.indexOf("throttle") + 1] || "invalid-wait",
                m = ll(p.split("ms")[0]) ? Number(p.split("ms")[0]) : 250;
            l = aK(l, m);
        }
        return (
            i.includes("prevent") &&
                (l = c(l, (e, t) => {
                    t.preventDefault(), e(t);
                })),
            i.includes("stop") &&
                (l = c(l, (e, t) => {
                    t.stopPropagation(), e(t);
                })),
            i.includes("once") &&
                (l = c(l, (e, i) => {
                    e(i), o.removeEventListener(t, l, d);
                })),
            (i.includes("away") || i.includes("outside")) &&
                ((o = document),
                (l = c(l, (t, i) => {
                    !e.contains(i.target) &&
                        !1 !== i.target.isConnected &&
                        (!(e.offsetWidth < 1) || !(e.offsetHeight < 1)) &&
                        !1 !== e._x_isShown &&
                        t(i);
                }))),
            i.includes("self") &&
                (l = c(l, (t, i) => {
                    i.target === e && t(i);
                })),
            (a = t),
            (["keydown", "keyup"].includes(a) || ld(t)) &&
                (l = c(l, (e, t) => {
                    !(function e(t, i) {
                        let s = i.filter(
                            (e) =>
                                ![
                                    "window",
                                    "document",
                                    "prevent",
                                    "stop",
                                    "once",
                                    "capture",
                                    "self",
                                    "away",
                                    "outside",
                                    "passive",
                                ].includes(e)
                        );
                        if (s.includes("debounce")) {
                            let r = s.indexOf("debounce");
                            s.splice(r, ll((s[r + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
                        }
                        if (s.includes("throttle")) {
                            let n = s.indexOf("throttle");
                            s.splice(n, ll((s[n + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
                        }
                        if (0 === s.length || (1 === s.length && lc(t.key).includes(s[0]))) return !1;
                        let a = ["ctrl", "shift", "alt", "meta", "cmd", "super"].filter((e) => s.includes(e));
                        if (((s = s.filter((e) => !a.includes(e))), a.length > 0)) {
                            let o = a.filter((e) => (("cmd" === e || "super" === e) && (e = "meta"), t[`${e}Key`]));
                            if (o.length === a.length && (ld(t.type) || lc(t.key).includes(s[0]))) return !1;
                        }
                        return !0;
                    })(t, i) && e(t);
                })),
            o.addEventListener(t, l, d),
            () => {
                o.removeEventListener(t, l, d);
            }
        );
    }
    function ll(e) {
        return !Array.isArray(e) && !isNaN(e);
    }
    function ld(e) {
        return ["contextmenu", "click", "mouse"].some((t) => e.includes(t));
    }
    function lc(e) {
        var t;
        if (!e) return [];
        e = [" ", "_"].includes((t = e))
            ? t
            : t
                  .replace(/([a-z])([A-Z])/g, "$1-$2")
                  .replace(/[_\s]/, "-")
                  .toLowerCase();
        let i = {
            ctrl: "control",
            slash: "/",
            space: " ",
            spacebar: " ",
            cmd: "meta",
            esc: "escape",
            up: "arrow-up",
            down: "arrow-down",
            left: "arrow-left",
            right: "arrow-right",
            period: ".",
            comma: ",",
            equal: "=",
            minus: "-",
            underscore: "_",
        };
        return (
            (i[e] = e),
            Object.keys(i)
                .map((t) => {
                    if (i[t] === e) return t;
                })
                .filter((e) => e)
        );
    }
    function lh(e, t, i, s) {
        return nL(() => {
            if (i instanceof CustomEvent && void 0 !== i.detail)
                return null !== i.detail && void 0 !== i.detail ? i.detail : i.target.value;
            if (a3(e)) {
                if (!Array.isArray(s)) return i.target.checked;
                {
                    let r = null;
                    return (
                        (r = t.includes("number")
                            ? lu(i.target.value)
                            : t.includes("boolean")
                              ? az(i.target.value)
                              : i.target.value),
                        i.target.checked
                            ? s.includes(r)
                                ? s
                                : s.concat([r])
                            : s.filter((e) => {
                                  var t, i;
                                  return (t = e), (i = r), t != i;
                              })
                    );
                }
            }
            if ("select" === e.tagName.toLowerCase() && e.multiple)
                return t.includes("number")
                    ? Array.from(i.target.selectedOptions).map((e) => lu(e.value || e.text))
                    : t.includes("boolean")
                      ? Array.from(i.target.selectedOptions).map((e) => az(e.value || e.text))
                      : Array.from(i.target.selectedOptions).map((e) => e.value || e.text);
            {
                let n;
                return ((n = aG(e) ? (i.target.checked ? i.target.value : s) : i.target.value), t.includes("number"))
                    ? lu(n)
                    : t.includes("boolean")
                      ? az(n)
                      : t.includes("trim")
                        ? n.trim()
                        : n;
            }
        });
    }
    function lu(e) {
        var t;
        let i = e ? parseFloat(e) : null;
        return ((t = i), Array.isArray(t) || isNaN(t)) ? e : i;
    }
    function lp(e, t) {
        return e == t;
    }
    function lm(e) {
        return null !== e && "object" == typeof e && "function" == typeof e.get && "function" == typeof e.set;
    }
    (la.inline = (e, { modifiers: t }, { cleanup: i }) => {
        t.includes("self") ? (e._x_ignoreSelf = !0) : (e._x_ignore = !0),
            i(() => {
                t.includes("self") ? delete e._x_ignoreSelf : delete e._x_ignore;
            });
    }),
        n6("ignore", la),
        n6(
            "effect",
            aO((e, { expression: t }, { effect: i }) => {
                i(nj(e, t));
            })
        ),
        n6("model", (e, { modifiers: t, expression: i }, { effect: s, cleanup: r }) => {
            let n = e;
            t.includes("parent") && (n = e.parentNode);
            let a = nj(n, i),
                o;
            o =
                "string" == typeof i
                    ? nj(n, `${i} = __placeholder`)
                    : "function" == typeof i && "string" == typeof i()
                      ? nj(n, `${i()} = __placeholder`)
                      : () => {};
            let l = () => {
                    let e;
                    return a((t) => (e = t)), lm(e) ? e.get() : e;
                },
                d = (e) => {
                    let t;
                    a((e) => (t = e)), lm(t) ? t.set(e) : o(() => {}, { scope: { __placeholder: e } });
                };
            "string" == typeof i &&
                "radio" === e.type &&
                nL(() => {
                    e.hasAttribute("name") || e.setAttribute("name", i);
                });
            var c =
                "select" === e.tagName.toLowerCase() || ["checkbox", "radio"].includes(e.type) || t.includes("lazy")
                    ? "change"
                    : "input";
            let h = aD
                ? () => {}
                : lo(e, c, t, (i) => {
                      d(lh(e, t, i, l()));
                  });
            if (
                (t.includes("fill") &&
                    ([void 0, null, ""].includes(l()) ||
                        (a3(e) && Array.isArray(l())) ||
                        ("select" === e.tagName.toLowerCase() && e.multiple)) &&
                    d(lh(e, t, { target: e }, l())),
                e._x_removeModelListeners || (e._x_removeModelListeners = {}),
                (e._x_removeModelListeners.default = h),
                r(() => e._x_removeModelListeners.default()),
                e.form)
            ) {
                let u = lo(e.form, "reset", [], (i) => {
                    aL(() => e._x_model && e._x_model.set(lh(e, t, { target: e }, l())));
                });
                r(() => u());
            }
            (e._x_model = {
                get: () => l(),
                set(e) {
                    d(e);
                },
            }),
                (e._x_forceModelUpdate = (t) => {
                    void 0 === t && "string" == typeof i && i.match(/\./) && (t = ""),
                        (window.fromModel = !0),
                        nL(() => aW(e, "value", t)),
                        delete window.fromModel;
                }),
                s(() => {
                    let i = l();
                    (t.includes("unintrusive") && document.activeElement.isSameNode(e)) || e._x_forceModelUpdate(i);
                });
        }),
        n6("cloak", (e) => queueMicrotask(() => nL(() => e.removeAttribute(n4("cloak"))))),
        ab(() => `[${n4("init")}]`),
        n6(
            "init",
            aO((e, { expression: t }, { evaluate: i }) =>
                "string" == typeof t ? !!t.trim() && i(t, {}, !1) : i(t, {}, !1)
            )
        ),
        n6("text", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
            let r = s(t);
            i(() => {
                r((t) => {
                    nL(() => {
                        e.textContent = t;
                    });
                });
            });
        }),
        n6("html", (e, { expression: t }, { effect: i, evaluateLater: s }) => {
            let r = s(t);
            i(() => {
                r((t) => {
                    nL(() => {
                        (e.innerHTML = t), (e._x_ignoreSelf = !0), aE(e), delete e._x_ignoreSelf;
                    });
                });
            });
        }),
        ar(at(":", n4("bind:")));
    var lf = (e, { value: t, modifiers: i, expression: s, original: r }, { effect: n, cleanup: a }) => {
        var o, l, d;
        if (!t) {
            let c = {};
            (o = c),
                Object.entries(aJ).forEach(([e, t]) => {
                    Object.defineProperty(o, e, {
                        get:
                            () =>
                            (...e) =>
                                t(...e),
                    });
                });
            nj(e, s)(
                (t) => {
                    aQ(e, t, r);
                },
                { scope: c }
            );
            return;
        }
        if ("key" === t) {
            return (l = e), (d = s), void (l._x_keyExpression = d);
        }
        if (e._x_inlineBindings && e._x_inlineBindings[t] && e._x_inlineBindings[t].extract) return;
        let h = nj(e, s);
        n(() =>
            h((r) => {
                void 0 === r && "string" == typeof s && s.match(/\./) && (r = ""), nL(() => aW(e, t, r, i));
            })
        ),
            a(() => {
                e._x_undoAddedClasses && e._x_undoAddedClasses(), e._x_undoAddedStyles && e._x_undoAddedStyles();
            });
    };
    function lg(e, t, i, s) {
        let r = {};
        return (
            /^\[.*\]$/.test(e.item) && Array.isArray(t)
                ? e.item
                      .replace("[", "")
                      .replace("]", "")
                      .split(",")
                      .map((e) => e.trim())
                      .forEach((e, i) => {
                          r[e] = t[i];
                      })
                : /^\{.*\}$/.test(e.item) && !Array.isArray(t) && "object" == typeof t
                  ? e.item
                        .replace("{", "")
                        .replace("}", "")
                        .split(",")
                        .map((e) => e.trim())
                        .forEach((e) => {
                            r[e] = t[e];
                        })
                  : (r[e.item] = t),
            e.index && (r[e.index] = i),
            e.collection && (r[e.collection] = s),
            r
        );
    }
    function ly() {}
    function lv(e, t, i) {
        n6(t, (s) =>
            au(
                `You can't use [x-${t}] without first installing the "${e}" plugin here: https://alpinejs.dev/plugins/${i}`,
                s
            )
        );
    }
    (lf.inline = (e, { value: t, modifiers: i, expression: s }) => {
        t &&
            (e._x_inlineBindings || (e._x_inlineBindings = {}),
            (e._x_inlineBindings[t] = { expression: s, extract: !1 }));
    }),
        n6("bind", lf),
        av(() => `[${n4("data")}]`),
        n6("data", (e, { expression: t }, { cleanup: i }) => {
            var s, r, n;
            if (((n = e), aD && (aV || n.hasAttribute("data-has-alpine-state")))) return;
            t = "" === t ? "{}" : t;
            let a = {};
            nH(a, e);
            let o = {};
            (s = o),
                (r = a),
                Object.entries(a7).forEach(([e, t]) => {
                    Object.defineProperty(s, e, {
                        get:
                            () =>
                            (...e) =>
                                t.bind(r)(...e),
                        enumerable: !1,
                    });
                });
            let l = n0(e, t, { scope: o });
            (void 0 === l || !0 === l) && (l = {}), nH(l, e);
            let d = L(l);
            nO(d);
            let c = nI(e, d);
            d.init && n0(e, d.init),
                i(() => {
                    d.destroy && n0(e, d.destroy), c();
                });
        }),
        aB((e, t) => {
            e._x_dataStack && ((t._x_dataStack = e._x_dataStack), t.setAttribute("data-has-alpine-state", !0));
        }),
        n6("show", (e, { modifiers: t, expression: i }, { effect: s }) => {
            let r = nj(e, i);
            e._x_doHide ||
                (e._x_doHide = () => {
                    nL(() => {
                        e.style.setProperty("display", "none", t.includes("important") ? "important" : void 0);
                    });
                }),
                e._x_doShow ||
                    (e._x_doShow = () => {
                        nL(() => {
                            1 === e.style.length && "none" === e.style.display
                                ? e.removeAttribute("style")
                                : e.style.removeProperty("display");
                        });
                    });
            let n = () => {
                    e._x_doHide(), (e._x_isShown = !1);
                },
                a = () => {
                    e._x_doShow(), (e._x_isShown = !0);
                },
                o = () => setTimeout(a),
                l = aI(
                    (e) => (e ? a() : n()),
                    (t) => {
                        "function" == typeof e._x_toggleAndCascadeWithTransitions
                            ? e._x_toggleAndCascadeWithTransitions(e, t, a, n)
                            : t
                              ? o()
                              : n();
                    }
                ),
                d,
                c = !0;
            s(() =>
                r((e) => {
                    (c || e !== d) && (t.includes("immediate") && (e ? o() : n()), l(e), (d = e), (c = !1));
                })
            );
        }),
        n6("for", (e, { expression: t }, { effect: i, cleanup: s }) => {
            let r = (function e(t) {
                    let i = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/,
                        s = t.match(/([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/);
                    if (!s) return;
                    let r = {};
                    r.items = s[2].trim();
                    let n = s[1].replace(/^\s*\(|\)\s*$/g, "").trim(),
                        a = n.match(i);
                    return (
                        a
                            ? ((r.item = n.replace(i, "").trim()),
                              (r.index = a[1].trim()),
                              a[2] && (r.collection = a[2].trim()))
                            : (r.item = n),
                        r
                    );
                })(t),
                n = nj(e, r.items),
                a = nj(e, e._x_keyExpression || "index");
            (e._x_prevKeys = []),
                (e._x_lookup = {}),
                i(() => {
                    var t, i, s, o;
                    let l, d;
                    return (
                        (t = e),
                        (i = r),
                        (s = n),
                        (o = a),
                        (l = (e) => "object" == typeof e && !Array.isArray(e)),
                        (d = t),
                        void s((e) => {
                            var s;
                            (s = e),
                                Array.isArray(s) ||
                                    isNaN(s) ||
                                    !(e >= 0) ||
                                    (e = Array.from(Array(e).keys(), (e) => e + 1)),
                                void 0 === e && (e = []);
                            let r = t._x_lookup,
                                n = t._x_prevKeys,
                                a = [],
                                c = [];
                            if (l(e))
                                e = Object.entries(e).map(([s, r]) => {
                                    let n = lg(i, r, s, e);
                                    o(
                                        (e) => {
                                            c.includes(e) && au("Duplicate key on x-for", t), c.push(e);
                                        },
                                        { scope: { index: s, ...n } }
                                    ),
                                        a.push(n);
                                });
                            else
                                for (let h = 0; h < e.length; h++) {
                                    let u = lg(i, e[h], h, e);
                                    o(
                                        (e) => {
                                            c.includes(e) && au("Duplicate key on x-for", t), c.push(e);
                                        },
                                        { scope: { index: h, ...u } }
                                    ),
                                        a.push(u);
                                }
                            let p = [],
                                m = [],
                                f = [],
                                g = [];
                            for (let y = 0; y < n.length; y++) {
                                let v = n[y];
                                -1 === c.indexOf(v) && f.push(v);
                            }
                            n = n.filter((e) => !f.includes(e));
                            let b = "template";
                            for (let $ = 0; $ < c.length; $++) {
                                let w = c[$],
                                    S = n.indexOf(w);
                                if (-1 === S) n.splice($, 0, w), p.push([b, $]);
                                else if (S !== $) {
                                    let E = n.splice($, 1)[0],
                                        x = n.splice(S - 1, 1)[0];
                                    n.splice($, 0, x), n.splice(S, 0, E), m.push([E, x]);
                                } else g.push(w);
                                b = w;
                            }
                            for (let k = 0; k < f.length; k++) {
                                let T = f[k];
                                T in r &&
                                    (nL(() => {
                                        ax(r[T]), r[T].remove();
                                    }),
                                    delete r[T]);
                            }
                            for (let _ = 0; _ < m.length; _++) {
                                let [A, C] = m[_],
                                    q = r[A],
                                    I = r[C],
                                    P = document.createElement("div");
                                nL(() => {
                                    I || au('x-for ":key" is undefined or invalid', d, C, r),
                                        I.after(P),
                                        q.after(I),
                                        I._x_currentIfEl && I.after(I._x_currentIfEl),
                                        P.before(q),
                                        q._x_currentIfEl && q.after(q._x_currentIfEl),
                                        P.remove();
                                }),
                                    I._x_refreshXForScope(a[c.indexOf(C)]);
                            }
                            for (let M = 0; M < p.length; M++) {
                                let [D, O] = p[M],
                                    F = "template" === D ? d : r[D];
                                F._x_currentIfEl && (F = F._x_currentIfEl);
                                let B = a[O],
                                    V = c[O],
                                    H = document.importNode(d.content, !0).firstElementChild,
                                    W = L(B);
                                nI(H, W, d),
                                    (H._x_refreshXForScope = (e) => {
                                        Object.entries(e).forEach(([e, t]) => {
                                            W[e] = t;
                                        });
                                    }),
                                    nL(() => {
                                        F.after(H), aO(() => aE(H))();
                                    }),
                                    "object" == typeof V &&
                                        au("x-for key cannot be an object, it must be a string or an integer", d),
                                    (r[V] = H);
                            }
                            for (let R = 0; R < g.length; R++) r[g[R]]._x_refreshXForScope(a[c.indexOf(g[R])]);
                            d._x_prevKeys = c;
                        })
                    );
                }),
                s(() => {
                    Object.values(e._x_lookup).forEach((e) =>
                        nL(() => {
                            ax(e), e.remove();
                        })
                    ),
                        delete e._x_prevKeys,
                        delete e._x_lookup;
                });
        }),
        (ly.inline = (e, { expression: t }, { cleanup: i }) => {
            let s = a$(e);
            s._x_refs || (s._x_refs = {}), (s._x_refs[t] = e), i(() => delete s._x_refs[t]);
        }),
        n6("ref", ly),
        n6("if", (e, { expression: t }, { effect: i, cleanup: s }) => {
            "template" !== e.tagName.toLowerCase() && au("x-if can only be used on a <template> tag", e);
            let r = nj(e, t),
                n = () => {
                    if (e._x_currentIfEl) return e._x_currentIfEl;
                    let t = e.content.cloneNode(!0).firstElementChild;
                    return (
                        nI(t, {}, e),
                        nL(() => {
                            e.after(t), aO(() => aE(t))();
                        }),
                        (e._x_currentIfEl = t),
                        (e._x_undoIf = () => {
                            nL(() => {
                                ax(t), t.remove();
                            }),
                                delete e._x_currentIfEl;
                        }),
                        t
                    );
                },
                a = () => {
                    e._x_undoIf && (e._x_undoIf(), delete e._x_undoIf);
                };
            i(() =>
                r((e) => {
                    e ? n() : a();
                })
            ),
                s(() => e._x_undoIf && e._x_undoIf());
        }),
        n6("id", (e, { expression: t }, { evaluate: i }) => {
            i(t).forEach((t) => {
                var i, s;
                return (i = e), (s = t), void (i._x_ids || (i._x_ids = {}), i._x_ids[s] || (i._x_ids[s] = li(s)));
            });
        }),
        aB((e, t) => {
            e._x_ids && (t._x_ids = e._x_ids);
        }),
        ar(at("@", n4("on:"))),
        n6(
            "on",
            aO((e, { value: t, modifiers: i, expression: s }, { cleanup: r }) => {
                let n = s ? nj(e, s) : () => {};
                "template" !== e.tagName.toLowerCase() ||
                    (e._x_forwardEvents || (e._x_forwardEvents = []),
                    e._x_forwardEvents.includes(t) || e._x_forwardEvents.push(t));
                let a = lo(e, t, i, (e) => {
                    n(() => {}, { scope: { $event: e }, params: [e] });
                });
                r(() => a());
            })
        ),
        lv("Collapse", "collapse", "collapse"),
        lv("Intersect", "intersect", "intersect"),
        lv("Focus", "trap", "focus"),
        lv("Mask", "mask", "mask"),
        aZ.setEvaluator(nG),
        aZ.setReactivityEngine({
            reactive: oQ,
            effect: function e(t, i = oe) {
                var s;
                (s = t) && !0 === s._isEffect && (t = t.raw);
                let r = (function e(t, i) {
                    let s = function e() {
                        if (!s.active) return t();
                        if (!of.includes(s)) {
                            ob(s);
                            try {
                                return ow.push(o$), (o$ = !0), of.push(s), (q = s), t();
                            } finally {
                                of.pop(), o8(), (q = of[of.length - 1]);
                            }
                        }
                    };
                    return (
                        (s.id = ov++),
                        (s.allowRecurse = !!i.allowRecurse),
                        (s._isEffect = !0),
                        (s.active = !0),
                        (s.raw = t),
                        (s.deps = []),
                        (s.options = i),
                        s
                    );
                })(t, i);
                return i.lazy || r(), r;
            },
            release: function e(t) {
                t.active && (ob(t), t.options.onStop && t.options.onStop(), (t.active = !1));
            },
            raw: oZ,
        });
    var lb = aZ;
    function l$(e) {
        return void 0 != e && null != e && "string" == typeof e.tagName && e.nodeType === Node.ELEMENT_NODE;
    }
    function lw(e) {
        return l$(e) && "TEMPLATE" === e.nodeName;
    }
    function l8(e) {
        return "object" == typeof e && null !== e && !Array.isArray(e) && !(e instanceof Date);
    }
    function lS(e, t, i, s) {
        let r = Object.getOwnPropertyDescriptor(e, i);
        if (!r) throw Error(`Property ${String(i)} not found on object`);
        Object.defineProperty(t, i, r);
    }
    function lE(e, t) {
        return ((e % t) + t) % t;
    }
    function lx(e) {
        return "number" == typeof e || (!isNaN(e) && !isNaN(parseFloat(e)));
    }
    function lk(e) {
        if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
        return e.classList.contains("shopify-section") ? e : e.closest(".shopify-section");
    }
    let lT = "listState",
        lL = ["read", "resolveKeyframes", "update", "preRender", "render", "postRender"],
        l_ = { value: null, addProjectionMetrics: null },
        lA = { skipAnimations: !1, useManualTiming: !1 },
        lC = (e) => e,
        {
            schedule: lq,
            cancel: lI,
            state: lP,
            steps: l9,
        } = (function e(t, i) {
            let s = !1,
                r = !0,
                n = { delta: 0, timestamp: 0, isProcessing: !1 },
                a = () => (s = !0),
                o = lL.reduce(
                    (e, t) => (
                        (e[t] = (function e(t, i) {
                            let s = new Set(),
                                r = new Set(),
                                n = !1,
                                a = !1,
                                o = new WeakSet(),
                                l = { delta: 0, timestamp: 0, isProcessing: !1 },
                                d = 0;
                            function c(e) {
                                o.has(e) && (h.schedule(e), t()), d++, e(l);
                            }
                            let h = {
                                schedule(e, t = !1, i = !1) {
                                    let a = i && n,
                                        l = a ? s : r;
                                    return t && o.add(e), l.has(e) || l.add(e), e;
                                },
                                cancel(e) {
                                    r.delete(e), o.delete(e);
                                },
                                process(e) {
                                    if (((l = e), n)) {
                                        a = !0;
                                        return;
                                    }
                                    (n = !0),
                                        ([s, r] = [r, s]),
                                        s.forEach(c),
                                        i && l_.value && l_.value.frameloop[i].push(d),
                                        (d = 0),
                                        s.clear(),
                                        (n = !1),
                                        a && ((a = !1), h.process(e));
                                },
                            };
                            return h;
                        })(a, t)),
                        e
                    ),
                    {}
                ),
                { read: l, resolveKeyframes: d, update: c, preRender: h, render: u, postRender: p } = o,
                m = () => {
                    let e = performance.now();
                    (s = !1),
                        (n.delta = r ? 1e3 / 60 : Math.max(Math.min(e - n.timestamp, 40), 1)),
                        (n.timestamp = e),
                        (n.isProcessing = !0),
                        l.process(n),
                        d.process(n),
                        c.process(n),
                        h.process(n),
                        u.process(n),
                        p.process(n),
                        (n.isProcessing = !1),
                        s && i && ((r = !1), t(m));
                },
                f = () => {
                    (s = !0), (r = !0), n.isProcessing || t(m);
                },
                g = lL.reduce((e, t) => {
                    let i = o[t];
                    return (e[t] = (e, t = !1, r = !1) => (s || f(), i.schedule(e, t, r))), e;
                }, {}),
                y = (e) => {
                    for (let t = 0; t < lL.length; t++) o[lL[t]].cancel(e);
                };
            return { schedule: g, cancel: y, state: n, steps: o };
        })("undefined" != typeof requestAnimationFrame ? requestAnimationFrame : lC, !0),
        lM;
    function lD() {
        lM = void 0;
    }
    let lO = {
            now: () => (
                void 0 === lM && lO.set(lP.isProcessing || lA.useManualTiming ? lP.timestamp : performance.now()), lM
            ),
            set(e) {
                (lM = e), queueMicrotask(lD);
            },
        },
        lF = new Set();
    function lB(e, t, i) {
        e || lF.has(t) || (console.warn(t), lF.add(t));
    }
    function lV(e, t) {
        let i = e.indexOf(t);
        i > -1 && e.splice(i, 1);
    }
    let lH = class e {
        add(e) {
            var t, i;
            return (t = this.subscriptions), (i = e), -1 === t.indexOf(i) && t.push(i), () => lV(this.subscriptions, e);
        }
        notify(e, t, i) {
            let s = this.subscriptions.length;
            if (s) {
                if (1 === s) this.subscriptions[0](e, t, i);
                else
                    for (let r = 0; r < s; r++) {
                        let n = this.subscriptions[r];
                        n && n(e, t, i);
                    }
            }
        }
        getSize() {
            return this.subscriptions.length;
        }
        clear() {
            this.subscriptions.length = 0;
        }
        constructor() {
            this.subscriptions = [];
        }
    };
    function lW(e, t) {
        return t ? e * (1e3 / t) : 0;
    }
    let lR = (e) => !isNaN(parseFloat(e)),
        lN = class e {
            setCurrent(e) {
                (this.current = e),
                    (this.updatedAt = lO.now()),
                    null === this.canTrackVelocity && void 0 !== e && (this.canTrackVelocity = lR(this.current));
            }
            setPrevFrameValue(e = this.current) {
                (this.prevFrameValue = e), (this.prevUpdatedAt = this.updatedAt);
            }
            onChange(e) {
                return (
                    "production" !== process.env.NODE_ENV &&
                        lB(!1, 'value.onChange(callback) is deprecated. Switch to value.on("change", callback).'),
                    this.on("change", e)
                );
            }
            on(e, t) {
                this.events[e] || (this.events[e] = new lH());
                let i = this.events[e].add(t);
                return "change" === e
                    ? () => {
                          i(),
                              lq.read(() => {
                                  this.events.change.getSize() || this.stop();
                              });
                      }
                    : i;
            }
            clearListeners() {
                for (let e in this.events) this.events[e].clear();
            }
            attach(e, t) {
                (this.passiveEffect = e), (this.stopPassiveEffect = t);
            }
            set(e, t = !0) {
                t && this.passiveEffect ? this.passiveEffect(e, this.updateAndNotify) : this.updateAndNotify(e, t);
            }
            setWithVelocity(e, t, i) {
                this.set(t), (this.prev = void 0), (this.prevFrameValue = e), (this.prevUpdatedAt = this.updatedAt - i);
            }
            jump(e, t = !0) {
                this.updateAndNotify(e),
                    (this.prev = e),
                    (this.prevUpdatedAt = this.prevFrameValue = void 0),
                    t && this.stop(),
                    this.stopPassiveEffect && this.stopPassiveEffect();
            }
            get() {
                return this.current;
            }
            getPrevious() {
                return this.prev;
            }
            getVelocity() {
                let e = lO.now();
                if (!this.canTrackVelocity || void 0 === this.prevFrameValue || e - this.updatedAt > 30) return 0;
                let t = Math.min(this.updatedAt - this.prevUpdatedAt, 30);
                return lW(parseFloat(this.current) - parseFloat(this.prevFrameValue), t);
            }
            start(e) {
                return (
                    this.stop(),
                    new Promise((t) => {
                        (this.hasAnimated = !0),
                            (this.animation = e(t)),
                            this.events.animationStart && this.events.animationStart.notify();
                    }).then(() => {
                        this.events.animationComplete && this.events.animationComplete.notify(), this.clearAnimation();
                    })
                );
            }
            stop() {
                this.animation &&
                    (this.animation.stop(), this.events.animationCancel && this.events.animationCancel.notify()),
                    this.clearAnimation();
            }
            isAnimating() {
                return !!this.animation;
            }
            clearAnimation() {
                delete this.animation;
            }
            destroy() {
                this.clearListeners(), this.stop(), this.stopPassiveEffect && this.stopPassiveEffect();
            }
            constructor(e, t = {}) {
                (this.version = "12.7.4"),
                    (this.canTrackVelocity = null),
                    (this.events = {}),
                    (this.updateAndNotify = (e, t = !0) => {
                        let i = lO.now();
                        this.updatedAt !== i && this.setPrevFrameValue(),
                            (this.prev = this.current),
                            this.setCurrent(e),
                            this.current !== this.prev && this.events.change && this.events.change.notify(this.current),
                            t && this.events.renderRequest && this.events.renderRequest.notify(this.current);
                    }),
                    (this.hasAnimated = !1),
                    this.setCurrent(e),
                    (this.owner = t.owner);
            }
        };
    function lz(e, t) {
        return new lN(e, t);
    }
    function l0(e, t, i) {
        if (e instanceof EventTarget) return [e];
        if ("string" == typeof e) {
            var s;
            let r = null !== (s = null == i ? void 0 : i[e]) && void 0 !== s ? s : document.querySelectorAll(e);
            return r ? Array.from(r) : [];
        }
        return Array.from(e);
    }
    let lj = () => {},
        lU = () => {};
    "production" !== process.env.NODE_ENV &&
        ((lj = (e, t) => {
            e || "undefined" == typeof console || console.warn(t);
        }),
        (lU = (e, t) => {
            if (!e) throw Error(t);
        }));
    let l3 = (e, t, i) => {
            let s = t - e;
            return 0 === s ? 1 : (i - e) / s;
        },
        lG = (e, t, i) => (i > t ? t : i < e ? e : i);
    function l1(e, t, i) {
        let s = Math.max(t - 5, 0);
        return lW(i - e(s), t - s);
    }
    let lK = {
            stiffness: 100,
            damping: 10,
            mass: 1,
            velocity: 0,
            duration: 800,
            bounce: 0.3,
            visualDuration: 0.3,
            restSpeed: { granular: 0.01, default: 2 },
            restDelta: { granular: 0.005, default: 0.5 },
            minDuration: 0.01,
            maxDuration: 10,
            minDamping: 0.05,
            maxDamping: 1,
        },
        l2 = (e) => 1e3 * e,
        l4 = (e) => e / 1e3;
    function lX(e, t) {
        return e * Math.sqrt(1 - t * t);
    }
    function lY(e) {
        let t = 0,
            i = e.next(t);
        for (; !i.done && t < 2e4; ) (t += 50), (i = e.next(t));
        return t >= 2e4 ? 1 / 0 : t;
    }
    function l6(e, t = 100, i) {
        let s = i({ ...e, keyframes: [0, t] }),
            r = Math.min(lY(s), 2e4);
        return { type: "keyframes", ease: (e) => s.next(r * e).value / t, duration: l4(r) };
    }
    let lJ = {};
    function lQ(e) {
        let t;
        return () => (void 0 === t && (t = e()), t);
    }
    let l7 = (function e(t, i) {
            var s;
            let r = lQ(t);
            return () => (null !== (s = lJ[i]) && void 0 !== s ? s : r());
        })(() => {
            try {
                document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
            } catch (e) {
                return !1;
            }
            return !0;
        }, "linearEasing"),
        l5 = (e, t, i = 10) => {
            let s = "",
                r = Math.max(Math.round(t / i), 2);
            for (let n = 0; n < r; n++) s += e(n / (r - 1)) + ", ";
            return `linear(${s.substring(0, s.length - 2)})`;
        },
        lZ = ["duration", "bounce"],
        de = ["stiffness", "damping", "mass"];
    function dt(e, t) {
        return t.some((t) => void 0 !== e[t]);
    }
    function di(e = lK.visualDuration, t = lK.bounce) {
        let i = "object" != typeof e ? { visualDuration: e, keyframes: [0, 1], bounce: t } : e,
            { restSpeed: s, restDelta: r } = i,
            n = i.keyframes[0],
            a = i.keyframes[i.keyframes.length - 1],
            o = { done: !1, value: n },
            {
                stiffness: l,
                damping: d,
                mass: c,
                duration: h,
                velocity: u,
                isResolvedFromDuration: p,
            } = (function e(t) {
                let i = {
                    velocity: lK.velocity,
                    stiffness: lK.stiffness,
                    damping: lK.damping,
                    mass: lK.mass,
                    isResolvedFromDuration: !1,
                    ...t,
                };
                if (!dt(t, de) && dt(t, lZ)) {
                    if (t.visualDuration) {
                        let s = t.visualDuration,
                            r = (2 * Math.PI) / (1.2 * s),
                            n = r * r,
                            a = 2 * lG(0.05, 1, 1 - (t.bounce || 0)) * Math.sqrt(n);
                        i = { ...i, mass: lK.mass, stiffness: n, damping: a };
                    } else {
                        let o = (function e({
                            duration: t = lK.duration,
                            bounce: i = lK.bounce,
                            velocity: s = lK.velocity,
                            mass: r = lK.mass,
                        }) {
                            let n, a;
                            lj(t <= l2(lK.maxDuration), "Spring duration must be 10 seconds or less");
                            let o = 1 - i;
                            (o = lG(lK.minDamping, lK.maxDamping, o)),
                                (t = lG(lK.minDuration, lK.maxDuration, l4(t))),
                                o < 1
                                    ? ((n = (e) => {
                                          let i = e * o,
                                              r = i * t,
                                              n = lX(e, o);
                                          return 0.001 - ((i - s) / n) * Math.exp(-r);
                                      }),
                                      (a = (e) => {
                                          let i = e * o,
                                              r = i * t,
                                              a = Math.pow(o, 2) * Math.pow(e, 2) * t,
                                              l = lX(Math.pow(e, 2), o),
                                              d = -n(e) + 0.001 > 0 ? -1 : 1;
                                          return (d * ((r * s + s - a) * Math.exp(-r))) / l;
                                      }))
                                    : ((n = (e) => {
                                          let i = Math.exp(-e * t),
                                              r = (e - s) * t + 1;
                                          return -0.001 + i * r;
                                      }),
                                      (a = (e) => {
                                          let i = Math.exp(-e * t),
                                              r = (s - e) * (t * t);
                                          return i * r;
                                      }));
                            let l = 5 / t,
                                d = (function e(t, i, s) {
                                    let r = s;
                                    for (let n = 1; n < 12; n++) r -= t(r) / i(r);
                                    return r;
                                })(n, a, l);
                            if (((t = l2(t)), isNaN(d)))
                                return { stiffness: lK.stiffness, damping: lK.damping, duration: t };
                            {
                                let c = Math.pow(d, 2) * r;
                                return { stiffness: c, damping: 2 * o * Math.sqrt(r * c), duration: t };
                            }
                        })(t);
                        (i = { ...i, ...o, mass: lK.mass }).isResolvedFromDuration = !0;
                    }
                }
                return i;
            })({ ...i, velocity: -l4(i.velocity || 0) }),
            m = u || 0,
            f = d / (2 * Math.sqrt(l * c)),
            g = a - n,
            y = l4(Math.sqrt(l / c)),
            v = 5 > Math.abs(g);
        s || (s = v ? lK.restSpeed.granular : lK.restSpeed.default),
            r || (r = v ? lK.restDelta.granular : lK.restDelta.default);
        let b;
        if (f < 1) {
            let $ = lX(y, f);
            b = (e) => a - Math.exp(-f * y * e) * (((m + f * y * g) / $) * Math.sin($ * e) + g * Math.cos($ * e));
        } else if (1 === f) b = (e) => a - Math.exp(-y * e) * (g + (m + y * g) * e);
        else {
            let w = y * Math.sqrt(f * f - 1);
            b = (e) => {
                let t = Math.min(w * e, 300);
                return a - (Math.exp(-f * y * e) * ((m + f * y * g) * Math.sinh(t) + w * g * Math.cosh(t))) / w;
            };
        }
        let S = {
            calculatedDuration: (p && h) || null,
            next(e) {
                let t = b(e);
                if (p) o.done = e >= h;
                else {
                    let i = 0;
                    f < 1 && (i = 0 === e ? l2(m) : l1(b, e, t));
                    let n = Math.abs(i) <= s,
                        l = Math.abs(a - t) <= r;
                    o.done = n && l;
                }
                return (o.value = o.done ? a : t), o;
            },
            toString() {
                let e = Math.min(lY(S), 2e4),
                    t = l5((t) => S.next(e * t).value, e, 30);
                return e + "ms " + t;
            },
            toTransition() {},
        };
        return S;
    }
    di.applyToOptions = (e) => {
        let t = l6(e, 100, di);
        return (e.ease = l7() ? t.ease : "easeOut"), (e.duration = l2(t.duration)), (e.type = "keyframes"), e;
    };
    let ds = (e, t, i) => {
            let s = t - e;
            return ((((i - e) % s) + s) % s) + e;
        },
        dr = (e) => Array.isArray(e) && "number" != typeof e[0];
    function dn(e, t) {
        return dr(e) ? e[ds(0, e.length, t)] : e;
    }
    let da = (e, t, i) => e + (t - e) * i;
    function dl(e, t) {
        let i = e[e.length - 1];
        for (let s = 1; s <= t; s++) {
            let r = l3(0, t, s);
            e.push(da(i, 1, r));
        }
    }
    function dd(e) {
        let t = [0];
        return dl(t, e.length - 1), t;
    }
    let dc = (e) => Boolean(e && e.getVelocity);
    function dh(e) {
        return "object" == typeof e && !Array.isArray(e);
    }
    function du(e, t, i, s) {
        return "string" == typeof e && dh(t)
            ? l0(e, i, s)
            : e instanceof NodeList
              ? Array.from(e)
              : Array.isArray(e)
                ? e
                : [e];
    }
    function dp(e, t, i) {
        return e * (t + 1);
    }
    function dm(e, t, i, s) {
        var r;
        if ("number" == typeof t) return t;
        if (t.startsWith("-") || t.startsWith("+")) return Math.max(0, e + parseFloat(t));
        if ("<" === t) return i;
        return null !== (r = s.get(t)) && void 0 !== r ? r : e;
    }
    function df(e, t, i, s, r, n) {
        !(function e(t, i, s) {
            for (let r = 0; r < t.length; r++) {
                let n = t[r];
                n.at > i && n.at < s && (lV(t, n), r--);
            }
        })(e, r, n);
        for (let a = 0; a < t.length; a++) e.push({ value: t[a], at: da(r, n, s[a]), easing: dn(i, a) });
    }
    function dg(e, t) {
        for (let i = 0; i < e.length; i++) e[i] = e[i] / (t + 1);
    }
    function dy(e, t) {
        return e.at !== t.at ? e.at - t.at : null === e.value ? 1 : null === t.value ? -1 : 0;
    }
    function dv(e) {
        return "function" == typeof e && "applyToOptions" in e;
    }
    function db(e, t) {
        return t.has(e) || t.set(e, {}), t.get(e);
    }
    function d$(e, t) {
        return t[e] || (t[e] = []), t[e];
    }
    function dw(e) {
        return Array.isArray(e) ? e : [e];
    }
    function d8(e, t) {
        return e && e[t] ? { ...e, ...e[t] } : { ...e };
    }
    let dS = (e) => "number" == typeof e,
        dE = (e) => e.every(dS),
        dx = new WeakMap(),
        dk = [
            "transformPerspective",
            "x",
            "y",
            "z",
            "translateX",
            "translateY",
            "translateZ",
            "scale",
            "scaleX",
            "scaleY",
            "rotate",
            "rotateX",
            "rotateY",
            "rotateZ",
            "skew",
            "skewX",
            "skewY",
        ],
        dT = new Set(dk),
        dL = new Set(["width", "height", "top", "left", "right", "bottom", ...dk]),
        d_ = (e) => Array.isArray(e),
        dA = (e) => (d_(e) ? e[e.length - 1] || 0 : e);
    function dC(e) {
        let t = [{}, {}];
        return (
            null == e ||
                e.values.forEach((e, i) => {
                    (t[0][i] = e.get()), (t[1][i] = e.getVelocity());
                }),
            t
        );
    }
    function dq(e, t, i, s) {
        if ("function" == typeof t) {
            let [r, n] = dC(s);
            t = t(void 0 !== i ? i : e.custom, r, n);
        }
        if (("string" == typeof t && (t = e.variants && e.variants[t]), "function" == typeof t)) {
            let [a, o] = dC(s);
            t = t(void 0 !== i ? i : e.custom, a, o);
        }
        return t;
    }
    function dI(e, t, i) {
        e.hasValue(t) ? e.getValue(t).set(i) : e.addValue(t, lz(i));
    }
    function dP(e, t) {
        var i;
        let s = e.getValue("willChange");
        if (Boolean(dc((i = s)) && i.add)) return s.add(t);
        if (!s && lA.WillChange) {
            let r = new lA.WillChange("auto");
            e.addValue("willChange", r), r.add(t);
        }
    }
    let d9 = (e) => e.replace(/([a-z])([A-Z])/gu, "$1-$2").toLowerCase(),
        dM = "data-" + d9("framerAppearId");
    function dD(e) {
        return e.props[dM];
    }
    let dO = (e, t, i) => (((1 - 3 * i + 3 * t) * e + (3 * i - 6 * t)) * e + 3 * t) * e;
    function dF(e, t, i, s) {
        if (e === t && i === s) return lC;
        let r = (t) =>
            (function e(t, i, s, r, n) {
                let a,
                    o,
                    l = 0;
                do (a = dO((o = i + (s - i) / 2), r, n) - t) > 0 ? (s = o) : (i = o);
                while (Math.abs(a) > 1e-7 && ++l < 12);
                return o;
            })(t, 0, 1, e, i);
        return (e) => (0 === e || 1 === e ? e : dO(r(e), t, s));
    }
    let dB = (e) => (t) => (t <= 0.5 ? e(2 * t) / 2 : (2 - e(2 * (1 - t))) / 2),
        dV = (e) => (t) => 1 - e(1 - t),
        dH = dF(0.33, 1.53, 0.69, 0.99),
        dW = dV(dH),
        dR = dB(dW),
        dN = (e) => ((e *= 2) < 1 ? 0.5 * dW(e) : 0.5 * (2 - Math.pow(2, -10 * (e - 1)))),
        dz = (e) => 1 - Math.sin(Math.acos(e)),
        d0 = dV(dz),
        dj = dB(dz),
        dU = (e) => /^0[^.\s]+$/u.test(e);
    function d3(e) {
        return "number" == typeof e ? 0 === e : null === e || "none" === e || "0" === e || dU(e);
    }
    let dG = { test: (e) => "number" == typeof e, parse: parseFloat, transform: (e) => e },
        d1 = { ...dG, transform: (e) => lG(0, 1, e) },
        dK = { ...dG, default: 1 },
        d2 = (e) => Math.round(1e5 * e) / 1e5,
        d4 = /-?(?:\d+(?:\.\d+)?|\.\d+)/gu,
        dX =
            /^(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))$/iu,
        dY = (e, t) => (i) => {
            var s;
            return Boolean(
                ("string" == typeof i && dX.test(i) && i.startsWith(e)) ||
                    (t && null != (s = i) && Object.prototype.hasOwnProperty.call(i, t))
            );
        },
        d6 = (e, t, i) => (s) => {
            if ("string" != typeof s) return s;
            let [r, n, a, o] = s.match(d4);
            return {
                [e]: parseFloat(r),
                [t]: parseFloat(n),
                [i]: parseFloat(a),
                alpha: void 0 !== o ? parseFloat(o) : 1,
            };
        },
        dJ = (e) => lG(0, 255, e),
        dQ = { ...dG, transform: (e) => Math.round(dJ(e)) },
        d7 = {
            test: dY("rgb", "red"),
            parse: d6("red", "green", "blue"),
            transform: ({ red: e, green: t, blue: i, alpha: s = 1 }) =>
                "rgba(" +
                dQ.transform(e) +
                ", " +
                dQ.transform(t) +
                ", " +
                dQ.transform(i) +
                ", " +
                d2(d1.transform(s)) +
                ")",
        },
        d5 = {
            test: dY("#"),
            parse: function e(t) {
                let i = "",
                    s = "",
                    r = "",
                    n = "";
                return (
                    t.length > 5
                        ? ((i = t.substring(1, 3)),
                          (s = t.substring(3, 5)),
                          (r = t.substring(5, 7)),
                          (n = t.substring(7, 9)))
                        : ((i = t.substring(1, 2)),
                          (s = t.substring(2, 3)),
                          (r = t.substring(3, 4)),
                          (n = t.substring(4, 5)),
                          (i += i),
                          (s += s),
                          (r += r),
                          (n += n)),
                    {
                        red: parseInt(i, 16),
                        green: parseInt(s, 16),
                        blue: parseInt(r, 16),
                        alpha: n ? parseInt(n, 16) / 255 : 1,
                    }
                );
            },
            transform: d7.transform,
        },
        dZ = (e) => ({
            test: (t) => "string" == typeof t && t.endsWith(e) && 1 === t.split(" ").length,
            parse: parseFloat,
            transform: (t) => `${t}${e}`,
        }),
        ce = dZ("deg"),
        ct = dZ("%"),
        ci = dZ("px"),
        cs = dZ("vh"),
        cr = dZ("vw"),
        cn = { ...ct, parse: (e) => ct.parse(e) / 100, transform: (e) => ct.transform(100 * e) },
        ca = {
            test: dY("hsl", "hue"),
            parse: d6("hue", "saturation", "lightness"),
            transform: ({ hue: e, saturation: t, lightness: i, alpha: s = 1 }) =>
                "hsla(" +
                Math.round(e) +
                ", " +
                ct.transform(d2(t)) +
                ", " +
                ct.transform(d2(i)) +
                ", " +
                d2(d1.transform(s)) +
                ")",
        },
        co = {
            test: (e) => d7.test(e) || d5.test(e) || ca.test(e),
            parse: (e) => (d7.test(e) ? d7.parse(e) : ca.test(e) ? ca.parse(e) : d5.parse(e)),
            transform: (e) => ("string" == typeof e ? e : e.hasOwnProperty("red") ? d7.transform(e) : ca.transform(e)),
        },
        cl =
            /(?:#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\))/giu,
        cd = "number",
        cc = "color",
        ch =
            /var\s*\(\s*--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)|#[\da-f]{3,8}|(?:rgb|hsl)a?\((?:-?[\d.]+%?[,\s]+){2}-?[\d.]+%?\s*(?:[,/]\s*)?(?:\b\d+(?:\.\d+)?|\.\d+)?%?\)|-?(?:\d+(?:\.\d+)?|\.\d+)/giu;
    function cu(e) {
        let t = e.toString(),
            i = [],
            s = { color: [], number: [], var: [] },
            r = [],
            n = 0,
            a = t.replace(
                ch,
                (e) => (
                    co.test(e)
                        ? (s.color.push(n), r.push(cc), i.push(co.parse(e)))
                        : e.startsWith("var(")
                          ? (s.var.push(n), r.push("var"), i.push(e))
                          : (s.number.push(n), r.push(cd), i.push(parseFloat(e))),
                    ++n,
                    "${}"
                )
            ),
            o = a.split("${}");
        return { values: i, split: o, indexes: s, types: r };
    }
    function cp(e) {
        return cu(e).values;
    }
    function cm(e) {
        let { split: t, types: i } = cu(e),
            s = t.length;
        return (e) => {
            let r = "";
            for (let n = 0; n < s; n++)
                if (((r += t[n]), void 0 !== e[n])) {
                    let a = i[n];
                    a === cd ? (r += d2(e[n])) : a === cc ? (r += co.transform(e[n])) : (r += e[n]);
                }
            return r;
        };
    }
    let cf = (e) => ("number" == typeof e ? 0 : e),
        cg = {
            test: function e(t) {
                var i, s;
                return (
                    isNaN(t) &&
                    "string" == typeof t &&
                    ((null === (i = t.match(d4)) || void 0 === i ? void 0 : i.length) || 0) +
                        ((null === (s = t.match(cl)) || void 0 === s ? void 0 : s.length) || 0) >
                        0
                );
            },
            parse: cp,
            createTransformer: cm,
            getAnimatableNone: function e(t) {
                let i = cp(t),
                    s = cm(t);
                return s(i.map(cf));
            },
        },
        cy = new Set(["brightness", "contrast", "saturate", "opacity"]);
    function cv(e) {
        let [t, i] = e.slice(0, -1).split("(");
        if ("drop-shadow" === t) return e;
        let [s] = i.match(d4) || [];
        if (!s) return e;
        let r = i.replace(s, ""),
            n = cy.has(t) ? 1 : 0;
        return s !== i && (n *= 100), t + "(" + n + r + ")";
    }
    let cb = /\b([a-z-]*)\(.*?\)/gu,
        c$ = {
            ...cg,
            getAnimatableNone(e) {
                let t = e.match(cb);
                return t ? t.map(cv).join(" ") : e;
            },
        },
        cw = { ...dG, transform: Math.round },
        c8 = {
            borderWidth: ci,
            borderTopWidth: ci,
            borderRightWidth: ci,
            borderBottomWidth: ci,
            borderLeftWidth: ci,
            borderRadius: ci,
            radius: ci,
            borderTopLeftRadius: ci,
            borderTopRightRadius: ci,
            borderBottomRightRadius: ci,
            borderBottomLeftRadius: ci,
            width: ci,
            maxWidth: ci,
            height: ci,
            maxHeight: ci,
            top: ci,
            right: ci,
            bottom: ci,
            left: ci,
            padding: ci,
            paddingTop: ci,
            paddingRight: ci,
            paddingBottom: ci,
            paddingLeft: ci,
            margin: ci,
            marginTop: ci,
            marginRight: ci,
            marginBottom: ci,
            marginLeft: ci,
            backgroundPositionX: ci,
            backgroundPositionY: ci,
            rotate: ce,
            rotateX: ce,
            rotateY: ce,
            rotateZ: ce,
            scale: dK,
            scaleX: dK,
            scaleY: dK,
            scaleZ: dK,
            skew: ce,
            skewX: ce,
            skewY: ce,
            distance: ci,
            translateX: ci,
            translateY: ci,
            translateZ: ci,
            x: ci,
            y: ci,
            z: ci,
            perspective: ci,
            transformPerspective: ci,
            opacity: d1,
            originX: cn,
            originY: cn,
            originZ: ci,
            zIndex: cw,
            size: ci,
            fillOpacity: d1,
            strokeOpacity: d1,
            numOctaves: cw,
        },
        cS = {
            ...c8,
            color: co,
            backgroundColor: co,
            outlineColor: co,
            fill: co,
            stroke: co,
            borderColor: co,
            borderTopColor: co,
            borderRightColor: co,
            borderBottomColor: co,
            borderLeftColor: co,
            filter: c$,
            WebkitFilter: c$,
        },
        cE = (e) => cS[e];
    function cx(e, t) {
        let i = cE(e);
        return i !== c$ && (i = cg), i.getAnimatableNone ? i.getAnimatableNone(t) : void 0;
    }
    let ck = new Set(["auto", "none", "0"]),
        cT = (e) => (180 * e) / Math.PI,
        cL = (e) => {
            let t = cT(Math.atan2(e[1], e[0]));
            return cA(t);
        },
        c_ = {
            x: 4,
            y: 5,
            translateX: 4,
            translateY: 5,
            scaleX: 0,
            scaleY: 3,
            scale: (e) => (Math.abs(e[0]) + Math.abs(e[3])) / 2,
            rotate: cL,
            rotateZ: cL,
            skewX: (e) => cT(Math.atan(e[1])),
            skewY: (e) => cT(Math.atan(e[2])),
            skew: (e) => (Math.abs(e[1]) + Math.abs(e[2])) / 2,
        },
        cA = (e) => ((e %= 360) < 0 && (e += 360), e),
        cC = cL,
        cq = (e) => Math.sqrt(e[0] * e[0] + e[1] * e[1]),
        cI = (e) => Math.sqrt(e[4] * e[4] + e[5] * e[5]),
        cP = {
            x: 12,
            y: 13,
            z: 14,
            translateX: 12,
            translateY: 13,
            translateZ: 14,
            scaleX: cq,
            scaleY: cI,
            scale: (e) => (cq(e) + cI(e)) / 2,
            rotateX: (e) => cA(cT(Math.atan2(e[6], e[5]))),
            rotateY: (e) => cA(cT(Math.atan2(-e[2], e[0]))),
            rotateZ: cC,
            rotate: cC,
            skewX: (e) => cT(Math.atan(e[4])),
            skewY: (e) => cT(Math.atan(e[1])),
            skew: (e) => (Math.abs(e[1]) + Math.abs(e[4])) / 2,
        };
    function c9(e) {
        return e.includes("scale") ? 1 : 0;
    }
    function cM(e, t) {
        if (!e || "none" === e) return c9(t);
        let i = e.match(/^matrix3d\(([-\d.e\s,]+)\)$/u),
            s,
            r;
        if (i) (s = cP), (r = i);
        else {
            let n = e.match(/^matrix\(([-\d.e\s,]+)\)$/u);
            (s = c_), (r = n);
        }
        if (!r) return c9(t);
        let a = s[t],
            o = r[1].split(",").map(cO);
        return "function" == typeof a ? a(o) : o[a];
    }
    let cD = (e, t) => {
        let { transform: i = "none" } = getComputedStyle(e);
        return cM(i, t);
    };
    function cO(e) {
        return parseFloat(e.trim());
    }
    let cF = (e) => e === dG || e === ci,
        cB = new Set(["x", "y", "z"]),
        cV = dk.filter((e) => !cB.has(e)),
        cH = {
            width: ({ x: e }, { paddingLeft: t = "0", paddingRight: i = "0" }) =>
                e.max - e.min - parseFloat(t) - parseFloat(i),
            height: ({ y: e }, { paddingTop: t = "0", paddingBottom: i = "0" }) =>
                e.max - e.min - parseFloat(t) - parseFloat(i),
            top: (e, { top: t }) => parseFloat(t),
            left: (e, { left: t }) => parseFloat(t),
            bottom: ({ y: e }, { top: t }) => parseFloat(t) + (e.max - e.min),
            right: ({ x: e }, { left: t }) => parseFloat(t) + (e.max - e.min),
            x: (e, { transform: t }) => cM(t, "x"),
            y: (e, { transform: t }) => cM(t, "y"),
        };
    (cH.translateX = cH.x), (cH.translateY = cH.y);
    let cW = new Set(),
        cR = !1,
        cN = !1;
    function cz() {
        if (cN) {
            let e = Array.from(cW).filter((e) => e.needsMeasurement),
                t = new Set(e.map((e) => e.element)),
                i = new Map();
            t.forEach((e) => {
                let t = (function e(t) {
                    let i = [];
                    return (
                        cV.forEach((e) => {
                            let s = t.getValue(e);
                            void 0 !== s && (i.push([e, s.get()]), s.set(e.startsWith("scale") ? 1 : 0));
                        }),
                        i
                    );
                })(e);
                t.length && (i.set(e, t), e.render());
            }),
                e.forEach((e) => e.measureInitialState()),
                t.forEach((e) => {
                    e.render();
                    let t = i.get(e);
                    t &&
                        t.forEach(([t, i]) => {
                            var s;
                            null === (s = e.getValue(t)) || void 0 === s || s.set(i);
                        });
                }),
                e.forEach((e) => e.measureEndState()),
                e.forEach((e) => {
                    void 0 !== e.suspendedScrollY && window.scrollTo(0, e.suspendedScrollY);
                });
        }
        (cN = !1), (cR = !1), cW.forEach((e) => e.complete()), cW.clear();
    }
    function c0() {
        cW.forEach((e) => {
            e.readKeyframes(), e.needsMeasurement && (cN = !0);
        });
    }
    let cj = class e {
            scheduleResolve() {
                (this.isScheduled = !0),
                    this.isAsync
                        ? (cW.add(this), cR || ((cR = !0), lq.read(c0), lq.resolveKeyframes(cz)))
                        : (this.readKeyframes(), this.complete());
            }
            readKeyframes() {
                let { unresolvedKeyframes: e, name: t, element: i, motionValue: s } = this;
                for (let r = 0; r < e.length; r++)
                    if (null === e[r]) {
                        if (0 === r) {
                            let n = null == s ? void 0 : s.get(),
                                a = e[e.length - 1];
                            if (void 0 !== n) e[0] = n;
                            else if (i && t) {
                                let o = i.readValue(t, a);
                                null != o && (e[0] = o);
                            }
                            void 0 === e[0] && (e[0] = a), s && void 0 === n && s.set(e[0]);
                        } else e[r] = e[r - 1];
                    }
            }
            setFinalKeyframe() {}
            measureInitialState() {}
            renderEndStyles() {}
            measureEndState() {}
            complete() {
                (this.isComplete = !0), this.onComplete(this.unresolvedKeyframes, this.finalKeyframe), cW.delete(this);
            }
            cancel() {
                this.isComplete || ((this.isScheduled = !1), cW.delete(this));
            }
            resume() {
                this.isComplete || this.scheduleResolve();
            }
            constructor(e, t, i, s, r, n = !1) {
                (this.isComplete = !1),
                    (this.isAsync = !1),
                    (this.needsMeasurement = !1),
                    (this.isScheduled = !1),
                    (this.unresolvedKeyframes = [...e]),
                    (this.onComplete = t),
                    (this.name = i),
                    (this.motionValue = s),
                    (this.element = r),
                    (this.isAsync = n);
            }
        },
        cU = (e) => /^-?(?:\d+(?:\.\d+)?|\.\d+)$/u.test(e),
        c3 = (e) => (t) => "string" == typeof t && t.startsWith(e),
        cG = c3("--"),
        c1 = c3("var(--"),
        cK = (e) => {
            let t = c1(e);
            return !!t && c2.test(e.split("/*")[0].trim());
        },
        c2 = /var\(--(?:[\w-]+\s*|[\w-]+\s*,(?:\s*[^)(\s]|\s*\((?:[^)(]|\([^)(]*\))*\))+\s*)\)$/iu,
        c4 = /^var\(--(?:([\w-]+)|([\w-]+), ?([a-zA-Z\d ()%#.,-]+))\)/u;
    function cX(e, t, i = 1) {
        lU(
            i <= 4,
            `Max CSS variable fallback depth detected in property "${e}". This may indicate a circular fallback dependency.`
        );
        let [s, r] = (function e(t) {
            let i = c4.exec(t);
            if (!i) return [,];
            let [, s, r, n] = i;
            return [`--${null != s ? s : r}`, n];
        })(e);
        if (!s) return;
        let n = window.getComputedStyle(t).getPropertyValue(s);
        if (n) {
            let a = n.trim();
            return cU(a) ? parseFloat(a) : a;
        }
        return cK(r) ? cX(r, t, i + 1) : r;
    }
    let cY = (e) => (t) => t.test(e),
        c6 = [dG, ci, ct, ce, cr, cs, { test: (e) => "auto" === e, parse: (e) => e }],
        cJ = (e) => c6.find(cY(e)),
        cQ = class e extends cj {
            readKeyframes() {
                let { unresolvedKeyframes: e, element: t, name: i } = this;
                if (!t || !t.current) return;
                super.readKeyframes();
                for (let s = 0; s < e.length; s++) {
                    let r = e[s];
                    if ("string" == typeof r && cK((r = r.trim()))) {
                        let n = cX(r, t.current);
                        void 0 !== n && (e[s] = n), s === e.length - 1 && (this.finalKeyframe = r);
                    }
                }
                if ((this.resolveNoneKeyframes(), !dL.has(i) || 2 !== e.length)) return;
                let [a, o] = e,
                    l = cJ(a),
                    d = cJ(o);
                if (l !== d) {
                    if (cF(l) && cF(d))
                        for (let c = 0; c < e.length; c++) {
                            let h = e[c];
                            "string" == typeof h && (e[c] = parseFloat(h));
                        }
                    else this.needsMeasurement = !0;
                }
            }
            resolveNoneKeyframes() {
                let { unresolvedKeyframes: e, name: t } = this,
                    i = [];
                for (let s = 0; s < e.length; s++) d3(e[s]) && i.push(s);
                i.length &&
                    (function e(t, i, s) {
                        let r = 0,
                            n;
                        for (; r < t.length && !n; ) {
                            let a = t[r];
                            "string" == typeof a && !ck.has(a) && cu(a).values.length && (n = t[r]), r++;
                        }
                        if (n && s) for (let o of i) t[o] = cx(s, n);
                    })(e, i, t);
            }
            measureInitialState() {
                let { element: e, unresolvedKeyframes: t, name: i } = this;
                if (!e || !e.current) return;
                "height" === i && (this.suspendedScrollY = window.pageYOffset),
                    (this.measuredOrigin = cH[i](e.measureViewportBox(), window.getComputedStyle(e.current))),
                    (t[0] = this.measuredOrigin);
                let s = t[t.length - 1];
                void 0 !== s && e.getValue(i, s).jump(s, !1);
            }
            measureEndState() {
                var e;
                let { element: t, name: i, unresolvedKeyframes: s } = this;
                if (!t || !t.current) return;
                let r = t.getValue(i);
                r && r.jump(this.measuredOrigin, !1);
                let n = s.length - 1,
                    a = s[n];
                (s[n] = cH[i](t.measureViewportBox(), window.getComputedStyle(t.current))),
                    null !== a && void 0 === this.finalKeyframe && (this.finalKeyframe = a),
                    (null === (e = this.removedTransforms) || void 0 === e ? void 0 : e.length) &&
                        this.removedTransforms.forEach(([e, i]) => {
                            t.getValue(e).set(i);
                        }),
                    this.resolveNoneKeyframes();
            }
            constructor(e, t, i, s, r) {
                super(e, t, i, s, r, !0);
            }
        },
        c7 = (e, t) =>
            "zIndex" !== t &&
            !!(
                "number" == typeof e ||
                Array.isArray(e) ||
                ("string" == typeof e && (cg.test(e) || "0" === e) && !e.startsWith("url("))
            ),
        c5 = (e) => null !== e;
    function cZ(e, { repeat: t, repeatType: i = "loop" }, s) {
        let r = e.filter(c5),
            n = t && "loop" !== i && t % 2 == 1 ? 0 : r.length - 1;
        return n && void 0 !== s ? s : r[n];
    }
    let he = class e {
        calcStartTime() {
            return this.resolvedAt && this.resolvedAt - this.createdAt > 40 ? this.resolvedAt : this.createdAt;
        }
        get resolved() {
            return this._resolved || this.hasAttemptedResolve || void (c0(), cz()), this._resolved;
        }
        onKeyframesResolved(e, t) {
            (this.resolvedAt = lO.now()), (this.hasAttemptedResolve = !0);
            let { name: i, type: s, velocity: r, delay: n, onComplete: a, onUpdate: o, isGenerator: l } = this.options;
            if (
                !l &&
                !(function e(t, i, s, r) {
                    let n = t[0];
                    if (null === n) return !1;
                    if ("display" === i || "visibility" === i) return !0;
                    let a = t[t.length - 1],
                        o = c7(n, i),
                        l = c7(a, i);
                    return (
                        lj(
                            o === l,
                            `You are trying to animate ${i} from "${n}" to "${a}". ${n} is not an animatable value - to enable this animation set ${n} to a value animatable to ${a} via the \`style\` property.`
                        ),
                        !!o &&
                            !!l &&
                            ((function e(t) {
                                let i = t[0];
                                if (1 === t.length) return !0;
                                for (let s = 0; s < t.length; s++) if (t[s] !== i) return !0;
                            })(t) ||
                                (("spring" === s || dv(s)) && r))
                    );
                })(e, i, s, r)
            ) {
                if (n) this.options.duration = 0;
                else {
                    o && o(cZ(e, this.options, t)), a && a(), this.resolveFinishedPromise();
                    return;
                }
            }
            let d = this.initPlayback(e, t);
            !1 !== d && ((this._resolved = { keyframes: e, finalKeyframe: t, ...d }), this.onPostResolved());
        }
        onPostResolved() {}
        then(e, t) {
            return this.currentFinishedPromise.then(e, t);
        }
        flatten() {
            this.options.allowFlatten && ((this.options.type = "keyframes"), (this.options.ease = "linear"));
        }
        updateFinishedPromise() {
            this.currentFinishedPromise = new Promise((e) => {
                this.resolveFinishedPromise = e;
            });
        }
        constructor({
            autoplay: e = !0,
            delay: t = 0,
            type: i = "keyframes",
            repeat: s = 0,
            repeatDelay: r = 0,
            repeatType: n = "loop",
            ...a
        }) {
            (this.isStopped = !1),
                (this.hasAttemptedResolve = !1),
                (this.createdAt = lO.now()),
                (this.options = { autoplay: e, delay: t, type: i, repeat: s, repeatDelay: r, repeatType: n, ...a }),
                this.updateFinishedPromise();
        }
    };
    function ht(e, t, i) {
        return (i < 0 && (i += 1), i > 1 && (i -= 1), i < 1 / 6)
            ? e + (t - e) * 6 * i
            : i < 0.5
              ? t
              : i < 2 / 3
                ? e + (t - e) * (2 / 3 - i) * 6
                : e;
    }
    function hi(e, t) {
        return (i) => (i > 0 ? t : e);
    }
    let hs = (e, t, i) => {
            let s = e * e,
                r = i * (t * t - s) + s;
            return r < 0 ? 0 : Math.sqrt(r);
        },
        hr = [d5, d7, ca],
        hn = (e) => hr.find((t) => t.test(e));
    function ha(e) {
        let t = hn(e);
        if ((lj(Boolean(t), `'${e}' is not an animatable color. Use the equivalent color code instead.`), !Boolean(t)))
            return !1;
        let i = t.parse(e);
        return (
            t === ca &&
                (i = (function e({ hue: t, saturation: i, lightness: s, alpha: r }) {
                    (t /= 360), (s /= 100);
                    let n = 0,
                        a = 0,
                        o = 0;
                    if ((i /= 100)) {
                        let l = s < 0.5 ? s * (1 + i) : s + i - s * i,
                            d = 2 * s - l;
                        (n = ht(d, l, t + 1 / 3)), (a = ht(d, l, t)), (o = ht(d, l, t - 1 / 3));
                    } else n = a = o = s;
                    return {
                        red: Math.round(255 * n),
                        green: Math.round(255 * a),
                        blue: Math.round(255 * o),
                        alpha: r,
                    };
                })(i)),
            i
        );
    }
    let ho = (e, t) => {
            let i = ha(e),
                s = ha(t);
            if (!i || !s) return hi(e, t);
            let r = { ...i };
            return (e) => (
                (r.red = hs(i.red, s.red, e)),
                (r.green = hs(i.green, s.green, e)),
                (r.blue = hs(i.blue, s.blue, e)),
                (r.alpha = da(i.alpha, s.alpha, e)),
                d7.transform(r)
            );
        },
        hl = (e, t) => (i) => t(e(i)),
        hd = (...e) => e.reduce(hl),
        hc = new Set(["none", "hidden"]);
    function hh(e, t) {
        return (i) => da(e, t, i);
    }
    function hu(e) {
        return "number" == typeof e
            ? hh
            : "string" == typeof e
              ? cK(e)
                  ? hi
                  : co.test(e)
                    ? ho
                    : hf
              : Array.isArray(e)
                ? hp
                : "object" == typeof e
                  ? co.test(e)
                      ? ho
                      : hm
                  : hi;
    }
    function hp(e, t) {
        let i = [...e],
            s = i.length,
            r = e.map((e, i) => hu(e)(e, t[i]));
        return (e) => {
            for (let t = 0; t < s; t++) i[t] = r[t](e);
            return i;
        };
    }
    function hm(e, t) {
        let i = { ...e, ...t },
            s = {};
        for (let r in i) void 0 !== e[r] && void 0 !== t[r] && (s[r] = hu(e[r])(e[r], t[r]));
        return (e) => {
            for (let t in s) i[t] = s[t](e);
            return i;
        };
    }
    let hf = (e, t) => {
        let i = cg.createTransformer(t),
            s = cu(e),
            r = cu(t),
            n =
                s.indexes.var.length === r.indexes.var.length &&
                s.indexes.color.length === r.indexes.color.length &&
                s.indexes.number.length >= r.indexes.number.length;
        if (!n)
            return (
                lj(
                    !0,
                    `Complex values '${e}' and '${t}' too different to mix. Ensure all colors are of the same type, and that each contains the same quantity of number and color values. Falling back to instant transition.`
                ),
                hi(e, t)
            );
        if ((hc.has(e) && !r.values.length) || (hc.has(t) && !s.values.length)) {
            var a, o;
            return (a = e), (o = t), hc.has(a) ? (e) => (e <= 0 ? a : o) : (e) => (e >= 1 ? o : a);
        }
        return hd(
            hp(
                (function e(t, i) {
                    let s = [],
                        r = { color: 0, var: 0, number: 0 };
                    for (let n = 0; n < i.values.length; n++) {
                        var a;
                        let o = i.types[n],
                            l = t.indexes[o][r[o]],
                            d = null !== (a = t.values[l]) && void 0 !== a ? a : 0;
                        (s[n] = d), r[o]++;
                    }
                    return s;
                })(s, r),
                r.values
            ),
            i
        );
    };
    function hg(e, t, i) {
        if ("number" == typeof e && "number" == typeof t && "number" == typeof i) return da(e, t, i);
        let s = hu(e);
        return s(e, t);
    }
    function hy({
        keyframes: e,
        velocity: t = 0,
        power: i = 0.8,
        timeConstant: s = 325,
        bounceDamping: r = 10,
        bounceStiffness: n = 500,
        modifyTarget: a,
        min: o,
        max: l,
        restDelta: d = 0.5,
        restSpeed: c,
    }) {
        let h = e[0],
            u = { done: !1, value: h },
            p = (e) => (void 0 !== o && e < o) || (void 0 !== l && e > l),
            m = (e) => (void 0 === o ? l : void 0 === l ? o : Math.abs(o - e) < Math.abs(l - e) ? o : l),
            f = i * t,
            g = h + f,
            y = void 0 === a ? g : a(g);
        y !== g && (f = y - h);
        let v = (e) => -f * Math.exp(-e / s),
            b = (e) => y + v(e),
            $ = (e) => {
                let t = v(e),
                    i = b(e);
                (u.done = Math.abs(t) <= d), (u.value = u.done ? y : i);
            },
            w,
            S,
            E = (e) => {
                p(u.value) &&
                    ((w = e),
                    (S = di({
                        keyframes: [u.value, m(u.value)],
                        velocity: l1(b, e, u.value),
                        damping: r,
                        stiffness: n,
                        restDelta: d,
                        restSpeed: c,
                    })));
            };
        return (
            E(0),
            {
                calculatedDuration: null,
                next(e) {
                    let t = !1;
                    return (S || void 0 !== w || ((t = !0), $(e), E(e)), void 0 !== w && e >= w)
                        ? S.next(e - w)
                        : (t || $(e), u);
                },
            }
        );
    }
    let hv = dF(0.42, 0, 1, 1),
        hb = dF(0, 0, 0.58, 1),
        h$ = dF(0.42, 0, 0.58, 1),
        hw = (e) => Array.isArray(e) && "number" == typeof e[0],
        h8 = {
            linear: lC,
            easeIn: hv,
            easeInOut: h$,
            easeOut: hb,
            circIn: dz,
            circInOut: dj,
            circOut: d0,
            backIn: dW,
            backInOut: dR,
            backOut: dH,
            anticipate: dN,
        },
        hS = (e) => {
            if (hw(e)) {
                lU(4 === e.length, "Cubic bezier arrays must contain four numerical values.");
                let [t, i, s, r] = e;
                return dF(t, i, s, r);
            }
            return "string" == typeof e ? (lU(void 0 !== h8[e], `Invalid easing type '${e}'`), h8[e]) : e;
        };
    function hE(e, t, { clamp: i = !0, ease: s, mixer: r } = {}) {
        let n = e.length;
        if ((lU(n === t.length, "Both input and output ranges must be the same length"), 1 === n)) return () => t[0];
        if (2 === n && t[0] === t[1]) return () => t[1];
        let a = e[0] === e[1];
        e[0] > e[n - 1] && ((e = [...e].reverse()), (t = [...t].reverse()));
        let o = (function e(t, i, s) {
                let r = [],
                    n = s || hg,
                    a = t.length - 1;
                for (let o = 0; o < a; o++) {
                    let l = n(t[o], t[o + 1]);
                    if (i) {
                        let d = Array.isArray(i) ? i[o] || lC : i;
                        l = hd(d, l);
                    }
                    r.push(l);
                }
                return r;
            })(t, s, r),
            l = o.length,
            d = (i) => {
                if (a && i < e[0]) return t[0];
                let s = 0;
                if (l > 1) for (; s < e.length - 2 && !(i < e[s + 1]); s++);
                let r = l3(e[s], e[s + 1], i);
                return o[s](r);
            };
        return i ? (t) => d(lG(e[0], e[n - 1], t)) : d;
    }
    function hx({ duration: e = 300, keyframes: t, times: i, ease: s = "easeInOut" }) {
        var r, n, a, o;
        let l = dr(s) ? s.map(hS) : hS(s),
            d = { done: !1, value: t[0] },
            c = ((r = i && i.length === t.length ? i : dd(t)), (n = e), r.map((e) => e * n)),
            h = hE(c, t, {
                ease: Array.isArray(l) ? l : ((a = t), (o = l), a.map(() => o || h$).splice(0, a.length - 1)),
            });
        return { calculatedDuration: e, next: (t) => ((d.value = h(t)), (d.done = t >= e), d) };
    }
    let hk = (e) => {
            let t = ({ timestamp: t }) => e(t);
            return {
                start: () => lq.update(t, !0),
                stop: () => lI(t),
                now: () => (lP.isProcessing ? lP.timestamp : lO.now()),
            };
        },
        hT = { decay: hy, inertia: hy, tween: hx, keyframes: hx, spring: di },
        hL = (e) => e / 100,
        h_ = class e extends he {
            flatten() {
                super.flatten(),
                    this._resolved && Object.assign(this._resolved, this.initPlayback(this._resolved.keyframes));
            }
            initPlayback(e) {
                let {
                        type: t = "keyframes",
                        repeat: i = 0,
                        repeatDelay: s = 0,
                        repeatType: r,
                        velocity: n = 0,
                    } = this.options,
                    a = dv(t) ? t : hT[t] || hx,
                    o,
                    l;
                "production" !== process.env.NODE_ENV &&
                    a !== hx &&
                    lU(
                        e.length <= 2,
                        `Only two keyframes currently supported with spring and inertia animations. Trying to animate ${e}`
                    ),
                    a !== hx && "number" != typeof e[0] && ((o = hd(hL, hg(e[0], e[1]))), (e = [0, 100]));
                let d = a({ ...this.options, keyframes: e });
                "mirror" === r && (l = a({ ...this.options, keyframes: [...e].reverse(), velocity: -n })),
                    null === d.calculatedDuration && (d.calculatedDuration = lY(d));
                let { calculatedDuration: c } = d,
                    h = c + s;
                return {
                    generator: d,
                    mirroredGenerator: l,
                    mapPercentToKeyframes: o,
                    calculatedDuration: c,
                    resolvedDuration: h,
                    totalDuration: h * (i + 1) - s,
                };
            }
            onPostResolved() {
                let { autoplay: e = !0 } = this.options;
                this.play(),
                    "paused" !== this.pendingPlayState && e ? (this.state = this.pendingPlayState) : this.pause();
            }
            tick(e, t = !1) {
                let { resolved: i } = this;
                if (!i) {
                    let { keyframes: s } = this.options;
                    return { done: !0, value: s[s.length - 1] };
                }
                let {
                    finalKeyframe: r,
                    generator: n,
                    mirroredGenerator: a,
                    mapPercentToKeyframes: o,
                    keyframes: l,
                    calculatedDuration: d,
                    totalDuration: c,
                    resolvedDuration: h,
                } = i;
                if (null === this.startTime) return n.next(0);
                let { delay: u, repeat: p, repeatType: m, repeatDelay: f, onUpdate: g } = this.options;
                this.speed > 0
                    ? (this.startTime = Math.min(this.startTime, e))
                    : this.speed < 0 && (this.startTime = Math.min(e - c / this.speed, this.startTime)),
                    t
                        ? (this.currentTime = e)
                        : null !== this.holdTime
                          ? (this.currentTime = this.holdTime)
                          : (this.currentTime = Math.round(e - this.startTime) * this.speed);
                let y = this.currentTime - u * (this.speed >= 0 ? 1 : -1),
                    v = this.speed >= 0 ? y < 0 : y > c;
                (this.currentTime = Math.max(y, 0)),
                    "finished" === this.state && null === this.holdTime && (this.currentTime = c);
                let b = this.currentTime,
                    $ = n;
                if (p) {
                    let w = Math.min(this.currentTime, c) / h,
                        S = Math.floor(w),
                        E = w % 1;
                    !E && w >= 1 && (E = 1), 1 === E && S--, (S = Math.min(S, p + 1));
                    let x = Boolean(S % 2);
                    x && ("reverse" === m ? ((E = 1 - E), f && (E -= f / h)) : "mirror" === m && ($ = a)),
                        (b = lG(0, 1, E) * h);
                }
                let k = v ? { done: !1, value: l[0] } : $.next(b);
                o && (k.value = o(k.value));
                let { done: T } = k;
                v || null === d || (T = this.speed >= 0 ? this.currentTime >= c : this.currentTime <= 0);
                let L = null === this.holdTime && ("finished" === this.state || ("running" === this.state && T));
                return L && void 0 !== r && (k.value = cZ(l, this.options, r)), g && g(k.value), L && this.finish(), k;
            }
            get duration() {
                let { resolved: e } = this;
                return e ? l4(e.calculatedDuration) : 0;
            }
            get time() {
                return l4(this.currentTime);
            }
            set time(e) {
                (e = l2(e)),
                    (this.currentTime = e),
                    null !== this.holdTime || 0 === this.speed
                        ? (this.holdTime = e)
                        : this.driver && (this.startTime = this.driver.now() - e / this.speed);
            }
            get speed() {
                return this.playbackSpeed;
            }
            set speed(e) {
                let t = this.playbackSpeed !== e;
                (this.playbackSpeed = e), t && (this.time = l4(this.currentTime));
            }
            play() {
                if ((this.resolver.isScheduled || this.resolver.resume(), !this._resolved)) {
                    this.pendingPlayState = "running";
                    return;
                }
                if (this.isStopped) return;
                let { driver: e = hk, onPlay: t, startTime: i } = this.options;
                this.driver || (this.driver = e((e) => this.tick(e))), t && t();
                let s = this.driver.now();
                null !== this.holdTime
                    ? (this.startTime = s - this.holdTime)
                    : this.startTime
                      ? "finished" === this.state && (this.startTime = s)
                      : (this.startTime = null != i ? i : this.calcStartTime()),
                    "finished" === this.state && this.updateFinishedPromise(),
                    (this.cancelTime = this.startTime),
                    (this.holdTime = null),
                    (this.state = "running"),
                    this.driver.start();
            }
            pause() {
                var e;
                if (!this._resolved) {
                    this.pendingPlayState = "paused";
                    return;
                }
                (this.state = "paused"), (this.holdTime = null !== (e = this.currentTime) && void 0 !== e ? e : 0);
            }
            complete() {
                "running" !== this.state && this.play(),
                    (this.pendingPlayState = this.state = "finished"),
                    (this.holdTime = null);
            }
            finish() {
                this.teardown(), (this.state = "finished");
                let { onComplete: e } = this.options;
                e && e();
            }
            cancel() {
                null !== this.cancelTime && this.tick(this.cancelTime), this.teardown(), this.updateFinishedPromise();
            }
            teardown() {
                (this.state = "idle"),
                    this.stopDriver(),
                    this.resolveFinishedPromise(),
                    this.updateFinishedPromise(),
                    (this.startTime = this.cancelTime = null),
                    this.resolver.cancel();
            }
            stopDriver() {
                this.driver && (this.driver.stop(), (this.driver = void 0));
            }
            sample(e) {
                return (this.startTime = 0), this.tick(e, !0);
            }
            get finished() {
                return this.currentFinishedPromise;
            }
            constructor(e) {
                super(e),
                    (this.holdTime = null),
                    (this.cancelTime = null),
                    (this.currentTime = 0),
                    (this.playbackSpeed = 1),
                    (this.pendingPlayState = "running"),
                    (this.startTime = null),
                    (this.state = "idle"),
                    (this.stop = () => {
                        if ((this.resolver.cancel(), (this.isStopped = !0), "idle" === this.state)) return;
                        this.teardown();
                        let { onStop: e } = this.options;
                        e && e();
                    });
                let { name: t, motionValue: i, element: s, keyframes: r } = this.options,
                    n = (null == s ? void 0 : s.KeyframeResolver) || cj,
                    a = (e, t) => this.onKeyframesResolved(e, t);
                (this.resolver = new n(r, a, t, i, s)), this.resolver.scheduleResolve();
            }
        },
        hA = new Set(["opacity", "clipPath", "filter", "transform"]),
        hC = lQ(() => Object.hasOwnProperty.call(Element.prototype, "animate")),
        hq = ([e, t, i, s]) => `cubic-bezier(${e}, ${t}, ${i}, ${s})`,
        hI = {
            linear: "linear",
            ease: "ease",
            easeIn: "ease-in",
            easeOut: "ease-out",
            easeInOut: "ease-in-out",
            circIn: hq([0, 0.65, 0.55, 1]),
            circOut: hq([0.55, 0, 1, 0.45]),
            backIn: hq([0.31, 0.01, 0.66, -0.59]),
            backOut: hq([0.33, 1.53, 0.69, 0.99]),
        };
    function hP(e, t) {
        (e.timeline = t), (e.onfinish = null);
    }
    let h9 = { anticipate: dN, backInOut: dR, circInOut: dj },
        hM = class e extends he {
            initPlayback(e, t) {
                var i, s;
                let {
                    duration: r = 300,
                    times: n,
                    ease: a,
                    type: o,
                    motionValue: l,
                    name: d,
                    startTime: c,
                } = this.options;
                if (!l.owner || !l.owner.current) return !1;
                if (
                    ("string" == typeof a && l7() && (i = a) in h9 && (a = h9[a]),
                    dv((s = this.options).type) ||
                        "spring" === s.type ||
                        !(function e(t) {
                            return Boolean(
                                ("function" == typeof t && l7()) ||
                                    !t ||
                                    ("string" == typeof t && (t in hI || l7())) ||
                                    hw(t) ||
                                    (Array.isArray(t) && t.every(e))
                            );
                        })(s.ease))
                ) {
                    let { onComplete: h, onUpdate: u, motionValue: p, element: m, ...f } = this.options,
                        g = (function e(t, i) {
                            let s = new h_({ ...i, keyframes: t, repeat: 0, delay: 0, isGenerator: !0 }),
                                r = { done: !1, value: t[0] },
                                n = [],
                                a = 0;
                            for (; !r.done && a < 2e4; ) n.push((r = s.sample(a)).value), (a += 10);
                            return { times: void 0, keyframes: n, duration: a - 10, ease: "linear" };
                        })(e, f);
                    1 === (e = g.keyframes).length && (e[1] = e[0]),
                        (r = g.duration),
                        (n = g.times),
                        (a = g.ease),
                        (o = "keyframes");
                }
                let y = (function e(
                    t,
                    i,
                    s,
                    {
                        delay: r = 0,
                        duration: n = 300,
                        repeat: a = 0,
                        repeatType: o = "loop",
                        ease: l = "easeInOut",
                        times: d,
                    } = {},
                    c
                ) {
                    let h = { [i]: s };
                    d && (h.offset = d);
                    let u = (function e(t, i) {
                        if (t)
                            return "function" == typeof t && l7()
                                ? l5(t, i)
                                : hw(t)
                                  ? hq(t)
                                  : Array.isArray(t)
                                    ? t.map((t) => e(t, i) || hI.easeOut)
                                    : hI[t];
                    })(l, n);
                    Array.isArray(u) && (h.easing = u);
                    let p = t.animate(h, {
                        delay: r,
                        duration: n,
                        easing: Array.isArray(u) ? "linear" : u,
                        fill: "both",
                        iterations: a + 1,
                        direction: "reverse" === o ? "alternate" : "normal",
                        pseudoElement: void 0,
                    });
                    return p;
                })(l.owner.current, d, e, { ...this.options, duration: r, times: n, ease: a });
                return (
                    (y.startTime = null != c ? c : this.calcStartTime()),
                    this.pendingTimeline
                        ? (hP(y, this.pendingTimeline), (this.pendingTimeline = void 0))
                        : (y.onfinish = () => {
                              let { onComplete: i } = this.options;
                              l.set(cZ(e, this.options, t)), i && i(), this.cancel(), this.resolveFinishedPromise();
                          }),
                    { animation: y, duration: r, times: n, type: o, ease: a, keyframes: e }
                );
            }
            get duration() {
                let { resolved: e } = this;
                if (!e) return 0;
                let { duration: t } = e;
                return l4(t);
            }
            get time() {
                let { resolved: e } = this;
                if (!e) return 0;
                let { animation: t } = e;
                return l4(t.currentTime || 0);
            }
            set time(e) {
                let { resolved: t } = this;
                if (!t) return;
                let { animation: i } = t;
                i.currentTime = l2(e);
            }
            get speed() {
                let { resolved: e } = this;
                if (!e) return 1;
                let { animation: t } = e;
                return t.playbackRate;
            }
            get finished() {
                return this.resolved.animation.finished;
            }
            set speed(e) {
                let { resolved: t } = this;
                if (!t) return;
                let { animation: i } = t;
                i.playbackRate = e;
            }
            get state() {
                let { resolved: e } = this;
                if (!e) return "idle";
                let { animation: t } = e;
                return t.playState;
            }
            get startTime() {
                let { resolved: e } = this;
                if (!e) return null;
                let { animation: t } = e;
                return t.startTime;
            }
            attachTimeline(e) {
                if (this._resolved) {
                    let { resolved: t } = this;
                    if (!t) return lC;
                    let { animation: i } = t;
                    hP(i, e);
                } else this.pendingTimeline = e;
                return lC;
            }
            play() {
                if (this.isStopped) return;
                let { resolved: e } = this;
                if (!e) return;
                let { animation: t } = e;
                "finished" === t.playState && this.updateFinishedPromise(), t.play();
            }
            pause() {
                let { resolved: e } = this;
                if (!e) return;
                let { animation: t } = e;
                t.pause();
            }
            stop() {
                if ((this.resolver.cancel(), (this.isStopped = !0), "idle" === this.state)) return;
                this.resolveFinishedPromise(), this.updateFinishedPromise();
                let { resolved: e } = this;
                if (!e) return;
                let { animation: t, keyframes: i, duration: s, type: r, ease: n, times: a } = e;
                if ("idle" === t.playState || "finished" === t.playState) return;
                if (this.time) {
                    let { motionValue: o, onUpdate: l, onComplete: d, element: c, ...h } = this.options,
                        u = new h_({ ...h, keyframes: i, duration: s, type: r, ease: n, times: a, isGenerator: !0 }),
                        p = l2(this.time);
                    o.setWithVelocity(u.sample(p - 10).value, u.sample(p).value, 10);
                }
                let { onStop: m } = this.options;
                m && m(), this.cancel();
            }
            complete() {
                let { resolved: e } = this;
                e && e.animation.finish();
            }
            cancel() {
                let { resolved: e } = this;
                e && e.animation.cancel();
            }
            static supports(e) {
                let { motionValue: t, name: i, repeatDelay: s, repeatType: r, damping: n, type: a } = e;
                if (!t || !t.owner || !(t.owner.current instanceof HTMLElement)) return !1;
                let { onUpdate: o, transformTemplate: l } = t.owner.getProps();
                return (
                    hC() &&
                    i &&
                    hA.has(i) &&
                    ("transform" !== i || !l) &&
                    !o &&
                    !s &&
                    "mirror" !== r &&
                    0 !== n &&
                    "inertia" !== a
                );
            }
            constructor(e) {
                super(e);
                let { name: t, motionValue: i, element: s, keyframes: r } = this.options;
                (this.resolver = new cQ(r, (e, t) => this.onKeyframesResolved(e, t), t, i, s)),
                    this.resolver.scheduleResolve();
            }
        },
        hD = { type: "spring", stiffness: 500, damping: 25, restSpeed: 10 },
        hO = (e) => ({ type: "spring", stiffness: 550, damping: 0 === e ? 2 * Math.sqrt(550) : 30, restSpeed: 10 }),
        hF = { type: "keyframes", duration: 0.8 },
        hB = { type: "keyframes", ease: [0.25, 0.1, 0.35, 1], duration: 0.3 },
        hV = (e, { keyframes: t }) => (t.length > 2 ? hF : dT.has(e) ? (e.startsWith("scale") ? hO(t[1]) : hD) : hB);
    function hH(e, t) {
        var i, s;
        return null !==
            (s = null !== (i = null == e ? void 0 : e[t]) && void 0 !== i ? i : null == e ? void 0 : e.default) &&
            void 0 !== s
            ? s
            : e;
    }
    let hW = lQ(() => void 0 !== window.ScrollTimeline),
        hR = class e {
            get finished() {
                return Promise.all(this.animations.map((e) => e.finished));
            }
            getAll(e) {
                return this.animations[0][e];
            }
            setAll(e, t) {
                for (let i = 0; i < this.animations.length; i++) this.animations[i][e] = t;
            }
            attachTimeline(e, t) {
                let i = this.animations.map((i) =>
                    hW() && i.attachTimeline ? i.attachTimeline(e) : "function" == typeof t ? t(i) : void 0
                );
                return () => {
                    i.forEach((e, t) => {
                        e && e(), this.animations[t].stop();
                    });
                };
            }
            get time() {
                return this.getAll("time");
            }
            set time(e) {
                this.setAll("time", e);
            }
            get speed() {
                return this.getAll("speed");
            }
            set speed(e) {
                this.setAll("speed", e);
            }
            get startTime() {
                return this.getAll("startTime");
            }
            get duration() {
                let e = 0;
                for (let t = 0; t < this.animations.length; t++) e = Math.max(e, this.animations[t].duration);
                return e;
            }
            runAll(e) {
                this.animations.forEach((t) => t[e]());
            }
            flatten() {
                this.runAll("flatten");
            }
            play() {
                this.runAll("play");
            }
            pause() {
                this.runAll("pause");
            }
            cancel() {
                this.runAll("cancel");
            }
            complete() {
                this.runAll("complete");
            }
            constructor(e) {
                (this.stop = () => this.runAll("stop")), (this.animations = e.filter(Boolean));
            }
        },
        hN = class e extends hR {
            then(e, t) {
                return this.finished.finally(e).then(() => {});
            }
        },
        hz =
            (e, t, i, s = {}, r, n) =>
            (a) => {
                let o = hH(s, e) || {},
                    l = o.delay || s.delay || 0,
                    { elapsed: d = 0 } = s;
                d -= l2(l);
                let c = {
                    keyframes: Array.isArray(i) ? i : [null, i],
                    ease: "easeOut",
                    velocity: t.getVelocity(),
                    ...o,
                    delay: -d,
                    onUpdate(e) {
                        t.set(e), o.onUpdate && o.onUpdate(e);
                    },
                    onComplete() {
                        a(), o.onComplete && o.onComplete();
                    },
                    name: e,
                    motionValue: t,
                    element: n ? void 0 : r,
                };
                !(function e({
                    when: t,
                    delay: i,
                    delayChildren: s,
                    staggerChildren: r,
                    staggerDirection: n,
                    repeat: a,
                    repeatType: o,
                    repeatDelay: l,
                    from: d,
                    elapsed: c,
                    ...h
                }) {
                    return !!Object.keys(h).length;
                })(o) && (c = { ...c, ...hV(e, c) }),
                    c.duration && (c.duration = l2(c.duration)),
                    c.repeatDelay && (c.repeatDelay = l2(c.repeatDelay)),
                    void 0 !== c.from && (c.keyframes[0] = c.from);
                let h = !1;
                if (
                    ((!1 !== c.type && (0 !== c.duration || c.repeatDelay)) ||
                        ((c.duration = 0), 0 !== c.delay || (h = !0)),
                    (c.allowFlatten = !o.type && !o.ease),
                    h && !n && void 0 !== t.get())
                ) {
                    let u = cZ(c.keyframes, o);
                    if (void 0 !== u)
                        return (
                            lq.update(() => {
                                c.onUpdate(u), c.onComplete();
                            }),
                            new hN([])
                        );
                }
                return !n && hM.supports(c) ? new hM(c) : new h_(c);
            };
    function h0({ protectedKeys: e, needsAnimating: t }, i) {
        let s = e.hasOwnProperty(i) && !0 !== t[i];
        return (t[i] = !1), s;
    }
    function hj(e, t, { delay: i = 0, transitionOverride: s, type: r } = {}) {
        let { transition: n = e.getDefaultTransition(), transitionEnd: a, ...o } = t;
        s && (n = s);
        let l = [],
            d = r && e.animationState && e.animationState.getState()[r];
        for (let c in o) {
            var h;
            let u = e.getValue(c, null !== (h = e.latestValues[c]) && void 0 !== h ? h : null),
                p = o[c];
            if (void 0 === p || (d && h0(d, c))) continue;
            let m = { delay: i, ...hH(n || {}, c) },
                f = !1;
            if (window.MotionHandoffAnimation) {
                let g = dD(e);
                if (g) {
                    let y = window.MotionHandoffAnimation(g, c, lq);
                    null !== y && ((m.startTime = y), (f = !0));
                }
            }
            dP(e, c), u.start(hz(c, u, p, e.shouldReduceMotion && dL.has(c) ? { type: !1 } : m, e, f));
            let v = u.animation;
            v && l.push(v);
        }
        return (
            a &&
                Promise.all(l).then(() => {
                    lq.update(() => {
                        a &&
                            (function e(t, i) {
                                let s = (function e(t, i, s) {
                                        let r = t.getProps();
                                        return dq(r, i, r.custom, t);
                                    })(t, i),
                                    { transitionEnd: r = {}, transition: n = {}, ...a } = s || {};
                                for (let o in (a = { ...a, ...r })) {
                                    let l = dA(a[o]);
                                    dI(t, o, l);
                                }
                            })(e, a);
                    });
                }),
            l
        );
    }
    let hU = () => ({ min: 0, max: 0 }),
        h3 = () => ({ x: hU(), y: hU() }),
        hG = {
            animation: [
                "animate",
                "variants",
                "whileHover",
                "whileTap",
                "exit",
                "whileInView",
                "whileFocus",
                "whileDrag",
            ],
            exit: ["exit"],
            drag: ["drag", "dragControls"],
            focus: ["whileFocus"],
            hover: ["whileHover", "onHoverStart", "onHoverEnd"],
            tap: ["whileTap", "onTap", "onTapStart", "onTapCancel"],
            pan: ["onPan", "onPanStart", "onPanSessionStart", "onPanEnd"],
            inView: ["whileInView", "onViewportEnter", "onViewportLeave"],
            layout: ["layout", "layoutId"],
        },
        h1 = {};
    for (let hK in hG) h1[hK] = { isEnabled: (e) => hG[hK].some((t) => !!e[t]) };
    let h2 = "undefined" != typeof window,
        h4 = { current: null },
        hX = { current: !1 },
        hY = [...c6, co, cg],
        h6 = (e) => hY.find(cY(e)),
        hJ = ["initial", "animate", "whileInView", "whileFocus", "whileHover", "whileTap", "whileDrag", "exit"];
    function hQ(e) {
        var t;
        return (
            (null !== (t = e.animate) && "object" == typeof t && "function" == typeof t.start) ||
            hJ.some((t) => {
                var i;
                return "string" == typeof (i = e[t]) || Array.isArray(i);
            })
        );
    }
    let h7 = [
            "AnimationStart",
            "AnimationComplete",
            "Update",
            "BeforeLayoutMeasure",
            "LayoutMeasure",
            "LayoutAnimationStart",
            "LayoutAnimationComplete",
        ],
        h5 = class e {
            scrapeMotionValuesFromProps(e, t, i) {
                return {};
            }
            mount(e) {
                (this.current = e),
                    dx.set(e, this),
                    this.projection && !this.projection.instance && this.projection.mount(e),
                    this.parent &&
                        this.isVariantNode &&
                        !this.isControllingVariants &&
                        (this.removeFromVariantTree = this.parent.addVariantChild(this)),
                    this.values.forEach((e, t) => this.bindToMotionValue(t, e)),
                    hX.current ||
                        (function e() {
                            if (((hX.current = !0), h2)) {
                                if (window.matchMedia) {
                                    let t = window.matchMedia("(prefers-reduced-motion)"),
                                        i = () => (h4.current = t.matches);
                                    t.addListener(i), i();
                                } else h4.current = !1;
                            }
                        })(),
                    (this.shouldReduceMotion =
                        "never" !== this.reducedMotionConfig && ("always" === this.reducedMotionConfig || h4.current)),
                    "production" !== process.env.NODE_ENV &&
                        lB(
                            !0 !== this.shouldReduceMotion,
                            "You have Reduced Motion enabled on your device. Animations may not appear as expected."
                        ),
                    this.parent && this.parent.children.add(this),
                    this.update(this.props, this.presenceContext);
            }
            unmount() {
                for (let e in (this.projection && this.projection.unmount(),
                lI(this.notifyUpdate),
                lI(this.render),
                this.valueSubscriptions.forEach((e) => e()),
                this.valueSubscriptions.clear(),
                this.removeFromVariantTree && this.removeFromVariantTree(),
                this.parent && this.parent.children.delete(this),
                this.events))
                    this.events[e].clear();
                for (let t in this.features) {
                    let i = this.features[t];
                    i && (i.unmount(), (i.isMounted = !1));
                }
                this.current = null;
            }
            bindToMotionValue(e, t) {
                this.valueSubscriptions.has(e) && this.valueSubscriptions.get(e)();
                let i = dT.has(e);
                i && this.onBindTransform && this.onBindTransform();
                let s = t.on("change", (t) => {
                        (this.latestValues[e] = t),
                            this.props.onUpdate && lq.preRender(this.notifyUpdate),
                            i && this.projection && (this.projection.isTransformDirty = !0);
                    }),
                    r = t.on("renderRequest", this.scheduleRender),
                    n;
                window.MotionCheckAppearSync && (n = window.MotionCheckAppearSync(this, e, t)),
                    this.valueSubscriptions.set(e, () => {
                        s(), r(), n && n(), t.owner && t.stop();
                    });
            }
            sortNodePosition(e) {
                return this.current && this.sortInstanceNodePosition && this.type === e.type
                    ? this.sortInstanceNodePosition(this.current, e.current)
                    : 0;
            }
            updateFeatures() {
                let e = "animation";
                for (e in h1) {
                    let t = h1[e];
                    if (!t) continue;
                    let { isEnabled: i, Feature: s } = t;
                    if (
                        (!this.features[e] && s && i(this.props) && (this.features[e] = new s(this)), this.features[e])
                    ) {
                        let r = this.features[e];
                        r.isMounted ? r.update() : (r.mount(), (r.isMounted = !0));
                    }
                }
            }
            triggerBuild() {
                this.build(this.renderState, this.latestValues, this.props);
            }
            measureViewportBox() {
                return this.current ? this.measureInstanceViewportBox(this.current, this.props) : h3();
            }
            getStaticValue(e) {
                return this.latestValues[e];
            }
            setStaticValue(e, t) {
                this.latestValues[e] = t;
            }
            update(e, t) {
                (e.transformTemplate || this.props.transformTemplate) && this.scheduleRender(),
                    (this.prevProps = this.props),
                    (this.props = e),
                    (this.prevPresenceContext = this.presenceContext),
                    (this.presenceContext = t);
                for (let i = 0; i < h7.length; i++) {
                    let s = h7[i];
                    this.propEventSubscriptions[s] &&
                        (this.propEventSubscriptions[s](), delete this.propEventSubscriptions[s]);
                    let r = "on" + s,
                        n = e[r];
                    n && (this.propEventSubscriptions[s] = this.on(s, n));
                }
                (this.prevMotionValues = (function e(t, i, s) {
                    for (let r in i) {
                        let n = i[r],
                            a = s[r];
                        if (dc(n))
                            t.addValue(r, n),
                                "development" === process.env.NODE_ENV &&
                                    lB(
                                        "12.7.4" === n.version,
                                        `Attempting to mix Motion versions ${n.version} with 12.7.4 may not work as expected.`
                                    );
                        else if (dc(a)) t.addValue(r, lz(n, { owner: t }));
                        else if (a !== n) {
                            if (t.hasValue(r)) {
                                let o = t.getValue(r);
                                !0 === o.liveStyle ? o.jump(n) : o.hasAnimated || o.set(n);
                            } else {
                                let l = t.getStaticValue(r);
                                t.addValue(r, lz(void 0 !== l ? l : n, { owner: t }));
                            }
                        }
                    }
                    for (let d in s) void 0 === i[d] && t.removeValue(d);
                    return i;
                })(this, this.scrapeMotionValuesFromProps(e, this.prevProps, this), this.prevMotionValues)),
                    this.handleChildMotionValue && this.handleChildMotionValue(),
                    this.onUpdate && this.onUpdate(this);
            }
            getProps() {
                return this.props;
            }
            getVariant(e) {
                return this.props.variants ? this.props.variants[e] : void 0;
            }
            getDefaultTransition() {
                return this.props.transition;
            }
            getTransformPagePoint() {
                return this.props.transformPagePoint;
            }
            getClosestVariantNode() {
                return this.isVariantNode ? this : this.parent ? this.parent.getClosestVariantNode() : void 0;
            }
            addVariantChild(e) {
                let t = this.getClosestVariantNode();
                if (t) return t.variantChildren && t.variantChildren.add(e), () => t.variantChildren.delete(e);
            }
            addValue(e, t) {
                let i = this.values.get(e);
                t !== i &&
                    (i && this.removeValue(e),
                    this.bindToMotionValue(e, t),
                    this.values.set(e, t),
                    (this.latestValues[e] = t.get()));
            }
            removeValue(e) {
                this.values.delete(e);
                let t = this.valueSubscriptions.get(e);
                t && (t(), this.valueSubscriptions.delete(e)),
                    delete this.latestValues[e],
                    this.removeValueFromRenderState(e, this.renderState);
            }
            hasValue(e) {
                return this.values.has(e);
            }
            getValue(e, t) {
                if (this.props.values && this.props.values[e]) return this.props.values[e];
                let i = this.values.get(e);
                return (
                    void 0 === i &&
                        void 0 !== t &&
                        ((i = lz(null === t ? void 0 : t, { owner: this })), this.addValue(e, i)),
                    i
                );
            }
            readValue(e, t) {
                var i;
                let s =
                    void 0 === this.latestValues[e] && this.current
                        ? null !== (i = this.getBaseTargetFromProps(this.props, e)) && void 0 !== i
                            ? i
                            : this.readValueFromInstance(this.current, e, this.options)
                        : this.latestValues[e];
                return (
                    null != s &&
                        ("string" == typeof s && (cU(s) || dU(s))
                            ? (s = parseFloat(s))
                            : !h6(s) && cg.test(t) && (s = cx(e, t)),
                        this.setBaseTarget(e, dc(s) ? s.get() : s)),
                    dc(s) ? s.get() : s
                );
            }
            setBaseTarget(e, t) {
                this.baseTarget[e] = t;
            }
            getBaseTarget(e) {
                let { initial: t } = this.props,
                    i;
                if ("string" == typeof t || "object" == typeof t) {
                    var s;
                    let r = dq(this.props, t, null === (s = this.presenceContext) || void 0 === s ? void 0 : s.custom);
                    r && (i = r[e]);
                }
                if (t && void 0 !== i) return i;
                let n = this.getBaseTargetFromProps(this.props, e);
                return void 0 === n || dc(n)
                    ? void 0 !== this.initialValues[e] && void 0 === i
                        ? void 0
                        : this.baseTarget[e]
                    : n;
            }
            on(e, t) {
                return this.events[e] || (this.events[e] = new lH()), this.events[e].add(t);
            }
            notify(e, ...t) {
                this.events[e] && this.events[e].notify(...t);
            }
            constructor(
                {
                    parent: e,
                    props: t,
                    presenceContext: i,
                    reducedMotionConfig: s,
                    blockInitialAnimation: r,
                    visualState: n,
                },
                a = {}
            ) {
                var o;
                (this.current = null),
                    (this.children = new Set()),
                    (this.isVariantNode = !1),
                    (this.isControllingVariants = !1),
                    (this.shouldReduceMotion = null),
                    (this.values = new Map()),
                    (this.KeyframeResolver = cj),
                    (this.features = {}),
                    (this.valueSubscriptions = new Map()),
                    (this.prevMotionValues = {}),
                    (this.events = {}),
                    (this.propEventSubscriptions = {}),
                    (this.notifyUpdate = () => this.notify("Update", this.latestValues)),
                    (this.render = () => {
                        this.current &&
                            (this.triggerBuild(),
                            this.renderInstance(this.current, this.renderState, this.props.style, this.projection));
                    }),
                    (this.renderScheduledAt = 0),
                    (this.scheduleRender = () => {
                        let e = lO.now();
                        this.renderScheduledAt < e && ((this.renderScheduledAt = e), lq.render(this.render, !1, !0));
                    });
                let { latestValues: l, renderState: d, onUpdate: c } = n;
                (this.onUpdate = c),
                    (this.latestValues = l),
                    (this.baseTarget = { ...l }),
                    (this.initialValues = t.initial ? { ...l } : {}),
                    (this.renderState = d),
                    (this.parent = e),
                    (this.props = t),
                    (this.presenceContext = i),
                    (this.depth = e ? e.depth + 1 : 0),
                    (this.reducedMotionConfig = s),
                    (this.options = a),
                    (this.blockInitialAnimation = Boolean(r)),
                    (this.isControllingVariants = hQ(t)),
                    (this.isVariantNode = Boolean(hQ((o = t)) || o.variants)),
                    this.isVariantNode && (this.variantChildren = new Set()),
                    (this.manuallyAnimateOnMount = Boolean(e && e.current));
                let { willChange: h, ...u } = this.scrapeMotionValuesFromProps(t, {}, this);
                for (let p in u) {
                    let m = u[p];
                    void 0 !== l[p] && dc(m) && m.set(l[p], !1);
                }
            }
        },
        hZ = class e extends h5 {
            sortInstanceNodePosition(e, t) {
                return 2 & e.compareDocumentPosition(t) ? 1 : -1;
            }
            getBaseTargetFromProps(e, t) {
                return e.style ? e.style[t] : void 0;
            }
            removeValueFromRenderState(e, { vars: t, style: i }) {
                delete t[e], delete i[e];
            }
            handleChildMotionValue() {
                this.childSubscription && (this.childSubscription(), delete this.childSubscription);
                let { children: e } = this.props;
                dc(e) &&
                    (this.childSubscription = e.on("change", (e) => {
                        this.current && (this.current.textContent = `${e}`);
                    }));
            }
            constructor() {
                super(...arguments), (this.KeyframeResolver = cQ);
            }
        },
        ue = (e, t) => (t && "number" == typeof e ? t.transform(e) : e),
        ut = { x: "translateX", y: "translateY", z: "translateZ", transformPerspective: "perspective" },
        ui = dk.length;
    function us(e, t, i) {
        let { style: s, vars: r, transformOrigin: n } = e,
            a = !1,
            o = !1;
        for (let l in t) {
            let d = t[l];
            if (dT.has(l)) {
                a = !0;
                continue;
            }
            if (cG(l)) {
                r[l] = d;
                continue;
            }
            {
                let c = ue(d, c8[l]);
                l.startsWith("origin") ? ((o = !0), (n[l] = c)) : (s[l] = c);
            }
        }
        if (
            (!t.transform &&
                (a || i
                    ? (s.transform = (function e(t, i, s) {
                          let r = "",
                              n = !0;
                          for (let a = 0; a < ui; a++) {
                              let o = dk[a],
                                  l = t[o];
                              if (void 0 === l) continue;
                              let d = !0;
                              if (
                                  !(d =
                                      "number" == typeof l
                                          ? l === (o.startsWith("scale") ? 1 : 0)
                                          : 0 === parseFloat(l)) ||
                                  s
                              ) {
                                  let c = ue(l, c8[o]);
                                  if (!d) {
                                      n = !1;
                                      let h = ut[o] || o;
                                      r += `${h}(${c}) `;
                                  }
                                  s && (i[o] = c);
                              }
                          }
                          return (r = r.trim()), s ? (r = s(i, n ? "" : r)) : n && (r = "none"), r;
                      })(t, e.transform, i))
                    : s.transform && (s.transform = "none")),
            o)
        ) {
            let { originX: h = "50%", originY: u = "50%", originZ: p = 0 } = n;
            s.transformOrigin = `${h} ${u} ${p}`;
        }
    }
    let ur = { offset: "stroke-dashoffset", array: "stroke-dasharray" },
        un = { offset: "strokeDashoffset", array: "strokeDasharray" };
    function ua(e, t, i) {
        return "string" == typeof e ? e : ci.transform(t + i * e);
    }
    let uo = new Set([
            "baseFrequency",
            "diffuseConstant",
            "kernelMatrix",
            "kernelUnitLength",
            "keySplines",
            "keyTimes",
            "limitingConeAngle",
            "markerHeight",
            "markerWidth",
            "numOctaves",
            "targetX",
            "targetY",
            "surfaceScale",
            "specularConstant",
            "specularExponent",
            "stdDeviation",
            "tableValues",
            "viewBox",
            "gradientTransform",
            "pathLength",
            "startOffset",
            "textLength",
            "lengthAdjust",
        ]),
        ul = (e) => "string" == typeof e && "svg" === e.toLowerCase();
    function ud(e, { style: t, vars: i }, s, r) {
        for (let n in (Object.assign(e.style, t, r && r.getProjectionStyles(s)), i)) e.style.setProperty(n, i[n]);
    }
    let uc = {};
    function uh(e, { layout: t, layoutId: i }) {
        return dT.has(e) || e.startsWith("origin") || ((t || void 0 !== i) && (!!uc[e] || "opacity" === e));
    }
    function uu(e, t, i) {
        let { style: s } = e,
            r = {};
        for (let n in s) {
            var a;
            (dc(s[n]) ||
                (t.style && dc(t.style[n])) ||
                uh(n, e) ||
                (null === (a = null == i ? void 0 : i.getValue(n)) || void 0 === a ? void 0 : a.liveStyle) !==
                    void 0) &&
                (r[n] = s[n]);
        }
        return r;
    }
    let up = class e extends hZ {
            getBaseTargetFromProps(e, t) {
                return e[t];
            }
            readValueFromInstance(e, t) {
                if (dT.has(t)) {
                    let i = cE(t);
                    return (i && i.default) || 0;
                }
                return (t = uo.has(t) ? t : d9(t)), e.getAttribute(t);
            }
            scrapeMotionValuesFromProps(e, t, i) {
                return (function e(t, i, s) {
                    let r = uu(t, i, s);
                    for (let n in t)
                        if (dc(t[n]) || dc(i[n])) {
                            let a = -1 !== dk.indexOf(n) ? "attr" + n.charAt(0).toUpperCase() + n.substring(1) : n;
                            r[a] = t[n];
                        }
                    return r;
                })(e, t, i);
            }
            onBindTransform() {
                this.current && !this.renderState.dimensions && lq.postRender(this.updateDimensions);
            }
            build(e, t, i) {
                !(function e(
                    t,
                    {
                        attrX: i,
                        attrY: s,
                        attrScale: r,
                        originX: n,
                        originY: a,
                        pathLength: o,
                        pathSpacing: l = 1,
                        pathOffset: d = 0,
                        ...c
                    },
                    h,
                    u
                ) {
                    if ((us(t, c, u), h)) {
                        t.style.viewBox && (t.attrs.viewBox = t.style.viewBox);
                        return;
                    }
                    (t.attrs = t.style), (t.style = {});
                    let { attrs: p, style: m, dimensions: f } = t;
                    p.transform && (f && (m.transform = p.transform), delete p.transform),
                        f &&
                            (void 0 !== n || void 0 !== a || m.transform) &&
                            (m.transformOrigin = (function e(t, i, s) {
                                let r = ua(i, t.x, t.width),
                                    n = ua(s, t.y, t.height);
                                return `${r} ${n}`;
                            })(f, void 0 !== n ? n : 0.5, void 0 !== a ? a : 0.5)),
                        void 0 !== i && (p.x = i),
                        void 0 !== s && (p.y = s),
                        void 0 !== r && (p.scale = r),
                        void 0 !== o &&
                            (function e(t, i, s = 1, r = 0, n = !0) {
                                t.pathLength = 1;
                                let a = n ? ur : un;
                                t[a.offset] = ci.transform(-r);
                                let o = ci.transform(i),
                                    l = ci.transform(s);
                                t[a.array] = `${o} ${l}`;
                            })(p, o, l, d, !1);
                })(e, t, this.isSVGTag, i.transformTemplate);
            }
            renderInstance(e, t, i, s) {
                !(function e(t, i, s, r) {
                    for (let n in (ud(t, i, void 0, r), i.attrs)) t.setAttribute(uo.has(n) ? n : d9(n), i.attrs[n]);
                })(e, t, i, s);
            }
            mount(e) {
                (this.isSVGTag = ul(e.tagName)), super.mount(e);
            }
            constructor() {
                super(...arguments),
                    (this.type = "svg"),
                    (this.isSVGTag = !1),
                    (this.measureInstanceViewportBox = h3),
                    (this.updateDimensions = () => {
                        this.current &&
                            !this.renderState.dimensions &&
                            (function e(t, i) {
                                try {
                                    i.dimensions =
                                        "function" == typeof t.getBBox ? t.getBBox() : t.getBoundingClientRect();
                                } catch (s) {
                                    i.dimensions = { x: 0, y: 0, width: 0, height: 0 };
                                }
                            })(this.current, this.renderState);
                    });
            }
        },
        um = class e extends hZ {
            readValueFromInstance(e, t) {
                if (dT.has(t)) return cD(e, t);
                {
                    var i;
                    let s = ((i = e), window.getComputedStyle(i)),
                        r = (cG(t) ? s.getPropertyValue(t) : s[t]) || 0;
                    return "string" == typeof r ? r.trim() : r;
                }
            }
            measureInstanceViewportBox(e, { transformPagePoint: t }) {
                var i, s;
                return (
                    (i = e),
                    (s = t),
                    (function e({ top: t, left: i, right: s, bottom: r }) {
                        return { x: { min: i, max: s }, y: { min: t, max: r } };
                    })(
                        (function e(t, i) {
                            if (!i) return t;
                            let s = i({ x: t.left, y: t.top }),
                                r = i({ x: t.right, y: t.bottom });
                            return { top: s.y, left: s.x, bottom: r.y, right: r.x };
                        })(i.getBoundingClientRect(), s)
                    )
                );
            }
            build(e, t, i) {
                us(e, t, i.transformTemplate);
            }
            scrapeMotionValuesFromProps(e, t, i) {
                return uu(e, t, i);
            }
            constructor() {
                super(...arguments), (this.type = "html"), (this.renderInstance = ud);
            }
        };
    function uf(e, t) {
        return e in t;
    }
    let ug = class e extends h5 {
        readValueFromInstance(e, t) {
            var i, s;
            if (((i = t), i in (s = e))) {
                let r = e[t];
                if ("string" == typeof r || "number" == typeof r) return r;
            }
        }
        getBaseTargetFromProps() {}
        removeValueFromRenderState(e, t) {
            delete t.output[e];
        }
        measureInstanceViewportBox() {
            return h3();
        }
        build(e, t) {
            Object.assign(e.output, t);
        }
        renderInstance(e, { output: t }) {
            Object.assign(e, t);
        }
        sortInstanceNodePosition() {
            return 0;
        }
        constructor() {
            super(...arguments), (this.type = "object");
        }
    };
    function uy(e) {
        var t;
        let i = {
                presenceContext: null,
                props: {},
                visualState: {
                    renderState: { transform: {}, transformOrigin: {}, style: {}, vars: {}, attrs: {} },
                    latestValues: {},
                },
            },
            s = (t = e) instanceof SVGElement && "svg" !== t.tagName ? new up(i) : new um(i);
        s.mount(e), dx.set(e, s);
    }
    function uv(e) {
        let t = new ug({
            presenceContext: null,
            props: {},
            visualState: { renderState: { output: {} }, latestValues: {} },
        });
        t.mount(e), dx.set(e, t);
    }
    function ub(e, t, i, s) {
        var r, n;
        let a = [];
        if (((r = e), (n = t), dc(r) || "number" == typeof r || ("string" == typeof r && !dh(n))))
            a.push(
                (function e(t, i, s) {
                    let r = dc(t) ? t : lz(t);
                    return r.start(hz("", r, i, s)), r.animation;
                })(e, (dh(t) && t.default) || t, (i && i.default) || i)
            );
        else {
            let o = du(e, t, s),
                l = o.length;
            lU(Boolean(l), "No valid elements provided.");
            for (let d = 0; d < l; d++) {
                let c = o[d],
                    h = c instanceof Element ? uy : uv;
                dx.has(c) || h(c);
                let u = dx.get(c),
                    p = { ...i };
                "delay" in p && "function" == typeof p.delay && (p.delay = p.delay(d, l)),
                    a.push(...hj(u, { ...t, transition: p }, {}));
            }
        }
        return a;
    }
    let u$ = function e(t, i, s) {
        var r;
        let n = [];
        n =
            Array.isArray((r = t)) && r.some(Array.isArray)
                ? (function e(t, i, s) {
                      let r = [],
                          n = (function e(t, { defaultTransition: i = {}, ...s } = {}, r, n) {
                              let a = i.duration || 0.3,
                                  o = new Map(),
                                  l = new Map(),
                                  d = {},
                                  c = new Map(),
                                  h = 0,
                                  u = 0,
                                  p = 0;
                              for (let m = 0; m < t.length; m++) {
                                  let f = t[m];
                                  if ("string" == typeof f) {
                                      c.set(f, u);
                                      continue;
                                  }
                                  if (!Array.isArray(f)) {
                                      c.set(f.name, dm(u, f.at, h, c));
                                      continue;
                                  }
                                  let [g, y, v = {}] = f;
                                  void 0 !== v.at && (u = dm(u, v.at, h, c));
                                  let b = 0,
                                      $ = (e, t, s, r = 0, o = 0) => {
                                          let l = dw(e),
                                              {
                                                  delay: d = 0,
                                                  times: c = dd(l),
                                                  type: h = "keyframes",
                                                  repeat: m,
                                                  repeatType: f,
                                                  repeatDelay: g = 0,
                                                  ...y
                                              } = t,
                                              { ease: v = i.ease || "easeOut", duration: $ } = t,
                                              w = "function" == typeof d ? d(r, o) : d,
                                              S = l.length,
                                              E = dv(h) ? h : null == n ? void 0 : n[h];
                                          if (S <= 2 && E) {
                                              let x = 100;
                                              if (2 === S && dE(l)) {
                                                  let k = l[1] - l[0];
                                                  x = Math.abs(k);
                                              }
                                              let T = { ...y };
                                              void 0 !== $ && (T.duration = l2($));
                                              let L = l6(T, x, E);
                                              (v = L.ease), ($ = L.duration);
                                          }
                                          null != $ || ($ = a);
                                          let _ = u + w;
                                          1 === c.length && 0 === c[0] && (c[1] = 1);
                                          let A = c.length - l.length;
                                          if ((A > 0 && dl(c, A), 1 === l.length && l.unshift(null), m)) {
                                              var C, q;
                                              lU(m < 20, "Repeat count too high, must be less than 20"),
                                                  ($ = ((C = $), C * ((q = m) + 1)));
                                              let I = [...l],
                                                  P = [...c];
                                              v = Array.isArray(v) ? [...v] : [v];
                                              let M = [...v];
                                              for (let D = 0; D < m; D++) {
                                                  l.push(...I);
                                                  for (let O = 0; O < I.length; O++)
                                                      c.push(P[O] + (D + 1)), v.push(0 === O ? "linear" : dn(M, O - 1));
                                              }
                                              dg(c, m);
                                          }
                                          let F = _ + $;
                                          df(s, l, v, c, _, F), (b = Math.max(w + $, b)), (p = Math.max(F, p));
                                      };
                                  if (dc(g)) {
                                      let w = db(g, l);
                                      $(y, v, d$("default", w));
                                  } else {
                                      let S = du(g, y, r, d),
                                          E = S.length;
                                      for (let x = 0; x < E; x++) {
                                          let k = S[x],
                                              T = db(k, l);
                                          for (let L in y) $(y[L], d8(v, L), d$(L, T), x, E);
                                      }
                                  }
                                  (h = u), (u += b);
                              }
                              return (
                                  l.forEach((e, t) => {
                                      for (let r in e) {
                                          let n = e[r];
                                          n.sort(dy);
                                          let a = [],
                                              l = [],
                                              d = [];
                                          for (let c = 0; c < n.length; c++) {
                                              let { at: h, value: u, easing: m } = n[c];
                                              a.push(u), l.push(l3(0, p, h)), d.push(m || "easeOut");
                                          }
                                          0 !== l[0] && (l.unshift(0), a.unshift(a[0]), d.unshift("easeInOut")),
                                              1 !== l[l.length - 1] && (l.push(1), a.push(null)),
                                              o.has(t) || o.set(t, { keyframes: {}, transition: {} });
                                          let f = o.get(t);
                                          (f.keyframes[r] = a),
                                              (f.transition[r] = { ...i, duration: p, ease: d, times: l, ...s });
                                      }
                                  }),
                                  o
                              );
                          })(t, i, s, { spring: di });
                      return (
                          n.forEach(({ keyframes: e, transition: t }, i) => {
                              r.push(...ub(i, e, t));
                          }),
                          r
                      );
                  })(t, i, S)
                : ub(t, i, s, S);
        let a = new hN(n);
        return a;
    };
    function uw(e, t) {
        let i,
            s = () => {
                let { currentTime: s } = t,
                    r = null === s ? 0 : s.value,
                    n = r / 100;
                i !== n && e(n), (i = n);
            };
        return lq.update(s, !0), () => lI(s);
    }
    let u8 = new WeakMap(),
        uS;
    function uE({ target: e, contentRect: t, borderBoxSize: i }) {
        var s;
        null === (s = u8.get(e)) ||
            void 0 === s ||
            s.forEach((s) => {
                s({
                    target: e,
                    contentSize: t,
                    get size() {
                        return (function e(t, i) {
                            if (i) {
                                let { inlineSize: s, blockSize: r } = i[0];
                                return { width: s, height: r };
                            }
                            return t instanceof SVGElement && "getBBox" in t
                                ? t.getBBox()
                                : { width: t.offsetWidth, height: t.offsetHeight };
                        })(e, i);
                    },
                });
            });
    }
    function ux(e) {
        e.forEach(uE);
    }
    let uk = new Set(),
        uT,
        uL = () => ({
            current: 0,
            offset: [],
            progress: 0,
            scrollLength: 0,
            targetOffset: 0,
            targetLength: 0,
            containerLength: 0,
            velocity: 0,
        }),
        u_ = () => ({ time: 0, x: uL(), y: uL() }),
        uA = { x: { length: "Width", position: "Left" }, y: { length: "Height", position: "Top" } };
    function uC(e, t, i, s) {
        let r = i[t],
            { length: n, position: a } = uA[t],
            o = r.current,
            l = i.time;
        (r.current = e[`scroll${a}`]),
            (r.scrollLength = e[`scroll${n}`] - e[`client${n}`]),
            (r.offset.length = 0),
            (r.offset[0] = 0),
            (r.offset[1] = r.scrollLength),
            (r.progress = l3(0, r.scrollLength, r.current));
        let d = s - l;
        r.velocity = d > 50 ? 0 : lW(r.current - o, d);
    }
    let uq = { start: 0, center: 0.5, end: 1 };
    function uI(e, t, i = 0) {
        let s = 0;
        if ((e in uq && (e = uq[e]), "string" == typeof e)) {
            let r = parseFloat(e);
            e.endsWith("px")
                ? (s = r)
                : e.endsWith("%")
                  ? (e = r / 100)
                  : e.endsWith("vw")
                    ? (s = (r / 100) * document.documentElement.clientWidth)
                    : e.endsWith("vh")
                      ? (s = (r / 100) * document.documentElement.clientHeight)
                      : (e = r);
        }
        return "number" == typeof e && (s = t * e), i + s;
    }
    let uP = [0, 0];
    function u9(e, t, i, s) {
        let r = Array.isArray(e) ? e : uP,
            n = 0,
            a = 0;
        return (
            "number" == typeof e
                ? (r = [e, e])
                : "string" == typeof e && (r = (e = e.trim()).includes(" ") ? e.split(" ") : [e, uq[e] ? e : "0"]),
            (n = uI(r[0], i, s)),
            (a = uI(r[1], t)),
            n - a
        );
    }
    let uM = {
            Enter: [
                [0, 1],
                [1, 1],
            ],
            Exit: [
                [0, 0],
                [1, 0],
            ],
            Any: [
                [1, 0],
                [0, 1],
            ],
            All: [
                [0, 0],
                [1, 1],
            ],
        },
        uD = { x: 0, y: 0 },
        uO = new WeakMap(),
        uF = new WeakMap(),
        uB = new WeakMap(),
        uV = (e) => (e === document.documentElement ? window : e);
    function uH(e, { container: t = document.documentElement, ...i } = {}) {
        let s = uB.get(t);
        s || ((s = new Set()), uB.set(t, s));
        let r = u_(),
            n = (function e(t, i, s, r = {}) {
                return {
                    measure: () =>
                        (function e(t, i = t, s) {
                            if (((s.x.targetOffset = 0), (s.y.targetOffset = 0), i !== t)) {
                                let r = i;
                                for (; r && r !== t; )
                                    (s.x.targetOffset += r.offsetLeft),
                                        (s.y.targetOffset += r.offsetTop),
                                        (r = r.offsetParent);
                            }
                            (s.x.targetLength = i === t ? i.scrollWidth : i.clientWidth),
                                (s.y.targetLength = i === t ? i.scrollHeight : i.clientHeight),
                                (s.x.containerLength = t.clientWidth),
                                (s.y.containerLength = t.clientHeight),
                                "production" !== process.env.NODE_ENV &&
                                    t &&
                                    i &&
                                    i !== t &&
                                    lB(
                                        "static" !== getComputedStyle(t).position,
                                        "Please ensure that the container has a non-static position, like 'relative', 'fixed', or 'absolute' to ensure scroll offset is calculated correctly."
                                    );
                        })(t, r.target, s),
                    update(e) {
                        var i, n, a;
                        (i = t),
                            (n = s),
                            uC(i, "x", n, (a = e)),
                            uC(i, "y", n, a),
                            (n.time = a),
                            (r.offset || r.target) &&
                                (function e(t, i, s) {
                                    var r;
                                    let { offset: n = uM.All } = s,
                                        { target: a = t, axis: o = "y" } = s,
                                        l = "y" === o ? "height" : "width",
                                        d =
                                            a !== t
                                                ? (function e(t, i) {
                                                      let s = { x: 0, y: 0 },
                                                          r = t;
                                                      for (; r && r !== i; )
                                                          if (r instanceof HTMLElement)
                                                              (s.x += r.offsetLeft),
                                                                  (s.y += r.offsetTop),
                                                                  (r = r.offsetParent);
                                                          else if ("svg" === r.tagName) {
                                                              let n = r.getBoundingClientRect();
                                                              r = r.parentElement;
                                                              let a = r.getBoundingClientRect();
                                                              (s.x += n.left - a.left), (s.y += n.top - a.top);
                                                          } else if (r instanceof SVGGraphicsElement) {
                                                              let { x: o, y: l } = r.getBBox();
                                                              (s.x += o), (s.y += l);
                                                              let d = null,
                                                                  c = r.parentNode;
                                                              for (; !d; )
                                                                  "svg" === c.tagName && (d = c), (c = r.parentNode);
                                                              r = d;
                                                          } else break;
                                                      return s;
                                                  })(a, t)
                                                : uD,
                                        c =
                                            a === t
                                                ? { width: t.scrollWidth, height: t.scrollHeight }
                                                : "getBBox" in (r = a) && "svg" !== r.tagName
                                                  ? r.getBBox()
                                                  : { width: r.clientWidth, height: r.clientHeight },
                                        h = { width: t.clientWidth, height: t.clientHeight };
                                    i[o].offset.length = 0;
                                    let u = !i[o].interpolate,
                                        p = n.length;
                                    for (let m = 0; m < p; m++) {
                                        let f = u9(n[m], h[l], c[l], d[o]);
                                        u || f === i[o].interpolatorOffsets[m] || (u = !0), (i[o].offset[m] = f);
                                    }
                                    u &&
                                        ((i[o].interpolate = hE(i[o].offset, dd(n), { clamp: !1 })),
                                        (i[o].interpolatorOffsets = [...i[o].offset])),
                                        (i[o].progress = lG(0, 1, i[o].interpolate(i[o].current)));
                                })(t, s, r);
                    },
                    notify: () => i(s),
                };
            })(t, e, r, i);
        if ((s.add(n), !uO.has(t))) {
            let a = () => {
                    for (let e of s) e.measure();
                },
                o = () => {
                    for (let e of s) e.update(lP.timestamp);
                },
                l = () => {
                    for (let e of s) e.notify();
                },
                d = () => {
                    lq.read(a, !1, !0), lq.read(o, !1, !0), lq.update(l, !1, !0);
                };
            uO.set(t, d);
            let c = uV(t);
            if ((window.addEventListener("resize", d, { passive: !0 }), t !== document.documentElement)) {
                var h, u, p;
                uF.set(
                    t,
                    ((h = t),
                    (u = d),
                    "function" == typeof h
                        ? ((p = h),
                          uk.add(p),
                          uT ||
                              ((uT = () => {
                                  let e = { width: window.innerWidth, height: window.innerHeight },
                                      t = { target: window, size: e, contentSize: e };
                                  uk.forEach((e) => e(t));
                              }),
                              window.addEventListener("resize", uT)),
                          () => {
                              uk.delete(p), !uk.size && uT && (uT = void 0);
                          })
                        : (function e(t, i) {
                              uS || "undefined" == typeof ResizeObserver || (uS = new ResizeObserver(ux));
                              let s = l0(t);
                              return (
                                  s.forEach((e) => {
                                      let t = u8.get(e);
                                      t || ((t = new Set()), u8.set(e, t)), t.add(i), null == uS || uS.observe(e);
                                  }),
                                  () => {
                                      s.forEach((e) => {
                                          let t = u8.get(e);
                                          null == t || t.delete(i),
                                              (null == t ? void 0 : t.size) || null == uS || uS.unobserve(e);
                                      });
                                  }
                              );
                          })(h, u))
                );
            }
            c.addEventListener("scroll", d, { passive: !0 });
        }
        let m = uO.get(t);
        return (
            lq.read(m, !1, !0),
            () => {
                lI(m);
                let e = uB.get(t);
                if (!e || (e.delete(n), e.size)) return;
                let i = uO.get(t);
                if ((uO.delete(t), i)) {
                    var s;
                    uV(t).removeEventListener("scroll", i),
                        null === (s = uF.get(t)) || void 0 === s || s(),
                        window.removeEventListener("resize", i);
                }
            }
        );
    }
    let uW = new Map();
    function uR({ source: e, container: t = document.documentElement, axis: i = "y" } = {}) {
        e && (t = e), uW.has(t) || uW.set(t, {});
        let s = uW.get(t);
        return (
            s[i] ||
                (s[i] = hW()
                    ? new ScrollTimeline({ source: t, axis: i })
                    : (function e({ source: t, container: i, axis: s = "y" }) {
                          t && (i = t);
                          let r = { value: 0 },
                              n = uH(
                                  (e) => {
                                      r.value = 100 * e[s].progress;
                                  },
                                  { container: i, axis: s }
                              );
                          return { currentTime: r, cancel: n };
                      })({ source: t, axis: i })),
            s[i]
        );
    }
    function uN(e) {
        return e && (e.target || e.offset);
    }
    function uz(e, { axis: t = "y", ...i } = {}) {
        var s, r, n;
        let a = { axis: t, ...i };
        return "function" == typeof e
            ? ((s = e),
              (r = a),
              2 === (n = s).length || uN(r)
                  ? uH((e) => {
                        s(e[r.axis].progress, e);
                    }, r)
                  : uw(s, uR(r)))
            : (function e(t, i) {
                  if ((t.flatten(), uN(i)))
                      return (
                          t.pause(),
                          uH((e) => {
                              t.time = t.duration * e[i.axis].progress;
                          }, i)
                      );
                  {
                      let s = uR(i);
                      return t.attachTimeline
                          ? t.attachTimeline(
                                s,
                                (e) => (
                                    e.pause(),
                                    uw((t) => {
                                        e.time = e.duration * t;
                                    }, s)
                                )
                            )
                          : lC;
                  }
              })(e, a);
    }
    let u0 = { some: 0, all: 1 };
    function uj(e, t, { root: i, margin: s, amount: r = "some" } = {}) {
        let n = l0(e),
            a = new WeakMap(),
            o = (e) => {
                e.forEach((e) => {
                    let i = a.get(e.target);
                    if (e.isIntersecting !== Boolean(i)) {
                        if (e.isIntersecting) {
                            let s = t(e.target, e);
                            "function" == typeof s ? a.set(e.target, s) : l.unobserve(e.target);
                        } else "function" == typeof i && (i(e), a.delete(e.target));
                    }
                });
            },
            l = new IntersectionObserver(o, { root: i, rootMargin: s, threshold: "number" == typeof r ? r : u0[r] });
        return n.forEach((e) => l.observe(e)), () => l.disconnect();
    }
    function uU(e = 0.1, { startDelay: t = 0, from: i = 0, ease: s } = {}) {
        return (r, n) => {
            let a =
                    "number" == typeof i
                        ? i
                        : (function e(t, i) {
                              if ("first" === t) return 0;
                              {
                                  let s = i - 1;
                                  return "last" === t ? s : s / 2;
                              }
                          })(i, n),
                o = e * Math.abs(a - r);
            if (s) {
                let l = n * e,
                    d = hS(s);
                o = d(o / l) * l;
            }
            return t + o;
        };
    }
    let u3 = (e) => e && "object" == typeof e && e.mix,
        uG = (e) => (u3(e) ? e.mix : void 0);
    function u1(...e) {
        let t = !Array.isArray(e[0]),
            i = t ? 0 : -1,
            s = e[0 + i],
            r = e[1 + i],
            n = e[2 + i],
            a = e[3 + i],
            o = hE(r, n, { mixer: uG(n[0]), ...a });
        return t ? o(s) : o;
    }
    class uK extends Error {
        constructor(e, t) {
            super(e), (this.el = t);
        }
    }
    class u2 extends Error {
        constructor(e, t, i) {
            super(e), (this.el = t), (this.unfinished = i);
        }
    }
    async function u4(e, t = {}) {
        return new Promise((i, s) => {
            let r = 50;
            (null == t ? void 0 : t.startTimeout) !== void 0 && (r = !1 === t.startTimeout ? 0 : t.startTimeout),
                setTimeout(() => {
                    let r = e.getAnimations(t);
                    t.excludeSubtree && (r = u6(r, t.excludeSubtree)),
                        0 === r.length
                            ? s(
                                  (function e(t, i = !1) {
                                      return i
                                          ? new uK(
                                                "Expected animations or transitions to start on element or its descendants, but none did after waiting 50ms",
                                                t
                                            )
                                          : new uK(
                                                "Expected animations or transitions to start on element, but none did after waiting 50ms",
                                                t
                                            );
                                  })(e, null == t ? void 0 : t.subtree)
                              )
                            : i(r);
                }, r);
        });
    }
    async function uX(e, t, i = !1, s) {
        let r = [];
        s && (t = u6(t, s));
        let n = t.map((e) => e.finished);
        var a,
            o = 2e3;
        if (
            (await ((a = n), Promise.allSettled(a.map((e) => uY(e, 2e3)))).then((e) => {
                e.forEach((e, i) => {
                    "rejected" === e.status && "timeout" === e.reason && (r = [...r, t[i]]);
                });
            }),
            r.length > 0)
        )
            throw (function e(t, i, s, r = !1) {
                return r
                    ? new u2(
                          `Expected all animations or transitions on element and its descendants to finish within 2000ms, but ${s.length} of ${i.length} did not`,
                          t,
                          s
                      )
                    : new u2(
                          `Expected all animations or transitions on element to finish within 2000ms, but ${s.length} of ${i.length} did not`,
                          t,
                          s
                      );
            })(e, t, r, i);
        return t;
    }
    async function uY(e, t) {
        let i,
            s = new Promise((e, s) => {
                i = setTimeout(() => {
                    s("timeout");
                }, t);
            });
        return Promise.race([e, s])
            .then((e) => (clearTimeout(i), e))
            .catch((e) => {
                throw (clearTimeout(i), e);
            });
    }
    function u6(e, t) {
        let i = (e) => {
            let i = e.parentElement;
            for (; i; ) {
                if (t(i)) return !0;
                i = i.parentElement;
            }
            return !1;
        };
        return e.filter((e) => {
            var s;
            if (!((s = e.effect) instanceof KeyframeEffect)) return !0;
            {
                let r = e.effect.target;
                return !r || (!t(r) && !i(r));
            }
        });
    }
    function uJ(e) {
        var t;
        let i = {
            isExpanded: null !== (t = null == e ? void 0 : e.isExpanded) && void 0 !== t && t,
            expand() {
                this.isExpanded = !0;
            },
            collapse() {
                this.isExpanded = !1;
            },
            toggle() {
                this.isExpanded = !this.isExpanded;
            },
            get isCollapsed() {
                return !this.isExpanded;
            },
        };
        if ((null == e ? void 0 : e.isExpanded) !== void 0) {
            let s = Object.getOwnPropertyDescriptor(e, "isExpanded");
            Object.defineProperty(i, "isExpanded", s);
        }
        return i;
    }
    ((E = I || (I = {})).INSPECTOR_ACTIVATED = "shopify:inspector:activate"),
        (E.INSPECTOR_DEACTIVATED = "shopify:inspector:deactivate"),
        (E.SECTION_LOAD = "shopify:section:load"),
        (E.SECTION_UNLOAD = "shopify:section:unload"),
        (E.SECTION_SELECT = "shopify:section:select"),
        (E.SECTION_DESELECT = "shopify:section:deselect"),
        (E.SECTION_REORDER = "shopify:section:reorder"),
        (E.BLOCK_SELECT = "shopify:block:select"),
        (E.BLOCK_DESELECT = "shopify:block:deselect"),
        ((x = P || (P = {})).CART_ITEM_ADD = "theme:cart-item:add"),
        (x.CART_ITEM_UPDATE = "theme:cart-item:update"),
        (x.THEME_SECTION_NAVIGATE = "theme:section:navigate"),
        (x.THEME_SECTION_LOAD = "theme:section:load"),
        (x.THEME_SECTION_UPDATE = "theme:section:update");
    let uQ = {
            isInspectorActive: !1,
            selectedSectionId: null,
            prevSelectedSectionId: null,
            selectedBlock: null,
            prevSelectedBlock: null,
            get selectedSection() {
                if (!this.selectedSectionId) return null;
                return document.getElementById(`shopify-section-${this.selectedSectionId}`);
            },
            get prevSelectedSection() {
                if (!this.prevSelectedSectionId) return null;
                return document.getElementById(`shopify-section-${this.prevSelectedSectionId}`);
            },
            init() {
                window.addEventListener(I.INSPECTOR_ACTIVATED, () => {
                    var e;
                    if (!(null === (e = window.Shopify) || void 0 === e ? void 0 : e.designMode)) return !1;
                    this.isInspectorActive = !0;
                }),
                    window.addEventListener(I.INSPECTOR_DEACTIVATED, () => {
                        var e;
                        if (!(null === (e = window.Shopify) || void 0 === e ? void 0 : e.designMode)) return !1;
                        this.isInspectorActive = !1;
                    }),
                    window.addEventListener(I.SECTION_SELECT, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        (this.prevSelectedSectionId = this.selectedSectionId),
                            (this.selectedSectionId = e.detail.sectionId);
                    }),
                    window.addEventListener(I.SECTION_DESELECT, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        (this.prevSelectedSectionId = this.selectedSectionId), (this.selectedSectionId = null);
                    }),
                    window.addEventListener(I.BLOCK_SELECT, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        (this.prevSelectedBlock = this.selectedBlock), (this.selectedBlock = e.target);
                    }),
                    window.addEventListener(I.BLOCK_DESELECT, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        (this.prevSelectedBlock = this.selectedBlock), (this.selectedBlock = null);
                    }),
                    window.addEventListener(I.SECTION_LOAD, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                    }),
                    window.addEventListener(I.SECTION_UNLOAD, (e) => {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                    });
            },
        },
        u7 = () => {};
    "production" !== process.env.NODE_ENV &&
        (u7 = (e, t) => {
            if (!e) throw Error(t);
        });
    let u5 = {};
    function uZ(e) {
        let t;
        return () => (void 0 === t && (t = e()), t);
    }
    let pe = (e) => e,
        pt = (e) => 1e3 * e,
        pi = (e) => e / 1e3,
        ps = uZ(() => void 0 !== window.ScrollTimeline),
        pr = class e {
            get finished() {
                return Promise.all(this.animations.map((e) => e.finished));
            }
            getAll(e) {
                return this.animations[0][e];
            }
            setAll(e, t) {
                for (let i = 0; i < this.animations.length; i++) this.animations[i][e] = t;
            }
            attachTimeline(e, t) {
                let i = this.animations.map((i) =>
                    ps() && i.attachTimeline ? i.attachTimeline(e) : "function" == typeof t ? t(i) : void 0
                );
                return () => {
                    i.forEach((e, t) => {
                        e && e(), this.animations[t].stop();
                    });
                };
            }
            get time() {
                return this.getAll("time");
            }
            set time(e) {
                this.setAll("time", e);
            }
            get speed() {
                return this.getAll("speed");
            }
            set speed(e) {
                this.setAll("speed", e);
            }
            get startTime() {
                return this.getAll("startTime");
            }
            get duration() {
                let e = 0;
                for (let t = 0; t < this.animations.length; t++) e = Math.max(e, this.animations[t].duration);
                return e;
            }
            runAll(e) {
                this.animations.forEach((t) => t[e]());
            }
            flatten() {
                this.runAll("flatten");
            }
            play() {
                this.runAll("play");
            }
            pause() {
                this.runAll("pause");
            }
            cancel() {
                this.runAll("cancel");
            }
            complete() {
                this.runAll("complete");
            }
            constructor(e) {
                (this.stop = () => this.runAll("stop")), (this.animations = e.filter(Boolean));
            }
        },
        pn = (e) => e.startsWith("--"),
        pa = {
            set(e, t, i) {
                pn(t) ? e.style.setProperty(t, i) : (e.style[t] = i);
            },
            get: (e, t) => (pn(t) ? e.style.getPropertyValue(t) : e.style[t]),
        },
        po = (e) => null !== e,
        pl = uZ(() => {
            try {
                document.createElement("div").animate({ opacity: [1] });
            } catch (e) {
                return !1;
            }
            return !0;
        }),
        pd = new Set([
            "borderWidth",
            "borderTopWidth",
            "borderRightWidth",
            "borderBottomWidth",
            "borderLeftWidth",
            "borderRadius",
            "radius",
            "borderTopLeftRadius",
            "borderTopRightRadius",
            "borderBottomRightRadius",
            "borderBottomLeftRadius",
            "width",
            "maxWidth",
            "height",
            "maxHeight",
            "top",
            "right",
            "bottom",
            "left",
            "padding",
            "paddingTop",
            "paddingRight",
            "paddingBottom",
            "paddingLeft",
            "margin",
            "marginTop",
            "marginRight",
            "marginBottom",
            "marginLeft",
            "backgroundPositionX",
            "backgroundPositionY",
        ]),
        pc = (e) => Array.isArray(e) && "number" == typeof e[0],
        ph = {},
        pu = (function e(t, i) {
            var s;
            let r = uZ(t);
            return () => (null !== (s = ph[i]) && void 0 !== s ? s : r());
        })(() => {
            try {
                document.createElement("div").animate({ opacity: 0 }, { easing: "linear(0, 1)" });
            } catch (e) {
                return !1;
            }
            return !0;
        }, "linearEasing"),
        pp = (e, t, i = 10) => {
            let s = "",
                r = Math.max(Math.round(t / i), 2);
            for (let n = 0; n < r; n++) s += e(n / (r - 1)) + ", ";
            return `linear(${s.substring(0, s.length - 2)})`;
        },
        pm = ([e, t, i, s]) => `cubic-bezier(${e}, ${t}, ${i}, ${s})`,
        pf = {
            linear: "linear",
            ease: "ease",
            easeIn: "ease-in",
            easeOut: "ease-out",
            easeInOut: "ease-in-out",
            circIn: pm([0, 0.65, 0.55, 1]),
            circOut: pm([0.55, 0, 1, 0.45]),
            backIn: pm([0.31, 0.01, 0.66, -0.59]),
            backOut: pm([0.33, 1.53, 0.69, 0.99]),
        };
    function pg(e, t) {
        if (e)
            return "function" == typeof e && pu()
                ? pp(e, t)
                : pc(e)
                  ? pm(e)
                  : Array.isArray(e)
                    ? e.map((e) => pg(e, t) || pf.easeOut)
                    : pf[e];
    }
    function py({ type: e, ...t }) {
        var i, s, r;
        return "function" == typeof (i = e) && "applyToOptions" in i
            ? e.applyToOptions(t)
            : ((null !== (s = t.duration) && void 0 !== s) || (t.duration = 300),
              (null !== (r = t.ease) && void 0 !== r) || (t.ease = "easeOut"),
              t);
    }
    let pv = new WeakMap(),
        pb = class e {
            play() {
                this.animation.play();
            }
            pause() {
                this.animation.pause();
            }
            complete() {
                this.animation.finish();
            }
            cancel() {
                try {
                    this.animation.cancel();
                } catch (e) {}
                this.removeAnimation();
            }
            stop() {
                let { state: e } = this;
                "idle" !== e && "finished" !== e && (this.commitStyles(), this.cancel());
            }
            commitStyles() {
                if (!this.isPseudoElement) {
                    var e, t;
                    null === (t = (e = this.animation).commitStyles) || void 0 === t || t.call(e);
                }
            }
            get duration() {
                var e;
                let t =
                    (null === (e = this.animation.effect) || void 0 === e ? void 0 : e.getComputedTiming().duration) ||
                    0;
                return pi(Number(t));
            }
            get time() {
                return pi(Number(this.animation.currentTime) || 0);
            }
            set time(e) {
                this.animation.currentTime = pt(e);
            }
            get speed() {
                return this.animation.playbackRate;
            }
            set speed(e) {
                this.animation.playbackRate = e;
            }
            get state() {
                return this.animation.playState;
            }
            get startTime() {
                return Number(this.animation.startTime);
            }
            get finished() {
                return this.animation.finished;
            }
            flatten() {
                if (this.allowFlatten) {
                    var e;
                    null === (e = this.animation.effect) || void 0 === e || e.updateTiming({ easing: "linear" });
                }
            }
            attachTimeline(e) {
                return (this.animation.timeline = e), (this.animation.onfinish = null), pe;
            }
            then(e, t) {
                return this.finished.then(e).catch(t);
            }
            constructor(e) {
                var t, i;
                if ("animation" in e) {
                    this.animation = e.animation;
                    return;
                }
                let { element: s, name: r, keyframes: n, pseudoElement: a, allowFlatten: o = !1 } = e,
                    { transition: l } = e;
                (this.isPseudoElement = Boolean(a)), (this.allowFlatten = o);
                let d = (function e(t) {
                        let i = pv.get(t) || new Map();
                        return pv.set(t, i), i;
                    })(s),
                    c = `${(t = r)}:${a || ""}`,
                    h = d.get(c);
                h && h.stop();
                let u = (function e(t, i, s, r) {
                    Array.isArray(s) || (s = [s]);
                    for (let n = 0; n < s.length; n++)
                        null === s[n] && (s[n] = 0 !== n || r ? s[n - 1] : pa.get(t, i)),
                            "number" == typeof s[n] && pd.has(i) && (s[n] = s[n] + "px");
                    return r || pl() || !(s.length < 2) || s.unshift(pa.get(t, i)), s;
                })(s, r, n, a);
                u7(
                    "string" != typeof l.type,
                    'animateMini doesn\'t support "type" as a string. Did you mean to import { spring } from "motion"?'
                ),
                    (l = py(l)),
                    (this.animation = (function e(
                        t,
                        i,
                        s,
                        {
                            delay: r = 0,
                            duration: n = 300,
                            repeat: a = 0,
                            repeatType: o = "loop",
                            ease: l = "easeInOut",
                            times: d,
                        } = {},
                        c
                    ) {
                        let h = { [i]: s };
                        d && (h.offset = d);
                        let u = pg(l, n);
                        Array.isArray(u) && (h.easing = u);
                        let p = t.animate(h, {
                            delay: r,
                            duration: n,
                            easing: Array.isArray(u) ? "linear" : u,
                            fill: "both",
                            iterations: a + 1,
                            direction: "reverse" === o ? "alternate" : "normal",
                            pseudoElement: c,
                        });
                        return p;
                    })(s, r, u, l, a)),
                    !1 === l.autoplay && this.animation.pause(),
                    (this.removeAnimation = () => d.delete(c)),
                    (this.animation.onfinish = () => {
                        a ||
                            (pa.set(
                                s,
                                r,
                                (function e(t, { repeat: i, repeatType: s = "loop" }, r) {
                                    let n = t.filter(po),
                                        a = i && "loop" !== s && i % 2 == 1 ? 0 : n.length - 1;
                                    return a && void 0 !== r ? r : n[a];
                                })(u, l)
                            ),
                            this.cancel());
                    }),
                    d.set(c, this);
            }
        };
    function p$(e, t) {
        var i, s;
        return null !==
            (s = null !== (i = null == e ? void 0 : e[t]) && void 0 !== i ? i : null == e ? void 0 : e.default) &&
            void 0 !== s
            ? s
            : e;
    }
    let pw = ["read", "resolveKeyframes", "update", "preRender", "render", "postRender"],
        { schedule: p8, cancel: pS } = (function e(t, i) {
            let s = !1,
                r = !0,
                n = { delta: 0, timestamp: 0, isProcessing: !1 },
                a = () => (s = !0),
                o = pw.reduce(
                    (e, t) => (
                        (e[t] = (function e(t, i) {
                            let s = new Set(),
                                r = new Set(),
                                n = !1,
                                a = !1,
                                o = new WeakSet(),
                                l = { delta: 0, timestamp: 0, isProcessing: !1 };
                            function d(e) {
                                o.has(e) && (c.schedule(e), t()), e(l);
                            }
                            let c = {
                                schedule(e, t = !1, i = !1) {
                                    let a = i && n,
                                        l = a ? s : r;
                                    return t && o.add(e), l.has(e) || l.add(e), e;
                                },
                                cancel(e) {
                                    r.delete(e), o.delete(e);
                                },
                                process(e) {
                                    if (((l = e), n)) {
                                        a = !0;
                                        return;
                                    }
                                    (n = !0),
                                        ([s, r] = [r, s]),
                                        s.forEach(d),
                                        s.clear(),
                                        (n = !1),
                                        a && ((a = !1), c.process(e));
                                },
                            };
                            return c;
                        })(a)),
                        e
                    ),
                    {}
                ),
                { read: l, resolveKeyframes: d, update: c, preRender: h, render: u, postRender: p } = o,
                m = () => {
                    let e = u5.useManualTiming ? n.timestamp : performance.now();
                    (s = !1),
                        u5.useManualTiming || (n.delta = r ? 1e3 / 60 : Math.max(Math.min(e - n.timestamp, 40), 1)),
                        (n.timestamp = e),
                        (n.isProcessing = !0),
                        l.process(n),
                        d.process(n),
                        c.process(n),
                        h.process(n),
                        u.process(n),
                        p.process(n),
                        (n.isProcessing = !1),
                        s && i && ((r = !1), t(m));
                },
                f = () => {
                    (s = !0), (r = !0), n.isProcessing || t(m);
                },
                g = pw.reduce((e, t) => {
                    let i = o[t];
                    return (e[t] = (e, t = !1, r = !1) => (s || f(), i.schedule(e, t, r))), e;
                }, {}),
                y = (e) => {
                    for (let t = 0; t < pw.length; t++) o[pw[t]].cancel(e);
                };
            return { schedule: g, cancel: y, state: n, steps: o };
        })(queueMicrotask, !1);
    function pE(e) {
        return "layout" === e
            ? "group"
            : "enter" === e || "new" === e
              ? "new"
              : "exit" === e || "old" === e
                ? "old"
                : "group";
    }
    let px = {},
        pk = null,
        pT = {
            set(e, t) {
                px[e] = t;
            },
            commit() {
                pk || ((pk = document.createElement("style")).id = "motion-view");
                let e = "";
                for (let t in px) {
                    let i = px[t];
                    for (let [s, r] of ((e += `${t} {
`),
                    Object.entries(i)))
                        e += `  ${s}: ${r};
`;
                    e += "}\n";
                }
                (pk.textContent = e), document.head.appendChild(pk), (px = {});
            },
            remove() {
                pk && pk.parentElement && pk.parentElement.removeChild(pk);
            },
        };
    function pL(e) {
        let t = e.match(/::view-transition-(old|new|group|image-pair)\((.*?)\)/);
        return t ? { layer: t[2], type: t[1] } : null;
    }
    function p_(e) {
        var t;
        let { effect: i } = e;
        return (
            !!i &&
            i.target === document.documentElement &&
            (null === (t = i.pseudoElement) || void 0 === t ? void 0 : t.startsWith("::view-transition"))
        );
    }
    let pA = ["layout", "enter", "exit", "new", "old"];
    function pC(e, t) {
        var i;
        return null == e ? void 0 : null === (i = e[t]) || void 0 === i ? void 0 : i.keyframes.opacity;
    }
    let pq = [],
        pI = null,
        pP = class e {
            get(e) {
                return (this.currentTarget = e), this;
            }
            layout(e, t) {
                return this.updateTarget("layout", e, t), this;
            }
            new(e, t) {
                return this.updateTarget("new", e, t), this;
            }
            old(e, t) {
                return this.updateTarget("old", e, t), this;
            }
            enter(e, t) {
                return this.updateTarget("enter", e, t), this;
            }
            exit(e, t) {
                return this.updateTarget("exit", e, t), this;
            }
            crossfade(e) {
                return (
                    this.updateTarget("enter", { opacity: 1 }, e), this.updateTarget("exit", { opacity: 0 }, e), this
                );
            }
            updateTarget(e, t, i = {}) {
                let { currentTarget: s, targets: r } = this;
                r.has(s) || r.set(s, {});
                let n = r.get(s);
                n[e] = { keyframes: t, options: i };
            }
            then(e, t) {
                return this.readyPromise.then(e, t);
            }
            constructor(e, t = {}) {
                var i;
                (this.currentTarget = "root"),
                    (this.targets = new Map()),
                    (this.notifyReady = pe),
                    (this.readyPromise = new Promise((e) => {
                        this.notifyReady = e;
                    })),
                    (this.update = e),
                    (this.options = { interrupt: "wait", ...t }),
                    (i = this),
                    pq.push(i),
                    p8.render(function e() {
                        var t;
                        for (let i = pq.length - 1; i >= 0; i--) {
                            let s = pq[i],
                                { interrupt: r } = s.options;
                            if ("immediate" === r) {
                                let n = pq.slice(0, i + 1).map((e) => e.update),
                                    a = pq.slice(i + 1);
                                (s.update = () => {
                                    n.forEach((e) => e());
                                }),
                                    (pq = [s, ...a]);
                                break;
                            }
                        }
                        (pI && (null === (t = pq[0]) || void 0 === t ? void 0 : t.options.interrupt) !== "immediate") ||
                            (function e() {
                                var t;
                                pI = null;
                                let [i] = pq;
                                i &&
                                    ((t = i),
                                    !(function e(t, i) {
                                        let s = t.indexOf(i);
                                        s > -1 && t.splice(s, 1);
                                    })(pq, t),
                                    (pI = t),
                                    (function e(t) {
                                        let { update: i, targets: s, options: r } = t;
                                        if (!document.startViewTransition)
                                            return new Promise(async (e) => {
                                                await i(), e(new pr([]));
                                            });
                                        var n,
                                            a = "root";
                                        (!(n = s).has(a) || !(Object.keys(n.get(a)).length > 0)) &&
                                            pT.set(":root", { "view-transition-name": "none" }),
                                            pT.set(
                                                "::view-transition-group(*), ::view-transition-old(*), ::view-transition-new(*)",
                                                { "animation-timing-function": "linear !important" }
                                            ),
                                            pT.commit();
                                        let o = document.startViewTransition(async () => {
                                            await i();
                                        });
                                        return (
                                            o.finished.finally(() => {
                                                pT.remove();
                                            }),
                                            new Promise((e) => {
                                                o.ready.then(() => {
                                                    let t = document.getAnimations().filter(p_),
                                                        i = [];
                                                    for (let n of (s.forEach((e, t) => {
                                                        for (let s of pA) {
                                                            if (!e[s]) continue;
                                                            let { keyframes: n, options: a } = e[s];
                                                            for (let [o, l] of Object.entries(n)) {
                                                                if (!l) continue;
                                                                let d = { ...p$(r, o), ...p$(a, o) },
                                                                    c = pE(s);
                                                                if ("opacity" === o && !Array.isArray(l)) {
                                                                    let h = "new" === c ? 0 : 1;
                                                                    l = [h, l];
                                                                }
                                                                "function" == typeof d.delay &&
                                                                    (d.delay = d.delay(0, 1)),
                                                                    d.duration && (d.duration = pt(d.duration)),
                                                                    d.delay && (d.delay = pt(d.delay));
                                                                let u = new pb({
                                                                    element: document.documentElement,
                                                                    name: o,
                                                                    pseudoElement: `::view-transition-${c}(${t})`,
                                                                    keyframes: l,
                                                                    transition: d,
                                                                });
                                                                i.push(u);
                                                            }
                                                        }
                                                    }),
                                                    t)) {
                                                        if ("finished" === n.playState) continue;
                                                        let { effect: a } = n;
                                                        if (!a || !(a instanceof KeyframeEffect)) continue;
                                                        let { pseudoElement: o } = a;
                                                        if (!o) continue;
                                                        let l = pL(o);
                                                        if (!l) continue;
                                                        let d = s.get(l.layer);
                                                        if (d)
                                                            pC(d, "enter") &&
                                                            pC(d, "exit") &&
                                                            a.getKeyframes().some((e) => e.mixBlendMode)
                                                                ? i.push(new pb({ animation: n }))
                                                                : n.cancel();
                                                        else {
                                                            var c;
                                                            let h = "group" === l.type ? "layout" : "",
                                                                u = { ...p$(r, h) };
                                                            u.duration && (u.duration = pt(u.duration)), (u = py(u));
                                                            let p = pg(u.ease, u.duration);
                                                            a.updateTiming({
                                                                delay: pt(
                                                                    null !== (c = u.delay) && void 0 !== c ? c : 0
                                                                ),
                                                                duration: u.duration,
                                                                easing: p,
                                                            }),
                                                                i.push(new pb({ animation: n }));
                                                        }
                                                    }
                                                    e(new pr(i));
                                                });
                                            })
                                        );
                                    })(t).then((i) => {
                                        t.notifyReady(i), i.finished.finally(e);
                                    }));
                            })();
                    });
            }
        };
    function p9(e, t = {}) {
        return new pP(e, t);
    }
    var pM = function (e, t) {
        var i = {};
        for (var s in e) Object.prototype.hasOwnProperty.call(e, s) && 0 > t.indexOf(s) && (i[s] = e[s]);
        if (null != e && "function" == typeof Object.getOwnPropertySymbols)
            for (var r = 0, s = Object.getOwnPropertySymbols(e); r < s.length; r++)
                0 > t.indexOf(s[r]) && Object.prototype.propertyIsEnumerable.call(e, s[r]) && (i[s[r]] = e[s[r]]);
        return i;
    };
    let pD = Symbol("ANIMATE_CONTEXT_KEY"),
        pO = ["id", "data-shopify-editor-block"],
        pF = {
            announcementBar: "[data-announcement-bar]",
            tickerFrame: "[data-ticker-frame]",
            tickerScale: "[data-ticker-scale]",
            tickerText: "[data-ticker-text]",
        },
        pB = { isSelected: "is-selected", tickerAnimated: "ticker--animated" },
        pV = { INITIAL: 0, LOADING: 1, SUCCESS: 2, ERROR: 3 },
        pH = {
            popdown: "[data-product-add-popdown-wrapper]",
            errors: "[data-add-action-errors]",
            errorBoundary: "[data-error-boundary]",
            errorDisplay: "[data-error-display]",
            quickviewModal: "[data-quickview-modal]",
            cartPageUpsellWrapper: "[data-cart-page-upsell-wrapper]",
            sectionTypeCart: '[data-section-type="cart"]',
            ajaxDisable: '[data-ajax-disable="true"]',
        },
        pW = { durationAddButtonDisable: 3500, hideErrorTime: 5e3 },
        pR = { INITIAL: 0, LOADING: 1 },
        pN = {
            quickviewHolder: "data-quickview-holder",
            addButtonWrapper: "[data-add-action-wrapper]",
            modalContent: "[data-product-quickview-ajax]",
            quickviewModal: "[data-quickview-modal]",
            quickviewModalScrolls: "[data-drawer-scrolls]",
            quickviewModalTemplate: "[data-quickview-modal-template]",
            quickviewHead: "[data-quickview-head]",
            quickviewFormArea: "[data-quickview-form-area]",
            toggleButton: "[data-toggle-button]",
            media: "[data-media-slide]",
            mediaId: "[data-media-id]",
            focusable: 'button, [href], select, textarea, [tabindex]:not([tabindex="-1"])',
        },
        pz = { hide: "hide", active: "is-active", expanded: "is-expanded", loading: "loading" },
        p0 = { minPart: 250, mediumPart: 400 };
    function pj() {
        return {
            isOpen: !1,
            get isClosed() {
                return !this.isOpen;
            },
            toggle() {
                if (this.isOpen) return this.close();
                this.open();
            },
            open() {
                this.isOpen = !0;
            },
            close() {
                this.isOpen && (this.isOpen = !1);
            },
        };
    }
    let pU = { tablist: '[role="tablist"]', tab: '[role="tab"]' };
    var p3 = (e, { expression: t }) => {
        t && -1 === document.referrer.indexOf(t) && !window.Shopify.designMode && e.parentNode.removeChild(e);
    };
    lb.data("announcement", function e() {
        new ru(this.$el);
    }),
        lb.data("announcementSlider", function e(t = 4e3) {
            return {
                options: {
                    initialIndex: 0,
                    autoPlay: t,
                    contain: !0,
                    pageDots: !1,
                    adaptiveHeight: !0,
                    wrapAround: !0,
                    groupCells: !1,
                    cellAlign: "left",
                    freeScroll: !1,
                    prevNextButtons: !0,
                    draggable: !0,
                    rightToLeft: window.isRTL,
                    on: {
                        ready: () => {
                            setTimeout(() => {
                                this.$el.dispatchEvent(
                                    new CustomEvent("theme:announcement:loaded", {
                                        bubbles: !0,
                                        detail: { slider: this.$el },
                                    })
                                );
                            }, 50);
                        },
                    },
                },
                flkty: null,
                desktopSlides: [],
                mobileSlides: [],
                isMobileSliderInitialized: !1,
                init() {
                    this.$nextTick(() => {
                        this.$el.children.length < 2 ||
                            ((this.flkty = new s(this.$el, this.options)),
                            this.removeDeviceSpecificSlides(),
                            eT.onChange(() => {
                                this.updateDeviceSpecificSlides();
                            }),
                            (this.scrollEvent = () => this.scrollEvents()),
                            (this.resizeEvent = () => this.resizeEvents()),
                            document.addEventListener("theme:resize", this.resizeEvent),
                            document.addEventListener("theme:scroll", this.scrollEvent));
                    });
                },
                removeDeviceSpecificSlides() {
                    let e = this.flkty.getCellElements();
                    e.forEach((e, t) => {
                        e.classList.remove(pB.isSelected),
                            "desktop" == e.dataset.device &&
                                (this.desktopSlides.push([e, t]), eT.isMobile() && this.flkty.remove(e)),
                            "mobile" == e.dataset.device &&
                                (this.mobileSlides.push([e, t]),
                                (eT.isDesktop() || eT.isTablet()) && this.flkty.remove(e));
                    }),
                        setTimeout(() => {
                            this.flkty.resize();
                        }, 1e3),
                        this.handleSliderAutoplay(),
                        (this.isMobileSliderInitialized = eT.isMobile());
                },
                updateDeviceSpecificSlides() {
                    (eT.isDesktop() || eT.isTablet()) &&
                        this.isMobileSliderInitialized &&
                        (this.desktopSlides.forEach((e) => {
                            this.flkty.insert(e[0], e[1]);
                        }),
                        this.mobileSlides.forEach((e) => {
                            this.flkty.remove(e[0]);
                        })),
                        eT.isMobile() &&
                            !this.isMobileSliderInitialized &&
                            (this.mobileSlides.forEach((e) => {
                                this.flkty.insert(e[0], e[1]);
                            }),
                            this.desktopSlides.forEach((e) => {
                                this.flkty.remove(e[0]);
                            })),
                        setTimeout(() => {
                            this.flkty.resize();
                        }, 1e3),
                        this.handleSliderAutoplay(),
                        (this.isMobileSliderInitialized = eT.isMobile());
                },
                handleSliderAutoplay() {
                    var e;
                    (null === (e = this.flkty) || void 0 === e ? void 0 : e.slides.length) > 1
                        ? this.flkty.playPlayer()
                        : this.flkty.pausePlayer();
                },
                resizeEvents() {
                    this.flkty.resize();
                },
                scrollEvents() {
                    if (!this.flkty.options.autoPlay) return;
                    let e = this.flkty.element,
                        t = e.getBoundingClientRect().top + window.scrollY + e.offsetHeight;
                    window.pageYOffset > t
                        ? "playing" === this.flkty.player.state && this.flkty.pausePlayer()
                        : "paused" === this.flkty.player.state && this.flkty.playPlayer();
                },
                onBlockSelect(e) {
                    let t = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                    if (!t) return;
                    let i = parseInt([...t.parentNode.children].indexOf(t));
                    this.flkty.selectCell(i), this.flkty.stopPlayer();
                },
                onBlockDeselect() {
                    this.flkty.playPlayer();
                },
                onUnload() {
                    (this.flkty.options.watchCSS = !1), this.flkty.destroy();
                },
            };
        }),
        lb.data("announcementTicker", function e(t = { stopClone: !1, waitForSlider: !1 }) {
            var i;
            return {
                tickerFrames:
                    null === (i = this.$el.closest(pF.announcementBar)) || void 0 === i
                        ? void 0
                        : i.querySelectorAll(pF.tickerFrame),
                init() {
                    var e;
                    (null == t ? void 0 : t.waitForSlider) &&
                    (null === (e = this.tickerFrames) || void 0 === e ? void 0 : e.length) > 1
                        ? document.addEventListener("theme:announcement:loaded", this.initTicker.bind(this))
                        : this.initTicker();
                },
                initTicker() {
                    new to(this.$el, null == t ? void 0 : t.stopClone);
                },
                toggleTicker(e, t) {
                    let i = this.$el.querySelector(pF.tickerScale),
                        s = this.$el.querySelector(`[x-ref="${e.detail.blockId}"]`);
                    if (s && null !== s.offsetParent) {
                        if (t) {
                            let r = Number(getComputedStyle(s).getPropertyValue("--items-spacing").replace("px", "")),
                                n = -(s.offsetLeft + r);
                            i.setAttribute("data-stop", ""),
                                i.querySelectorAll(pF.tickerText).forEach((e) => {
                                    e.classList.remove(pB.tickerAnimated),
                                        (e.style.transform = `translate3d(${n}px, 0, 0)`);
                                });
                        }
                        t ||
                            (i.querySelectorAll(pF.tickerText).forEach((e) => {
                                e.classList.add(pB.tickerAnimated), e.removeAttribute("style");
                            }),
                            i.removeAttribute("data-stop"));
                    }
                },
                onBlockSelect(e) {
                    this.toggleTicker(e, !0);
                },
                onBlockDeselect(e) {
                    this.toggleTicker(e, !1);
                },
            };
        }),
        lb.data("productAddButtonForm", function e(t = {}) {
            let i = { ...pW, ...t.times };
            return {
                state: pV.INITIAL,
                error: "",
                isUpsell: !1,
                isInCartPage: !1,
                get cartPageUpsellWrapper() {
                    return this.$el.closest(pH.cartPageUpsellWrapper);
                },
                get sectionTypeCart() {
                    return this.$el.closest(pH.sectionTypeCart);
                },
                get form() {
                    if (this.isUpsell && this.isInCartPage) return this.$el.closest("form");
                    return this.$el.querySelector("form");
                },
                get button() {
                    return this.$el.querySelector("button");
                },
                get popdown() {
                    return document.querySelector(pH.popdown);
                },
                get errorDisplay() {
                    let s = this.$el.querySelector(pH.errors);
                    if (!s) {
                        let r = this.$el.closest(pH.errorBoundary);
                        r && (s = r.querySelector(pH.errorDisplay));
                    }
                    return s || (s = this.$el.querySelector(pH.errorDisplay)), s;
                },
                get quickViewModal() {
                    return this.$el.closest(pH.quickviewModal);
                },
                get isInitial() {
                    return this.state === pV.INITIAL;
                },
                get isLoading() {
                    return this.state === pV.LOADING;
                },
                get isSuccess() {
                    return this.state === pV.SUCCESS;
                },
                get isError() {
                    return this.state === pV.ERROR;
                },
                get isDisabled() {
                    return this.isLoading;
                },
                get isAjaxDisabled() {
                    return !!this.$el.closest(pH.ajaxDisable);
                },
                get isInsideQuickViewModal() {
                    return Boolean(this.quickViewModal);
                },
                handleClickAddButton(e) {
                    e.preventDefault(), (this.state = pV.LOADING);
                    let t = new FormData(this.form);
                    this.addToCart(t).then(this.handleSuccess.bind(this)).catch(this.handleError.bind(this));
                },
                // handleSuccess(e) {
                //     let t = e.data;
                //     (this.state = pV.SUCCESS),
                //         this.updateHeaderTotal(),
                //         setTimeout(() => {
                //             this.state = pV.INITIAL;
                //         }, i.durationAddButtonDisable),
                //         this.isInsideQuickViewModal && this.closeQuickView(),
                //         window.theme.state.cartOpen || this.isInCartPage || this.isOnCartPage
                //             ? this.reloadCart()
                //             : this.openPopdown(t);
                // },
handleSuccess(e) {
    let t = e.data;
    (this.state = pV.SUCCESS),
        this.updateHeaderTotal(),
        setTimeout(() => {
            this.state = pV.INITIAL;
        }, i.durationAddButtonDisable),
        this.isInsideQuickViewModal && this.closeQuickView();

    if (window.theme.state.cartOpen || this.isInCartPage || this.isOnCartPage) {
        this.reloadCart();
    } else {
        let cartDrawer = document.querySelector('[data-drawer="drawer-cart"]');
        
        if (cartDrawer) {
            document.addEventListener('theme:cart:change', function() {
                
                setTimeout(() => {
                    requestAnimationFrame(() => {
                        cartDrawer.dispatchEvent(new CustomEvent("theme:drawer:open", { bubbles: false }));
                    });
                }, 50);

            }, { once: true });

            this.reloadCart();
        }
    }
},
                handleError(e) {
                    if (null == e ? void 0 : e.data) {
                        if (
                            ((this.state = pV.ERROR),
                            e.data.description && "string" == typeof e.data.description
                                ? (this.error = e.data.description)
                                : e.data.message && "string" == typeof e.data.message
                                  ? (this.error = e.data.message)
                                  : e.data.description && "object" == typeof e.data.description
                                    ? (this.error = Object.keys(e.data.description)
                                          .map((t) => `${t}: ${e.data.description[t]}`)
                                          .join("<br>"))
                                    : (this.error = "Network error: please try again"),
                            this.errorDisplay)
                        ) {
                            let t = `<div class="errors">${this.error}</div>`;
                            (this.errorDisplay.innerHTML = t),
                                t7(this.errorDisplay),
                                setTimeout(() => {
                                    t5(this.errorDisplay);
                                }, i.hideErrorTime);
                        }
                    } else throw e;
                },
                addToCart(e) {
                    let t = `${window.theme.routes.cart}/add.js`,
                        i = new URLSearchParams(e).toString();
                    return o.post(t, i, {
                        headers: {
                            "X-Requested-With": "XMLHttpRequest",
                            "Content-Type": "application/x-www-form-urlencoded",
                        },
                    });
                },
                updateHeaderTotal: () =>
                    o
                        .get(`${window.theme.routes.cart}.js`)
                        .then((e) => {
                            document.dispatchEvent(
                                new CustomEvent("theme:cart:change", { detail: { cart: e.data }, bubbles: !0 })
                            );
                        })
                        .catch((e) => {
                            console.error(e);
                        }),
                closeQuickView() {
                    this.quickViewModal.dispatchEvent(new CustomEvent("theme:quickview:close"));
                },
                reloadCart() {
                    document.dispatchEvent(new CustomEvent("theme:cart:reload", { bubbles: !0 }));
                },
                openPopdown(e) {
                    this.popdown.dispatchEvent(
                        new CustomEvent("theme:cart:popdown", { detail: { variant: e }, bubbles: !0 })
                    );
                },
                get isInCartPage() {
                    return Boolean(this.sectionTypeCart);
                },
                get isOnCartPage() {
                    return Boolean(document.body.querySelector(pH.sectionTypeCart));
                },
                get isUpsell() {
                    return Boolean(this.cartPageUpsellWrapper);
                },
                init() {
                    this.button.addEventListener("click", this.handleClickAddButton.bind(this));
                },
            };
        }),
        lb.data("productQuickViewButton", function e(t, i) {
            return {
                state: pR.INITIAL,
                get quickviewHolder() {
                    return this.$root.querySelector(`[${pN.quickviewHolder}]`);
                },
                get isInitial() {
                    return this.state === pR.INITIAL;
                },
                get isLoading() {
                    return this.state === pR.LOADING;
                },
                get isDisabled() {
                    return this.isLoading;
                },
                clickQuickviewButton(e) {
                    this.modal && this.modalID && (this.modal.id = this.modalID),
                        document.documentElement.hasAttribute("data-scroll-locked") && (this.scrollLockEnable = !1),
                        (this.state = pR.LOADING),
                        this.getQuickviewHTML();
                },
                getQuickviewHTML() {
                    window
                        .fetch(`${window.theme.routes.root_url}products/${i}?section_id=api-product-quickview`)
                        .then(this.handleErrors)
                        .then((e) => e.text())
                        .then((e) => {
                            let t = document.createElement("div");
                            (t.innerHTML = e),
                                (this.modalContent = this.modal.querySelector(pN.modalContent)),
                                (this.modalContent.innerHTML = t.querySelector("[data-api-content]").innerHTML),
                                (this.modalScroll = this.modal.querySelector(pN.quickviewModalScrolls));
                            let i = this.modalContent.querySelector(pN.mediaId);
                            if (i) {
                                let s = document.createElement("div");
                                (s.innerHTML = i.parentElement.innerHTML),
                                    this.quickviewHolder.dispatchEvent(
                                        new CustomEvent("theme:quickview:media", { bubbles: !0, detail: { media: s } })
                                    );
                            }
                            let r = { container: this.modalContent };
                            (this.media = new sf(r)), this.modalCreate(), (this.state = pR.INITIAL);
                        });
                },
                modalCreate() {
                    r.show(this.modalID, {
                        onShow: (e, t, i) => {
                            (this.quickviewHead = e.querySelector(pN.quickviewHead)),
                                (this.quickviewFormArea = e.querySelector(pN.quickviewFormArea)),
                                (this.toggleButton = e.querySelector(pN.toggleButton)),
                                this.toggleForm("loading"),
                                document.addEventListener(
                                    "theme:resize",
                                    i4(() => {
                                        this.toggleForm("resize");
                                    }, 500)
                                ),
                                this.clickEventToggleForm();
                            let s = e.querySelector(pN.focusable);
                            eX(e, { elementToFocus: s }),
                                this.modal.addEventListener("theme:quickview:close", this.modalClose),
                                document.dispatchEvent(
                                    new CustomEvent("theme:scroll:lock", { bubbles: !0, detail: this.modalScroll })
                                ),
                                new sj(this.modal);
                        },
                        onClose: (e, t, i) => {
                            i && i.preventDefault(), this.media.destroy();
                            let s = e.querySelectorAll(pN.media);
                            s.forEach((e) => {
                                e.dispatchEvent(new CustomEvent("pause"));
                            }),
                                eY(),
                                t.focus(),
                                this.modal.removeEventListener("theme:quickview:close", this.modalClose),
                                this.scrollLockEnable
                                    ? document.dispatchEvent(new CustomEvent("theme:scroll:unlock", { bubbles: !0 }))
                                    : (this.scrollLockEnable = !0);
                        },
                    });
                },
                modalClose() {
                    r.close(this.modalID);
                },
                handleErrors: (e) =>
                    e.ok
                        ? e
                        : e.json().then(function (t) {
                              let i = new eh({ status: e.statusText, headers: e.headers, json: t });
                              throw i;
                          }),
                toggleForm(e) {
                    (this.windowH !== window.innerHeight || "resize" !== e) &&
                        (this.toggleButton.classList.contains(pz.hide) || this.toggleButton.classList.add(pz.hide),
                        this.quickviewFormArea.classList.contains(pz.expanded) ||
                            this.quickviewFormArea.classList.add(pz.expanded),
                        "resize" === e &&
                            (this.quickviewFormArea.classList.add(pz.expanded),
                            this.toggleButton.classList.add(pz.hide),
                            (this.windowH = window.innerHeight)),
                        setTimeout(() => {
                            let t =
                                    window.innerHeight -
                                    this.quickviewHead.offsetHeight -
                                    this.quickviewFormArea.offsetHeight,
                                i = t < p0.mediumPart && t > p0.minPart,
                                s = t < p0.minPart;
                            i || s
                                ? (this.toggleButton.classList.remove(pz.hide),
                                  this.toggleButton.classList.add(pz.active))
                                : this.toggleButton.classList.add(pz.hide),
                                s
                                    ? ("loading" === e &&
                                          (this.quickviewFormArea.classList.add(pz.loading),
                                          setTimeout(() => {
                                              this.quickviewFormArea.classList.remove(pz.loading);
                                          }, 50)),
                                      this.quickviewFormArea.classList.remove(pz.expanded),
                                      this.toggleButton.classList.remove(pz.active))
                                    : this.quickviewFormArea.classList.add(pz.expanded);
                        }, 200));
                },
                clickEventToggleForm() {
                    this.toggleButton &&
                        this.toggleButton.addEventListener("click", () => {
                            this.toggleButton.classList.toggle(pz.active),
                                this.quickviewFormArea.classList.toggle(pz.expanded);
                        });
                },
                init() {
                    if (
                        this.quickviewHolder &&
                        ((this.modalTemplate = this.quickviewHolder.querySelector(pN.quickviewModalTemplate)),
                        (this.modal = document.querySelector(pN.quickviewModal)),
                        (this.modalID = this.quickviewHolder.getAttribute(pN.quickviewHolder)),
                        (this.modalContent = null),
                        (this.modalScroll = null),
                        (this.scrollLockEnable = !0),
                        (this.windowH = window.innerHeight),
                        this.modalTemplate && !this.modal)
                    ) {
                        let e = this.modalTemplate.innerHTML,
                            t = document.createElement("div");
                        (t.innerHTML = e),
                            (this.modalHtml = t.querySelector(pN.quickviewModal)),
                            document.body.appendChild(this.modalHtml),
                            (this.modal = document.querySelector(pN.quickviewModal));
                    }
                },
            };
        }),
        lb.data("productGridItemQuickAddMenu", function e() {
            return (function e(...t) {
                return t.reduce(
                    (e, t) => {
                        var i;
                        let s = "function" == typeof (i = t) ? t() : t;
                        s.init && e._initializers.push(s.init), delete s.init;
                        let r = Object.defineProperties(e, Object.getOwnPropertyDescriptors(s));
                        return r;
                    },
                    {
                        _initializers: [],
                        init() {
                            this._initializers.forEach((e) => e.call(this));
                        },
                    }
                );
            })(pj(), {
                controller: null,
                init() {
                    this.$watch("isOpen", (e) => {
                        e ? this.listen() : this.unlisten();
                    });
                },
                listen() {
                    (this.controller = new AbortController()),
                        this.$el.addEventListener(
                            "mouseleave",
                            () => {
                                this.close();
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "click",
                            (e) => {
                                !this.$el.contains(e.target) && !1 !== this.$el._x_isShown && this.close();
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "focusin",
                            (e) => {
                                this.$el.contains(e.target) || this.close();
                            },
                            { signal: this.controller.signal }
                        ),
                        document.addEventListener(
                            "keydown",
                            (e) => {
                                "Escape" === e.key && this.close();
                            },
                            { signal: this.controller.signal }
                        );
                },
                unlisten() {
                    this.controller.abort(), (this.controller = null);
                },
            });
        }),
        lb.data("toggle", pj),
        lb.data("tabs", function e(t = 0) {
            return {
                selectedIndex: null,
                init() {
                    this.$nextTick(() => this.select(t));
                },
                get tablist() {
                    return this.$el.querySelector(pU.tablist);
                },
                get tabs() {
                    var i;
                    return null === (i = this.tablist) || void 0 === i ? void 0 : i.querySelectorAll(pU.tab);
                },
                getTab(e) {
                    var t;
                    return null === (t = this.tabs) || void 0 === t ? void 0 : t[e];
                },
                isSelected(e) {
                    return this.selectedIndex === e;
                },
                select(e, t = !0) {
                    this.selectedIndex = e;
                    let i = this.getTab(e);
                    i && t && this.tablist.scrollTo({ top: 0, left: i.offsetLeft - i.clientWidth, behavior: "smooth" });
                },
                bindTabs: { "x-id": "['tab', 'tab-panel']" },
                bindTablist: {
                    ":role": "'tablist'",
                    "@keydown.right.prevent.stop": "$focus.wrap().next()",
                    "@keydown.home.prevent.stop": "$focus.first()",
                    "@keydown.page-up.prevent.stop": "$focus.first()",
                    "@keydown.left.prevent.stop": "$focus.wrap().prev()",
                    "@keydown.end.prevent.stop": "$focus.last()",
                    "@keydown.page-down.prevent.stop": "$focus.last()",
                },
                bindTabpanels: {},
                bindTab: (e) => ({
                    ":id": `$id('tab', ${e + 1})`,
                    ":role": "'tab'",
                    "@click": `select(${e})`,
                    "@mousedown.prevent": "",
                    "@focus": `select(${e})`,
                    ":tabindex": `isSelected(${e}) ? 0 : -1`,
                    ":aria-selected": `isSelected(${e})`,
                    ":aria-controls": `$id('tab-panel', ${e + 1})`,
                }),
                bindTabpanel: (e) => ({
                    ":id": `$id('tab-panel', ${e + 1})`,
                    ":role": "'tabpanel'",
                    "x-show": `isSelected(${e})`,
                    ":aria-labelledby": `$id('tab', ${e + 1})`,
                }),
            };
        }),
        lb.data("overflow", function e(t = {}) {
            let i = { top: 0, right: 0, bottom: 0, left: 0, ...t.inset };
            return {
                get overflowContainer() {
                    return this.$refs.overflowContainer;
                },
                isOverflowing: { top: !1, bottom: !1, left: !1, right: !1 },
                checkOverflow() {
                    let e = this.overflowContainer.scrollHeight - this.overflowContainer.scrollTop - i.bottom,
                        t = this.overflowContainer.scrollWidth - this.overflowContainer.scrollLeft - i.right;
                    (this.isOverflowing.top = this.overflowContainer.scrollTop - i.top > 0),
                        (this.isOverflowing.bottom = e > this.overflowContainer.clientHeight),
                        (this.isOverflowing.left = this.overflowContainer.scrollLeft - i.left > 0),
                        (this.isOverflowing.right = t > this.overflowContainer.clientWidth);
                },
                scrollTo(e) {
                    this.overflowContainer.scrollTo(e);
                },
            };
        }),
        lb.directive("target-referrer", p3),
        lb.plugin(ne),
        lb.plugin(ni),
        lb.plugin(nr),
        lb.plugin(function e(t) {
            t
                .directive("clone", (e, { expression: i }, { effect: s, evaluateLater: r, cleanup: n }) => {
                    let a = r(i);
                    if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                    (e._x_insertClone = (i) => {
                        var s;
                        if (!l$(i)) return;
                        if (!lw(e)) throw Error("x-clone can only be used on a <template> tag");
                        e._x_clonedElement && (null === (s = e._x_undoClone) || void 0 === s || s.call(e));
                        let r = lw(i) ? i.content.cloneNode(!0).firstElementChild : i.cloneNode(!0);
                        r &&
                            (t.addScopeToNode(r, {}, e),
                            t.mutateDom(() => {
                                e.after(r), t.skipDuringClone(() => t.initTree(r))();
                            }),
                            (e._x_clonedElement = r),
                            (e._x_undoClone = () => {
                                t.destroyTree(r), r.remove(), delete e._x_clonedElement;
                            }));
                    }),
                        s(() => {
                            a((t) => {
                                e._x_insertClone(t);
                            });
                        }),
                        n(() => e._x_undoClone && e._x_undoClone());
                })
                .before("bind"),
                t.magic("clone", (e) => e._x_insertClone);
        }),
        lb.plugin(function e(t) {
            var i;
            t
                .directive("slider-reveal", (e, i) => {
                    if ("handle" == i.value)
                        (function e(t, i, s) {
                            i.bind(t, { "x-init": "__sliderReveal_handle = $el" });
                        })(e, t);
                    else if ("reveal" == i.value)
                        (function e(t, i, s) {
                            i.bind(t, { "x-init": "__sliderReveal_reveal = $el" });
                        })(e, t);
                    else if (null == i.value)
                        (function e(t, i, s) {
                            let r = s.modifiers.includes("vertical") ? "vertical" : "horizontal",
                                n = 0;
                            if (
                                (s.modifiers.includes("initial") &&
                                    (n = Number(s.modifiers[s.modifiers.indexOf("initial") + 1])),
                                s.modifiers.includes("progress"))
                            ) {
                                let a = s.modifiers[s.modifiers.indexOf("progress") + 1];
                                if (!a)
                                    throw Error(
                                        "x-slider-reveal.progress requires a value (e.g. x-slider-reveal.progress.50%)"
                                    );
                                let o = a.match(/([0-9]+)%/);
                                o && (n = Number(o[1]));
                            }
                            let l = u1([0, 100], ["0%", "100%"]);
                            i.bind(t, {
                                "x-data": () => ({
                                    __sliderReveal_progressMotionValue: (function e(t, i) {
                                        let s = lz(i),
                                            r = t.reactive({ value: s.get() });
                                        return (
                                            s.on("change", (e) => {
                                                r.value = e;
                                            }),
                                            new Proxy(s, {
                                                get: (e, t, i) => ("get" === t && r.value, Reflect.get(e, t, i)),
                                            })
                                        );
                                    })(i, n),
                                    __sliderReveal_handle: null,
                                    __sliderReveal_reveal: null,
                                    __sliderReveal_scrollAnimationFn: null,
                                    init() {
                                        this.$nextTick(() => {
                                            this.__sliderReveal_updateElements(n),
                                                this.__sliderReveal_progressMotionValue.on(
                                                    "change",
                                                    this.__sliderReveal_updateElements.bind(this)
                                                );
                                        });
                                    },
                                    __enableScroll() {
                                        this.__sliderReveal_scrollAnimationFn ||
                                            (this.__sliderReveal_scrollAnimationFn = uz(
                                                (e) => {
                                                    let t = this.__sliderReveal_progressMotionValue.get(),
                                                        i = u1([0, 1], [0, 100]),
                                                        s = u1([0, 100], [Math.max(0, t - 15), Math.min(100, t + 15)]),
                                                        r = i(e),
                                                        n = s(r);
                                                    this.__sliderReveal_updateElements(n);
                                                },
                                                { target: t, offset: ["end start", "start end"] }
                                            ));
                                    },
                                    __disableScroll() {
                                        var e;
                                        null === (e = this.__sliderReveal_scrollAnimationFn) ||
                                            void 0 === e ||
                                            e.call(this),
                                            (this.__sliderReveal_scrollAnimationFn = null);
                                    },
                                    __sliderReveal_updateElements(e) {
                                        let t = l(e);
                                        "vertical" === r
                                            ? this.__sliderReveal_handle &&
                                              ((this.__sliderReveal_handle.style.transform = `translateY(${t})`),
                                              (this.__sliderReveal_reveal.style.clipPath = `inset(${t} 0% 0% 0%)`))
                                            : this.__sliderReveal_handle &&
                                              ((this.__sliderReveal_handle.style.transform = `translateX(${t})`),
                                              (this.__sliderReveal_reveal.style.clipPath = `inset(0% 0% 0% ${t})`));
                                    },
                                }),
                            });
                        })(e, t, i);
                    else throw Error(`Unknown directive: x-slider-reveal:${i.value}`);
                })
                .before("bind"),
                t.magic(
                    "sliderReveal",
                    ((i = t),
                    function (e) {
                        let t = i.$data(e);
                        return {
                            get progressMotionValue() {
                                return t.__sliderReveal_progressMotionValue;
                            },
                            get progress() {
                                return t.__sliderReveal_progressMotionValue.get();
                            },
                            set progress(value) {
                                t.__sliderReveal_progressMotionValue.set(value);
                            },
                            enableScroll() {
                                t.__enableScroll();
                            },
                            disableScroll() {
                                t.__disableScroll();
                            },
                        };
                    })
                );
        }),
        lb.plugin(function e(t) {
            t
                .directive("slideshow", (e, i, s) => {
                    if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                    if ("slide" === i.value)
                        (function e(t, i) {
                            i.bind(t, {
                                "x-data": () => ({
                                    __slideshowSlide_slideIndex: null,
                                    init() {
                                        (this.__slideshowSlide_slideIndex = this.__slideshow_state.totalSlides),
                                            (this.__slideshow_state.totalSlides = this.__slideshowSlide_slideIndex + 1);
                                    },
                                    get __slideshowSlide_isCurrentSlide() {
                                        return (
                                            this.__slideshow_state.currentSlideIndex ===
                                            this.__slideshowSlide_slideIndex
                                        );
                                    },
                                    get __slideshowSlide_wasLastSlide() {
                                        return (
                                            this.__slideshow_state.lastSlideIndex === this.__slideshowSlide_slideIndex
                                        );
                                    },
                                    destroy() {
                                        this.__slideshow_state.totalSlides -= 1;
                                    },
                                }),
                                role: "group",
                                "aria-roledescription": "slide",
                            });
                        })(e, t);
                    else if ("control" === i.value)
                        (function e(t, i) {
                            i.bind(t, { ":aria-controls": '$id("slideshow")' });
                        })(e, t);
                    else if ("play" === i.value)
                        (function e(t, i) {
                            i.bind(t, { "@click": "$slideshow.play()", "x-slideshow:control": "" });
                        })(e, t);
                    else if ("pause" === i.value)
                        (function e(t, i) {
                            i.bind(t, { "@click": "$slideshow.pause()", "x-slideshow:control": "" });
                        })(e, t);
                    else if ("next" === i.value)
                        (function e(t, i) {
                            i.bind(t, { "@click": "$slideshow.pause(); $slideshow.next()", "x-slideshow:control": "" });
                        })(e, t);
                    else if ("prev" === i.value)
                        (function e(t, i) {
                            i.bind(t, { "@click": "$slideshow.pause(); $slideshow.prev()", "x-slideshow:control": "" });
                        })(e, t);
                    else if ("toggle" === i.value)
                        (function e(t, i) {
                            i.bind(t, { "@click": "$slideshow.toggle()", "x-slideshow:control": "" });
                        })(e, t);
                    else if ("viewport" === i.value)
                        (function e(t, i) {
                            i.bind(t, {
                                ":id": "$id('slideshow')",
                                role: "region",
                                "aria-roledescription": "carousel",
                                ":aria-live": '$slideshow.state == "playing" ? "off" : "polite"',
                                "@keydown.left.stop.prevent": "$slideshow.prev()",
                                "@keydown.right.stop.prevent": "$slideshow.next()",
                                "@focus": "$slideshow.pause()",
                            });
                        })(e, t);
                    else if (null === i.value)
                        (function e(t, i, s, { evaluate: r }) {
                            let n = 1e3,
                                a = s.modifiers.includes("autoplay");
                            if (s.modifiers.includes("duration")) {
                                let o = s.modifiers[s.modifiers.indexOf("duration") + 1],
                                    l = o.match(/([0-9]+)ms/);
                                l && (n = Number(l[1]));
                            }
                            let d = r("" === s.expression ? "{}" : s.expression);
                            if (((d.slideDuration = n), (d.autoplay = a), null != d && !l8(d)))
                                throw Error(`options must be an object, but got ${d}`);
                            let c = (function e(t = {}) {
                                let i = {
                                    state: t.autoplay ? "playing" : "paused",
                                    slideDuration: t.slideDuration || 1e3,
                                    currentSlideIndex: t.initialSlideIndex || 0,
                                    lastSlideIndex: null,
                                    currentSlideElapsedTime: 0,
                                    totalSlides: 0,
                                    get nextSlideIndex() {
                                        return lE(this.currentSlideIndex + 1, this.totalSlides);
                                    },
                                    get prevSlideIndex() {
                                        return lE(this.currentSlideIndex - 1, this.totalSlides);
                                    },
                                    next() {
                                        this.currentSlideIndex = this.nextSlideIndex;
                                    },
                                    prev() {
                                        this.currentSlideIndex = this.prevSlideIndex;
                                    },
                                    play() {
                                        "playing" !== this.state && (this.state = "playing");
                                    },
                                    pause() {
                                        "paused" !== this.state && (this.state = "paused");
                                    },
                                    toggle() {
                                        "playing" === this.state ? this.pause() : this.play();
                                    },
                                };
                                return (
                                    (null == t ? void 0 : t.state) !== void 0 && lS(t, i, "state"),
                                    (null == t ? void 0 : t.currentSlideIndex) !== void 0 &&
                                        lS(t, i, "currentSlideIndex"),
                                    i
                                );
                            })(d);
                            i.bind(t, {
                                "x-data": () => ({
                                    __slideshow_autoplayTimeoutId: void 0,
                                    __slideshow_animationFrameId: void 0,
                                    __slideshow_state: c,
                                    init() {
                                        let e,
                                            t = (i) => {
                                                void 0 === e && (e = i);
                                                let s = i - e;
                                                (e = i),
                                                    (this.__slideshow_state.currentSlideElapsedTime = Math.round(
                                                        this.__slideshow_state.currentSlideElapsedTime + s
                                                    )),
                                                    "playing" === this.__slideshow_state.state &&
                                                        (this.__slideshow_animationFrameId = requestAnimationFrame(t));
                                            },
                                            i = () => {
                                                void 0 !== this.__slideshow_animationFrameId &&
                                                    cancelAnimationFrame(this.__slideshow_animationFrameId),
                                                    (e = void 0),
                                                    (this.__slideshow_animationFrameId = requestAnimationFrame(t));
                                            },
                                            s = () => {
                                                void 0 !== this.__slideshow_animationFrameId &&
                                                    (cancelAnimationFrame(this.__slideshow_animationFrameId),
                                                    (this.__slideshow_animationFrameId = void 0));
                                            },
                                            r = () => {
                                                if (
                                                    (void 0 !== this.__slideshow_autoplayTimeoutId &&
                                                        (clearTimeout(this.__slideshow_autoplayTimeoutId),
                                                        (this.__slideshow_autoplayTimeoutId = void 0)),
                                                    "playing" === this.__slideshow_state.state)
                                                ) {
                                                    i();
                                                    let e =
                                                        this.__slideshow_state.slideDuration -
                                                        this.__slideshow_state.currentSlideElapsedTime;
                                                    this.__slideshow_autoplayTimeoutId = window.setTimeout(() => {
                                                        this.__slideshow_state.next(),
                                                            (this.__slideshow_state.currentSlideElapsedTime = 0),
                                                            r();
                                                    }, e);
                                                } else s();
                                            };
                                        this.$watch("__slideshow_state.state", () => {
                                            r();
                                        }),
                                            this.$watch("__slideshow_state.currentSlideIndex", (e, t) => {
                                                (this.__slideshow_state.currentSlideElapsedTime = 0),
                                                    (this.__slideshow_state.lastSlideIndex = t),
                                                    r();
                                            }),
                                            r();
                                    },
                                    destroy() {
                                        void 0 !== this.__slideshow_autoplayTimeoutId &&
                                            clearTimeout(this.__slideshow_autoplayTimeoutId),
                                            void 0 !== this.__slideshow_animationFrameId &&
                                                cancelAnimationFrame(this.__slideshow_animationFrameId);
                                    },
                                }),
                                "x-id": "['slideshow']",
                            });
                        })(e, t, i, s);
                    else throw Error(`Unknown directive: x-slideshow:${i.value}`);
                })
                .before("bind"),
                t.magic("slideshow", function (e) {
                    let i = t.$data(e);
                    return i.__slideshow_state || {};
                }),
                t.magic("slide", function (e) {
                    let i = t.$data(e);
                    return {
                        get slideIndex() {
                            return i.__slideshowSlide_slideIndex;
                        },
                        get isCurrentSlide() {
                            return i.__slideshowSlide_isCurrentSlide;
                        },
                        get wasLastSlide() {
                            return i.__slideshowSlide_wasLastSlide;
                        },
                    };
                });
        }),
        lb.plugin(function e(t) {
            t.directive("list-state", (e, { value: i, expression: s, modifiers: r }, { evaluate: n }) => {
                if ("item" == i) {
                    let a = t.$data(e),
                        o = `$${lT}`;
                    if (r.includes("for") && r.length >= 2) {
                        let l = r.indexOf("for");
                        o = `$${r[l + 1]}`;
                    }
                    if (!(o in a))
                        throw Error(
                            "x-list-state:item must be used within x-list-state directive. To register an item in a scoped list state, use $myScopeName.register($el)"
                        );
                    t.bind(e, {
                        "x-init"() {
                            a[o].register(this.$el);
                        },
                        "x-destroy"() {
                            a[o].unregister(this.$el);
                        },
                    });
                } else if (null == i) {
                    var d, c;
                    let h = {},
                        u = `$${lT}`;
                    if (r.includes("as") && r.length >= 2) {
                        let p = r.indexOf("as");
                        u = `$${r[p + 1]}`;
                    }
                    if (s) {
                        let m = n("" === s ? "{}" : s);
                        l8(m) && (h = m).scope && (u = `$${h.scope}`);
                    }
                    let f;
                    if (h.multiple || r.includes("multiple")) {
                        if ((null == h ? void 0 : h.selectedIndices) && !(h.selectedIndices instanceof Set))
                            throw Error("selectedIndices must be a Set");
                        let g;
                        f =
                            ((d = h),
                            (g = {
                                selectedIndices: new Set(),
                                items: new Set(),
                                isSelected(e) {
                                    return this.selectedIndices.has(e);
                                },
                                register(e) {
                                    this.items.add(e);
                                },
                                unregister(e) {
                                    this.items.delete(e);
                                },
                                indexOf(e) {
                                    return Array.from(this.items).indexOf(e);
                                },
                                toggle(e) {
                                    this.selectedIndices.has(e) ? this.deselect(e) : this.select(e);
                                },
                                select(e) {
                                    let t = this.selectedIndices;
                                    t.add(e), (this.selectedIndices = new Set(Array.from(t)));
                                },
                                deselect(e) {
                                    let t = this.selectedIndices;
                                    t.delete(e), (this.selectedIndices = new Set(Array.from(t)));
                                },
                            }),
                            "selectedIndices" in d && lS(d, g, "selectedIndices"),
                            g);
                    } else {
                        let y;
                        f =
                            ((c = h),
                            (y = {
                                selectedIndex: null,
                                items: new Set(),
                                isSelected(e) {
                                    return this.selectedIndex == e;
                                },
                                register(e) {
                                    this.items.add(e);
                                },
                                unregister(e) {
                                    this.items.delete(e);
                                },
                                indexOf(e) {
                                    return Array.from(this.items).indexOf(e);
                                },
                                toggle(e) {
                                    this.selectedIndex == e ? this.deselect(e) : this.select(e);
                                },
                                select(e) {
                                    this.selectedIndex = e;
                                },
                                deselect(e) {
                                    this.selectedIndex == e && (this.selectedIndex = null);
                                },
                            }),
                            "selectedIndex" in c && lS(c, y, "selectedIndex"),
                            y);
                    }
                    t.addScopeToNode(e, { [u]: t.reactive(f) });
                } else throw Error(`Unknown directive: x-list-state:${i}`);
            }).before("bind");
        }),
        lb.plugin(function e(t) {
            var i;
            t.directive("animate", (e, { expression: i, modifiers: s }, { evaluateLater: r, effect: n }) => {
                if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                if (!i)
                    throw Error(
                        "Expected x-animate to be passed a motion keyframes object but was passed nothing. See https://motion.dev/dom/animate#keyframes"
                    );
                let a = r(i),
                    o = t.reactive({ controls: null }),
                    l = !s.includes("pause");
                n(() => {
                    a((t) => {
                        if (!l8(t))
                            throw Error(
                                String.raw`Expected x-animate to be passed a motion keyframes object but got '${String(t)}'. See https://motion.dev/dom/animate#keyframes`
                            );
                        o.controls = u$(e, t, { autoplay: l });
                    }),
                        t.addScopeToNode(e, { [pD]: o });
                });
            }),
                t.directive("animate-scroll", (e, { expression: i }, { evaluate: s }) => {
                    if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                    if (!i)
                        throw Error(
                            "Expected x-animate to be passed a motion keyframes object but was passed nothing. See https://motion.dev/dom/animate#keyframes"
                        );
                    let r = s(i);
                    t.bind(e, {
                        "x-data": () => ({
                            __animateScroll_isVisible: !1,
                            __animateScroll_animation: null,
                            __animateScroll_cancelScrollAnimation: null,
                            init() {
                                (this.__animateScroll_animation = u$(e, r)),
                                    this.$watch("__animateScroll_isVisible", (t) => {
                                        var i, s;
                                        t
                                            ? (null === (i = this.__animateScroll_cancelScrollAnimation) ||
                                                  void 0 === i ||
                                                  i.call(this),
                                              (this.__animateScroll_cancelScrollAnimation = uz(
                                                  this.__animateScroll_animation,
                                                  { target: e, offset: ["0% 100%", "100% 0%"] }
                                              )))
                                            : null === (s = this.__animateScroll_cancelScrollAnimation) ||
                                              void 0 === s ||
                                              s.call(this);
                                    });
                            },
                            destroy() {
                                var e;
                                null === (e = this.__animateScroll_cancelScrollAnimation) ||
                                    void 0 === e ||
                                    e.call(this);
                            },
                        }),
                        "x-intersect:enter": "__animateScroll_isVisible = true",
                        "x-intersect:leave": "__animateScroll_isVisible = false",
                    });
                }),
                t.directive("animate-scroll-stagger", (e, { expression: i, value: s }, { evaluate: r }) => {
                    if ("enter" == s) {
                        let n = r(i);
                        t.bind(e, {
                            "x-init"() {
                                this.$data.__animateScrollStagger_enterKeyframes = n;
                            },
                        });
                    } else if ("leave" == s) {
                        let a = r(i);
                        t.bind(e, {
                            "x-init"() {
                                this.$data.__animateScrollStagger_leaveKeyframes = a;
                            },
                        });
                    } else {
                        let o = i ? r(i) : {},
                            { selector: l } = o,
                            d = pM(o, ["selector"]);
                        t.bind(e, {
                            "x-data": () => ({
                                __animateScrollStagger_cancelScroll: null,
                                __animateScrollStagger_fitsInViewport: null,
                                __animateScrollStagger_didBeginFullyVisible: !1,
                                __animateScrollStagger_wasFullyVisible: null,
                                __animateScrollStagger_isFullyVisible: null,
                                __animateScrollStagger_wasPartiallyVisible: null,
                                __animateScrollStagger_isPartiallyVisible: null,
                                __animateScrollStagger_enterKeyframes: {},
                                __animateScrollStagger_visibleKeyframes: d,
                                __animateScrollStagger_leaveKeyframes: {},
                                get __animateScrollStagger_items() {
                                    return Array.from(e.querySelectorAll(l || "[data-animate-stagger-item]"));
                                },
                                init() {
                                    this.$watch("__animateScrollStagger_wasFullyVisible", (e) => {
                                        this.__animateScrollStagger_wasFullyVisible = e;
                                    }),
                                        this.$watch("__animateScrollStagger_wasPartiallyVisible", (e) => {
                                            this.__animateScrollStagger_wasPartiallyVisible = e;
                                        });
                                },
                                destroy() {
                                    this.__animateScrollStagger_cancelScrollAnimation();
                                },
                                __animateScrollStagger_startScrollAnimation() {
                                    var t;
                                    if (null !== this.__animateScrollStagger_cancelScroll) return;
                                    let i = "-0.8",
                                        s = this.__animateScrollStagger_items.map((e) => [
                                            e,
                                            this.__animateScrollStagger_enterKeyframes,
                                            { duration: 1, at: i },
                                        ]),
                                        r =
                                            null !== this.__animateScrollStagger_visibleKeyframes &&
                                            Object.keys(this.__animateScrollStagger_visibleKeyframes).length > 0
                                                ? this.__animateScrollStagger_visibleKeyframes
                                                : ((t = this.__animateScrollStagger_enterKeyframes),
                                                  Object.entries(t).reduce(
                                                      (e, [t, i]) =>
                                                          Object.assign(Object.assign({}, e), {
                                                              [t]: Array.isArray(i)
                                                                  ? i.length > 1
                                                                      ? [i[1], i[1]]
                                                                      : i[0]
                                                                  : [i, i],
                                                          }),
                                                      {}
                                                  )),
                                        n = this.__animateScrollStagger_items.map((e) => [
                                            e,
                                            r,
                                            { duration: 1, at: i },
                                        ]),
                                        a = this.__animateScrollStagger_items.map((e) => [
                                            e,
                                            this.__animateScrollStagger_leaveKeyframes,
                                            { duration: 1, at: i },
                                        ]);
                                    !1 == this.__animateScrollStagger_fitsInViewport
                                        ? (this.__animateScrollStagger_cancelScroll = uz(u$(s), {
                                              target: e,
                                              offset: ["0% 100%", "100% 0%"],
                                          }))
                                        : (this.__animateScrollStagger_cancelScroll = uz(u$([...s, ...n, ...a]), {
                                              target: e,
                                              offset: ["25% 100%", "0% 50%", "0% 0%", "75% 0%"],
                                          }));
                                },
                                __animateScrollStagger_cancelScrollAnimation() {
                                    var e;
                                    null === (e = this.__animateScrollStagger_cancelScroll) ||
                                        void 0 === e ||
                                        e.call(this),
                                        (this.__animateScrollStagger_cancelScroll = null);
                                },
                            }),
                            "x-intersect:enter.threshold.0": "__animateScrollStagger_isPartiallyVisible = true",
                            "x-intersect:leave.threshold.0": "__animateScrollStagger_isPartiallyVisible = false",
                            "x-intersect:enter.full": "__animateScrollStagger_isFullyVisible = true",
                            "x-intersect:leave.full": "__animateScrollStagger_isFullyVisible = false",
                            async "x-effect"() {
                                null == this.__animateScrollStagger_wasFullyVisible &&
                                this.__animateScrollStagger_isFullyVisible
                                    ? this.__animateScrollStagger_startScrollAnimation()
                                    : !1 == this.__animateScrollStagger_isFullyVisible &&
                                      (!0 == this.__animateScrollStagger_isPartiallyVisible
                                          ? this.__animateScrollStagger_startScrollAnimation()
                                          : !0 == this.__animateScrollStagger_wasPartiallyVisible &&
                                            !1 == this.__animateScrollStagger_isPartiallyVisible &&
                                            this.__animateScrollStagger_cancelScrollAnimation());
                            },
                            "x-resize"() {
                                this.__animateScrollStagger_fitsInViewport = this.$resize.height <= window.innerHeight;
                            },
                        });
                    }
                }),
                t.magic("m", function (e) {
                    return {
                        animate: u$,
                        stagger: uU,
                        spring: di,
                        scroll: uz,
                        inView: uj,
                        motionValue: lz,
                        animateView: p9,
                        transform: u1,
                    };
                }),
                t.magic("animation", (e) => {
                    let i = t.$data(e)[pD];
                    if (!i) throw Error("$animation needs to be used on or inside an element with x-animate directive");
                    return i.controls;
                });
        }),
        lb.plugin(function e(t) {
            t.magic("waitForAnimations", function (e) {
                return async function (t) {
                    var i;
                    let s = null !== (i = null == t ? void 0 : t.target) && void 0 !== i ? i : e,
                        r = await u4(s, t);
                    return uX(s, r, null == t ? void 0 : t.subtree, null == t ? void 0 : t.excludeSubtree);
                };
            });
        }),
        lb.plugin(function e(t) {
            var i, s;
            t
                .directive("disclosure", (e, i, s) => {
                    if ("panel" === i.value)
                        (function e(t, i) {
                            i.bind(t, {
                                ":id": "$el.id || $id('disclosure-panel')",
                                role: "group",
                                "x-show": "$disclosure.isExpanded",
                                "x-init"() {
                                    this.__disclosure_contentEl = this.$el;
                                    let e = () => {
                                            this.$el.setAttribute("hidden", "");
                                        },
                                        t = () => this.$el.removeAttribute("hidden");
                                    this.__disclosure_state.isExpanded ? t() : e(),
                                        this.$watch("__disclosure_state.isExpanded", async (i) => {
                                            i ? t() : (await this.__disclosure_waitForAnimations(), e());
                                        });
                                },
                                ":aria-labelledby": "__disclosure_buttonEl?.id",
                            });
                        })(e, t);
                    else if ("button" === i.value)
                        (function e(t, i) {
                            i.bind(t, {
                                role: "button",
                                ":id": "$el.id || $id('disclosure-button')",
                                "x-init": "__disclosure_buttonEl = $el",
                                "@click.stop.prevent": "$disclosure.toggle()",
                                ":aria-controls": "__disclosure_contentEl?.id",
                                ":aria-expanded": "$disclosure.isExpanded",
                            });
                        })(e, t);
                    else if (null === i.value)
                        (function e(t, i, { modifiers: s, expression: r }, { evaluate: n }) {
                            let a = i.$data(t),
                                o = a.__disclosure_isInGroup,
                                l = !s.includes("noanimate"),
                                d = {};
                            if (r) {
                                let c = n("" === r ? "{}" : r);
                                !0 === c || !1 === c ? (d.isExpanded = c) : l8(c) && (d = c);
                            }
                            let h = uJ(d);
                            o &&
                                (h = uJ({
                                    get isExpanded() {
                                        var u, p;
                                        let m =
                                                null === (p = (u = a.__disclosure_group_state).indexOf) || void 0 === p
                                                    ? void 0
                                                    : p.call(u, t),
                                            f = a.__disclosure_group_state.isExpanded(m);
                                        return f;
                                    },
                                    set isExpanded(value) {
                                        var g, y;
                                        let v =
                                            null === (y = (g = a.__disclosure_group_state).indexOf) || void 0 === y
                                                ? void 0
                                                : y.call(g, t);
                                        value
                                            ? a.__disclosure_group_state.expand(v)
                                            : a.__disclosure_group_state.collapse(v);
                                    },
                                })),
                                i.bind(t, {
                                    ":id": "$el.id || $id('disclosure')",
                                    "x-data": () => ({
                                        __disclosure_buttonEl: null,
                                        __disclosure_contentEl: null,
                                        __disclosure_state: h,
                                        init() {
                                            o && this.$data.__disclosure_group_state.register(this.$el),
                                                this.$watch("__disclosure_state.isExpanded", (e) => {
                                                    this.$dispatch(e ? "expand" : "collapse");
                                                });
                                        },
                                        destroy() {
                                            o && this.$data.__disclosure_group_state.unregister(this.$el);
                                        },
                                        async __disclosure_waitForAnimations() {
                                            if (!l) return Promise.resolve([]);
                                            try {
                                                return await this.$waitForAnimations({
                                                    subtree: !0,
                                                    target: this.__disclosure_contentEl,
                                                    excludeSubtree: (e) => e.hasAttribute("data-skip-transition-wait"),
                                                });
                                            } catch (e) {
                                                if (e instanceof uK)
                                                    return (
                                                        "development" === process.env.NODE_ENV &&
                                                            console.warn(
                                                                "[x-disclosure] no animations started within 50ms of transitioning to expanded. If you don't need animations add the .noanimate modifier",
                                                                this.__disclosure_contentEl
                                                            ),
                                                        Promise.resolve([])
                                                    );
                                                if (e instanceof u2)
                                                    return (
                                                        "development" === process.env.NODE_ENV &&
                                                            console.warn(
                                                                "[x-disclosure] animations did not complete before timeout, it is recommended to keep your animations under a 2000ms",
                                                                this.__disclosure_contentEl
                                                            ),
                                                        Promise.resolve([])
                                                    );
                                                throw e;
                                            }
                                        },
                                        get __disclosure_groupIndex() {
                                            var e, t;
                                            return null === (t = (e = a.__disclosure_group_state).indexOf) ||
                                                void 0 === t
                                                ? void 0
                                                : t.call(e, this.$el);
                                        },
                                    }),
                                    "x-id": "['disclosure', 'disclosure-panel', 'disclosure-button']",
                                });
                        })(e, t, i, s);
                    else throw Error(`Unknown directive: x-disclosure:${i.value}`);
                })
                .before("bind"),
                t
                    .directive("disclosure-group", (e, i, s) => {
                        if (null === i.value)
                            (function e(t, i, { expression: s, modifiers: r }, { evaluate: n }) {
                                var a, o, l, d;
                                let c = n("" === s ? "{}" : s);
                                if (null != c && !l8(c)) throw Error(`options must be an object, but got ${c}`);
                                let h, u, p;
                                (h =
                                    c.multiple || r.includes("multiple")
                                        ? ((a = c),
                                          (u = {
                                              expandedIndices:
                                                  null !== (o = null == a ? void 0 : a.initiallyExpandedIndices) &&
                                                  void 0 !== o
                                                      ? o
                                                      : new Set(),
                                              items: new Set(),
                                              isExpanded(e) {
                                                  return this.expandedIndices.has(e);
                                              },
                                              register(e) {
                                                  this.items.add(e);
                                              },
                                              unregister(e) {
                                                  this.items.delete(e);
                                              },
                                              indexOf(e) {
                                                  return Array.from(this.items).indexOf(e);
                                              },
                                              toggle(e) {
                                                  this.expandedIndices.has(e) ? this.collapse(e) : this.expand(e);
                                              },
                                              expand(e) {
                                                  let t = this.expandedIndices;
                                                  t.add(e), (this.expandedIndices = new Set(Array.from(t)));
                                              },
                                              collapse(e) {
                                                  let t = this.expandedIndices;
                                                  t.delete(e), (this.expandedIndices = new Set(Array.from(t)));
                                              },
                                          }),
                                          a && "expandedIndices" in a && lS(a, u, "expandedIndices"),
                                          u)
                                        : ((l = c),
                                          (p = {
                                              expandedIndex:
                                                  null !== (d = null == l ? void 0 : l.initiallyExpandedIndex) &&
                                                  void 0 !== d
                                                      ? d
                                                      : null,
                                              items: new Set(),
                                              isExpanded(e) {
                                                  return this.expandedIndex === e;
                                              },
                                              register(e) {
                                                  this.items.add(e);
                                              },
                                              unregister(e) {
                                                  this.items.delete(e);
                                              },
                                              indexOf(e) {
                                                  return Array.from(this.items).indexOf(e);
                                              },
                                              toggle(e) {
                                                  this.expandedIndex === e ? this.collapse(e) : this.expand(e);
                                              },
                                              expand(e) {
                                                  this.expandedIndex = e;
                                              },
                                              collapse(e) {
                                                  this.expandedIndex === e && (this.expandedIndex = null);
                                              },
                                          }),
                                          l && "expandedIndex" in l && lS(l, p, "expandedIndex"),
                                          p)),
                                    i.bind(t, {
                                        "x-data": () => ({
                                            __disclosure_group_state: h,
                                            get __disclosure_isInGroup() {
                                                return !0;
                                            },
                                        }),
                                    });
                            })(e, t, i, s);
                        else throw Error(`Unknown directive: x-disclosure-group:${i.value}`);
                    })
                    .before("bind"),
                t.magic(
                    "disclosure",
                    ((i = t),
                    function (e) {
                        let t = i.$data(e);
                        return {
                            get isExpanded() {
                                var s;
                                return null === (s = t.__disclosure_state) || void 0 === s ? void 0 : s.isExpanded;
                            },
                            set isExpanded(value) {
                                if (!t.__disclosure_state) return;
                                t.__disclosure_state.isExpanded = value;
                            },
                            get isCollapsed() {
                                var r;
                                return null === (r = t.__disclosure_state) || void 0 === r ? void 0 : r.isCollapsed;
                            },
                            get groupIndex() {
                                return t.__disclosure_groupIndex;
                            },
                            toggle() {
                                var e;
                                null === (e = t.__disclosure_state) || void 0 === e || e.toggle();
                            },
                            expand() {
                                var e;
                                null === (e = t.__disclosure_state) || void 0 === e || e.expand();
                            },
                            collapse() {
                                var e;
                                null === (e = t.__disclosure_state) || void 0 === e || e.collapse();
                            },
                            waitForAnimations: () => t.__disclosure_waitForAnimations(),
                        };
                    })
                ),
                t.magic(
                    "disclosureGroup",
                    ((s = t),
                    function (e) {
                        let t = s.$data(e);
                        return t.__disclosure_group_state || {};
                    })
                );
        }),
        lb.plugin(function e(t) {
            var i, s, r, n, a, o, l, d, c, h;
            t.magic(
                "isSelectedSection",
                ((i = t),
                function (e) {
                    var t;
                    if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                    if (!l$) throw Error(`Expected HTMLElement but got ${e}`);
                    let s = lk(e),
                        r = i.store("themeEditor").selectedSection;
                    return !!s && !!r && s.id == r.id;
                })
            ),
                t.magic(
                    "isSelectedBlock",
                    ((s = t),
                    function (e) {
                        var t;
                        if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        let i = e.closest("[data-shopify-editor-block]"),
                            r = s.store("themeEditor").selectedBlock;
                        return !!i && !!r && i === r;
                    })
                ),
                t.magic(
                    "isInSelectedBlockTree",
                    ((r = t),
                    function (e) {
                        var t;
                        if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        let i = e.closest("[data-shopify-editor-block]"),
                            s = r.store("themeEditor").selectedBlock;
                        return !!i && !!s && (i.contains(s) || i === s || s.contains(i));
                    })
                ),
                t.magic(
                    "wasSelectedSection",
                    ((n = t),
                    function (e) {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        if (!l$) throw Error(`Expected HTMLElement but got ${e}`);
                        let i = lk(e),
                            s = n.store("themeEditor").prevSelectedSection;
                        return !!i && !!s && i.id == s.id;
                    })
                ),
                t.magic(
                    "wasInSelectedBlockTree",
                    ((a = t),
                    function (e) {
                        var t;
                        if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        let i = e.closest("[data-shopify-editor-block]"),
                            s = a.store("themeEditor").prevSelectedBlock;
                        return !!i && !!s && (i.contains(s) || i === s || s.contains(i));
                    })
                ),
                t.magic(
                    "wasSelectedBlock",
                    ((o = t),
                    function (e) {
                        var t;
                        if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return !1;
                        let i = e.closest("[data-shopify-editor-block]"),
                            s = o.store("themeEditor").prevSelectedBlock;
                        return !!i && !!s && i == s;
                    })
                ),
                t.magic(
                    "selectedSection",
                    ((l = t),
                    function (e) {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return null;
                        let i = l.store("themeEditor").selectedSection;
                        return i;
                    })
                ),
                t.magic(
                    "selectedBlock",
                    ((d = t),
                    function (e) {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return null;
                        let i = d.store("themeEditor").selectedBlock;
                        return i;
                    })
                ),
                t.magic(
                    "prevSelectedSection",
                    ((c = t),
                    function (e) {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return null;
                        let i = c.store("themeEditor").prevSelectedSection;
                        return i;
                    })
                ),
                t.magic(
                    "prevSelectedBlock",
                    ((h = t),
                    function (e) {
                        var t;
                        if (!(null === (t = window.Shopify) || void 0 === t ? void 0 : t.designMode)) return null;
                        let i = h.store("themeEditor").prevSelectedBlock;
                        return i;
                    })
                ),
                t.store("themeEditor", uQ);
        }),
        lb.plugin(function e(t) {
            t
                .directive("marquee", (e, { value: i, modifiers: s }) => {
                    if ("source" == i) t.bind(e, { "x-init": "__marquee_sourceEl = $el" });
                    else if ("target" == i) t.bind(e, { "x-init": "__marquee_targetEl = $el" });
                    else if (null == i) {
                        let r = 60,
                            n = s.includes("fill"),
                            a = !s.includes("pause");
                        s.includes("speed") && (r = Number(s[s.indexOf("speed") + 1])),
                            t.bind(e, {
                                "x-data"() {
                                    var e, i;
                                    return {
                                        __marquee_state:
                                            ((e = { isPlaying: a }),
                                            {
                                                isPlaying:
                                                    null !== (i = null == e ? void 0 : e.isPlaying) &&
                                                    void 0 !== i &&
                                                    i,
                                                play() {
                                                    this.isPlaying = !0;
                                                },
                                                pause() {
                                                    this.isPlaying = !1;
                                                },
                                                toggle() {
                                                    this.isPlaying = !this.isPlaying;
                                                },
                                            }),
                                        __marquee_isInitialized: !1,
                                        __marquee_isRendering: !1,
                                        __marquee_sourceEl: null,
                                        __marquee_targetEl: null,
                                        __marquee_originalContentFragment: document.createDocumentFragment(),
                                        __marquee_originalContentWidth: 0,
                                        __marquee_sourceElWidth: 0,
                                        __marquee_viewportWidth: 0,
                                        __marquee_sourceAnimation: null,
                                        __marquee_targetAnimation: null,
                                        __marquee_sentinel: null,
                                        get __marquee_animationDuration() {
                                            return (this.__marquee_sourceElWidth / Math.abs(r)) * 1e3;
                                        },
                                        __marquee_fillSource() {
                                            return new Promise((e) => {
                                                0 === this.__marquee_originalContentWidth &&
                                                    ((this.__marquee_originalContentWidth =
                                                        this.__marquee_sourceEl.clientWidth),
                                                    (this.__marquee_sourceElWidth =
                                                        this.__marquee_originalContentWidth)),
                                                    this.__marquee_sentinel
                                                        ? t.mutateDom(() => {
                                                              let e = this.__marquee_sentinel.nextSibling;
                                                              for (; e; ) {
                                                                  let t = e;
                                                                  (e = e.nextSibling),
                                                                      this.__marquee_sourceEl.removeChild(t);
                                                              }
                                                              (this.__marquee_originalContentWidth =
                                                                  this.__marquee_sourceEl.clientWidth),
                                                                  (this.__marquee_sourceElWidth =
                                                                      this.__marquee_originalContentWidth);
                                                          })
                                                        : t.mutateDom(() => {
                                                              (this.__marquee_sentinel =
                                                                  document.createComment("marquee-sentinel")),
                                                                  this.__marquee_sourceEl.appendChild(
                                                                      this.__marquee_sentinel
                                                                  );
                                                          });
                                                let i = Math.max(
                                                    0,
                                                    this.__marquee_viewportWidth - this.__marquee_originalContentWidth
                                                );
                                                if (0 === i) return e();
                                                let s = Math.ceil(i / this.__marquee_originalContentWidth),
                                                    r = document.createDocumentFragment();
                                                for (let n = 0; n < s; n++) {
                                                    let a = this.__marquee_originalContentFragment.cloneNode(!0);
                                                    r.appendChild(a);
                                                }
                                                t.mutateDom(() => {
                                                    this.__marquee_sentinel.after(r),
                                                        t.skipDuringClone(() => t.initTree(this.__marquee_sourceEl))(),
                                                        window.requestAnimationFrame(() => {
                                                            (this.__marquee_sourceElWidth =
                                                                this.__marquee_sourceEl.clientWidth),
                                                                e();
                                                        });
                                                });
                                            });
                                        },
                                        __marquee_cloneSourceToTarget() {
                                            return new Promise((e) => {
                                                if (this.__marquee_sourceElWidth < this.__marquee_viewportWidth)
                                                    return e();
                                                t.mutateDom(() => {
                                                    let i = this.__marquee_sourceEl.cloneNode(!0);
                                                    this.__marquee_targetEl.replaceChildren(...i.children),
                                                        t.skipDuringClone(() => t.initTree(this.__marquee_targetEl))(),
                                                        e();
                                                });
                                            });
                                        },
                                        __marquee_setupAnimations() {
                                            var e, t;
                                            let i = r < 0 ? "reverse" : "normal",
                                                s = this.__marquee_animationDuration,
                                                n = [
                                                    { transform: "translateX(0%)" },
                                                    { transform: "translateX(-100%)" },
                                                ],
                                                a = { duration: s, iterations: 1 / 0, direction: i };
                                            if (null == this.__marquee_sourceAnimation) {
                                                let o = new Animation(
                                                    new KeyframeEffect(this.__marquee_sourceEl, n, a)
                                                );
                                                this.__marquee_sourceAnimation = o;
                                            } else
                                                null === (e = this.__marquee_sourceAnimation.effect) ||
                                                    void 0 === e ||
                                                    e.updateTiming({ duration: s });
                                            if (null == this.__marquee_targetAnimation) {
                                                let l = new Animation(
                                                    new KeyframeEffect(this.__marquee_targetEl, n, a)
                                                );
                                                (l.startTime = this.__marquee_sourceAnimation.startTime),
                                                    (l.currentTime = this.__marquee_sourceAnimation.currentTime),
                                                    (this.__marquee_targetAnimation = l);
                                            } else
                                                null === (t = this.__marquee_targetAnimation.effect) ||
                                                    void 0 === t ||
                                                    t.updateTiming({ duration: s });
                                            this.__marquee_state.isPlaying &&
                                                this.__marquee_sourceElWidth > this.__marquee_viewportWidth &&
                                                (this.__marquee_sourceAnimation.play(),
                                                this.__marquee_targetAnimation.play());
                                        },
                                        __marquee_scrollTo(e) {
                                            let t = e.offsetLeft;
                                            this.__marquee_sourceAnimation.effect.setKeyframes([
                                                { transform: `translateX(${-t}px)` },
                                                { transform: "translateX(-100%)" },
                                            ]),
                                                this.__marquee_targetAnimation.effect.setKeyframes([
                                                    { transform: `translateX(${-t}px)` },
                                                    { transform: "translateX(-100%)" },
                                                ]);
                                        },
                                        async __marquee_render() {
                                            if (!this.__marquee_isRendering)
                                                try {
                                                    (this.__marquee_isRendering = !0),
                                                        n && (await this.__marquee_fillSource()),
                                                        await this.__marquee_cloneSourceToTarget(),
                                                        window.matchMedia("(prefers-reduced-motion: reduce)").matches ||
                                                            this.__marquee_setupAnimations(),
                                                        (this.__marquee_isInitialized = !0),
                                                        window.requestAnimationFrame(() => {
                                                            this.__marquee_isRendering = !1;
                                                        });
                                                } finally {
                                                    this.__marquee_isRendering = !1;
                                                }
                                        },
                                        init() {
                                            this.$nextTick(() => {
                                                if (null == this.__marquee_sourceEl)
                                                    throw Error(
                                                        "Source element not found, x-marquee:source must be applied to a child element of the x-marquee directive"
                                                    );
                                                if (null == this.__marquee_targetEl)
                                                    throw Error(
                                                        "Target element not found, x-marquee:target must be applied to a child element of the x-marquee directive"
                                                    );
                                                Array.from(this.__marquee_sourceEl.children).forEach((e) => {
                                                    let t = e.cloneNode(!0);
                                                    for (let i of pO) t.removeAttribute(i);
                                                    this.__marquee_originalContentFragment.append(t);
                                                }),
                                                    window.requestAnimationFrame(() => {
                                                        (this.__marquee_originalContentWidth =
                                                            this.__marquee_sourceEl.clientWidth),
                                                            (this.__marquee_sourceElWidth =
                                                                this.__marquee_originalContentWidth),
                                                            (this.__marquee_viewportWidth = this.$el.clientWidth),
                                                            this.__marquee_render();
                                                    });
                                            }),
                                                this.$watch("__marquee_state.isPlaying", (e) => {
                                                    var t, i, s, r;
                                                    e
                                                        ? (null === (t = this.__marquee_sourceAnimation) ||
                                                              void 0 === t ||
                                                              t.play(),
                                                          null === (i = this.__marquee_targetAnimation) ||
                                                              void 0 === i ||
                                                              i.play())
                                                        : (null === (s = this.__marquee_sourceAnimation) ||
                                                              void 0 === s ||
                                                              s.pause(),
                                                          null === (r = this.__marquee_targetAnimation) ||
                                                              void 0 === r ||
                                                              r.pause());
                                                });
                                        },
                                        destroy() {
                                            var e, t, i, s;
                                            null === (e = this.__marquee_sourceEl) ||
                                                void 0 === e ||
                                                e.replaceChildren(this.__marquee_originalContentFragment),
                                                (this.__marquee_originalContentFragment =
                                                    document.createDocumentFragment()),
                                                null === (t = this.__marquee_sentinel) || void 0 === t || t.remove(),
                                                null === (i = this.__marquee_sourceAnimation) ||
                                                    void 0 === i ||
                                                    i.cancel(),
                                                null === (s = this.__marquee_targetAnimation) ||
                                                    void 0 === s ||
                                                    s.cancel(),
                                                (this.__marquee_sourceAnimation = null),
                                                (this.__marquee_targetAnimation = null);
                                        },
                                    };
                                },
                                "x-resize.300ms"() {
                                    window.requestAnimationFrame(() => {
                                        (this.__marquee_viewportWidth = this.$el.clientWidth), this.__marquee_render();
                                    });
                                },
                            });
                    } else throw Error(`Unknown directive: x-marquee:${i}`);
                })
                .before("bind"),
                t.magic("marquee", (e) => {
                    let i = t.$data(e);
                    return {
                        get isPlaying() {
                            var s;
                            return null === (s = i.__marquee_state) || void 0 === s ? void 0 : s.isPlaying;
                        },
                        play() {
                            var e;
                            null === (e = i.__marquee_state) || void 0 === e || e.play();
                        },
                        pause() {
                            var e;
                            null === (e = i.__marquee_state) || void 0 === e || e.pause();
                        },
                        toggle() {
                            var e;
                            null === (e = i.__marquee_state) || void 0 === e || e.toggle();
                        },
                        scrollTo(e) {
                            var t;
                            null === (t = i.__marquee_scrollTo) || void 0 === t || t.call(i, e);
                        },
                        get isReady() {
                            return i.__marquee_isInitialized;
                        },
                    };
                });
        }),
        lb.plugin(function e(t) {
            t.directive("hold", (e, { modifiers: i, expression: s }, { evaluate: r }) => {
                if (!l$(e)) throw Error(`Expected HTMLElement but got ${e}`);
                let n = i[0] || "",
                    a = lx(n.split("ms")[0]) ? Number(n.split("ms")[0]) : 25,
                    o = i[i.indexOf("max") + 1],
                    l = lx(null == o ? void 0 : o.split("ms")[0]) ? Number(o.split("ms")[0]) : 1500;
                t.bind(e, {
                    "x-data": () => ({
                        __intervalId: void 0,
                        __onPointerDown(e) {
                            var t;
                            l$(e.target) &&
                                (null === (t = e.target) || void 0 === t ? void 0 : t.hasPointerCapture(e.pointerId)) &&
                                e.target.releasePointerCapture(e.pointerId);
                            let i = 0;
                            this.__intervalId = window.setInterval(() => {
                                r(s), (i += 1) * a >= l && window.clearInterval(this.__intervalId);
                            }, a);
                        },
                        __onPointerUp(e) {
                            window.clearInterval(this.__intervalId);
                        },
                        __onPointerLeave(e) {
                            window.clearInterval(this.__intervalId);
                        },
                        destroy() {
                            window.clearInterval(this.__intervalId);
                        },
                    }),
                    "@pointerdown": "__onPointerDown",
                    "@pointerup.window": "__onPointerUp",
                    "@pointerleave": "__onPointerLeave",
                });
            }).before("bind");
        }),
        lb.plugin(function e(t) {
            t.directive("ensemble", (e, { value: i, modifiers: s }) => {
                let { $ensemble: r } = t.$data(e);
                switch (i) {
                    case "slideshow":
                        t.bind(e, {
                            [`x-slideshow.${s.join(".")}`]: () => ({
                                get currentSlideIndex() {
                                    if (null === r.selectedIndex) return 0;
                                    if (r.selectedIndex >= this.totalSlides) return this.totalSlides - 1;
                                    return r.selectedIndex;
                                },
                                set currentSlideIndex(value) {
                                    r.selectedIndex = value;
                                },
                                get state() {
                                    if (this.totalSlides < r.totalSlides) return "paused";
                                    return r.isPlaying ? "playing" : "paused";
                                },
                                set state(value) {
                                    r.isPlaying = "playing" === value;
                                },
                            }),
                            "x-effect"() {
                                this.$slideshow.totalSlides > this.$ensemble.totalSlides &&
                                    (this.$ensemble.totalSlides = this.$slideshow.totalSlides);
                            },
                        });
                        break;
                    case "disclosure-group":
                        t.bind(e, {
                            "x-disclosure-group": () => ({
                                get expandedIndex() {
                                    if (null === r.selectedIndex) return 0;
                                    let e = Array.from(this.items).length - 1;
                                    if (r.selectedIndex > e) return e;
                                    return r.selectedIndex;
                                },
                                set expandedIndex(value) {
                                    if (null === value) return;
                                    (r.isPlaying = !1), (r.selectedIndex = value);
                                },
                            }),
                        });
                        break;
                    case "slider":
                        t.bind(e, {
                            "x-flickity": "",
                            "x-list-state": () => ({
                                scope: "sliderItems",
                                get selectedIndex() {
                                    if (null === r.selectedIndex) return null;
                                    return r.selectedIndex;
                                },
                                set selectedIndex(value) {
                                    r.selectedIndex = value;
                                },
                            }),
                            "x-init"() {
                                this.$watch("$sliderItems.selectedIndex", (e, t) => {
                                    if (window.innerWidth < 768) {
                                        let i = Array.from(this.$sliderItems.items)[e];
                                        i &&
                                            i.scrollIntoView({
                                                behavior: "smooth",
                                                block: "nearest",
                                                inline: "center",
                                            });
                                    } else
                                        e !== this.$flickity.instance.selectedIndex &&
                                            this.$flickity.instance.select(e);
                                }),
                                    this.$watch("$flickity.isReady", (e) => {
                                        (this.$flickity.instance.options.fade = !0),
                                            (this.$flickity.instance.options.freeScroll = !1),
                                            this.$flickity.instance.resize(),
                                            e &&
                                                this.$flickity.instance.on("select", (e) => {
                                                    e !== this.$sliderItems.selectedIndex &&
                                                        (this.$sliderItems.selectedIndex = e);
                                                });
                                    });
                            },
                        });
                        break;
                    case "hotspots":
                        t.bind(e, {
                            "x-list-state": () => ({
                                scope: "hotspots",
                                get selectedIndex() {
                                    if (null === r.selectedIndex) return null;
                                    return r.selectedIndex;
                                },
                                set selectedIndex(value) {
                                    (r.isPlaying = !1), (r.selectedIndex = value);
                                },
                            }),
                        });
                        break;
                    case null:
                        t.bind(e, {
                            "x-intersect:enter": "$ensemble.isPlaying = true",
                            "x-intersect:leave": "$ensemble.isPlaying = false",
                            "@focusin": "$ensemble.isPlaying = false",
                            "x-data": () => ({
                                $ensemble: {
                                    titleEl: null,
                                    selectedIndex: 0,
                                    totalSlides: 0,
                                    isPlaying: !1,
                                    members: {},
                                    registerMember(e, t) {
                                        this.members[e] = t;
                                    },
                                    getPeerIds(e) {
                                        return Object.keys(this.members).filter((t) => t !== e);
                                    },
                                },
                            }),
                            ":aria-labelledby": "$ensemble.titleEl?.id",
                        });
                        break;
                    default:
                        throw Error(`Invalid ensemble directive: ${i}`);
                }
            }).before("bind");
        }),
        lb.plugin(function e(t) {
            t
                .directive("flickity", (e, { value: i, modifiers: r }) => {
                    switch (i) {
                        case "slider":
                            t.bind(e, { "x-init": "__flickity_sliderEl = $el" });
                            break;
                        case null:
                            t.bind(e, {
                                "x-data": () => ({
                                    __flickity_sliderEl: null,
                                    __flickity_isReady: !1,
                                    __flickity_instance: null,
                                    __flickity_mutationObserver: null,
                                    init() {
                                        this.$nextTick(() => {
                                            this.__flickity_sliderEl.classList.contains("flickity-enabled")
                                                ? ((this.__flickity_instance = s.data(this.__flickity_sliderEl)),
                                                  (this.__flickity_isReady = !0))
                                                : ((this.__flickity_mutationObserver = new MutationObserver((e) => {
                                                      e.forEach((e) => {
                                                          "attributes" === e.type &&
                                                              "class" === e.attributeName &&
                                                              e.target.classList.contains("flickity-enabled") &&
                                                              ((this.__flickity_instance = s.data(
                                                                  this.__flickity_sliderEl
                                                              )),
                                                              (this.__flickity_isReady = !0));
                                                      });
                                                  })),
                                                  this.__flickity_mutationObserver.observe(this.__flickity_sliderEl, {
                                                      attributes: !0,
                                                  }));
                                        });
                                    },
                                    destroy() {
                                        this.__flickity_mutationObserver.disconnect();
                                    },
                                }),
                            });
                            break;
                        default:
                            throw Error(`Invalid flickity directive: ${i}`);
                    }
                })
                .before("bind"),
                t.magic("flickity", (e) => {
                    let i = t.$data(e);
                    return {
                        get instance() {
                            return i.__flickity_instance;
                        },
                        get isReady() {
                            return i.__flickity_isReady;
                        },
                    };
                });
        }),
        lb.plugin(function e(t) {
            t.magic("sectionEl", (e) => lk(e)),
                t.magic("sectionId", (e) => {
                    var t;
                    return null === (t = lk(e)) || void 0 === t ? void 0 : t.id;
                });
        }),
        lb.start(),
        (window.Alpine = lb);
})(
    themeVendor.AOS,
    themeVendor.FlickityFade,
    themeVendor.ScrollLock,
    themeVendor.Flickity,
    themeVendor.MicroModal,
    themeVendor.Rellax,
    themeVendor.themeCurrency,
    themeVendor.axios,
    themeVendor.FlickitySync,
    themeVendor.themeAddresses,
    themeVendor.Sqrl
);
